/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
/**
 * What became of a background agent.
 * `running` while it works, `completed` when it reported its result, `failed` when it crashed without recovering or its request was refused, and `stopped` when someone stopped it.
 */
export enum AgentBackgroundAgentStatus {
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  Stopped = "stopped",
}

/**
 * Steering on how far an agent should reach when it changes content.
 * Only `read-only` is a hard boundary: the editing tools are not given to the agent, so it cannot change content whatever it is asked. The other values are guidance the agent follows — they steer where the work belongs. Agents can still make small edits elsewhere when the change it was asked for would otherwise leave the documentation broken (e.g. an inbound link to a page it renamed).
 * `all` sets no specific focus, which is the default. `read-only` reads, searches and comments without editing. `current-page` focuses on the page the user is on and its subpages. `modified-pages` focuses on the pages a change request has already touched.
 */
export enum AgentEditScope {
  All = "all",
  ReadOnly = "read-only",
  CurrentPage = "current-page",
  ModifiedPages = "modified-pages",
}

export enum AgentStatus {
  Idle = "idle",
  Processing = "processing",
  Errored = "errored",
}

/** Source type used to answer a site question. */
export enum SiteQuestionAnswerSourceType {
  Page = "page",
  Record = "record",
}

/** The status of ads on the site */
export enum SiteAdsStatus {
  Pending = "pending",
  InReview = "in-review",
  Live = "live",
  Rejected = "rejected",
  Disabled = "disabled",
}

export enum CustomizationThemeMode {
  Light = "light",
  Dark = "dark",
}

export enum APIIntegrationScope {
  IntegrationRead = "integration:read",
  IntegrationUpdate = "integration:update",
  IntegrationInstallationRead = "integration:installation:read",
  IntegrationInstallationUpdate = "integration:installation:update",
}

export enum BillingStatus {
  Trialing = "trialing",
  Active = "active",
  PastDue = "past_due",
  IncompleteExpired = "incomplete_expired",
  Canceled = "canceled",
  Unpaid = "unpaid",
  Paused = "paused",
}

/** Lifecycle state of a pull or merge request on the Git provider. */
export enum GitProviderChangeState {
  Open = "open",
  Closed = "closed",
  Merged = "merged",
}

/** Lifecycle state of a durable Git Sync run. */
export enum GitSyncRunState {
  Queued = "queued",
  Running = "running",
  Success = "success",
  Failure = "failure",
  Timeout = "timeout",
  Cancelled = "cancelled",
}

/** Operation performed by a durable Git Sync run. */
export enum GitSyncRunOperation {
  Import = "import",
  Export = "export",
  Check = "check",
  Merge = "merge",
  Recovery = "recovery",
}

/**
 * Core stages of a Git Sync process. This is not exhaustive, but should cover
 * the important ones.
 * - repo_fetch: Includes fetching the latest repository contents from remote provider.
 * - config_check: Includes checking if the YAML config is valid, etc.
 * - content_process: Includes processing of pages & files to be imported/exported.
 * - finalize: Includes finalizing the sync process like creating the commit on git, or
 * creating a new revision.
 */
export enum GitSyncOperationStage {
  RepoFetch = "repo_fetch",
  ConfigCheck = "config_check",
  ContentProcess = "content_process",
  Finalize = "finalize",
}

/** The type of semantic change. */
export enum RevisionSemanticChangeType {
  PageCreated = "page_created",
  PageEdited = "page_edited",
  PageDeleted = "page_deleted",
  PageMoved = "page_moved",
  FileCreated = "file_created",
  FileEdited = "file_edited",
  FileDeleted = "file_deleted",
  CustomFieldsEdited = "custom_fields_edited",
  TagCreated = "tag_created",
  TagDeleted = "tag_deleted",
  TagEdited = "tag_edited",
}

/** Predefined GitBook user identifiers */
export enum GitBookUsers {
  GitbookAgent = "gitbook:agent",
  GitbookGitsync = "gitbook:gitsync",
}

/** The Cloudflare Hostname TLS validation method */
export enum CloudflareHostnameTLSValidationMethod {
  Http = "http",
  Txt = "txt",
  Email = "email",
}

/** The Cloudflare Hostname TLS status */
export enum CloudflareHostnameTLSStatus {
  Initializing = "initializing",
  PendingValidation = "pending_validation",
  PendingIssuance = "pending_issuance",
  PendingDeployment = "pending_deployment",
  Active = "active",
  PendingDeletion = "pending_deletion",
  PendingCleanup = "pending_cleanup",
  Deleted = "deleted",
}

/** The Cloudflare Hostname status */
export enum CloudflareHostnameStatus {
  Pending = "pending",
  Active = "active",
  Blocked = "blocked",
  Moved = "moved",
  Deleted = "deleted",
}

export enum CustomHostnameErrorStatus {
  InvalidDomain = "invalid_domain",
  InternalError = "internal_error",
}

export enum CustomHostnameSslStatus {
  Live = "live",
  SslUnknown = "ssl_unknown",
  SslPending = "ssl_pending",
  SslFailed = "ssl_failed",
  SslRetryExpired = "ssl_retry_expired",
}

export enum CustomHostnameDnsStatus {
  DnsPassed = "dns_passed",
  DnsWrongCname = "dns_wrong_cname",
  DnsNoCname = "dns_no_cname",
  DnsCloudflareProxied = "dns_cloudflare_proxied",
  DnsWrongCaa = "dns_wrong_caa",
}

export enum SiteChannelRole {
  Collaborator = "collaborator",
  Support = "support",
}

export enum SiteChannelStatus {
  Active = "active",
  Pending = "pending",
}

/**
 * Transport protocol used to connect to the MCP server
 * @default "sse"
 */
export enum SiteMcpServerTransport {
  Sse = "sse",
  Http = "http",
}

/**
 * The field to sort site redirects by. `createdAt` returns the most recently created redirects first. `updatedAt` returns the most recently updated redirects first (falling back to the creation date for redirects never updated). `source` returns redirects sorted alphabetically by source path. Defaults to 'createdAt'.
 * @default "createdAt"
 */
export enum SiteRedirectOrderBy {
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
  Source = "source",
}

export enum SiteInsightsQueryRangePreset {
  YearToDate = "yearToDate",
  LastYear = "lastYear",
  Last3Months = "last3Months",
  Last30Days = "last30Days",
  Last7Days = "last7Days",
  Last24Hours = "last24Hours",
}

export enum SiteInsightsQueryOperator {
  In = "in",
  NotIn = "notIn",
  GreaterThan = "greaterThan",
  GreaterThanOrEqual = "greaterThanOrEqual",
  LessThan = "lessThan",
  LessThanOrEqual = "lessThanOrEqual",
}

/** Why a site URL returned a 404. `conditional` means the URL targets content gated by an adaptive-content condition, so the visitor lacked access to a page that exists. Computed by GitBook when the event is ingested; 404s recorded before this existed, and those on genuinely missing pages, carry no value. */
export enum SiteInsightsPageNotFoundType {
  Conditional = "conditional",
}

export enum SiteInsightsVisitorBot {
  Unknown = "unknown",
  Googlebot = "googlebot",
  Bingbot = "bingbot",
  Duckduckbot = "duckduckbot",
  Facebookbot = "facebookbot",
  Applebot = "applebot",
  Chatgpt = "chatgpt",
  Openai = "openai",
  Claude = "claude",
  Anthropic = "anthropic",
  Gemini = "gemini",
  Perplexity = "perplexity",
  Cohere = "cohere",
  Mistral = "mistral",
  Deepseek = "deepseek",
  Meta = "meta",
  Bytespider = "bytespider",
  Ccbot = "ccbot",
  Amazonbot = "amazonbot",
  Youbot = "youbot",
  Cursor = "cursor",
  Vscode = "vscode",
  ClaudeCode = "claude-code",
  Codex = "codex",
  Opencode = "opencode",
  Gptbot = "gptbot",
  Claudebot = "claudebot",
  MetaFetcher = "meta-fetcher",
  Grok = "grok",
  GithubCopilot = "github-copilot",
  MetaWebindexer = "meta-webindexer",
  MetaAds = "meta-ads",
  Duckassist = "duckassist",
  AmznSearchbot = "amzn-searchbot",
  AmznUser = "amzn-user",
  OtherBot = "other-bot",
  Parallel = "parallel",
  Exa = "exa",
  Linkup = "linkup",
  VertexAi = "vertex-ai",
  Atlassian = "atlassian",
  Kapa = "kapa",
  Bedrock = "bedrock",
}

export enum SiteInsightsVisitorOS {
  Windows = "windows",
  Macos = "macos",
  Linux = "linux",
  Android = "android",
  Ios = "ios",
  Unknown = "unknown",
}

export enum SiteInsightsVisitorDevice {
  Desktop = "desktop",
  Tablet = "tablet",
  Mobile = "mobile",
  Unknown = "unknown",
}

export enum SiteInsightsVisitorBrowser {
  Chrome = "chrome",
  Firefox = "firefox",
  Safari = "safari",
  Edge = "edge",
  Ie = "ie",
  Opera = "opera",
  Unknown = "unknown",
}

export enum SiteInsightsEventType {
  PageView = "page_view",
  PageMarkdownRequest = "page_markdown_request",
  SearchOpen = "search_open",
  SearchTypeQuery = "search_type_query",
  SearchOpenResult = "search_open_result",
  PagePostFeedback = "page_post_feedback",
  PagePostFeedbackComment = "page_post_feedback_comment",
  AgentFeedback = "agent_feedback",
  AskQuestion = "ask_question",
  AskView = "ask_view",
  AskTriggerClick = "ask_trigger_click",
  AskRateResponse = "ask_rate_response",
  LinkClick = "link_click",
  ApiClientOpen = "api_client_open",
  ApiClientRequest = "api_client_request",
  AdClick = "ad_click",
  AdDisplay = "ad_display",
  TrademarkClick = "trademark_click",
  LlmsRequest = "llms_request",
  McpRequest = "mcp_request",
  RssRequest = "rss_request",
}

export enum SiteInsightsLLMSVariant {
  Standard = "standard",
  Full = "full",
}

export enum SiteInsightsAdPlacement {
  Aside = "aside",
}

export enum SiteInsightsTrademarkPlacement {
  Sidebar = "sidebar",
  Ad = "ad",
  Footer = "footer",
  Pdf = "pdf",
  Embed = "embed",
}

export enum SiteInsightsLinkPosition {
  Announcement = "announcement",
  Header = "header",
  Footer = "footer",
  Sidebar = "sidebar",
  Content = "content",
}

/** How a page's markdown was requested. `page-action` means a reader used the site's page-actions menu — its copy or view-as-markdown action — rather than a client fetching the URL directly. */
export enum SiteInsightsMarkdownSource {
  PageAction = "page-action",
}

/** Context in which the event was recorded. */
export enum SiteInsightsDisplayContext {
  Site = "site",
  Server = "server",
  Embed = "embed",
  Mcp = "mcp",
}

/** Controls how issue remediation change requests should be handled for a site. */
export enum SiteSettingsFindingChangeRequests {
  Always = "always",
  AutoFixable = "auto-fixable",
  Never = "never",
}

/** Controls when topics are being scanned for findings. */
export enum SiteSettingsScanTopics {
  Auto = "auto",
  Never = "never",
}

/**
 * How much GitBook may do on its own when it resolves broken links automatically. GitBook never
 * applies a fix it isn't sure about, at any level.
 *   - `suggest-fixes` drafts fixes for approval and applies none.
 *   - `fix-clear-matches` applies the clearest fixes and drafts the less certain ones for approval.
 *   - `fix-close-matches` applies the clear and the close fixes.
 * At every level, GitBook drafts change requests that fix broken links to other sites, and never
 * merges them.
 */
export enum SiteSettingsBrokenLinksAutonomyLevel {
  SuggestFixes = "suggest-fixes",
  FixClearMatches = "fix-clear-matches",
  FixCloseMatches = "fix-close-matches",
}

export enum AIModel {
  Fast = "fast",
  ReasoningLow = "reasoning-low",
  ReasoningMedium = "reasoning-medium",
  ReasoningHigh = "reasoning-high",
}

/** The phase of a step in a message from the AI agent. */
export enum AIMessageStepPhase {
  Commentary = "commentary",
  FinalAnswer = "final_answer",
}

/** Describe the state in which the steps started. */
export enum AIMessageStepStartCondition {
  Compaction = "compaction",
}

export enum AIMessageRole {
  User = "user",
  Assistant = "assistant",
  Developer = "developer",
}

/** Helpfulness of the response for the end user need. */
export enum SiteQuestionAnswerHelpfulness {
  Low = "low",
  Medium = "medium",
  High = "high",
}

/** Size of a timeline bucket. Weeks start on Sunday, and every bucket is in UTC. */
export enum SiteQuestionTimelineInterval {
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month",
}

/** Whether the response answered the question. */
export enum SiteQuestionAnswerResolution {
  No = "no",
  Partially = "partially",
  Yes = "yes",
}

/** Who asked the question: `human` for a person using a web browser, `agent` for an AI agent, `bot` for another automated client that names itself, such as a search engine crawler, and `unknown` when it can't be told, such as for a script calling the API. */
export enum SiteQuestionVisitorType {
  Human = "human",
  Agent = "agent",
  Bot = "bot",
  Unknown = "unknown",
}

export enum SiteConfigurableChannelType {
  BuiltinSlack = "builtin:slack",
  BuiltinDiscord = "builtin:discord",
  BuiltinGithub = "builtin:github",
  BuiltinLinear = "builtin:linear",
}

export enum SiteCoreChannelType {
  Site = "site",
  Embed = "embed",
  Api = "api",
}

/** Relevance classification of the user question. */
export enum SiteQuestionAnswerRelevance {
  Relevant = "relevant",
  Spam = "spam",
  OffTopic = "off-topic",
  Unclear = "unclear",
}

/** Relative score adjustment applied to records from a connection when searching. */
export enum ContextSearchBoost {
  X08 = "x0.8",
  X10 = "x1.0",
  X12 = "x1.2",
}

/**
 * Why an AI task was skipped before execution.
 *
 * - `ai_unavailable_for_organization`: The organization's effective plan does not include AI or a
 *   required feature. Takes precedence when both the organization and site plans block the task.
 * - `ai_unavailable_for_site`: The site's effective plan does not include the required feature.
 *   The site's applied plan takes precedence over its own plan.
 * - `ai_paused`: AI usage is temporarily paused by automatic usage controls.
 * - `ai_disabled`: AI or a required AI feature has been turned off in the organization's settings.
 * - `ai_restricted`: AI is blocked by GitBook or a contractual restriction and cannot be enabled
 *   through organization settings.
 */
export enum AISkipReason {
  AiUnavailableForOrganization = "ai_unavailable_for_organization",
  AiUnavailableForSite = "ai_unavailable_for_site",
  AiDisabled = "ai_disabled",
  AiRestricted = "ai_restricted",
  AiPaused = "ai_paused",
}

/** Why a synchronization failed, indicating who can resolve it. `authentication` and `misconfigured` need the connection to be reconfigured; `rate_limited` and `upstream_unavailable` are the source's own limits or downtime and are retried; `unknown` could not be attributed to the source's response. */
export enum ContextConnectionFailureReason {
  Authentication = "authentication",
  Misconfigured = "misconfigured",
  RateLimited = "rate_limited",
  UpstreamUnavailable = "upstream_unavailable",
  Unknown = "unknown",
}

export enum ContextConnectionStatus {
  Pending = "pending",
  Syncing = "syncing",
  Succeeded = "succeeded",
  Failed = "failed",
  Skipped = "skipped",
}

/** Type classification of the user question. */
export enum SiteQuestionType {
  Exploring = "exploring",
  HowTo = "how-to",
  Troubleshooting = "troubleshooting",
  Reference = "reference",
  Unknown = "unknown",
}

/**
 * An action that moves a finding to another state. A finding's `actions` lists the ones it allows.
 *   - `approve` makes the redirect GitBook drafted for a broken link live, which resolves the finding. A change request GitBook drafted for an outbound link is approved by merging it.
 *   - `reject` deletes the redirect GitBook drafted for a broken link; the finding stays open and GitBook won't draft a fix for it again. For an outbound link, it archives the change request GitBook drafted (`awaitingChangeRequest`) and unlinks every link it fixes. They are open again, marked `undone`, and GitBook won't draft a fix for them again.
 *   - `create-redirect` creates a redirect for a broken link's path with `createSiteRedirect`, prefilled with the suggestion; it resolves the finding.
 *   - `mark-resolved` resolves it. A broken link resolved this way has no redirect: visitors still get a 404.
 *   - `reopen` reopens a resolved finding. For a broken link, it deletes the live redirect at its path; for a fix GitBook applied, this undoes the fix and GitBook won't fix the link again.
 *   - `ignore` dismisses it.
 *   - `restore` reopens a dismissed finding.
 */
export enum SiteFindingAction {
  Approve = "approve",
  Reject = "reject",
  CreateRedirect = "create-redirect",
  MarkResolved = "mark-resolved",
  Reopen = "reopen",
  Ignore = "ignore",
  Restore = "restore",
}

/**
 * The field to sort site findings by. `updatedAt` returns the most recently updated findings first. `severity` returns the most severe findings first. `sources` returns the findings with the most linked sources (questions plus records) first. `suggestedFix` is for link findings: those that come with a fix (a suggested redirect, or an outbound link to correct) come before broken URLs the audit found no page for, most severe first within each group. Other finding types sort with the second group. Defaults to 'updatedAt'.
 * @default "updatedAt"
 */
export enum SiteFindingOrderBy {
  UpdatedAt = "updatedAt",
  Severity = "severity",
  Sources = "sources",
  SuggestedFix = "suggestedFix",
}

/** Findings source filter matching evidence coming from site questions. */
export enum SiteTriageFilterQuestions {
  Questions = "questions",
}

/**
 * Where a link finding stands, from its status and what GitBook did with it.
 *   - `open` needs a fix.
 *   - `awaiting-approval` has a fix GitBook drafted, waiting to be approved or rejected: a redirect at a `broken-link` finding's path, or an unmerged change request for an `outbound-link-error` finding (`awaitingChangeRequest`).
 *   - `resolved` was fixed or closed: `servingRedirect` says whether a live redirect serves its path.
 *   - `ignored` was dismissed.
 */
export enum SiteFindingState {
  Open = "open",
  AwaitingApproval = "awaiting-approval",
  Resolved = "resolved",
  Ignored = "ignored",
}

/**
 * What GitBook did on its own to resolve a finding.
 *   - `drafted` drafted a fix that waits for approval.
 *   - `applied` has its fix live, applied on its own or approved from a draft, resolving the finding.
 *   - `undone` had its fix undone or rejected, so GitBook won't try again.
 */
export enum SiteFindingAutoResolution {
  Drafted = "drafted",
  Applied = "applied",
  Undone = "undone",
}

/** Estimated end-user severity of a site finding. */
export enum SiteFindingSeverity {
  Low = "low",
  Medium = "medium",
  High = "high",
}

/**
 * Classification of a site finding:
 *   - Outdated content: The content was correct but is no longer up to date with external context and may be misleading or incorrect.
 *   - Incorrect content: The content is factually wrong or misleading, leading users astray regardless of whether it was ever correct.
 *   - Content gap: The content is missing important information that should be present to answer user questions effectively.
 *   - Broken link: A URL on the site returns a 404, and can be resolved by creating a redirect or a new page.
 *   - Outbound link error: An external URL used by the site's content fails to resolve, and can be fixed by replacing or removing the link.
 *   - Other: Any other type of finding not covered by the above categories.
 */
export enum SiteFindingType {
  ContentOutdated = "content-outdated",
  ContentIncorrect = "content-incorrect",
  ContentGap = "content-gap",
  BrokenLink = "broken-link",
  OutboundLinkError = "outbound-link-error",
  Other = "other",
}

/**
 * Status of a site finding.
 *   - `candidate` is a finding that has been raised but not yet confirmed. Typically these are not shown to users.
 *   - `open` is a finding that has been surfaced to users and is still under investigation.
 *   - `done` is a finding that has been resolved and is no longer under investigation.
 *   - `canceled` is a finding that has been canceled and is no longer under investigation.
 */
export enum SiteFindingStatus {
  Candidate = "candidate",
  Open = "open",
  Done = "done",
  Canceled = "canceled",
}

/** Status of a persisted site scan. */
export enum SiteScanStatus {
  Pending = "pending",
  Running = "running",
  Done = "done",
  Failed = "failed",
}

export enum ContextRecordType {
  Ticket = "ticket",
  Document = "document",
}

/** The surface the agent was running on when it submitted the feedback: the MCP server exposed by the site, or the site assistant. */
export enum AgentFeedbackSource {
  Mcp = "mcp",
  Assistant = "assistant",
}

/** Whether the member is part of the change request, or a tombstone kept so that a member removed and later re-added keeps its identity, comments and history. */
export enum SiteChangeRequestMemberStatus {
  Active = "active",
  Removed = "removed",
}

/** A step of the setup of a site, in the order they are done. */
export enum SiteSetupStepId {
  FirstEdit = "first-edit",
  Customize = "customize",
  GitSync = "git-sync",
  Domain = "domain",
  Publish = "publish",
}

/** The platform of the social handle. */
export enum SiteSocialAccountPlatform {
  Twitter = "twitter",
  Instagram = "instagram",
  Facebook = "facebook",
  Linkedin = "linkedin",
  Github = "github",
  Discord = "discord",
  Slack = "slack",
  Youtube = "youtube",
  Tiktok = "tiktok",
  Reddit = "reddit",
  Bluesky = "bluesky",
  Mastodon = "mastodon",
  Threads = "threads",
  Medium = "medium",
}

/**
 * How external links should open when clicked.
 * - `self`: External links open in the current tab.
 * - `blank`: External links open in a new browser tab.
 */
export enum SiteExternalLinksTarget {
  Self = "self",
  Blank = "blank",
}

/** Type of a built-in page action that can be displayed in the page actions menu of a published page. */
export enum CustomizationPageActionType {
  Assistant = "assistant",
  ExternalAi = "external-ai",
  Markdown = "markdown",
  Mcp = "mcp",
  Git = "git",
  Pdf = "pdf",
}

export enum CustomizationAIMode {
  None = "none",
  Search = "search",
  Assistant = "assistant",
}

export enum CustomizationDefaultThemeMode {
  Light = "light",
  Dark = "dark",
  System = "system",
}

/**
 * The header preset to use for the site. This is a legacy setting and the site styling theme should be used instead.
 * @deprecated
 */
export enum CustomizationHeaderPreset {
  Default = "default",
  Bold = "bold",
  Contrast = "contrast",
  Custom = "custom",
  None = "none",
}

/**
 * Language for the UI element
 * @deprecated
 */
export enum CustomizationLocale {
  En = "en",
  Fr = "fr",
  Es = "es",
  Zh = "zh",
  Ja = "ja",
  De = "de",
  Nl = "nl",
  No = "no",
  PtBr = "pt-br",
  Ru = "ru",
}

/**
 * The style of the search button.
 * - `prominent`: large search bar in the middle of the header, with less room for other header items,
 * - `subtle`: small search bar in the corner of the header, with more room for other header items.
 */
export enum CustomizationSearchStyle {
  Prominent = "prominent",
  Subtle = "subtle",
}

/**
 * - `default`: Simple list items without special styling, groups are inset with a line.
 * - `pill`: Rounded capsule shape around selected/active items.
 * - `line`: Continuous line next to all items, with colored line part for selected/active items.
 */
export enum CustomizationSidebarListStyle {
  Default = "default",
  Pill = "pill",
  Line = "line",
}

/**
 * - `default`: No background, content sits directly against sidebar edge.
 * - `filled`: Muted background color that extends to sidebar edges.
 */
export enum CustomizationSidebarBackgroundStyle {
  Default = "default",
  Filled = "filled",
}

export enum CustomizationCodeTheme {
  DefaultLight = "default-light",
  DefaultDark = "default-dark",
  MonochromeLight = "monochrome-light",
  MonochromeDark = "monochrome-dark",
  Andromeeda = "andromeeda",
  AuroraX = "aurora-x",
  AyuDark = "ayu-dark",
  CatppuccinFrappe = "catppuccin-frappe",
  CatppuccinLatte = "catppuccin-latte",
  CatppuccinMacchiato = "catppuccin-macchiato",
  CatppuccinMocha = "catppuccin-mocha",
  DarkPlus = "dark-plus",
  Dracula = "dracula",
  DraculaSoft = "dracula-soft",
  EverforestDark = "everforest-dark",
  EverforestLight = "everforest-light",
  GithubDark = "github-dark",
  GithubDarkDefault = "github-dark-default",
  GithubDarkDimmed = "github-dark-dimmed",
  GithubDarkHighContrast = "github-dark-high-contrast",
  GithubLight = "github-light",
  GithubLightDefault = "github-light-default",
  GithubLightHighContrast = "github-light-high-contrast",
  GruvboxDarkHard = "gruvbox-dark-hard",
  GruvboxDarkMedium = "gruvbox-dark-medium",
  GruvboxDarkSoft = "gruvbox-dark-soft",
  GruvboxLightHard = "gruvbox-light-hard",
  GruvboxLightMedium = "gruvbox-light-medium",
  GruvboxLightSoft = "gruvbox-light-soft",
  Houston = "houston",
  KanagawaDragon = "kanagawa-dragon",
  KanagawaLotus = "kanagawa-lotus",
  KanagawaWave = "kanagawa-wave",
  Laserwave = "laserwave",
  LightPlus = "light-plus",
  MaterialTheme = "material-theme",
  MaterialThemeDarker = "material-theme-darker",
  MaterialThemeLighter = "material-theme-lighter",
  MaterialThemeOcean = "material-theme-ocean",
  MaterialThemePalenight = "material-theme-palenight",
  MinDark = "min-dark",
  MinLight = "min-light",
  Monokai = "monokai",
  NightOwl = "night-owl",
  Nord = "nord",
  OneDarkPro = "one-dark-pro",
  OneLight = "one-light",
  Plastic = "plastic",
  Poimandres = "poimandres",
  Red = "red",
  RosePine = "rose-pine",
  RosePineDawn = "rose-pine-dawn",
  RosePineMoon = "rose-pine-moon",
  SlackDark = "slack-dark",
  SlackOchin = "slack-ochin",
  SnazzyLight = "snazzy-light",
  SolarizedDark = "solarized-dark",
  SolarizedLight = "solarized-light",
  Synthwave84 = "synthwave-84",
  TokyoNight = "tokyo-night",
  Vesper = "vesper",
  VitesseBlack = "vitesse-black",
  VitesseDark = "vitesse-dark",
  VitesseLight = "vitesse-light",
}

export enum CustomizationIconsStyle {
  Regular = "regular",
  Solid = "solid",
  Duotone = "duotone",
  Light = "light",
  Thin = "thin",
}

/**
 * The background style has been deprecated and will be removed in a future release. Use the `tint` settings instead.
 * @deprecated
 */
export enum CustomizationBackground {
  Plain = "plain",
  Match = "match",
}

export enum CustomizationDefaultMonospaceFont {
  FiraCode = "FiraCode",
  IBMPlexMono = "IBMPlexMono",
  JetBrainsMono = "JetBrainsMono",
  SourceCodePro = "SourceCodePro",
  RobotoMono = "RobotoMono",
  SpaceMono = "SpaceMono",
  DMMono = "DMMono",
  Inconsolata = "Inconsolata",
}

export enum CustomizationDefaultFont {
  ABCFavorit = "ABCFavorit",
  Inter = "Inter",
  Roboto = "Roboto",
  RobotoSlab = "RobotoSlab",
  OpenSans = "OpenSans",
  SourceSansPro = "SourceSansPro",
  Lato = "Lato",
  Ubuntu = "Ubuntu",
  Raleway = "Raleway",
  Merriweather = "Merriweather",
  Overpass = "Overpass",
  NotoSans = "NotoSans",
  IBMPlexSerif = "IBMPlexSerif",
  Poppins = "Poppins",
  FiraSans = "FiraSans",
}

/**
 * The style used for regular links in the main content, header and footer. Sidebar items are styled separately.
 * - `default`: Links are colored in the primary color and feature an underline in the same color.
 * - `accent`: Links are colored the same as body text and feature an underline in the primary color.
 */
export enum CustomizationLinksStyle {
  Default = "default",
  Accent = "accent",
}

/**
 * The degree of visual depth (through shadows, gradients and elevation effects) of elements on the site.
 * - `subtle`: Subtle shadows and minimal elevation.
 * - `flat`: Flat elements, no shadows and no elevation.
 */
export enum CustomizationDepth {
  Subtle = "subtle",
  Flat = "flat",
}

export enum CustomizationCorners {
  Straight = "straight",
  Rounded = "rounded",
  Circular = "circular",
}

/**
 * The theme to apply to the site. Supercedes the old header preset themes.
 * - `clean`: Modern theme featuring translucency and minimally-styled elements.
 * - `muted`: Sophisticated theme with decreased contrast between elements.
 * - `bold`: High-impact theme with prominent colors and strong contrasts.
 * - `gradient`: Trendy theme featuring colorful gradients and splashes of color.
 */
export enum CustomizationTheme {
  Clean = "clean",
  Muted = "muted",
  Bold = "bold",
  Gradient = "gradient",
}

/** The provider of the Git Sync installation. */
export enum GitSyncInstallationProvider {
  Github = "github",
  Gitlab = "gitlab",
}

/** Which side should be treated as the source of truth when Git Sync is configured. */
export enum GitSyncInstallationPriority {
  Git = "git",
  Gitbook = "gitbook",
}

export enum StorageUploadKind {
  CustomizationFont = "customization_font",
  ImportFile = "import_file",
  OrganizationFile = "organization_file",
}

export enum TranslationStatus {
  Pending = "pending",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
}

/** OpenAPI processing error code */
export enum OpenAPISpecProcessingErrorCode {
  FETCH_TIMEOUT = "FETCH_TIMEOUT",
  FETCH_ERROR = "FETCH_ERROR",
  PARSE_ERROR = "PARSE_ERROR",
}

/** Processing state */
export enum OpenAPISpecProcessingState {
  Pending = "pending",
  Progress = "progress",
  Complete = "complete",
}

/** Identity provider that provisions members through the SCIM connection. */
export enum SCIMConnectionProvider {
  Okta = "okta",
  Entra = "entra",
  Generic = "generic",
}

/**
 * Status of the provider.
 * - `active`: The provider is active and can be used to authenticate users.
 * - `pending`: The provider is pending and is not yet fully configured.
 */
export enum SAMLProviderStatus {
  Active = "active",
  Pending = "pending",
}

/** An organization feature used for plan access and upgrade prompts. */
export enum OrganizationFeature {
  MaxMembers = "max-members",
  Ai = "ai",
  AiLens = "ai-lens",
  PdfExport = "pdf-export",
  AiWriting = "ai-writing",
  ReusableContent = "reusable-content",
  Translations = "translations",
  MembersAdvancedRoles = "members-advanced-roles",
  MembersTeams = "members-teams",
  MembersTeamOwners = "members-team-owners",
  SecuritySaml = "security-saml",
  Scim = "scim",
  ChangeRequestsMergeRules = "change-requests-merge-rules",
}

/**
 * UTC calendar interval for AI usage, with weeks starting on Monday.
 * @default "day"
 */
export enum AIUsageInterval {
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
}

export enum BillingSwitchAction {
  Trial = "trial",
  Upgrade = "upgrade",
  UpgradePassive = "upgrade_passive",
  Downgrade = "downgrade",
  SwitchInterval = "switch_interval",
}

/** Where AI credits come from: - `paid`: credits included in the monthly bundle - `bonus`: free credits included with the monthly bundle - `site`: credits from published paid sites - `rollover`: unused paid credits carried over from the previous period - `custom`: credits granted manually by Sales or Support */
export enum AICreditGrantType {
  Paid = "paid",
  Bonus = "bonus",
  Site = "site",
  Rollover = "rollover",
  Custom = "custom",
}

/** Identifier of a billing meter */
export enum BillingMeter {
  AiResponses = "ai_responses",
  AiAgentResponses = "ai_agent_responses",
  TranslationWords = "translation_words",
}

/**
 * "The role of a team member.
 * "owner": Can manage team members.
 * "member": Is a member of the team.
 */
export enum TeamMemberRole {
  Owner = "owner",
  Member = "member",
}

/** Something the user is interested in doing with the site. */
export enum SiteOnboardingInterest {
  AdaptiveContent = "adaptive-content",
  ApiDocs = "api-docs",
  ProactiveAgent = "proactive-agent",
}

/** Who the user wants to be able to access their site. */
export enum SiteOnboardingAudience {
  Public = "public",
  Mixed = "mixed",
  Protected = "protected",
  Internal = "internal",
}

/** Where the user's docs are coming from today. */
export enum SiteOnboardingSource {
  MarkdownInGit = "markdown-in-git",
  Import = "import",
  Template = "template",
}

export enum ContentKitIcon {
  Close = "close",
  Edit = "edit",
  Github = "github",
  Gitlab = "gitlab",
  Maximize = "maximize",
  Email = "email",
  Settings = "settings",
  Search = "search",
  Delete = "delete",
  Star = "star",
  Warning = "warning",
  Link = "link",
  LinkExternal = "link-external",
  Eye = "eye",
  EyeOff = "eye-off",
  Lock = "lock",
  Check = "check",
  CheckCircle = "check-circle",
}

/** A list of all premium customizations. */
export enum SiteCustomizationFeature {
  HeaderLogo = "header-logo",
  HeaderPrimaryLink = "header-primary-link",
  ThemePreset = "theme-preset",
  PremiumFonts = "premium-fonts",
  CustomIcons = "custom-icons",
  FooterLogo = "footer-logo",
  FooterLinks = "footer-links",
  FooterCopyright = "footer-copyright",
  SemanticColors = "semantic-colors",
}

/** The site feature identifier */
export enum SiteFeatureKey {
  SitesAdaptiveContent = "sites-adaptive-content",
  SitesAdvancedCustomization = "sites-advanced-customization",
  SitesAdvancedInsights = "sites-advanced-insights",
  SitesAds = "sites-ads",
  SitesAiSearch = "sites-ai-search",
  SitesAiAssistant = "sites-ai-assistant",
  SitesAiInsights = "sites-ai-insights",
  SitesFixBrokenLinks = "sites-fix-broken-links",
  SitesConnections = "sites-connections",
  SitesContentGaps = "sites-content-gaps",
  SitesChannels = "sites-channels",
  SitesEmbed = "sites-embed",
  SitesApiPlayground = "sites-api-playground",
  SitesBasicCustomization = "sites-basic-customization",
  SitesBrokenLinks = "sites-broken-links",
  SitesCustomDomain = "sites-custom-domain",
  SitesCustomSubdirectory = "sites-custom-subdirectory",
  SitesFullTextSearch = "sites-full-text-search",
  SitesMultivariantSite = "sites-multivariant-site",
  SitesNoCustomDomain = "sites-no-custom-domain",
  SitesPageFeedback = "sites-page-feedback",
  SitesPageTrafficInsights = "sites-page-traffic-insights",
  SitesPdfExport = "sites-pdf-export",
  SitesPreviewDeployments = "sites-preview-deployments",
  SitesPublicVisibility = "sites-public-visibility",
  SitesRedirects = "sites-redirects",
  SitesSearchInsights = "sites-search-insights",
  SitesSections = "sites-sections",
  SitesSeo = "sites-seo",
  SitesShareLinks = "sites-share-links",
  SitesStyleGuide = "sites-style-guide",
  SitesUnlistedVisibility = "sites-unlisted-visibility",
  SitesUserContribution = "sites-user-contribution",
  SitesVisitorAuthentication = "sites-visitor-authentication",
  SitesVisitors = "sites-visitors",
}

/** Topic of the content */
export enum SiteAdsTopic {
  Webdev = "webdev",
  Crypto = "crypto",
}

/**
 * The visibility setting of the site determines the audience of the site.
 * * `public`: Anyone can access the site, and the site is indexed by search engines.
 * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
 * * `share-link`: Anyone with a secret token in the url can access the site.
 * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
 */
export enum SiteVisibility {
  Public = "public",
  Unlisted = "unlisted",
  ShareLink = "share-link",
  VisitorAuth = "visitor-auth",
}

/** The type of the site */
export enum SiteType {
  Basic = "basic",
  Premium = "premium",
  Ultimate = "ultimate",
  Sponsored = "sponsored",
}

export enum PageFeedbackRating {
  Bad = "bad",
  Ok = "ok",
  Good = "good",
}

/** Describe whether all sites have been selected or there's a selection involved */
export enum IntegrationInstallationSiteSelection {
  All = "all",
  Selected = "selected",
}

/** Describe whether all spaces have been selected or there's a selection involved */
export enum IntegrationInstallationSpaceSelection {
  All = "all",
  Selected = "selected",
}

export enum IntegrationInstallationStatus {
  Active = "active",
  Pending = "pending",
  Paused = "paused",
}

/** Source for an organization block */
export enum BlockSource {
  Backoffice = "backoffice",
  External = "external",
  Internal = "internal",
}

/** - notapplicable, no trial can be started for this organization. - none, no trial has been started yet. - active, trial is active. - ended, the trial has ended and the user has choosen to stay on the free plan or has upgraded to a paid plan. - expired, the trial has ended but the user hasn't deciced yet what to do. */
export enum BillingTrialStatus {
  Notapplicable = "notapplicable",
  None = "none",
  Active = "active",
  Ended = "ended",
  Expired = "expired",
}

/** The AI credit bundle to top up every month */
export enum BillingCreditsBundle {
  None = "none",
  Value4750250 = "4750_250",
  Value90001000 = "9000_1000",
  Value127502250 = "12750_2250",
  Value3000010000 = "30000_10000",
}

/** Interval for a billing subscription */
export enum BillingInterval {
  Monthly = "monthly",
  Yearly = "yearly",
}

/** Name of the product */
export enum BillingProduct {
  Free2024 = "free_2024",
  Plus2024 = "plus_2024",
  Pro2024 = "pro_2024",
  Enterprise2024 = "enterprise_2024",
  Community2024 = "community_2024",
  Internal = "internal",
}

export enum OrganizationCommunityType {
  NonProfit = "nonProfit",
  OpenSource = "openSource",
  Education = "education",
}

export enum OrganizationUseCase {
  InternalDocs = "internalDocs",
  DocsSite = "docsSite",
  AudienceControlledSite = "audienceControlledSite",
  ProductDocs = "productDocs",
  TeamKnowledgeBase = "teamKnowledgeBase",
  DesignSystem = "designSystem",
  OpenSourceDocs = "openSourceDocs",
  Notes = "notes",
  Other = "other",
}

export enum OrganizationType {
  Business = "business",
  Community = "community",
}

export enum IntegrationCategory {
  Analytics = "analytics",
  Collaboration = "collaboration",
  Content = "content",
  Marketing = "marketing",
  VisitorAuth = "visitor-auth",
  Other = "other",
}

export enum IntegrationScope {
  SpaceContentRead = "space:content:read",
  SpaceContentWrite = "space:content:write",
  SpaceMetadataRead = "space:metadata:read",
  SpaceMetadataWrite = "space:metadata:write",
  SpaceGitSync = "space:git:sync",
  PageFeedbackRead = "page:feedback:read",
  SiteMetadataRead = "site:metadata:read",
  SiteViewsRead = "site:views:read",
  SiteScriptInject = "site:script:inject",
  SiteScriptCookies = "site:script:cookies",
  SiteVisitorAuth = "site:visitor:auth",
  SiteVisitorClaims = "site:visitor:claims",
  SiteAdaptiveRead = "site:adaptive:read",
  SiteAdaptiveWrite = "site:adaptive:write",
  ConversationsIngest = "conversations:ingest",
  OpenapiRead = "openapi:read",
  OpenapiWrite = "openapi:write",
}

export enum IntegrationVisibility {
  Public = "public",
  Private = "private",
  Unlisted = "unlisted",
}

/** The target on which the integration can operate and needs to be configured for */
export enum IntegrationTarget {
  All = "all",
  Site = "site",
  Space = "space",
  Organization = "organization",
}

/**
 * Why a member is disabled in an organization.
 * "billing": The organization's plan has reached its maximum number of members.
 * "scim": The member was deactivated by the organization's identity provider.
 * "admin": An organization admin disabled the member.
 */
export enum MemberDisabledReason {
  Billing = "billing",
  Scim = "scim",
  Admin = "admin",
}

/** The core layout presets for a page. */
export enum RevisionPageLayoutPreset {
  Docs = "docs",
  Editorial = "editorial",
  Landing = "landing",
}

export enum RevisionPageType {
  Document = "document",
  Group = "group",
  Link = "link",
  Computed = "computed",
}

/** Status of a change request review. */
export enum ChangeRequestReviewStatus {
  ChangesRequested = "changes-requested",
  Approved = "approved",
}

/**
 * The field to sort change requests by. Defaults to 'updatedAt'.
 * @default "updatedAt"
 */
export enum ChangeRequestOrderBy {
  UpdatedAt = "updatedAt",
  CreatedAt = "createdAt",
}

export enum ChangeRequestStatus {
  Draft = "draft",
  Open = "open",
  Archived = "archived",
  Merged = "merged",
}

export enum RevisionPageDocumentCoverTextColor {
  Black = "black",
  White = "white",
}

/** Mask applied to the cover image. */
export enum RevisionPageLayoutOptionsCoverMask {
  None = "none",
  Radial = "radial",
}

/** Size of the cover image. */
export enum RevisionPageLayoutOptionsCoverSize {
  Hero = "hero",
  Full = "full",
  Background = "background",
}

/** Width of the page. */
export enum RevisionPageLayoutOptionsWidth {
  Default = "default",
  Wide = "wide",
}

/**
 * The visibility setting of the OpenAPI spec.
 * * `private`: The spec is not publicly available.
 * * `public`: The spec is available to anyone with a public link.
 */
export enum OpenAPISpecVisibility {
  Private = "private",
  Public = "public",
}

export enum VerticalAlignment {
  Top = "top",
  Middle = "middle",
  Bottom = "bottom",
}

/** Object fit for image display in card views */
export enum CardsImageObjectFit {
  Contain = "contain",
  Fill = "fill",
  Cover = "cover",
}

export enum TextAlignment {
  Start = "start",
  Center = "center",
  End = "end",
}

/** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
export enum DocumentTextColor {
  Default = "default",
  Green = "green",
  Blue = "blue",
  Red = "red",
  Orange = "orange",
  Yellow = "yellow",
  Purple = "purple",
  Pink = "pink",
  Violet = "violet",
  Cyan = "cyan",
  Primary = "$primary",
  Secondary = "$secondary",
  Info = "$info",
  Success = "$success",
  Warning = "$warning",
  Danger = "$danger",
  Tint = "$tint",
}

/**
 * "The role of a member in an organization.
 * "admin": Can administrate the content: create, delete spaces, ...
 * "create": Can create content.
 * "review": Can review content.
 * "edit": Can edit the content (live or change requests).
 * "comment": Can access the content and its discussions.
 * "read": Can access the content, but cannot update it in any way.
 */
export enum MemberRole {
  Admin = "admin",
  Create = "create",
  Edit = "edit",
  Review = "review",
  Comment = "comment",
  Read = "read",
}

export enum GitSyncOperationDirection {
  Export = "export",
  Import = "import",
}

/**
 * * `running`: The operation is still running
 * * `failure`: The operation failed
 * * `success`: The operation was successful
 * * `timeout`: The operation timed out
 */
export enum GitSyncOperationState {
  Running = "running",
  Failure = "failure",
  Success = "success",
  Timeout = "timeout",
}

/** The provider of the Git Sync installation. */
export enum GitSyncProvider {
  Github = "github",
  Gitlab = "gitlab",
  GithubLegacy = "github-legacy",
}

export enum GitSyncInstallationStatus {
  Unauthenticated = "unauthenticated",
  Active = "active",
  Pending = "pending",
}

export enum TranslationLanguage {
  En = "en",
  Fr = "fr",
  De = "de",
  Es = "es",
  It = "it",
  Pt = "pt",
  PtBr = "pt-br",
  Ru = "ru",
  Ja = "ja",
  Zh = "zh",
  ZhTw = "zh-tw",
  Yue = "yue",
  Ko = "ko",
  Ar = "ar",
  Hi = "hi",
  Nl = "nl",
  Pl = "pl",
  Tr = "tr",
  Sv = "sv",
  No = "no",
  Da = "da",
  Fi = "fi",
  El = "el",
  Cs = "cs",
  Hu = "hu",
  Ro = "ro",
  Th = "th",
  Vi = "vi",
  Id = "id",
  Ms = "ms",
  He = "he",
  Uk = "uk",
  Sk = "sk",
  Bg = "bg",
  Hr = "hr",
  Lt = "lt",
  Lv = "lv",
  Et = "et",
  Sl = "sl",
  FrCa = "fr-ca",
  EsMx = "es-mx",
  Es419 = "es-419",
}

/**
 * Determines how a Space can be edited.
 * * `live`: Users can directly edit the space
 * * `locked`: All edits are locked for this space.
 */
export enum SpaceEditMode {
  Live = "live",
  Locked = "locked",
}

/**
 * * `public`: Anyone can access the content, and the content is indexed by search engines.
 * * `unlisted`: Anyone can access the content, and the content is not indexed by search engines
 * * `share-link`: Anyone with a secret token in the url can access the content.
 * * `visitor-auth`: Anyone authenticated through a JWT token can access the content.
 * * `in-collection`: Anyone who can access the parent collection can access the content.
 *   Only available for spaces in a collection.
 * * `private`: Authorized members can access the content.
 */
export enum ContentVisibility {
  Public = "public",
  Unlisted = "unlisted",
  ShareLink = "share-link",
  VisitorAuth = "visitor-auth",
  InCollection = "in-collection",
  Private = "private",
}

/** Data passed through a realtime channel */
export type APIChannelData =
  | APIChannelGitSyncOperationData
  | APIChannelGitSyncSiteOperationData
  | APIChannelTranslationRunData
  | APIChannelImportRunData
  | APIChannelMutationData;

/** Channel to subscribe to for realtime updates. */
export type APIChannel =
  | APIChannelSpaceInfo
  | APIChannelSpaceContent
  | APIChannelSpaceGitInfo
  | APIChannelSpacePublishingAuth
  | APIChannelSpacePublishingCustomization
  | APIChannelSpaceIntegrations
  | APIChannelUserAPITokens
  | APIChannelUserOrganizations
  | APIChannelUserProfile
  | APIChannelChangeRequest
  | APIChannelChangeRequests
  | APIChannelChangeRequestReviews
  | APIChannelCollection
  | APIChannelCollectionPublishingCustomization
  | APIChannelOrganizationInfo
  | APIChannelOrganizationAgentData
  | APIChannelOrganizationInviteLinks
  | APIChannelOrganizationMembers
  | APIChannelOrganizationMember
  | APIChannelOrganizationSAML
  | APIChannelOrganizationTeams
  | APIChannelOrganizationTeam
  | APIChannelOrganizationTeamMembers
  | APIChannelOrganizationTeamMember
  | APIChannelOrganizationSpaces
  | APIChannelOrganizationCollections
  | APIChannelOrganizationIntegrations
  | APIChannelOrganizationInstallations
  | APIChannelOrganizationSites
  | APIChannelOrganizationOpenAPISpecs
  | APIChannelOrganizationTranslations
  | APIChannelOrganizationTranslationsGlossary
  | APIChannelOrganizationSCIMConnections
  | APIChannelOrganizationCustomFonts
  | APIChannelOrganizationAgentInstructions
  | APIChannelOrganizationChangeRequests
  | APIChannelSpaceComments
  | APIChannelChangeRequestComments
  | APIChannelCommentInfo
  | APIChannelCommentReplies
  | APIChannelIntegration
  | APIChannelIntegrationInstallation
  | APIChannelIntegrationSpaceInstallation
  | APIChannelIntegrationSpaceInstallations
  | APIChannelIntegrationSiteInstallation
  | APIChannelIntegrationSiteInstallations
  | APIChannelPublishedContentSite
  | APIChannelSiteRedirects
  | APIChannelSite
  | APIChannelSiteChannels
  | APIChannelSiteContext
  | APIChannelSiteCustomization
  | APIChannelSiteAgentSettings
  | APIChannelSiteIntegrations
  | APIChannelSiteSpace
  | APIChannelSiteSpaceCustomization
  | APIChannelSiteStructure
  | APIChannelSiteAdaptiveSchema
  | APIChannelSitePublishingAuth
  | APIChannelSiteShareLinks
  | APIChannelSiteShareLink
  | APIChannelSiteMcpServers
  | APIChannelSiteMcpServer
  | APIChannelSiteSection
  | APIChannelCustomHostname
  | APIChannelGitSyncInstallation
  | APIChannelGitSyncOperation
  | APIChannelGitSyncSiteOperation
  | APIChannelOpenAPISpec
  | APIChannelSubdomain
  | APIChannelTranslation
  | APIChannelTranslationRun
  | APIChannelImportRun;

/** The plan upgrade that would make a feature available. */
export type FeatureUpgradeRequirement =
  | {
      type: "organization";
      /** An organization feature used for plan access and upgrade prompts. */
      feature: OrganizationFeature;
      /** The internal identifier of the minimum organization plan that includes the feature. The human-readable name is provided in requiredPlanName. */
      requiredPlan: BillingProduct;
      /**
       * The human-readable name of the required organization plan.
       * @example "Pro"
       */
      requiredPlanName: string;
      /**
       * Where an admin may upgrade the organization's plan.
       * @format uri
       */
      url: string;
    }
  | {
      type: "site";
      /** The site feature identifier */
      feature: SiteFeatureKey;
      /** The internal identifier of the minimum site plan that includes the feature. The human-readable name is provided in requiredPlanName. */
      requiredPlan: SiteType;
      /**
       * The human-readable name of the required site plan.
       * @example "Ultimate"
       */
      requiredPlanName: string;
      /**
       * Where an admin may upgrade the site's plan.
       * @format uri
       */
      url: string;
    };

/** An absolute reference to content in GitBook. */
export type ContentLocation =
  | ContentLocationFile
  | ContentLocationURL
  | ContentLocationPage
  | ContentLocationUser
  | ContentLocationCollection
  | ContentLocationSpace
  | ContentLocationReusableContent
  | ContentLocationOpenAPI;

export type PublishedContentRedirect =
  | {
      /** Type of target for the redirect */
      target: "application" | "content";
      redirect: URL;
    }
  | {
      /** Type of target for the redirect */
      target: "external";
      /** ID of the resolved site. */
      site: string;
      redirect: URL;
    };

/** Result of a search */
export type AIToolCallSearchResult =
  | AIToolCallSearchResultPage
  | AIToolCallSearchResultRecord;

export type SiteQuestionAnswerSource =
  | SiteQuestionAnswerSourcePage
  | SiteQuestionAnswerSourceRecord;

/** What the feedback is about. `kind` determines both the shape of the subject and the surface the agent was working through. */
export type AgentFeedbackSubject =
  | AgentFeedbackSubjectMCPTool
  | AgentFeedbackSubjectCliCommand
  | AgentFeedbackSubjectApiEndpoint
  | AgentFeedbackSubjectDocumentation
  | AgentFeedbackSubjectGeneric;

/** Resource targeted by a Git Sync installation. */
export type GitSyncInstallationTarget =
  | {
      /** Type of resource targeted by the Git Sync installation. */
      type: "space";
      /** Unique identifier of the space targeted by the Git Sync installation. */
      spaceId: string;
      /** Unique identifier of the site whose Git Sync installation should manage the space installation. Omit to install Git Sync directly on the space. */
      siteId?: string;
    }
  | {
      /** Type of resource targeted by the Git Sync installation. */
      type: "site";
      /** Unique identifier of the site targeted by the Git Sync installation. */
      siteId: string;
    };

export type SearchAIAnswerSource =
  | SearchAIAnswerSourcePage
  | SearchAIAnswerSourceRecord;

/** Element used as root */
export type ContentKitRootElement =
  | ContentKitBlock
  | ContentKitModal
  | ContentKitConfiguration;

/** Any element that is inline. */
export type ContentKitInlineElement =
  | ContentKitText
  | ContentKitImage
  | ContentKitLink;

/** Any element that can be used as children. */
export type ContentKitDescendantElement =
  | ContentKitButton
  | ContentKitTextInput
  | ContentKitHStack
  | ContentKitVStack
  | ContentKitBox
  | ContentKitDivider
  | ContentKitWebFrame
  | ContentKitCodeBlock
  | ContentKitMarkdown
  | ContentKitCard
  | ContentKitImage
  | ContentKitInput
  | ContentKitSelect
  | ContentKitSwitch
  | ContentKitCheckbox
  | ContentKitRadio
  | ContentKitText
  | ContentKitHint
  | ContentKitLink
  | ContentKitStepperStep;

/** Any event that can be received from GitBook. */
export type Event =
  | InstallationSetupEvent
  | InstallationDeletedEvent
  | SpaceInstallationSetupEvent
  | SpaceInstallationDeletedEvent
  | SiteInstallationSetupEvent
  | SiteInstallationDeletedEvent
  | SiteViewEvent
  | SpaceContentUpdatedEvent
  | SpaceGitSyncCompletedEvent
  | SpaceGitSyncStartedEvent
  | SpaceVisibilityUpdatedEvent
  | TaskEvent
  | FetchEvent
  | FetchPublishedScriptEvent
  | FetchVisitorAuthenticationEvent
  | UIRenderEvent
  | ContentComputeDocumentEvent
  | ContentComputeRevisionEvent
  | PageFeedbackEvent;

/** An outcome of a content change. */
export type ChangeRequestContentUpdateChange =
  | ({
      object: "created_page";
    } & ChangeRequestContentUpdateInsertedPage)
  | ({
      object: "updated_page";
    } & ChangeRequestContentUpdateUpdatedPage)
  | ({
      object: "deleted_page";
    } & ChangeRequestContentUpdateDeletedPage);

export type ChangeRequestContentChange =
  | ({
      operation: "update_page";
    } & ChangeRequestContentChangeUpdatePage)
  | ({
      operation: "insert_page";
    } & ChangeRequestContentChangeInsertPage)
  | ({
      operation: "delete_page";
    } & ChangeRequestContentChangeDeletePage)
  | ({
      operation: "revert_page";
    } & ChangeRequestContentChangeRevertPage)
  | ({
      operation: "insert_files";
    } & ChangeRequestContentChangeInsertFiles)
  | ({
      operation: "insert_computed_page";
    } & ChangeRequestContentChangeInsertComputedPage)
  | ({
      operation: "insert_reusable_contents";
    } & ChangeRequestContentChangeInsertReusableContents)
  | ({
      operation: "update_reusable_content";
    } & ChangeRequestContentChangeUpdateReusableContent)
  | ({
      operation: "delete_reusable_content";
    } & ChangeRequestContentChangeDeleteReusableContent)
  | ({
      operation: "insert_variables";
    } & ChangeRequestContentChangeInsertVariables)
  | ({
      operation: "update_variable";
    } & ChangeRequestContentChangeUpdateVariable)
  | ({
      operation: "delete_variable";
    } & ChangeRequestContentChangeDeleteVariable)
  | ({
      operation: "insert_tags";
    } & ChangeRequestContentChangeInsertTags)
  | ({
      operation: "update_tag";
    } & ChangeRequestContentChangeUpdateTag)
  | ({
      operation: "delete_tag";
    } & ChangeRequestContentChangeDeleteTag);

export type Revision =
  | RevisionTypeEdits
  | RevisionTypeMerge
  | RevisionTypeRollback
  | RevisionTypeUpdate
  | RevisionTypeComputed;

export type RevisionPage =
  | RevisionPageDocument
  | RevisionPageGroup
  | RevisionPageLink
  | RevisionPageComputed;

export interface ApiInformation {
  /** Current release of GitBook */
  version: string;
  /** Date of the latest release in ISO format */
  build: string;
}

export interface User {
  /** Type of Object, always equals to "user" */
  object: "user";
  /** Unique identifier for the user */
  id: string;
  /** Full name for the user */
  displayName: string;
  /** Email address of the user */
  email?: string;
  /** URL of the user's profile picture */
  photoURL?: string;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the user in the API
     * @format uri
     */
    location: string;
  };
}

/** Identity of the token used to authenticate the request. */
export interface UserTokenInfo {
  object: "user-token-info";
  /** The user ID the token belongs to. */
  userId: string;
  /** The type of token used to authenticate the request. */
  tokenType: "personal-api-token" | "oauth-token";
  /** The OAuth client the token was issued to. Only present for OAuth tokens. */
  oauthClient?: {
    /** The OAuth client ID. */
    id: string;
    /** The OAuth client name. */
    name: string;
  };
}

export interface APITemporaryToken {
  /** Temporary access token to authenticate with the API */
  token: string;
}

export interface List {
  next?: {
    /** Unique identifier to query the next results page */
    page: string;
  };
  /** Total count of objects in the list */
  count?: number;
}

/** @maxLength 50 */
export type APITokenLabel = string;

/** @format date-time */
export type Timestamp = string;

/** The API token details, excluding the token itself. */
export interface UserAPIToken {
  /** The API token ID. */
  id: string;
  /** A descriptive label for the API token. */
  label: APITokenLabel;
  /** The API token creation date. */
  createdAt: Timestamp;
}

/** The API token details, including the token itself. */
export type UserAPITokenExtended = UserAPIToken & {
  /** The actual token value. */
  token: string;
};

/**
 * @format uri
 * @maxLength 2048
 */
export type URL = string;

/**
 * A unique entity identifier
 * @pattern ^[a-zA-Z0-9_-]+$
 */
export type EntityId = string;

/**
 * Title of the space
 * @maxLength 50
 */
export type SpaceTitle = string;

/**
 * Unicode codepoint or character of the emoji
 * @format emoji
 * @maxLength 50
 * @example "🎉"
 */
export type Emoji = string;

/** The merge rules inherits from the organization configuration. */
export interface MergeRulesConfigurationInherit {
  type: "inherit";
}

/**
 * Expression to evaluate
 * @minLength 0
 * @maxLength 1024
 */
export type Expression = string;

/** The merge rule is written in the advanced custom expression syntax. */
export type MergeRule =
  | {
      rule: "require_specific_reviewers";
      /** List of user IDs. */
      users: string[];
    }
  | {
      rule: "require_one_of_specific_reviewers";
      /** List of user IDs. */
      users: string[];
    }
  | {
      rule: "allow_bypass";
      /** List of user IDs. */
      users: string[];
    }
  | {
      rule:
        | "require_at_least_one_review"
        | "require_at_least_one_approved_review"
        | "require_all_reviews_approved"
        | "require_agent_review"
        | "require_up_to_date_change_request"
        | "require_change_request_subject"
        | "require_change_request_description"
        | "require_author_to_merge";
    }
  | {
      rule: "custom";
      /** Expression to evaluate */
      expression: Expression;
      /** Optional message to display when the expression evaluates to false. */
      message?: string;
    };

/** The merge rules are composed of individual rules that must all pass. */
export interface MergeRulesConfigurationRules {
  type: "rules";
  rules: MergeRule[];
}

/** The merge rules are disabled, change requests can be merged without review. */
export interface MergeRulesConfigurationNone {
  type: "none";
}

export type MergeRulesStandaloneConfiguration =
  | MergeRulesConfigurationRules
  | MergeRulesConfigurationNone;

export type MergeRulesSpaceConfiguration =
  | MergeRulesConfigurationInherit
  | MergeRulesStandaloneConfiguration;

/** An action the user can take to resolve a failed Git Sync operation. */
export interface GitSyncOperationErrorAction {
  /** Label for the action. */
  label: string;
  /**
   * URL where the user can resolve the failure.
   * @format uri
   */
  url: string;
}

export interface GitSyncState {
  /** Repository name. */
  repoName?: string;
  installationStatus: GitSyncInstallationStatus;
  /** The provider of the Git Sync installation. */
  installationProvider: GitSyncProvider;
  /**
   * The integration name providing the Git Sync.
   * @deprecated
   */
  integration?: string;
  /** The ID of the Git Sync installation. */
  installationId: string;
  /** The ID of the parent Git Sync installation, if any. */
  parentInstallationId?: string;
  /** The URL to the repository tree, used when rendering public content. */
  url?: string;
  /** Directory in the repository this content syncs from, resolved against the parent installation when the installation is managed by a site. Absent when the content syncs from the root of the repository. */
  installationProjectDirectory?: string;
  /** The latest operation on the Git Sync installation. */
  operation?: {
    /**
     * * `running`: The operation is still running
     * * `failure`: The operation failed
     * * `success`: The operation was successful
     * * `timeout`: The operation timed out
     */
    state: GitSyncOperationState;
    direction: GitSyncOperationDirection;
    startedAt: Timestamp;
    endedAt?: Timestamp;
    /** Why the operation failed, when it did. */
    error?: string;
    /** An action the user can take to resolve a failed Git Sync operation. */
    errorAction?: GitSyncOperationErrorAction;
  };
  /** How long an operation is allowed to run before it is terminated (in milliseconds). */
  operationTimeout?: number;
  /** When the Git provider details were last updated */
  updatedAt?: Timestamp;
}

/** What is still known about a target's Git Sync after its installation was removed. Never returned alongside `gitSync`, which describes a live installation. */
export interface PreviousGitSyncState {
  /** The URL to the directory of the repository tree the content synced with before its Git Sync installation was removed, at the branch it synced. */
  url: string;
}

export type ContentImportSource =
  | {
      type: "website";
      url: URL;
    }
  | {
      type: "file";
      /**
       * Files to import
       * @maxItems 50
       */
      files: string[];
    };

export interface ContentImportTarget {
  /** ID of the space to import in */
  space: string;
  /** ID of the change request to import in */
  changeRequest?: string;
  /** ID of the page to import in */
  page?: string;
}

export interface ContentImportRun {
  /** Type of Object, always equals to "import-run" */
  object?: "import-run";
  /** Unique ID of the import */
  id: string;
  /** Date when the import has started */
  startedAt?: Timestamp;
  /** Filled when the imported is in status "completed" */
  completedAt?: Timestamp;
  /** Date when the import was requested */
  createdAt?: Timestamp;
  /** Date when the import was last updated */
  updatedAt?: Timestamp;
  /** Status of the import */
  status: "pending" | "in-progress" | "completed" | "failed" | "cancelled";
  /** Reason for the import failure when `status` is `failed`. */
  reason?: string;
  /** Where the content is imported from. */
  source?: ContentImportSource;
  /** Where the content is imported into. */
  target?: ContentImportTarget;
  /** ID of the site the target space belongs to, when it belongs to exactly one. */
  site?: string;
  /** ID of the user who started the import. */
  createdBy?: string;
  /** URLs associated with the object */
  urls?: {
    /**
     * URL of the import run in the API
     * @format uri
     */
    location: string;
  };
  /** Pages included in the import */
  pages?: {
    /** ID of page */
    id: string;
    /** Source URL where the page has been imported from */
    sourceURL?: string;
    /** Type of page */
    type: "page" | "folder";
    /** Status of the page */
    status: "complete" | "pending";
  }[];
}

/** Custom backend for authenticated access */
export interface VisitorAuthCustomBackend {
  /** Custom backend for authenticated access */
  backend: "custom";
}

/** Integration backend for authenticated access */
export interface VisitorAuthIntegrationBackend {
  /** Integration as backend for authenticated access */
  backend: "integration";
}

export type VisitorAuth =
  | VisitorAuthCustomBackend
  | (VisitorAuthIntegrationBackend & {
      /** Name of integration being used as the backend for authenticated access */
      integration: string;
    });

/** The role of a member in an organization, null for guests */
export type MemberRoleOrGuest = MemberRole | null;

/** Default level for a piece of content */
export type DefaultLevel = MemberRoleOrGuest | "inherit";

export interface Space {
  /** Type of Object, always equals to "space" */
  object: "space";
  /** Unique identifier for the space */
  id: string;
  /** Title of the space */
  title: SpaceTitle;
  /** An emoji for this space. It'll match the emoji shown in the GitBook app. */
  emoji: Emoji;
  /**
   * * `public`: Anyone can access the content, and the content is indexed by search engines.
   * * `unlisted`: Anyone can access the content, and the content is not indexed by search engines
   * * `share-link`: Anyone with a secret token in the url can access the content.
   * * `visitor-auth`: Anyone authenticated through a JWT token can access the content.
   * * `in-collection`: Anyone who can access the parent collection can access the content.
   *   Only available for spaces in a collection.
   * * `private`: Authorized members can access the content.
   */
  visibility: ContentVisibility;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  deletedAt?: Timestamp;
  /**
   * Determines how a Space can be edited.
   * * `live`: Users can directly edit the space
   * * `locked`: All edits are locked for this space.
   */
  editMode?: SpaceEditMode;
  /** Kind of space. Only set to `styleguide` for spaces holding a team's writing style guide; omitted for regular spaces. */
  type?: "styleguide";
  mergeRules: MergeRulesSpaceConfiguration;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the space in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the space in the application
     * @format uri
     */
    app: string;
    /**
     * URL of the published version of the space. Only defined when visibility is not "private."
     * @format uri
     */
    published?: string;
    /**
     * URL of the public version of the space. Only defined when visibility is "public".
     * @format uri
     */
    public?: string;
    /** URL of the icon of this space, if defined. */
    icon?: URL;
  };
  /** ID of the organization owning this space */
  organization: string;
  /** ID of the parent collection. */
  parent?: string;
  language?: TranslationLanguage;
  gitSync?: GitSyncState;
  /** What is still known about a target's Git Sync after its installation was removed. Never returned alongside `gitSync`, which describes a live installation. */
  previousGitSync?: PreviousGitSyncState;
  /** Import runs targeting this space, still running or ended recently, most recent first. Only returned when fetching a single space. */
  imports?: ContentImportRun[];
  visitorAuth?: VisitorAuth;
  /** ID of the active revision in the space. */
  revision: string;
  /** Default level for a piece of content */
  defaultLevel: DefaultLevel;
  /** Count of opened comments on the space. */
  comments: number;
  /** Total count of change requests on the space. */
  changeRequests: number;
  /** Count of open change requests on the space. */
  changeRequestsOpen: number;
  /** Count of draft change requests on the space. */
  changeRequestsDraft: number;
  /** Whether the space is powered by V2 of the content system. */
  internal_poweredByV2?: boolean;
  /** Whether the space uses a single websocket connection for all real-time communication. */
  internal_singleWebsocket?: boolean;
  /** The set of permissions for the space */
  permissions: {
    /** Can the user view the space content. */
    view: boolean;
    /** Can the user access the space in the application. */
    access: boolean;
    /** Can the user edit the title, install integrations, and manage the space. */
    admin: boolean;
    /** Can the user view the invite links of the space. */
    viewInviteLinks: boolean;
    /** Can the user edit the content of the space by creating a change request. */
    edit: boolean;
    /** Can the user trigger a git sync. */
    triggerGitSync: boolean;
    /** Can the user comment on the content. */
    comment: boolean;
    /** Can the user merge change requests. */
    merge: boolean;
    /** Can the user review change requests. */
    review: boolean;
    /** Can the user install integrations in the space. */
    installIntegration: boolean;
  };
}

export interface SpacePointer {
  type: "space";
  /** Unique identifier for the space */
  space: string;
}

export interface CollectionPointer {
  type: "collection";
  /** Unique identifier for the collection */
  collection: string;
}

/** Position at which to insert an item */
export interface ContentPosition {
  before?: SpacePointer | CollectionPointer;
  after?: SpacePointer | CollectionPointer;
}

/** Format the custom block as a codeblock */
export type IntegrationBlockMarkdown = {
  /** Code block syntax to use to identify the block. */
  codeblock: string;
  /** Key of the property to use as body of the codeblock. */
  body: string;
};

export interface IntegrationBlock {
  /** Unique ID in the integration for the block. It also represents the UI component used. */
  id: string;
  /**
   * Short descriptive title for the block.
   * @minLength 2
   * @maxLength 40
   */
  title: string;
  /**
   * Long descriptive text for the block.
   * @minLength 0
   * @maxLength 150
   */
  description?: string;
  /** URL of the icon to represent this block. */
  icon?: string;
  /** URLs patterns to convert as this block. */
  urlUnfurl?: string[];
  /** Format the custom block as a codeblock */
  markdown?: IntegrationBlockMarkdown;
}

export type Embed = {
  title: string;
  site: string;
  icon?: string;
} & (
  | {
      type: "link";
    }
  | {
      type: "rich";
      html: string;
    }
  | {
      type: "integration";
      /** The identifier of the integration performing the rendering */
      integration: string;
      block: IntegrationBlock;
    }
);

/**
 * Relevance score for a search result. Higher is better and the score is unbounded.
 * @min 0
 */
export type SearchResultScore = number;

/** Search result representing a section in a page. */
export interface SearchSectionResult {
  id: string;
  title: string;
  path: string;
  /** Relevance score for a search result. Higher is better and the score is unbounded. */
  score: SearchResultScore;
  /** Whether the result matched on the page fields (title, description) or on the section content. When "page", the section is an arbitrary section of the matching page. */
  resultType?: "page" | "section";
  body: string;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the section in the application
     * @format uri
     */
    app: string;
  };
}

/** Search result representing a page in a space. */
export interface SearchPageResult {
  id: string;
  title: string;
  /** Description of the page, suitable for presenting a page-root search destination. */
  description: string;
  path: string;
  /** Relevance score for a search result. Higher is better and the score is unbounded. */
  score: SearchResultScore;
  /**
   * One-based position in the globally ranked result set, preserved when results are paginated and grouped by space.
   * @min 1
   */
  rank: number;
  /** Whether the page matched on its own fields (title, description) or on the content of one of its sections. */
  resultType?: "page" | "section";
  sections?: SearchSectionResult[];
  /** Data about the ancestors of the current page, from top-level to direct parent. */
  ancestors: {
    title: string;
  }[];
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the page in the application
     * @format uri
     */
    app: string;
  };
}

/** Update metadata about the Git provider on the space */
export interface UpdateSpaceGitInfo {
  /** The git provider */
  provider?: "github" | "gitlab";
  /** The repository's tree URL */
  url?: string;
}

export interface ImportGitRepository {
  /** URL of the Git repository to import. It can contain basic auth credentials. */
  url: string;
  /** Git ref to import in the format "refs/heads/main" */
  ref: string;
  /**
   * Unique identifier to use to cache the Git repository across multiple operations.
   * @deprecated
   */
  repoCacheID?: string;
  /** URL to use as a prefix for external file references. */
  repoTreeURL?: string;
  /** URL to use as a prefix for the commit URL. */
  repoCommitURL?: string;
  /** Path to a root directory for the project in the repository. */
  repoProjectDirectory?: string;
  /** The timestamp of the event that triggered this import. It ensures that Git sync import and export operations are executed in the same order on GitBook and on the remote repository. */
  timestamp?: Timestamp;
  force?: boolean;
  /** If true, the import will generate a revision without updating the space primary content. */
  standalone?: boolean;
  /**
   * Optional metadata to store on the space about the Git provider
   * @deprecated
   */
  gitInfo?: UpdateSpaceGitInfo;
}

export interface ExportToGitRepository {
  /** URL of the Git repository to export to. It can contain basic auth credentials. */
  url: string;
  /** Git ref to push the commit to in the format "refs/heads/main" */
  ref: string;
  /** Message for the commit generated by the export */
  commitMessage: string;
  /**
   * Unique identifier to use to cache the Git repository across multiple operations.
   * @deprecated
   */
  repoCacheID?: string;
  /** URL to use as a prefix for external file references. */
  repoTreeURL?: string;
  /** URL to use as a prefix for the commit URL. */
  repoCommitURL?: string;
  /** Path to a root directory for the project in the repository. */
  repoProjectDirectory?: string;
  /** The timestamp of the event that triggered this export. It ensures that Git sync import and export operations are executed in the same order on GitBook and on the remote repository. */
  timestamp?: Timestamp;
  force?: boolean;
  /** If true, the export will be done in a standalone mode, meaning that the exported content will not be linked to the Git repository. This is useful for creating a snapshot of the space's content. */
  standalone?: boolean;
  /**
   * Optional metadata to store on the space about the Git provider
   * @deprecated
   */
  gitInfo?: UpdateSpaceGitInfo;
}

export type InviteUsersAndTeams = (
  | {
      /** @minItems 1 */
      teams: string[];
    }
  | {
      /** @minItems 1 */
      users: string[];
    }
) & {
  /** Role to set. */
  role: MemberRoleOrGuest;
};

/** Permission of a user in a content. */
export interface UserContentPermission {
  /**
   * "The role of a member in an organization.
   * "admin": Can administrate the content: create, delete spaces, ...
   * "create": Can create content.
   * "review": Can review content.
   * "edit": Can edit the content (live or change requests).
   * "comment": Can access the content and its discussions.
   * "read": Can access the content, but cannot update it in any way.
   */
  permission: MemberRole;
  user: User;
}

/**
 * Title of the team
 * @minLength 1
 * @maxLength 64
 */
export type OrganizationTeamTitle = string;

export interface OrganizationTeam {
  /** Type of Object, always equals to "team" */
  object: "team";
  /** Unique identifier for the team. */
  id: string;
  /** Title of the team */
  title: OrganizationTeamTitle;
  /** Count of members in this team. */
  members: number;
  /** Count of spaces this team has access to. */
  spaces: number;
  /** Date at which the team was created. */
  createdAt: Timestamp;
  /** The set of permissions for the team */
  permissions: {
    /** Can the user manage the team */
    admin: boolean;
    /** Can the user view the team and list its members */
    view: boolean;
  };
}

/**
 * Name of the icon
 * @format icon
 * @maxLength 50
 * @example "gear"
 */
export type Icon = string;

export interface RevisionPageBase {
  /** Unique identifier for the page in the revision */
  id: string;
  /**
   * Title of the page
   * @minLength 1
   */
  title: string;
  /**
   * Optional custom title for the page ToC and mention entries instead of the page title.
   * @minLength 1
   * @maxLength 100
   */
  linkTitle?: string;
  /** Emoji of the page, if one has been set. */
  emoji?: Emoji;
  /** Icon of the page, if one has been set. */
  icon?: Icon;
  /** When the page was first created. Only present if page has been edited at least once. */
  createdAt?: Timestamp;
  /** When the page was last edited. Only present if page has been edited at least once. */
  updatedAt?: Timestamp;
  /**
   * Adaptive-content condition controlling whether the page is shown to a visitor. Only present when the page has a condition set, and only returned when the API is called with a user, user-internal or OAuth token (never with a site/content token).
   * @minLength 1
   */
  condition?: string;
}

export interface MarkdownDocument {
  /**
   * Content of the document formatted as markdown
   * @example "# Hello World
   *
   * This is a markdown document linking to [another page](/pages/page_id).
   * "
   */
  markdown: string;
}

export interface DocumentMarkBold {
  object: "mark";
  type: "bold";
}

export interface DocumentMarkItalic {
  object: "mark";
  type: "italic";
}

export interface DocumentMarkCode {
  object: "mark";
  type: "code";
}

export interface DocumentMarkKeyboard {
  object: "mark";
  type: "keyboard";
}

export interface DocumentMarkStrikethrough {
  object: "mark";
  type: "strikethrough";
}

export interface DocumentMarkColor {
  object: "mark";
  type: "color";
  data: {
    /** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
    text: DocumentTextColor;
    /** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
    background: DocumentTextColor;
  };
}

export interface DocumentMarkSuperscript {
  object: "mark";
  type: "superscript";
}

export interface DocumentMarkSubscript {
  object: "mark";
  type: "subscript";
}

export type DocumentTextMark =
  | DocumentMarkBold
  | DocumentMarkItalic
  | DocumentMarkCode
  | DocumentMarkKeyboard
  | DocumentMarkStrikethrough
  | DocumentMarkColor
  | DocumentMarkSuperscript
  | DocumentMarkSubscript;

export interface DocumentTextLeaf {
  object: "leaf";
  text: string;
  marks: DocumentTextMark[];
}

export interface DocumentText {
  object: "text";
  key?: string;
  leaves: DocumentTextLeaf[];
}

export interface ContentRefURL {
  kind: "url";
  url: string;
}

export interface ContentRefFile {
  kind: "file";
  file: string;
  /** ID of the space the file is in. The file is considered as in the current space if none is provided. */
  space?: string;
}

export interface DocumentInlineImage {
  object: "inline";
  type: "inline-image";
  key?: string;
  data: {
    ref: ContentRefURL | ContentRefFile;
    refDark?: ContentRefURL | ContentRefFile;
    caption?: string;
    alt?: string;
    size?: "original" | "line";
  };
  isVoid: true;
}

export interface DocumentInlineMath {
  object: "inline";
  type: "inline-math";
  key?: string;
  data: {
    formula: string;
  };
  isVoid: true;
}

export interface DocumentInlineExpression {
  object: "inline";
  type: "expression";
  key?: string;
  data: {
    expression: string;
  };
  isVoid: true;
}

export interface ContentRefPage {
  kind: "page";
  page: string;
  /** ID of the space the page is in. The page is considered as in the current space if none is provided. */
  space?: string;
}

export interface ContentRefAnchor {
  kind: "anchor";
  anchor: string;
  /** ID of the space the page is in. The page is considered as in the current space if none is provided. */
  space?: string;
  /** ID of the page the anchor is in. The anchor is considered as in the current page if none is provided. */
  page?: string;
}

export interface ContentRefUser {
  kind: "user";
  user: string;
}

export interface ContentRefCollection {
  kind: "collection";
  collection: string;
}

export interface ContentRefSpace {
  kind: "space";
  space: string;
}

export interface ContentRefReusableContent {
  kind: "reusable-content";
  reusableContent: string;
  /** The space in which the reusable content is defined. If undefined, the reusable content is assumed to be in the same space as the content reference. */
  space?: string;
}

export interface ContentRefTag {
  kind: "tag";
  /** The slug of the tag, also used as the ID, and references the tags defined on a revision. */
  tag: string;
  /** The space in which the tag is defined. If undefined, the tag is assumed to be in the same space as the content reference. */
  space?: string;
}

export interface ContentRefOpenAPI {
  kind: "openapi";
  /** Slug of the OpenAPI specification */
  spec: string;
}

/** A relative reference to content in GitBook. */
export type ContentRef =
  | ContentRefFile
  | ContentRefURL
  | ContentRefPage
  | ContentRefAnchor
  | ContentRefUser
  | ContentRefCollection
  | ContentRefSpace
  | ContentRefReusableContent
  | ContentRefTag
  | ContentRefOpenAPI;

export interface DocumentInlineMention {
  object: "inline";
  type: "mention";
  key?: string;
  data: {
    /** A relative reference to content in GitBook. */
    ref: ContentRef;
  };
  isVoid: true;
}

export interface DocumentInlineLink {
  object: "inline";
  type: "link";
  key?: string;
  nodes: (
    | DocumentText
    | DocumentInlineImage
    | DocumentInlineMath
    | DocumentInlineExpression
    | DocumentInlineMention
  )[];
  data: {
    /** A relative reference to content in GitBook. */
    ref: ContentRef;
  };
  isVoid?: false;
}

export interface DocumentInlineEmoji {
  object: "inline";
  type: "emoji";
  key?: string;
  data: {
    code: string;
  };
  isVoid: true;
}

export interface DocumentInlineIcon {
  object: "inline";
  type: "icon";
  key?: string;
  data: {
    icon: string;
    /** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
    color?: DocumentTextColor;
  };
  isVoid: true;
}

export interface DocumentBlockParagraph {
  object: "block";
  type: "paragraph";
  key?: string;
  nodes: (DocumentInline | DocumentText)[];
  isVoid?: false;
  data?: {
    align?: TextAlignment;
  };
}

export type DocumentInline =
  | DocumentInlineLink
  | DocumentInlineEmoji
  | DocumentInlineIcon
  | DocumentInlineExpression
  | DocumentInlineMath
  | DocumentInlineImage
  | DocumentInlineAnnotation
  | DocumentInlineMention
  | DocumentInlineButton;

export interface DocumentBlockHeading {
  object: "block";
  type: "heading-1" | "heading-2" | "heading-3";
  key?: string;
  nodes: (DocumentInline | DocumentText)[];
  data: {
    /** @pattern ^[-a-z0-9.+_]+$ */
    id?: string;
    align?: TextAlignment;
  };
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
  isVoid?: false;
}

export type DocumentBlocksEssentials =
  | DocumentBlockParagraph
  | DocumentBlockHeading
  | DocumentBlockListOrdered
  | DocumentBlockListUnordered
  | DocumentBlockListTasks
  | DocumentBlockDivider;

export interface DocumentInlineAnnotation {
  object: "inline";
  type: "annotation";
  key?: string;
  fragments: (DocumentFragment & {
    type: "annotation-body";
    /** @minItems 1 */
    nodes: (DocumentBlocksEssentials | DocumentBlockCode)[];
  })[];
  isVoid: false;
  nodes: DocumentText[];
  data?: object;
}

export interface DocumentBlockCodeLine {
  object: "block";
  type: "code-line";
  key?: string;
  nodes: (DocumentText | DocumentInlineAnnotation | DocumentInlineExpression)[];
  data: {
    highlighted?: boolean;
  };
  isVoid?: false;
}

export interface DocumentBlockCode {
  object: "block";
  type: "code";
  key?: string;
  data: {
    syntax?: string;
    title?: string;
    /** @default "scroll" */
    overflow?: "scroll" | "wrap";
    lineNumbers?: boolean;
    fullWidth?: boolean;
    expandable?: boolean;
    /**
     * Number of lines rendered in a code block when it is collapsed
     * @min 1
     * @default 10
     */
    collapsedLineCount?: number;
  };
  nodes: DocumentBlockCodeLine[];
  isVoid?: false;
}

export interface DocumentFragment {
  object: "fragment";
  key?: string;
  fragment?: string;
  type?: string;
  nodes: DocumentBlock[];
}

export interface DocumentBlockEmbed {
  object: "block";
  type: "embed";
  key?: string;
  data: {
    url: string;
    fullWidth?: boolean;
  };
  fragments?: (DocumentFragment & {
    fragment: "caption";
    nodes: DocumentBlockParagraph[];
  })[];
  isVoid: true;
}

export type PlainObject = any;

/** Action to open an overlay modal defined by "componentId". */
export type ContentKitDefaultAction =
  | {
      action: "@ui.modal.open";
      componentId: string;
      props: PlainObject;
    }
  | {
      action: "@ui.modal.close";
      returnValue: PlainObject;
    }
  | {
      action: "@ui.url.open";
      url: string;
    }
  | {
      action: "@link.unfurl";
      url: string;
    }
  | {
      action: "@editor.node.updateProps";
      props: PlainObject;
    };

/** Custom action to re-render the block. */
export type ContentKitAction =
  | {
      action: string;
      [key: string]: any;
    }
  | ContentKitDefaultAction;

export interface DocumentBlockIntegration {
  object: "block";
  type: "integration";
  key?: string;
  data: {
    /** Name of the integration */
    integration: string;
    /** ID of the block in the integration */
    block: string;
    /** Properties passed to the block during rendering */
    props: PlainObject;
    /** Custom action to re-render the block. */
    action?: ContentKitAction;
    /**
     * URL associated with the content represented by the block.
     * This property is set when creating a block from a URL (unfurl) to ensure
     * we can convert the block back to an embed.
     */
    url?: string;
    fullWidth?: boolean;
  };
  isVoid: true;
  meta?: {
    /** A content token that can be used to authenticate requests for cross-space integration blocks. */
    token?: string;
    /** ID of the space the integration block originates from */
    spaceId?: string;
  };
}

export interface DocumentTableViewGrid {
  type: "grid";
  /** Ordered list of the definition IDs to display */
  columns: string[];
  /** Percent width of each column */
  columnWidths?: Record<string, number>;
  /** Should we display the header with column titles */
  hideHeader: boolean;
  /** Should we keep the table header sticky while the page scrolls */
  stickyHeader?: boolean;
  /** Should we keep the first visible table column sticky while horizontally scrolling */
  stickyFirstColumn?: boolean;
  /**
   * Tables in GitBook originally used a scaled width approach i.e. the width defined
   * in columnWidths would be scaled to ensure a 100% width table.
   *
   * We later changed this to treat the widths in columnWidths as exact values - they are
   * never scaled. A columnWidth of 50 is rendered as 50px.
   *
   * In order to maintain backwards compatibility, we track whether or not we
   * use the new system here.
   *
   * All new tables should have this value set to true, older tables will have it set
   * to undefined.
   */
  useNewSizing?: boolean;
}

export interface DocumentTableViewCards {
  type: "cards";
  /** Size of the cards. It indicates how many columns will be used */
  cardSize: "medium" | "large";
  /** Ordered list of the definition IDs to display */
  columns: string[];
  /** Definition ID to use as a target link for the card */
  targetDefinition?: string;
  /** Definition ID to use as a cover image */
  coverDefinition?: string;
  /** Definition ID to use as a dark mode cover image */
  coverDefinitionDark?: string;
  /** Should we display the column title or not */
  hideColumnTitle?: boolean;
  /** Whether the cards wrap onto multiple rows (true, the default) or are laid out in a single horizontally-scrolling carousel row (false). */
  wrap?: boolean;
}

/** A table record value for image columns, supporting both direct ContentRefs and the additional format with record-level settings. */
export type DocumentTableImageRecord =
  | ContentRefFile
  | ContentRefURL
  | {
      ref: ContentRefFile | ContentRefURL;
      /** Object fit for image display in card views */
      objectFit?: CardsImageObjectFit;
      /** Alternative text for the cover image */
      alt?: string;
    };

export interface DocumentTableRecord {
  orderIndex: string;
  values: Record<
    string,
    | number
    | string
    | null
    | boolean
    | string[]
    | ContentRef
    | DocumentTableImageRecord
  >;
}

export interface DocumentTableDefinitionBase {
  id: string;
  /** Title for the column */
  title: string;
}

export type DocumentTableDefinitionText = DocumentTableDefinitionBase & {
  type: "text";
  textAlignment: "center" | "right" | "left";
  verticalAlignment?: VerticalAlignment;
};

export type DocumentTableDefinitionNumber = DocumentTableDefinitionBase & {
  type: "number";
};

export type DocumentTableDefinitionCheckbox = DocumentTableDefinitionBase & {
  type: "checkbox";
};

export type DocumentTableDefinitionFiles = DocumentTableDefinitionBase & {
  type: "files";
};

export type DocumentTableDefinitionUsers = DocumentTableDefinitionBase & {
  type: "users";
  multiple: boolean;
};

export type DocumentTableDefinitionRating = DocumentTableDefinitionBase & {
  type: "rating";
  max: number;
};

export interface DocumentTableSelectOption {
  value: string;
  label: string;
  color: string;
}

export type DocumentTableDefinitionSelect = DocumentTableDefinitionBase & {
  type: "select";
  multiple: boolean;
  options: DocumentTableSelectOption[];
};

export type DocumentTableDefinitionContentRef = DocumentTableDefinitionBase & {
  type: "content-ref";
};

export type DocumentTableDefinitionImage = DocumentTableDefinitionBase & {
  type: "image";
};

export type DocumentTableDefinition =
  | DocumentTableDefinitionText
  | DocumentTableDefinitionNumber
  | DocumentTableDefinitionCheckbox
  | DocumentTableDefinitionFiles
  | DocumentTableDefinitionUsers
  | DocumentTableDefinitionRating
  | DocumentTableDefinitionSelect
  | DocumentTableDefinitionContentRef
  | DocumentTableDefinitionImage;

/**
 * Number of rows or columns covered by a table cell merge
 * @min 1
 * @max 50
 */
export type DocumentTableCellSpan = number;

/** Positional table cell merge range. The anchor and spans are resolved against the current sorted record order and visible column order. The current document model applies only non-overlapping horizontal or vertical merges of adjacent Text or Number body cells; unsupported ranges are removed during normalization. */
export interface DocumentTableCellMerge {
  /** Cell at the top-left of the merged range */
  anchor: {
    /** ID of the anchor record */
    record: string;
    /** ID of the anchor column */
    column: string;
  };
  /** Number of rows or columns covered by a table cell merge */
  rowSpan: DocumentTableCellSpan;
  /** Number of rows or columns covered by a table cell merge */
  colSpan: DocumentTableCellSpan;
}

export interface DocumentBlockTable {
  object: "block";
  type: "table";
  key?: string;
  isVoid: true;
  data: {
    view: DocumentTableViewGrid | DocumentTableViewCards;
    records: Record<string, DocumentTableRecord>;
    definition: Record<string, DocumentTableDefinition>;
    /** Positional table cell merge ranges. The current document model retains only non-overlapping horizontal or vertical merges between adjacent Text or Number body cells. Anchors and spans are resolved against the table's current sorted record order and visible column order. */
    cellMerges?: DocumentTableCellMerge[];
    /** Whether to render the block as a full width one */
    fullWidth?: boolean;
    /** Whether to show the search bar on the table. When unset, search is shown automatically on grid tables once they have enough rows. */
    search?: boolean;
  };
  fragments: DocumentFragment[];
}

export interface DocumentBlockQuote {
  object: "block";
  type: "blockquote";
  key?: string;
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockQuote
    | DocumentBlockCode
    | DocumentBlockDrawing
    | DocumentBlockEmbed
    | DocumentBlockExpandable
    | DocumentBlockFile
    | DocumentBlockHint
    | DocumentBlockIf
    | DocumentBlockMath
    | DocumentBlockPrompt
    | DocumentBlockStepper
    | DocumentBlockTabs
  )[];
  isVoid?: false;
  data?: object;
}

export interface DocumentBlockDrawing {
  object: "block";
  type: "drawing";
  key?: string;
  data: {
    ref?: ContentRefFile;
  };
  fragments?: (DocumentFragment & {
    fragment: "caption";
    nodes: DocumentBlockParagraph[];
  })[];
  isVoid: true;
}

export interface DocumentBlockFile {
  object: "block";
  type: "file";
  key?: string;
  data: {
    ref: ContentRefFile;
  };
  fragments?: (DocumentFragment & {
    fragment: "caption";
    nodes: DocumentBlockParagraph[];
  })[];
  isVoid: true;
}

export type Length =
  | number
  | {
      unit: string;
      value: number;
    };

export interface DocumentBlockImage {
  object: "block";
  type: "image";
  key?: string;
  data: {
    ref: ContentRefURL | ContentRefFile;
    refDark?: ContentRefURL | ContentRefFile;
    width?: Length;
    height?: Length;
    alt?: string;
  };
  fragments: (DocumentFragment & {
    fragment: "caption";
    nodes: DocumentBlockParagraph[];
  })[];
  isVoid: true;
}

export interface DocumentBlockImages {
  object: "block";
  type: "images";
  key?: string;
  data: {
    align?: "center" | "left" | "right";
    fullWidth?: boolean;
    withFrame?: boolean;
  };
  nodes: DocumentBlockImage[];
  isVoid: false;
}

export interface DocumentBlockHint {
  object: "block";
  type: "hint";
  key?: string;
  data: {
    style: "info" | "warning" | "danger" | "success";
    /** Name of the icon */
    icon?: Icon;
  };
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockEmbed
    | DocumentBlockIntegration
    | DocumentBlockTable
    | DocumentBlockQuote
    | DocumentBlockCode
    | DocumentBlockDrawing
    | DocumentBlockExpandable
    | DocumentBlockFile
    | DocumentBlockHint
    | DocumentBlockIf
    | DocumentBlockMath
    | DocumentBlockPrompt
    | DocumentBlockStepper
    | DocumentBlockTabs
  )[];
  isVoid?: false;
}

export interface DocumentBlockPrompt {
  object: "block";
  type: "prompt";
  key?: string;
  data: {
    description: string;
    /** Name of the icon */
    icon?: Icon;
    openInAIProviders?: boolean;
    /**
     * Controls how much of the prompt content is visible by default.
     * @default "hidden"
     */
    defaultExpanded?: "hidden" | "partial" | "full";
  };
  /**
   * @maxItems 1
   * @minItems 1
   */
  nodes: DocumentBlockCode[];
  isVoid?: false;
}

export type DocumentBlocksTopLevels =
  | DocumentBlocksEssentials
  | DocumentBlockQuote
  | DocumentBlockHint
  | DocumentBlockPrompt
  | DocumentBlockImages
  | DocumentBlockFile
  | DocumentBlockDrawing
  | DocumentBlockEmbed
  | DocumentBlockCode
  | DocumentBlockMath
  | DocumentBlockExpandable
  | DocumentBlockTabs
  | DocumentBlockTable
  | DocumentBlockOpenAPI
  | DocumentBlockOpenAPIOperation
  | DocumentBlockOpenAPISchemas
  | DocumentBlockOpenAPIWebhook
  | DocumentBlockContentRef
  | DocumentBlockIntegration
  | DocumentBlockReusableContent
  | DocumentBlockStepper
  | DocumentBlockIf
  | DocumentBlockColumns
  | DocumentBlockUpdates;

export interface DocumentBlockIf {
  object: "block";
  type: "if";
  key?: string;
  nodes: DocumentBlocksTopLevels[];
  isVoid?: false;
  data: {
    expression: string;
  };
}

export interface DocumentBlockReusableContent {
  object: "block";
  type: "reusable-content";
  key?: string;
  data: {
    ref: ContentRefReusableContent;
  };
  isVoid: true;
  meta?: {
    /** A content token that can be used to fetch the reusable content from the API. */
    token?: string;
  };
}

export interface DocumentBlockContentRef {
  object: "block";
  type: "content-ref";
  key?: string;
  data: {
    /** A relative reference to content in GitBook. */
    ref: ContentRef;
  };
  isVoid: true;
}

export interface DocumentBlockMath {
  object: "block";
  type: "math";
  key?: string;
  data: {
    formula: string;
  };
  isVoid: true;
}

export interface DocumentBlockExpandable {
  object: "block";
  type: "expandable";
  key?: string;
  isVoid: true;
  data: {
    defaultExpanded?: boolean;
  };
  fragments: (
    | (DocumentFragment & {
        fragment: "expandable-title";
        type: "expandable-title";
        /**
         * @maxItems 1
         * @minItems 1
         */
        nodes: DocumentBlockParagraph[];
      })
    | (DocumentFragment & {
        fragment: "expandable-body";
        type: "expandable-body";
        /** @minItems 1 */
        nodes: (
          | DocumentBlocksEssentials
          | DocumentBlockEmbed
          | DocumentBlockFile
          | DocumentBlockImages
          | DocumentBlockCode
          | DocumentBlockTable
          | DocumentBlockHint
          | DocumentBlockPrompt
          | DocumentBlockQuote
          | DocumentBlockIf
          | DocumentBlockReusableContent
          | DocumentBlockIntegration
          | DocumentBlockStepper
          | DocumentBlockTabs
        )[];
      })
  )[];
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
}

export interface DocumentBlockStepper {
  object: "block";
  type: "stepper";
  key?: string;
  nodes: DocumentBlockStepperStep[];
  isVoid?: false;
  data?: object;
}

export interface DocumentBlockTabs {
  object: "block";
  type: "tabs";
  key?: string;
  nodes: DocumentBlockTabsItem[];
  isVoid?: false;
  data?: {
    fullWidth?: boolean;
  };
}

export interface DocumentBlockTabsItem {
  object: "block";
  type: "tabs-item";
  key?: string;
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockContentRef
    | DocumentBlockCode
    | DocumentBlockEmbed
    | DocumentBlockFile
    | DocumentBlockImages
    | DocumentBlockDrawing
    | DocumentBlockHint
    | DocumentBlockPrompt
    | DocumentBlockQuote
    | DocumentBlockMath
    | DocumentBlockIntegration
    | DocumentBlockTable
    | DocumentBlockExpandable
    | DocumentBlockIf
    | DocumentBlockReusableContent
    | DocumentBlockStepper
    | DocumentBlockTabs
  )[];
  data: {
    title?: string;
    /** Name of the icon */
    icon?: Icon;
    /** Stable identifier for this tab's selection, shared with every tab and button targeting the same slug. It is slugified before matching, so casing and spacing need not be exact. Omit it — or send an empty value, which counts as omitted — to derive one from the title, which is what makes same-named tabs across a site select together. A value that slugifies to nothing, such as emoji alone, also falls back to the title. */
    slug?: string;
  };
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
  isVoid?: false;
}

export interface DocumentBlockStepperStep {
  object: "block";
  type: "stepper-step";
  key?: string;
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockContentRef
    | DocumentBlockCode
    | DocumentBlockEmbed
    | DocumentBlockFile
    | DocumentBlockImages
    | DocumentBlockDrawing
    | DocumentBlockHint
    | DocumentBlockPrompt
    | DocumentBlockQuote
    | DocumentBlockMath
    | DocumentBlockIntegration
    | DocumentBlockExpandable
    | DocumentBlockTable
    | DocumentBlockTabs
    | DocumentBlockIf
    | DocumentBlockReusableContent
    | DocumentBlockStepper
  )[];
  data: {
    icon?: string;
  };
  isVoid?: false;
}

export interface DocumentBlockListItem {
  object: "block";
  type: "list-item";
  key?: string;
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockCode
    | DocumentBlockHint
    | DocumentBlockQuote
    | DocumentBlockMath
    | DocumentBlockTable
    | DocumentBlockImages
  )[];
  isVoid?: false;
  data?: {
    checked?: boolean;
  };
}

export interface DocumentBlockListOrdered {
  object: "block";
  type: "list-ordered";
  key?: string;
  data: {
    /** An integer to start counting from for the list items. */
    start?: number;
  };
  nodes: DocumentBlockListItem[];
  isVoid?: false;
}

export interface DocumentBlockListUnordered {
  object: "block";
  type: "list-unordered";
  key?: string;
  nodes: DocumentBlockListItem[];
  data?: object;
  isVoid?: false;
}

export interface DocumentBlockListTasks {
  object: "block";
  type: "list-tasks";
  key?: string;
  nodes: DocumentBlockListItem[];
  isVoid?: false;
  data?: object;
}

export interface DocumentBlockDivider {
  object: "block";
  type: "divider";
  key?: string;
  isVoid: true;
  data: object;
}

/** Pointer to an operation in the OpenAPI spec. */
export interface OpenAPIOperationPointer {
  /** Path of the operation in the OpenAPI spec. */
  path: string;
  /** HTTP method of the operation in the OpenAPI spec. */
  method: string;
}

export interface DocumentBlockOpenAPI {
  object: "block";
  type: "swagger";
  key?: string;
  data: OpenAPIOperationPointer & {
    ref: ContentRefFile | ContentRefURL;
    /** If true, the block is opened by default. */
    expanded?: boolean;
    fullWidth?: boolean;
  };
  isVoid: true;
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
}

export interface DocumentBlockOpenAPIOperation {
  object: "block";
  type: "openapi-operation";
  key?: string;
  data: OpenAPIOperationPointer & {
    ref: ContentRefOpenAPI;
    /** When true, the block omits its own title and description; the page renders them instead. Set by the computed one-operation-per-page layout; not intended to be set manually. */
    headless?: boolean;
  };
  isVoid: true;
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
}

/** Pointer to schemas in the OpenAPI spec. */
export interface OpenAPISchemasPointer {
  /**
   * Whether the schemas are grouped or not.
   * @default true
   */
  grouped?: boolean;
  /** List of schemas name from the OpenAPI spec. */
  schemas: string[];
  /** Custom title for the schemas block. When not provided, defaults to "The <SchemaName> object". */
  title?: string;
}

export interface DocumentBlockOpenAPISchemas {
  object: "block";
  type: "openapi-schemas";
  key?: string;
  data: OpenAPISchemasPointer & {
    ref: ContentRefOpenAPI;
  };
  isVoid: true;
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
}

/** Pointer to a webhook in the OpenAPI spec. */
export interface OpenAPIWebhookPointer {
  /** Name of the webhook in the OpenAPI spec. */
  name: string;
  /** HTTP method of the webhook in the OpenAPI spec. */
  method: string;
}

export interface DocumentBlockOpenAPIWebhook {
  object: "block";
  type: "openapi-webhook";
  key?: string;
  data: OpenAPIWebhookPointer & {
    ref: ContentRefOpenAPI;
    /** When true, the block omits its own title and description; the page renders them instead. Set by the computed one-operation-per-page layout; not intended to be set manually. */
    headless?: boolean;
  };
  isVoid: true;
  meta?: {
    /** Unique ID to be used in an URL for the block. */
    id: string;
  };
}

export interface DocumentBlockColumn {
  object: "block";
  type: "column";
  key?: string;
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockImages
    | DocumentBlockCode
    | DocumentBlockHint
    | DocumentBlockPrompt
    | DocumentBlockContentRef
    | DocumentBlockDrawing
    | DocumentBlockEmbed
    | DocumentBlockFile
    | DocumentBlockIntegration
    | DocumentBlockMath
    | DocumentBlockQuote
    | DocumentBlockTable
    | DocumentBlockExpandable
    | DocumentBlockStepper
    | DocumentBlockIf
  )[];
  isVoid?: false;
  data: {
    width?: Length;
    verticalAlignment?: VerticalAlignment;
  };
}

export interface DocumentBlockColumns {
  object: "block";
  type: "columns";
  key?: string;
  data: {
    fullWidth?: boolean;
  };
  nodes: DocumentBlockColumn[];
  isVoid: false;
}

export interface DocumentBlockUpdate {
  object: "block";
  type: "update";
  key?: string;
  nodes: (
    | DocumentBlocksEssentials
    | DocumentBlockContentRef
    | DocumentBlockCode
    | DocumentBlockEmbed
    | DocumentBlockFile
    | DocumentBlockImages
    | DocumentBlockDrawing
    | DocumentBlockHint
    | DocumentBlockPrompt
    | DocumentBlockQuote
    | DocumentBlockMath
    | DocumentBlockIntegration
    | DocumentBlockTabs
    | DocumentBlockExpandable
    | DocumentBlockTable
    | DocumentBlockIf
    | DocumentBlockStepper
  )[];
  data: {
    /** Date of the update. Accepts a YYYY-MM-DD date or a timestamp. Timestamps are normalized to their UTC calendar date; responses use YYYY-MM-DD. */
    date: string | Timestamp;
    /** Array of tags. Each tag is id'ed by its slug. */
    tags?: ContentRefTag[];
  };
  isVoid?: false;
}

export interface DocumentBlockUpdates {
  object: "block";
  type: "updates";
  key?: string;
  nodes: DocumentBlockUpdate[];
  isVoid?: false;
  data: {
    /** @default "full" */
    format: "numeric" | "full" | "short";
  };
}

export type DocumentBlock =
  | DocumentBlockParagraph
  | DocumentBlockHeading
  | DocumentBlockListOrdered
  | DocumentBlockListUnordered
  | DocumentBlockListTasks
  | DocumentBlockListItem
  | DocumentBlockDivider
  | DocumentBlockQuote
  | DocumentBlockHint
  | DocumentBlockPrompt
  | DocumentBlockIf
  | DocumentBlockImages
  | DocumentBlockImage
  | DocumentBlockFile
  | DocumentBlockDrawing
  | DocumentBlockEmbed
  | DocumentBlockCode
  | DocumentBlockCodeLine
  | DocumentBlockMath
  | DocumentBlockExpandable
  | DocumentBlockTabs
  | DocumentBlockTabsItem
  | DocumentBlockTable
  | DocumentBlockOpenAPI
  | DocumentBlockOpenAPIOperation
  | DocumentBlockOpenAPISchemas
  | DocumentBlockOpenAPIWebhook
  | DocumentBlockContentRef
  | DocumentBlockIntegration
  | DocumentBlockReusableContent
  | DocumentBlockStepper
  | DocumentBlockStepperStep
  | DocumentBlockColumns
  | DocumentBlockColumn
  | DocumentBlockUpdates
  | DocumentBlockUpdate;

/** Action to perform when an inline button is clicked. */
export type DocumentAction =
  | {
      action: "search";
      /** The search query to prefill. */
      query?: string;
      /** Where to search. `site` searches the whole site; `space` limits the search to the space the visitor is reading. */
      scope?: "site" | "space";
    }
  | {
      action: "ask";
      /** The question to prefill. */
      query?: string;
    }
  | {
      action: "select";
      /** The slug of the option to select. */
      slug: string;
    };

export interface DocumentInlineButton {
  object: "inline";
  type: "button";
  key?: string;
  data: {
    label: string;
    kind: "primary" | "secondary";
    size?: "small" | "medium" | "large";
    /** Name of the icon */
    icon?: Icon;
  } & (
    | {
        /** A relative reference to content in GitBook. */
        ref: ContentRef;
      }
    | {
        /** Action to perform when an inline button is clicked. */
        action: DocumentAction;
      }
  );
  isVoid: true;
}

/** @example {"object":"document","data":{},"nodes":[{"object":"block","type":"paragraph","data":{},"nodes":[{"object":"text","leaves":[{"object":"leaf","text":"Hello world","marks":[]}]}]}]} */
export interface JSONDocument {
  object: "document";
  data: {
    /** The schema version of the document. If undefined, the document is considered to be of the latest schema version. */
    schemaVersion?: number;
    [key: string]: any;
  };
  nodes: DocumentBlocksTopLevels[];
  meta?: {
    /** A content token that can be used to fetch the content referenced in this document from the API. */
    token?: string;
  };
}

export type Document =
  | MarkdownDocument
  | {
      document: JSONDocument;
    }
  | object;

/**
 * Page's slug in its direct parent
 * @minLength 0
 * @maxLength 100
 */
export type RevisionPageSlug = string;

export type RevisionPageDocument = RevisionPageBase &
  Document & {
    /** @deprecated */
    kind: "sheet";
    type: "document";
    urls: {
      /** Location of the page in the app */
      app: URL;
    };
    /** Page's slug in its direct parent */
    slug: RevisionPageSlug;
    /** Complete path to access the page in the revision. */
    path: string;
    description?: string;
    /**
     * Optional title for the page's HTML `<title>` tag. When set, it replaces the page title in the composed `<title>` (`<tagTitle || title> | <section> | <site>`), while the page's visible heading and navigation title remain unchanged. Use this when the search result or browser tab should use a different title from the page itself.
     * @maxLength 100
     */
    tagTitle?: string;
    pages: (RevisionPageDocument | RevisionPageLink | RevisionPageComputed)[];
    git?: GitSyncBlob;
    layout: RevisionPageLayoutOptions;
    cover?: RevisionPageDocumentCover;
    variables?: Variables;
    /**
     * If true, the page is not displayed in the navigation, while still being accessible.
     * @default false
     */
    hidden?: boolean;
    /**
     * If true, the page is not indexable in the search and ask features.
     * @default false
     */
    noIndex?: boolean;
    /**
     * If true, the page is not indexable by search engine robots.
     * @default false
     */
    noRobotsIndex?: boolean;
    /** Meta links associated with the page. */
    metaLinks?: RevisionPageMetaLinks;
    /** A list of all the tags added to this page */
    tags: RevisionPageTag[];
  } & (
    | {
        computed: ComputedContentSourceDocument;
        /** Seed to use for the generation of IDs. */
        computedSeed: string;
      }
    | {
        /** ID of the document with the page body. If undefined, the page is empty. */
        documentId?: string;
      }
  );

export type RevisionPageLink = RevisionPageBase & {
  /** @deprecated */
  kind: "link";
  type: "link";
  /** A relative reference to content in GitBook. */
  target: ContentRef;
  href?: string;
  /**
   * If true, the page is not displayed in the navigation, while still being accessible.
   * @default false
   */
  hidden?: boolean;
};

export interface ComputedContentDependencyOpenAPI {
  ref: ContentRefOpenAPI;
  /** See `OpenAPI` schema component. */
  value: {
    object: "openapi-spec";
    id: string;
    slug: string;
    lastVersion?: string;
    /**
     * The visibility setting of the OpenAPI spec.
     * * `private`: The spec is not publicly available.
     * * `public`: The spec is available to anyone with a public link.
     */
    visibility?: OpenAPISpecVisibility;
  };
}

/** Generic parameters from an OpenAPI computed content source */
export interface ComputedContentSourceOpenAPIBase {
  type: "builtin:openapi";
  dependencies: {
    spec:
      | {
          ref: ContentRefOpenAPI;
        }
      | ComputedContentDependencyOpenAPI;
  };
}

/** Parameters for an OpenAPI computed revision */
export type ComputedContentSourceRevisionOpenAPI =
  ComputedContentSourceOpenAPIBase & {
    props: {
      models: boolean;
      /** Whether to show a link to download the OpenAPI spec. */
      downloadLink?: boolean;
      /** How GitBook will group generated pages. "by-tag" groups operations under their tag; "by-operation" creates a separate page per operation. Defaults to "by-tag" when absent. */
      grouping?: "by-tag" | "by-operation";
    };
  };

export interface TranslationRef {
  kind: "translation";
  /** ID of the translation sync */
  translation: string;
}

/** Result of a translation. */
export interface TranslationResult {
  /** ID of the space containing the result of the translation */
  space: string;
  /** ID of the revision generated by the translation */
  revision: string;
  language: TranslationLanguage;
}

export interface ComputedContentDependencyTranslation {
  ref: TranslationRef;
  /** Translation has not been run yet */
  value: TranslationResult | null;
}

/** Parameters for a translation computed content source */
export interface ComputedContentSourceRevisionTranslation {
  type: "builtin:translation";
  props: object;
  dependencies: {
    translation:
      | {
          ref: TranslationRef;
        }
      | ComputedContentDependencyTranslation;
  };
}

/** Dependency for a computation, before its resolution. */
export interface ComputedContentDependency {
  ref: ContentRefSpace | ContentRefOpenAPI | TranslationRef;
}

export interface ComputedContentDependencySpace {
  ref: ContentRefSpace;
  /** See `Space` schema component. */
  value: {
    object: "space";
    id: string;
    revision: string;
  };
}

/** Dependency for a computation, with its resolved value. */
export type ComputedContentDependencyResolved =
  | ComputedContentDependencySpace
  | ComputedContentDependencyOpenAPI
  | ComputedContentDependencyTranslation;

/** Parameters for a computed content managed by an integration */
export interface ComputedContentSourceIntegration {
  /**
   * Type of the computed source
   * @pattern ^integration:[^:]+:[^:]+$
   */
  type: `integration:${string}:${string}`;
  /** Properties to be passed to the computation */
  props: PlainObject;
  /**
   * Dependencies the computation depends on.
   * The state of the dependencies will be passed to the computation.
   * When the dependency's targets are updated, the computation will be updated.
   */
  dependencies?: Record<
    string,
    ComputedContentDependency | ComputedContentDependencyResolved
  >;
}

export type ComputedContentSourceRevision =
  | ComputedContentSourceRevisionOpenAPI
  | ComputedContentSourceRevisionTranslation
  | ComputedContentSourceIntegration;

export type RevisionPageComputed = RevisionPageBase & {
  type: "computed";
  computed: ComputedContentSourceRevision;
};

export interface GitSyncBlob {
  /** SHA for the blob */
  oid: string;
  /** Path of the blob in the Git tree */
  path: string;
}

export interface RevisionPageLayoutOptions {
  /** Width of the page. */
  width: RevisionPageLayoutOptionsWidth;
  /** Should the cover be visible? */
  cover: boolean;
  /** Size of the cover image. */
  coverSize: RevisionPageLayoutOptionsCoverSize;
  /** Mask applied to the cover image. */
  coverMask: RevisionPageLayoutOptionsCoverMask;
  /** Should the title be visible? */
  title: boolean;
  /** Should the description be visible? */
  description: boolean;
  /** Should the table of contents be visible? */
  tableOfContents: boolean;
  /** Should the outline be visible? */
  outline: boolean;
  /** Should the pagination be visible? */
  pagination: boolean;
  /** Should the page metadata (last modified, author, etc.) be visible? */
  metadata: boolean;
  /** Should the tags be visible on the page? */
  tags: boolean;
  /** Should the page actions be visible on the page? */
  actions: boolean;
  /** Should the anchor links on headings and other linkable blocks be visible? */
  anchors: boolean;
}

export interface RevisionPageDocumentCover {
  /** Content reference pointing to the source image. */
  ref?: ContentRefFile | ContentRefURL;
  /** Content reference pointing to the source image for dark mode. */
  refDark?: ContentRefFile | ContentRefURL;
  /** Text color to use on top of the cover image when in background mode. */
  textColor?: RevisionPageDocumentCoverTextColor;
  /** Text color to use on top of the dark mode cover image when in background mode. */
  textColorDark?: RevisionPageDocumentCoverTextColor;
  /**
   * Vertical position of the cover image.
   * @default 0
   */
  yPos: number;
  /**
   * Height of the cover image in pixels.
   * @min 10
   * @max 700
   * @default 240
   */
  height?: number;
}

export type VariableValue = string | number | boolean;

export type Variables = Record<string, VariableValue>;

export type RevisionPageMetaLinkTarget = ContentRefPage | ContentRefURL;

export interface RevisionPageMetaLinks {
  canonical?: RevisionPageMetaLinkTarget;
  alternates?: RevisionPageMetaLinkTarget[];
}

/** A reference to a tag with optional primary flag for page-level tags. */
export interface RevisionPageTag {
  tag: ContentRefTag;
  /** Whether this is the primary tag for display in table of contents. */
  primary?: boolean;
}

/** Parameters for an OpenAPI computed document */
export type ComputedContentSourceDocumentOpenAPI =
  ComputedContentSourceOpenAPIBase & {
    props:
      | {
          doc: "models";
        }
      | {
          doc: "operations" | "info";
          /** @minLength 1 */
          page: string;
        }
      | {
          doc: "operation";
          /** @minLength 1 */
          page: string;
          method:
            | "get"
            | "post"
            | "put"
            | "delete"
            | "patch"
            | "options"
            | "head"
            | "trace"
            | "hook";
          deprecated?: boolean;
        }
      | {
          doc: "tag";
          /** @minLength 1 */
          page: string;
        };
  };

/** Parameters for a document translation computed content source */
export interface ComputedContentSourceDocumentTranslation {
  type: "builtin:translation";
  props: {
    space: string;
    document: string;
  };
  dependencies: {
    translation:
      | {
          ref: TranslationRef;
        }
      | ComputedContentDependencyTranslation;
  };
}

export type ComputedContentSourceDocument =
  | ComputedContentSourceDocumentOpenAPI
  | ComputedContentSourceDocumentTranslation
  | ComputedContentSourceIntegration;

export type RevisionPageGroup = RevisionPageBase & {
  /** @deprecated */
  kind: "group";
  type: "group";
  /** Page's slug in its direct parent */
  slug: string;
  /** Complete path to access the page in the revision. */
  path: string;
  /**
   * If true, the page is not displayed in the navigation, while still being accessible.
   * @default false
   */
  hidden?: boolean;
  /**
   * If true, the page is not indexable in the search and ask features.
   * @default false
   */
  noIndex?: boolean;
  /**
   * If true, the page is not indexable by search engine robots.
   * @default false
   */
  noRobotsIndex?: boolean;
  pages: (RevisionPageDocument | RevisionPageLink | RevisionPageComputed)[];
};

export interface RevisionFile {
  id: string;
  name: string;
  contentType: string;
  downloadURL: string;
  size: number;
  /** For images, it contains the dimensions of it. */
  dimensions?: {
    width: number;
    height: number;
  };
  git?: GitSyncBlob;
}

export type RevisionReusableContent = {
  id: string;
  title: string;
  git?: GitSyncBlob;
} & (
  | {
      computed: ComputedContentSourceDocument;
      /** Seed to use for the generation of IDs. */
      computedSeed: string;
    }
  | {
      /** ID of the document with the content body. If undefined, the reusable content is empty. */
      document?: string;
    }
);

/** A reusable tag that different types of content can be associated to (e.g. pages, update entries) */
export type RevisionTag = {
  /** The slug identifier for the tag, immutable after creation. */
  slug: string;
  /** Display label for the tag. Can be renamed and differ from the slug. */
  label: string;
  /** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
  color: DocumentTextColor;
} & (
  | {
      /** Unicode codepoint or character of the emoji */
      emoji: Emoji;
    }
  | {
      /** Name of the icon */
      icon?: Icon;
    }
);

export interface GitSyncCommit {
  /** SHA for the commit */
  oid: string;
  /** Message describing the purpose of the commit */
  message: string;
  /** If true, the Git commit was generated by an export from GitBook */
  createdByGitBook: boolean;
  /** URL of the commit in the GitSync provider */
  url?: string;
  /** Original name of the ref where the commit originated from */
  ref?: string;
}

export interface RevisionBase {
  /** Type of Object, always equals to "revision" */
  object: "revision";
  /** Unique identifier for the revision */
  id: string;
  /** IDs of the parent revisions */
  parents: string[];
  pages: RevisionPage[];
  files: RevisionFile[];
  reusableContents: RevisionReusableContent[];
  /** List of available tags within this revision */
  tags: RevisionTag[];
  variables?: Variables;
  /** When the revision was created. */
  createdAt: Timestamp;
  /** Metadata about a potential associated git commit. */
  git?: GitSyncCommit;
  urls: {
    /**
     * URL in the application for the revision
     * @format uri
     */
    app: string;
    /**
     * URL of the published version of the revision. Only defined when the space visibility is not "private."
     * @format uri
     */
    published?: string;
    /**
     * URL of the public version of the revision. Only defined when the space visibility is "public".
     * @format uri
     */
    public?: string;
  };
}

export type RevisionTypeEdits = RevisionBase & {
  /** Revision created by editing the content. */
  type: "edits";
};

/**
 * Subject of the change request
 * @minLength 0
 * @maxLength 100
 */
export type ChangeRequestSubject = string;

/** Counts of entities grouped by how they changed relative to the change request base. */
export interface ChangeRequestChangeCountsByType {
  /** @min 0 */
  added: number;
  /** @min 0 */
  modified: number;
  /** @min 0 */
  deleted: number;
}

/** Exact semantic entity and page-document block counts for a change request at its current head and base revisions. */
export interface ChangeRequestChangeCounts {
  /** Counts of entities grouped by how they changed relative to the change request base. */
  pages: ChangeRequestChangeCountsByType;
  /** Counts of entities grouped by how they changed relative to the change request base. */
  library: ChangeRequestChangeCountsByType;
  /** Nested user-visible page-document block counts. Absent when `blocksOmittedReason` is set. */
  blocks?: ChangeRequestChangeCountsByType;
  /** Why `blocks` is absent: too many pages changed (`too-many-pages`), the changed pages hold too many blocks to compare within the counting budget (`too-many-blocks`; this is not a count of changed blocks), or counting ran out of time (`timeout`). Page and library counts are still exact. */
  blocksOmittedReason?: "too-many-pages" | "too-many-blocks" | "timeout";
}

/**
 * Optional title to display for the link.
 * @maxLength 128
 */
export type ChangeRequestLinkTitle = string;

/** External link associated with a change request. */
export interface ChangeRequestLinkInput {
  /** The ID of an existing link, as served on the change request. Pass it back to update that link, or omit it to add a new one. */
  id?: string;
  ref: ContentRefURL;
  /** Optional title to display for the link. */
  title?: ChangeRequestLinkTitle;
}

/** External ticket data resolved for this link by a configured connector. */
export type ChangeRequestLinkExpanded =
  | {
      kind: "external-ticket";
      provider: "jira" | "linear";
      state: "connected";
      /** The ticket's provider-specific key. */
      key: string;
      /**
       * URL to open the ticket.
       * @format uri
       */
      url: string;
      status: {
        id: string;
        name: string;
      };
      /** The ticket's summary. */
      summary: string;
    }
  | {
      kind: "external-ticket";
      provider: "jira" | "linear";
      state: "error";
    };

export type ChangeRequestLink = ChangeRequestLinkInput & {
  /** The ID of the link. */
  id: string;
  /** Whether this link owns synchronization with the external issue. Other links are references only. */
  isSyncing: boolean;
  /** External ticket data resolved for this link by a configured connector. */
  expanded?: ChangeRequestLinkExpanded;
};

/**
 * External links associated with the change request.
 * @maxItems 10
 */
export type ChangeRequestLinks = ChangeRequestLink[];

export interface ChangeRequest {
  /** Type of Object, always equals to "change-request" */
  object: "change-request";
  /** Unique identifier for the change request */
  id: string;
  /** Incremental identifier of the change request */
  number: number;
  status: ChangeRequestStatus;
  /** Subject of the change request */
  subject: ChangeRequestSubject;
  description?: JSONDocument;
  createdBy: User;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  /** User who merged the change request. Only present when the change request has been merged. */
  mergedBy?: User;
  /** Date at which the change request was merged. Only present when the change request has been merged. */
  mergedAt?: Timestamp;
  /** ID of the space in which the change request was created. */
  space: string;
  /** ID of the active revision in the change request. */
  revision: string;
  /** ID of the initial revision in the space from which the change request was created. */
  revisionInitial: string;
  /** ID of the latest revision when updating from main space content. */
  revisionMergedAncestor?: string;
  /** When merged, ID of the revision resulting from the merge. */
  revisionMerged?: string;
  /** Count of opened comments on the change request. */
  comments: number;
  /** Change counts computed when the change request gets a new revision, for its current head and base revisions. Merged change requests keep their last computed counts. Absent until computed. */
  changeCounts?: ChangeRequestChangeCounts;
  /** Site topic the change request was created from, when it came from one. */
  siteTopic?: {
    /** ID of the site associated with the change request. */
    site: string;
    /** ID of the site topic associated with the change request. */
    topic: string;
    /**
     * ID of the site finding the change request fixes. Use `siteFindings` instead: a change request can fix a finding without belonging to a topic, and this field is absent in that case.
     * @deprecated
     */
    finding?: string;
  };
  /**
   * First linked site finding. Use `siteFindings` to read all linked findings.
   * @deprecated
   */
  siteFinding?: {
    /** ID of the site the finding belongs to. */
    site: string;
    /** ID of the site finding the change request fixes. */
    finding: string;
  };
  /** Site findings linked to the change request, in link order. Absent when none are linked. Merging resolves findings once every linked change request is merged, except outbound broken links, which are resolved by the outbound checker. */
  siteFindings?: {
    /** ID of the site the finding belongs to. */
    site: string;
    /** ID of the site finding the change request fixes. */
    finding: string;
  }[];
  /** Style guide check that opened the change request, when it came from one. A check can be run again on the change request already open on a space, rather than opening a second one, so several checks can share a change request. */
  styleguide?: {
    /** ID of the site the style guide belongs to. */
    site: string;
    /** ID of the style guide check run that opened the change request. */
    run: string;
    /** Number of pages the check changed, recorded when it finished. Absent while it is still running, or when it never completed. */
    changedPages?: number;
    /** When the most recent style guide check on the change request finished. Later edits from anyone else do not move it. Absent while the first one is still running. */
    checkedAt?: Timestamp;
  };
  /** If true, the change request is not up-to-date with latest changes in the main content. */
  outdated: boolean;
  /** Import runs targeting this change request, still running or ended recently, most recent first. Only returned when fetching a single change request. */
  imports?: ContentImportRun[];
  /** External links associated with the change request. */
  links?: ChangeRequestLinks;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the space in the application
     * @format uri
     */
    app: string;
    /**
     * URL of the user in the API
     * @format uri
     */
    location: string;
  };
}

export type RevisionTypeMerge = RevisionBase & {
  /** Revision created when merging a change request with primary. */
  type: "merge";
  mergedFrom: ChangeRequest;
};

export type RevisionTypeRollback = RevisionBase & {
  /** Revision created as a rollback of a previous revision. */
  type: "rollback";
};

export type RevisionTypeUpdate = RevisionBase & {
  /** Revision created when updating a change request with changes from primary. */
  type: "update";
};

export type RevisionTypeComputed = RevisionBase & {
  /** Virtual revision, computed from a source revision */
  type: "computed";
  /** ID of the non-computed revision used to compute this revision. */
  sourceRevision: string;
  /** The change request the source revision was merged from, when the computed revision is derived from a merge revision. */
  mergedFrom?: ChangeRequest;
};

/** Parameters for a space template */
export interface SpaceTemplateParams {
  contentRefs?: Record<string, ContentRef>;
}

export interface ApplySpaceTemplate {
  /** The ID of the template to use for the space */
  id: string;
  /** Parameters for a space template */
  params?: SpaceTemplateParams;
}

/** An emoji reaction by one or many users */
export interface EmojiReaction {
  /** The Emoji of the reaction */
  emoji: string;
  /** The number of users who reacted with this emoji */
  count: number;
  /** The users who reacted with this emoji */
  users: {
    user: User;
    reactedAt: Timestamp;
  }[];
}

export type EmojiReactions = EmojiReaction[];

/** Contributor towards content. */
export interface UserContributor {
  updatedAt: Timestamp;
  count: number;
  user: User;
}

/** Details about the table cell this comment is attached to, if any. */
export interface TableCellTarget {
  record: string;
  definition: string;
}

export type Comment = {
  /** Type of Object, always equals to "comment" */
  object: "comment";
  /** Unique identifier for the comment. */
  id: string;
  /** The user who posted the comment. */
  postedBy: User;
  /** When the comment was posted. */
  postedAt: Timestamp;
  /** Date when the comment was edited, if it has been edited. */
  editedAt?: Timestamp;
  /** Any emoji reactions to the comment. */
  reactions: EmojiReactions;
  /** The number of replies to this comment. */
  replies: number;
  /** The users who replied to this comment. */
  repliers: UserContributor[];
  /** The content of the comment. */
  body: Document;
  /** Information about the target of the comment. */
  target: {
    /** The node this comment is attached to. */
    node?: {
      id: string;
    };
    /** Details about the table cell this comment is attached to, if any. */
    tableCell?: TableCellTarget;
    /** The change request containing this comment, if the comment was made inside a change request. */
    changeRequest?: string;
    /** The review containing this comment, if this comment was made as part of a review. */
    review?: string;
    /** Information about the page, if this comment refers to a specific page. */
    page?: {
      /** The ID of the page */
      id: string;
    };
    /** The space containing this comment. */
    space: string;
    /** The revision in which the target can be found in. */
    revision: string;
  };
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the comment in the API
     * @format uri
     */
    location: string;
  };
  /** The set of permissions for the comment */
  permissions: {
    /** Can the user view the comment. */
    view: boolean;
    /** Can the user edit the comment. */
    edit: boolean;
    /** Can the user react or send a reply to the comment. */
    reply?: boolean;
    /** Can the user delete the comment. */
    delete: boolean;
  };
} & (
  | {
      /** Status of the comment. */
      status: "resolved";
      /** If the comment has been resolved, the date at which it was resolved. If this field is not defined, the comment is not resolved. */
      resolvedAt: Timestamp;
      /** If the comment has been resolved, the user who resolved it. If this field is not defined, the comment is not resolved. */
      resolvedBy: User;
    }
  | {
      /** Status of the comment. */
      status: "open";
    }
);

export interface ChangeRequestReview {
  /** Type of Object, always equals to "change-request-review" */
  object: "change-request-review";
  /** Unique identifier for the review. */
  id: string;
  /** The revision this review was made against. */
  revision: string;
  /** The user who performed the review. */
  reviewer: User;
  /** The user who requested the review. If undefined, the review was left without a request. */
  requestedBy?: User;
  /** The status of the review. */
  status: ChangeRequestReviewStatus;
  /** Whether this review has been superseded by a newer review request or submission. */
  outdated: boolean;
  comment?: Comment;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the review in the API
     * @format uri
     */
    location: string;
  };
}

/** Exact review totals for the applied filters, independent of pagination. Keyed by review status, with a count of zero for a status nobody used. */
export type ChangeRequestReviewStats = Partial<
  Record<ChangeRequestReviewStatus, number>
>;

export interface Team {
  /** Type of Object, always equals to "team" */
  object: "team";
  /** Unique identifier for the team */
  id: string;
}

export type ChangeRequestRequestedReviewer = {
  /** Type of Object, always equals to "change-request-requested-reviewer" */
  object: "change-request-requested-reviewer";
  /** The revision of the content when the request was made. */
  revision: string;
  /** The user who made the request. */
  requestedBy: User;
  createdAt: Timestamp;
} & (
  | {
      kind: "user";
      /** The user who was requested to review. */
      user: User;
    }
  | {
      kind: "team";
      /** The team who was requested to review. */
      team: Team;
    }
);

export interface AgentConversation {
  /** Type of Object, always equals to "agent-conversation" */
  object: "agent-conversation";
  /** The unique ID of the conversation. This is the client-generated identifier used to address the conversation; for the default conversation of a change request it is "default". */
  id: string;
  /** The title of the conversation, generated from the first message. Absent until generated. */
  title?: string;
  /** Whether the conversation is shared with everyone who has access to its context, rather than only its creator. Conversations are shared by default; a private conversation is only ever visible to its creator and stays private for good. */
  shared: boolean;
  /** The change request the conversation is currently editing in. Only set for organization agent conversations, which start without one and attach a change request the first time the agent needs to change content. Absent for change request conversations, whose change request is the conversation's context. */
  changeRequest?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface PostCommentSchema {
  /** The node to which the comment is posted, if any. */
  node?: string;
  /** The page to which the comment is posted, if any. */
  page?: string;
  /** The content of the comment. */
  body: Document;
  /** Details about the table cell this comment is attached to, if any. */
  tableCell?: TableCellTarget;
}

export interface UpdateCommentSchema {
  /** Whether the comment is resolved or not. */
  resolved?: boolean;
  /** Content of the comment. */
  body?: Document;
  /** Reactions to add to the comment. */
  addedReactions?: string[];
  /** Reactions to remove from the comment. */
  removedReactions?: string[];
}

export interface CommentReply {
  /** Type of Object, always equals to "comment-reply" */
  object: "comment-reply";
  /** Unique identifier for the reply. */
  id: string;
  postedBy: User;
  postedAt: Timestamp;
  /** Date when the reply was edited, if it has been edited. */
  editedAt?: Timestamp;
  reactions: EmojiReactions;
  body: Document;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the comment reply in the API
     * @format uri
     */
    location: string;
  };
  /** The set of permissions for the comment reply */
  permissions: {
    /** Can the user view the comment reply. */
    view: boolean;
    /** Can the user edit the comment reply. */
    edit: boolean;
    /** Can the user react or reply to the comment reply. */
    reply?: boolean;
    /** Can the user delete the comment reply. */
    delete: boolean;
  };
}

export interface PostCommentReplySchema {
  /** The content of the comment. */
  body: Document;
}

export type ChangeRequestUserContributor = UserContributor & {
  actionType: "edit" | "comment";
};

/** Page metadata that can be set when inserting or updating a page through a change request. When a markdown document is provided on the same operation, the values read from its frontmatter take precedence over these fields. */
export interface RevisionPageUpdate {
  /**
   * Title of the page.
   * @minLength 1
   */
  title?: string;
  /** Slug of the page in its parent, used to build the page's path. When omitted, the slug is derived from the title. The slug must be unique among the page's siblings; any collision is rejected. */
  slug?: RevisionPageSlug;
  /** Emoji of the page. Set to an empty string to remove it. */
  emoji?: Emoji;
  /** Icon of the page. Set to an empty string to remove it. */
  icon?: Icon;
  /** Description of the page. */
  description?: string;
  /**
   * Optional custom title used for the page in the table of contents and mentions instead of its page title. Set to an empty string to remove it.
   * @maxLength 100
   */
  linkTitle?: string;
  /**
   * Optional title for the page's HTML `<title>` tag. When set, it replaces the page title in the composed `<title>` (`<tagTitle || title> | <section> | <site>`), while the page's visible heading and navigation title remain unchanged. Use this when the search result or browser tab should use a different title from the page itself. Set to an empty string to remove it.
   * @maxLength 100
   */
  tagTitle?: string;
  /** If true, the page is not displayed in the navigation, while still being accessible. */
  hidden?: boolean;
  /** If true, the page is not indexable in the search and ask features. */
  noIndex?: boolean;
  /** If true, the page is not indexable by search engine robots. */
  noRobotsIndex?: boolean;
  /** Adaptive-content condition controlling whether the page is shown to a visitor. Set to an empty string to remove the condition. */
  condition?: string;
  /** Page variables, referenced in the page's content as `page.vars.<name>`. They are separate from space variables (`space.vars.<name>`). The object replaces all of the page's variables: set it to `{}` to remove them, or omit it to leave them unchanged. In a markdown document, the `vars` frontmatter sets them too. Names follow the same rules as space variables. Document pages only. */
  variables?: Variables;
}

/**
 * Update an existing page. Its document and/or its metadata (title, icon, description, visibility, adaptive-content condition) can be changed, and it can be moved to a new parent and/or position with `into`/`at`.
 * @example {"operation":"update_page","page":"page_id","document":{"markdown":"# Hello World\n\nThis is a markdown document linking to [another page](/pages/page_id).\n"}}
 */
export type ChangeRequestContentChangeUpdatePage = RevisionPageUpdate & {
  operation: "update_page";
  /** ID of the page to update. */
  page: string;
  /** New document for the page. When provided as markdown, its frontmatter is read to update the page metadata. Omit to update only the metadata fields. */
  document?: Document;
  /** Move the page to be a child of this page ID. Set to `null` to move it to the root of the page tree. Omit to leave the page's parent unchanged. The target cannot be the page itself or one of its own descendants. */
  into?: string | null;
  /**
   * Zero-based index to move the page to among its new siblings (those of `into`, or the root pages when `into` is omitted or `null`). Omit to leave the page's position unchanged when its parent isn't changing, or to append it at the end when its parent is changing.
   * @min 0
   */
  at?: number;
};

/**
 * Insert a new page into the change request. The title is taken from `title`, or, when the document is markdown, from the document's frontmatter or leading heading (which take precedence, matching Git Sync). When no title can be resolved, the page falls back to a default title.
 * @example {"operation":"insert_page","title":"New page","document":{"markdown":"# New page\n\nThis is a new page.\n"}}
 */
export type ChangeRequestContentChangeInsertPage = RevisionPageUpdate & {
  operation: "insert_page";
  /** ID of the parent page to insert the new page into. If omitted, the page is inserted as a root page. */
  into?: string;
  /**
   * Zero-based index to insert the page at among its siblings. If omitted, the page is appended at the end.
   * @min 0
   */
  at?: number;
  /** Temporary local reference for the page, used only for the lifetime of this request and never persisted. Other pages inserted in the same batch can link to this page by its ref (e.g. `[Page](./<ref>.md)`), which resolves to the page's ID at apply time — regardless of operation order or the page's eventual slug. A ref must be unique within the batch and must not collide with an existing page's path. */
  ref?: string;
  /**
   * Stable identifier for the page's content, such as the ID of the record it is generated from. The page's ID is derived from it, so re-inserting a deleted page with the same key restores its ID and links to it keep working. The same key gives the same page ID in every space, including duplicated spaces. To change a page that exists, use `update_page`: an insert whose key matches an existing page, or another insert in the batch, is rejected, so deleting a page and re-inserting its key must be done in separate requests. A re-created page takes over the old page's comments, redirects, insights and history. When two change requests insert the same key, merging both keeps only one of the pages, without a conflict.
   * @minLength 1
   * @maxLength 255
   */
  stableKey?: string;
  /** Document for the new page. When provided as markdown, its frontmatter is read to set the page metadata. */
  document: Document;
};

/**
 * Delete an existing page (and its subpages) from the change request.
 * @example {"operation":"delete_page","page":"page_id"}
 */
export interface ChangeRequestContentChangeDeletePage {
  operation: "delete_page";
  /** ID of the page to delete. */
  page: string;
}

/**
 * Revert a page to the state it had in a given revision. If `revision` is omitted, the page is reverted to the change request's base revision. Without `block`, the whole page is reverted — added pages are removed, deleted pages are restored, and modified pages have their document reset. With `block`, only the listed block-level changes in the page's document are reverted (each block is removed if it was added, restored if it was deleted, or reset if it was modified or moved); other blocks and the page's properties/metadata are left untouched.
 * @example {"operation":"revert_page","page":"page_id"}
 */
export interface ChangeRequestContentChangeRevertPage {
  operation: "revert_page";
  /** ID of the page to revert. */
  page: string;
  /** ID of the revision to revert the page to. If omitted, the change request's base revision is used. */
  revision?: string;
  /** Keys of the specific blocks to revert within the page's document, as they appear in the page's document. If omitted, the whole page is reverted. */
  block?: string[];
}

/**
 * Upload files (images or attachments) into the change request. A document references one as `![Alt](/files/<fileId>)` or `[Label](/files/<fileId>)` — use a `ref` to reference it from a later change in the same batch, or read the generated IDs from `insertedFiles`.
 * @example {"operation":"insert_files","files":[{"ref":"architecture.png","name":"architecture.png","url":"https://example.com/architecture.png"}]}
 */
export interface ChangeRequestContentChangeInsertFiles {
  operation: "insert_files";
  /**
   * @maxItems 20
   * @minItems 1
   */
  files: ((
    | {
        /**
         * Public http(s) URL to fetch the file from. A URL resolving to a private or reserved address is rejected — send internally hosted bytes with `base64` instead.
         * @format uri
         * @maxLength 2048
         */
        url: string;
      }
    | {
        /** Base64-encoded bytes, max 1MB. Requires `contentType`. */
        base64: string;
      }
  ) & {
    /** Temporary local reference for the file, used only for the lifetime of this request and never persisted. Pages inserted in the same batch can link to this file by its ref (e.g. `[File](./<ref>)`), which resolves to the file's ID at apply time — regardless of operation order or the file's eventual path. A ref must be unique within the batch and must not collide a page ref in the batch or an existing page path. */
    ref?: string;
    /**
     * Filename to store the file under, including its extension.
     * @minLength 1
     * @maxLength 256
     */
    name: string;
    /** MIME type. Required with `base64`; overrides the source's own type otherwise. */
    contentType?: string;
  })[];
}

/**
 * Insert a page whose content GitBook generates from a source instead of a document: an OpenAPI spec of the organization, rendered as an API reference. GitBook replaces the page, at its position, with the pages it generates and regenerates them whenever the source changes.
 * @example {"operation":"insert_computed_page","title":"API reference","computed":{"type":"builtin:openapi","props":{"models":true},"dependencies":{"spec":{"ref":{"kind":"openapi","spec":"my-api"}}}}}
 */
export interface ChangeRequestContentChangeInsertComputedPage {
  operation: "insert_computed_page";
  /** Parameters for an OpenAPI computed revision */
  computed: ComputedContentSourceRevisionOpenAPI;
  /**
   * Title of the page, only shown in the editor since the generated pages take its place. Defaults to "OpenAPI".
   * @minLength 1
   */
  title?: string;
  /** ID of the parent page to insert the page into, so the generated pages are nested under it. If omitted, the page is inserted at the root. */
  into?: string;
  /**
   * Zero-based index to insert the page at among its siblings. If omitted, the page is appended at the end.
   * @min 0
   */
  at?: number;
}

/**
 * Create reusable content (snippets shared by several pages) in the change request. A markdown document includes one as `{% include "/reusable-content/<reusableContentId>" %}` — use a `ref` to include it from a page in the same batch, or read the generated IDs from `insertedReusableContents`.
 * @example {"operation":"insert_reusable_contents","reusableContents":[{"ref":"disclaimer","title":"Disclaimer","document":{"markdown":"{% hint style=\"warning\" %}\nThis feature is in beta.\n{% endhint %}\n"}}]}
 */
export interface ChangeRequestContentChangeInsertReusableContents {
  operation: "insert_reusable_contents";
  /**
   * @maxItems 20
   * @minItems 1
   */
  reusableContents: {
    /** Temporary local reference for the reusable content, used only for the lifetime of this request and never persisted. Pages in the same batch can include it by its ref (e.g. `{% include "./<ref>" %}`), which resolves to the reusable content's ID at apply time — regardless of operation order. A ref must be unique among the reusable content refs of the batch. */
    ref?: string;
    /**
     * Title of the reusable content, shown when picking it in the editor.
     * @minLength 1
     * @maxLength 100
     */
    title: string;
    /** Body of the reusable content. */
    document: Document;
  }[];
}

/**
 * Update an existing reusable content's title and/or document. Its ID is unchanged, so every page including it shows the update.
 * @example {"operation":"update_reusable_content","reusableContent":"reusable_content_id","title":"Beta disclaimer"}
 */
export interface ChangeRequestContentChangeUpdateReusableContent {
  operation: "update_reusable_content";
  /** ID of the reusable content to update. */
  reusableContent: string;
  /**
   * New title of the reusable content. Omit to keep the current title.
   * @minLength 1
   * @maxLength 100
   */
  title?: string;
  /** New body of the reusable content. Omit to keep the current body. */
  document?: Document;
}

/**
 * Delete an existing reusable content from the change request.
 * @example {"operation":"delete_reusable_content","reusableContent":"reusable_content_id"}
 */
export interface ChangeRequestContentChangeDeleteReusableContent {
  operation: "delete_reusable_content";
  /** ID of the reusable content to delete. */
  reusableContent: string;
}

/**
 * Name of a variable, referenced in content as `space.vars.<name>`. It starts with a letter, `_` or `$` and contains only letters, digits, `_` and `$`.
 * @minLength 1
 * @maxLength 64
 * @pattern ^[a-zA-Z_$][a-zA-Z0-9_$]*$
 */
export type VariableName = string;

/**
 * Create space variables in the change request (Git Sync's `.gitbook/vars.yaml`), or with `page`, variables of that page. Content references one as an expression, `<code class="expression">space.vars.<name></code>` (or `page.vars.<name>` on that page) in markdown, which renders the variable's value. To replace all of a page's variables at once, set the page's `variables` or its `vars` frontmatter instead.
 * @example {"operation":"insert_variables","variables":[{"name":"version","value":"2.0"}]}
 */
export interface ChangeRequestContentChangeInsertVariables {
  operation: "insert_variables";
  /** ID of a document page to add the variables to, as its own variables (`page.vars.<name>`). Omit to add space variables. */
  page?: string;
  /**
   * @maxItems 50
   * @minItems 1
   */
  variables: {
    /** Name of a variable, referenced in content as `space.vars.<name>`. It starts with a letter, `_` or `$` and contains only letters, digits, `_` and `$`. */
    name: VariableName;
    /** Value of the variable. */
    value: VariableValue;
  }[];
}

/**
 * Change the value of an existing space variable, or with `page`, of one of that page's own variables without resending the others. Every expression referencing it shows the new value.
 * @example {"operation":"update_variable","variable":"version","value":"2.1"}
 */
export interface ChangeRequestContentChangeUpdateVariable {
  operation: "update_variable";
  /** ID of a document page whose own variable (`page.vars.<name>`) to update. Omit to update a space variable. */
  page?: string;
  /** Name of the variable to update. */
  variable: VariableName;
  /** New value of the variable. */
  value: VariableValue;
}

/**
 * Delete an existing space variable from the change request, or with `page`, one of that page's own variables. Expressions referencing it are kept in pages, as in the editor.
 * @example {"operation":"delete_variable","variable":"version"}
 */
export interface ChangeRequestContentChangeDeleteVariable {
  operation: "delete_variable";
  /** ID of a document page whose own variable (`page.vars.<name>`) to delete. Omit to delete a space variable. */
  page?: string;
  /** Name of the variable to delete. */
  variable: VariableName;
}

/**
 * Display label of a tag.
 * @minLength 1
 * @maxLength 50
 */
export type RevisionTagLabel = string;

/** Create flat tags in array order. The batch is rejected atomically if any tag is invalid. */
export interface ChangeRequestContentChangeInsertTags {
  operation: "insert_tags";
  /**
   * @maxItems 50
   * @minItems 1
   */
  tags: {
    /**
     * Stable tag identifier; generated from the label when omitted.
     * @minLength 1
     */
    slug?: string;
    /** Display label of a tag. */
    label: RevisionTagLabel;
    /** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
    color?: DocumentTextColor;
    /** Name of the icon */
    icon?: Icon;
    /** Unicode codepoint or character of the emoji */
    emoji?: Emoji;
  }[];
}

/** Rename or restyle an existing tag. The slug is immutable. */
export interface ChangeRequestContentChangeUpdateTag {
  operation: "update_tag";
  /**
   * Slug of the tag to update.
   * @minLength 1
   */
  tag: string;
  /** Display label of a tag. */
  label?: RevisionTagLabel;
  /** Allowed color tokens for color marks (text and background; background reuses this enum). Named colors are fixed palette keys. `$*` tokens are semantic: resolved from the published sites customization when rendering; authors may still persist them in content when valid. */
  color?: DocumentTextColor;
  /** Icon to set. Null removes the icon; omission preserves it. */
  icon?: Icon | null;
  /** Emoji to set. Null removes the emoji; omission preserves it. */
  emoji?: Emoji | null;
}

/** Delete an existing tag definition. Page and block references remain in content but stop resolving. */
export interface ChangeRequestContentChangeDeleteTag {
  operation: "delete_tag";
  /** @minLength 1 */
  tag: string;
}

export interface ChangeRequestContentUpdatePageRef {
  /** Type of Object, always equals to "page". */
  object: "page";
  /** Unique identifier of the page. */
  id: string;
  urls: {
    /** API URL to fetch the page's full, normalized content. For a computed page, it reads the page as stored (`computed=false`), since the computed content replaces the page with the pages it generates. */
    location: URL;
  };
}

/** A page created by the operation with its resolved ID, ref as passed by the caller, and a URL to fetch its content. */
export interface ChangeRequestContentUpdateInsertedPage {
  /** Type of Object, always equals to "created_page". */
  object: "created_page";
  /** The batch-local `ref` provided on the insert operation, echoed so the caller can map their reference to the created page's ID. Absent when the operation had no ref. */
  ref?: string;
  /** Reference to the created page, with a URL to fetch its normalized content. */
  page: ChangeRequestContentUpdatePageRef;
}

/** A page updated by the operation, with a URL to fetch its content. */
export interface ChangeRequestContentUpdateUpdatedPage {
  /** Type of Object, always equals to "updated_page". */
  object: "updated_page";
  /** Reference to the updated page, with a URL to fetch its normalized content. */
  page: ChangeRequestContentUpdatePageRef;
}

/** A page deleted by the batch. Only its ID is returned, as it no longer has content. */
export interface ChangeRequestContentUpdateDeletedPage {
  /** Type of Object, always equals to "deleted_page". */
  object: "deleted_page";
  /** ID of the deleted page. */
  page: string;
}

/** The result of applying a batch of content changes. */
export interface ChangeRequestContentUpdate {
  /** The change request after the batch was applied. */
  changeRequest: ChangeRequest;
  /** One entry per affected page (deduplicated), in the order the pages were first touched by the batch. */
  changes: ChangeRequestContentUpdateChange[];
  /** Files created by the `insert_files` changes in this batch, in the order they were inserted. Use their IDs to reference them from a document. */
  insertedFiles?: RevisionFile[];
  /** Reusable contents created by the `insert_reusable_contents` changes in this batch, in the order they were inserted. Use their IDs to include them from a document. */
  insertedReusableContents?: RevisionReusableContent[];
}

export interface ChangedRevisionPage {
  id: string;
  type: RevisionPageType;
  title: string;
  path?: string;
}

export interface RevisionSemanticChangePageCreated {
  type: "page_created";
  page: ChangedRevisionPage;
}

export interface ChangeAttributeString {
  before?: string;
  after?: string;
}

export interface ChangeAttributeRevisionPageDocumentCover {
  before?: RevisionPageDocumentCover;
  after?: RevisionPageDocumentCover;
}

export type RevisionPageLayout =
  | RevisionPageLayoutPreset
  | RevisionPageLayoutOptions;

export interface ChangeAttributeRevisionPageLayout {
  before?: RevisionPageLayout;
  after?: RevisionPageLayout;
}

export interface ChangeAttributeVariables {
  before?: Variables;
  after?: Variables;
}

export interface RevisionPageDocumentChangeAttributes {
  title?: ChangeAttributeString;
  description?: ChangeAttributeString;
  slug?: ChangeAttributeString;
  document?: ChangeAttributeString;
  cover?: ChangeAttributeRevisionPageDocumentCover;
  emoji?: ChangeAttributeString;
  layout?: ChangeAttributeRevisionPageLayout;
  variables?: ChangeAttributeVariables;
}

export interface RevisionPageGroupChangeAttributes {
  title?: ChangeAttributeString;
  emoji?: ChangeAttributeString;
  slug?: ChangeAttributeString;
}

export interface ChangeAttributeContentReference {
  /** A relative reference to content in GitBook. */
  before?: ContentRef;
  /** A relative reference to content in GitBook. */
  after?: ContentRef;
}

export interface RevisionPageLinkChangeAttributes {
  title?: ChangeAttributeString;
  emoji?: ChangeAttributeString;
  target?: ChangeAttributeContentReference;
}

export interface RevisionSemanticChangePageEdited {
  type: "page_edited";
  page: ChangedRevisionPage;
  attributes:
    | RevisionPageDocumentChangeAttributes
    | RevisionPageGroupChangeAttributes
    | RevisionPageLinkChangeAttributes;
}

export interface RevisionSemanticChangePageDeleted {
  type: "page_deleted";
  page: ChangedRevisionPage;
}

export interface RevisionSemanticChangePageMoved {
  type: "page_moved";
  page: ChangedRevisionPage;
  parent: {
    before?: ChangedRevisionPage;
    after?: ChangedRevisionPage;
  };
}

export interface ChangedRevisionFile {
  id: string;
  name: string;
  contentType: string;
  downloadURL: string;
}

export interface RevisionSemanticChangeFileCreated {
  type: "file_created";
  file: ChangedRevisionFile;
}

export interface ChangeAttributeNumber {
  before?: number;
  after?: number;
}

export interface RevisionFileImageDimensions {
  height: number;
  width: number;
}

export interface ChangeAttributeRevisionFileImageDimensions {
  before?: RevisionFileImageDimensions;
  after?: RevisionFileImageDimensions;
}

export interface RevisionFileChangeAttributes {
  name?: ChangeAttributeString;
  downloadURL?: ChangeAttributeString;
  size?: ChangeAttributeNumber;
  contentType?: ChangeAttributeString;
  dimensions?: ChangeAttributeRevisionFileImageDimensions;
}

export interface RevisionSemanticChangeFileEdited {
  type: "file_edited";
  file: ChangedRevisionFile;
  attributes: RevisionFileChangeAttributes;
}

export interface RevisionSemanticChangeFileDeleted {
  type: "file_deleted";
  file: ChangedRevisionFile;
}

export interface ChangeAttributeVariable {
  before?: VariableValue;
  after?: VariableValue;
}

export interface RevisionSemanticChangeVariablesEdited {
  type: "variables_edited";
  variables: Record<string, ChangeAttributeVariable>;
}

export interface ChangedRevisionReusableContent {
  id: string;
  title: string;
  document?: string;
}

export interface RevisionSemanticChangeReusableContentCreated {
  type: "reusable_content_created";
  reusableContent: ChangedRevisionReusableContent;
}

export interface RevisionSemanticChangeReusableContentDeleted {
  type: "reusable_content_deleted";
  reusableContent: ChangedRevisionReusableContent;
}

export interface RevisionReusableContentChangeAttributes {
  title?: ChangeAttributeString;
  document?: ChangeAttributeString;
}

export interface RevisionSemanticChangeReusableContentEdited {
  type: "reusable_content_edited";
  reusableContent: ChangedRevisionReusableContent;
  attributes: RevisionReusableContentChangeAttributes;
}

export interface ChangedRevisionTag {
  slug: string;
  label: string;
}

export interface RevisionSemanticChangeTagCreated {
  type: "tag_created";
  tag: ChangedRevisionTag;
}

export interface RevisionSemanticChangeTagDeleted {
  type: "tag_deleted";
  tag: ChangedRevisionTag;
}

export interface RevisionTagChangeAttributes {
  label?: ChangeAttributeString;
}

export interface RevisionSemanticChangeTagEdited {
  type: "tag_edited";
  tag: ChangedRevisionTag;
  attributes: RevisionTagChangeAttributes;
}

export type RevisionSemanticChange =
  | RevisionSemanticChangePageCreated
  | RevisionSemanticChangePageEdited
  | RevisionSemanticChangePageDeleted
  | RevisionSemanticChangePageMoved
  | RevisionSemanticChangeFileCreated
  | RevisionSemanticChangeFileEdited
  | RevisionSemanticChangeFileDeleted
  | RevisionSemanticChangeVariablesEdited
  | RevisionSemanticChangeReusableContentCreated
  | RevisionSemanticChangeReusableContentDeleted
  | RevisionSemanticChangeReusableContentEdited
  | RevisionSemanticChangeTagCreated
  | RevisionSemanticChangeTagDeleted
  | RevisionSemanticChangeTagEdited;

export interface RevisionSemanticChanges {
  /** The change request object that initiated the changes in the case of a merge revision. */
  mergedFrom?: ChangeRequest;
  changes: RevisionSemanticChange[];
  /** How many changes were omitted because above the result limit */
  more?: number;
}

export interface UpdateCommentReplySchema {
  /** Content of the comment. */
  body?: Document;
  /** Reactions to add to the comment. */
  addedReactions?: string[];
  /** Reactions to remove from the comment. */
  removedReactions?: string[];
}

/** Why the member is disabled, or false when the member is active. A disabled member cannot access the organization or its content. */
export type MemberDisabled = false | MemberDisabledReason;

export interface OrganizationMember {
  /** Type of Object, always equals to "member" */
  object: "member";
  /** Unique identifier for the user. */
  id: string;
  /** The role of a member in an organization, null for guests */
  role: MemberRoleOrGuest;
  user: User;
  /** Why the member is disabled, or false when the member is active. A disabled member cannot access the organization or its content. */
  disabled: MemberDisabled;
  /** Date at which the user joined the organization. */
  joinedAt: Timestamp;
  /** Date at which the user was last seen active in the organization. */
  lastSeenAt?: Timestamp;
  /** Whether the user can login with SSO. */
  sso: boolean;
  spaces: number;
  teams: number;
  sites: number;
}

/**
 * Title of the integration
 * @minLength 2
 * @maxLength 30
 */
export type IntegrationTitle = string;

/**
 * Description of the integration
 * @maxLength 100
 */
export type IntegrationDescription = string;

/**
 * Long form markdown summary of the integration
 * @maxLength 2048
 */
export type IntegrationSummary = string;

/** Permissions that should be granted to the integration */
export type IntegrationScopes = IntegrationScope[];

/** Categories for which the integration is listed in the marketplace */
export type IntegrationCategories = IntegrationCategory[];

/** Custom blocks defined by this integration. */
export type IntegrationBlocks = IntegrationBlock[];

/** ContentKit component for configuration */
export interface IntegrationConfigurationComponent {
  /** ID of the ContentKit component defined in the integration */
  componentId: string;
}

/** Definition of a content source provided by the integration. */
export interface IntegrationContentSource {
  /** Unique ID in the integration for the source. */
  id: string;
  /**
   * Short descriptive title for the source.
   * @minLength 2
   * @maxLength 40
   */
  title: string;
  /**
   * Long descriptive text for the source.
   * @minLength 0
   * @maxLength 150
   */
  description?: string;
  /** URL of the icon to represent this source. */
  icon?: string;
  /** ContentKit component for configuration */
  configuration: IntegrationConfigurationComponent;
}

/**
 * Property title for an integration configuration property
 * @minLength 2
 * @maxLength 50
 */
export type IntegrationPropertyTitle = string;

/** Schema for a configuration */
export interface IntegrationConfigurationSchema {
  properties: Record<
    string,
    {
      /** Property title for an integration configuration property */
      title?: IntegrationPropertyTitle;
      /** @maxLength 100 */
      description?: string;
    } & (
      | {
          type: "string";
          default?: string;
          /** If specified, this URL will be called to fetch suggestions for auto-completing the property. */
          completion_url?: string;
          /** If specified, only values from this array are allowed as inputs. */
          enum?: string[];
        }
      | {
          type: "number";
          default?: number;
        }
      | {
          type: "boolean";
          default?: boolean;
        }
      | {
          type: "button";
          callback_url: string;
          button_text: string;
        }
    )
  >;
  /** @uniqueItems true */
  required?: string[];
}

export type IntegrationConfiguration =
  | IntegrationConfigurationSchema
  | IntegrationConfigurationComponent;

export interface IntegrationConfigurations {
  account?: IntegrationConfiguration;
  space?: IntegrationConfiguration;
  site?: IntegrationConfiguration;
}

/**
 * External urls configured by the developer of the integration
 * @maxItems 5
 */
export type IntegrationExternalLinks = {
  url: URL;
  label: string;
}[];

/**
 * Name of the organization
 * @minLength 2
 * @maxLength 255
 * @pattern \S.*\S
 */
export type OrganizationTitle = string;

export type OrganizationEmailDomains = string[];

/**
 * Default hostname for the organization's public content, e.g. <org-hostname>.gitbook.io
 * @minLength 3
 * @maxLength 32
 */
export type OrganizationHostname = string;

export interface SitePointer {
  type: "site";
  /** Unique identifier for the site */
  site: string;
}

/** The default content for the organization */
export type OrganizationDefaultContent = SitePointer;

/** An AI credit threshold from 5% to 50%, or null when disabled. */
export type AICreditThreshold = number | null;

/** AI preferences. Missing feature keys leave features enabled, subject to the master AI setting and feature eligibility. */
export interface OrganizationAISettings {
  "ai-agent"?: false;
  "ai-assistant"?: false;
  "ai-broken-links"?: false;
  "ai-content-gap"?: false;
  "ai-insight"?: false;
  "ai-import"?: false;
  "ai-platform"?: false;
  "ai-style-guide"?: false;
  "ai-translation"?: false;
  /** An AI credit threshold from 5% to 50%, or null when disabled. */
  aiCreditAlertThreshold?: AICreditThreshold;
  /** Whether AI features pause automatically once all AI credits are used, before usage is billed as overage. */
  aiCreditPauseEnabled?: boolean;
  aiAlertNotificationAlertId?: string;
  aiPauseNotificationAlertId?: string;
}

/** Pricing pair for monthly and yearly intervals */
export interface OrganizationPricePair {
  /**
   * Monthly price in USD
   * @min 0
   */
  monthly: number;
  /**
   * Yearly price in USD (per month)
   * @min 0
   */
  yearly: number;
}

/** Pricing information for an organization */
export interface OrganizationPricing {
  /** Pricing for members (organization plan) */
  members: {
    /** Pricing pair for monthly and yearly intervals */
    plus_2024: OrganizationPricePair;
    /** Pricing pair for monthly and yearly intervals */
    pro_2024: OrganizationPricePair;
  };
  /** Pricing for site types (site plans) */
  sites: {
    /** Pricing pair for monthly and yearly intervals */
    premium: OrganizationPricePair;
    /** Pricing pair for monthly and yearly intervals */
    ultimate: OrganizationPricePair;
  };
}

export interface BillingMeterAddon {
  enabled: boolean;
}

export interface OrganizationBilling {
  /** Interval for a billing subscription */
  interval: BillingInterval;
  endDate: Timestamp | null;
  /** If true, we were unable to collect the last payment */
  hasPaymentFailed: boolean;
  /**
   * If true, organization can create a checkout session to subscribe/update billing.
   * If false, organization must resolve other billing issues before a checkout can be done.
   */
  canCheckout: boolean;
  /** If true, the billing is set to cancel at the end of its current period */
  isScheduledToCancel: boolean;
  /** Pricing information for the organization */
  pricing: OrganizationPricing;
  /** Configuration for the usage-based addons */
  usageAddons: Record<string, BillingMeterAddon>;
  /** The minimum number of members allowed for this organization. */
  minUsers?: number;
  /** The maximum number of members allowed for this organization */
  maxUsers?: number;
  /** The minimum number of premium sites allowed for this organization. */
  minPremiumSites?: number;
  /** The maximum number of premium sites allowed for this organization. */
  maxPremiumSites?: number;
  /** The minimum number of ultimate sites allowed for this organization. */
  minUltimateSites?: number;
  /** The maximum number of ultimate sites allowed for this organization. */
  maxUltimateSites?: number;
  /** The number of paid members on the current subscription. */
  paidMembers?: number;
  /** The number of paid premium sites on the current subscription. */
  paidPremiumSites?: number;
  /** The number of paid ultimate sites on the current subscription. */
  paidUltimateSites?: number;
  /** Whether changing billing interval is allowed */
  canChangeInterval: boolean;
  /** Whether configuring SAML is allowed */
  canUseSAML: boolean;
  /** Whether AI can be enabled for the organization */
  canUseAI: boolean;
  /** The AI credit bundle the organization tops up every month, or null when the organization is not billed for AI usage. `none` means pay as you go. */
  creditsBundle: BillingCreditsBundle | null;
  /** The yearly AI credit allowance agreed in the organization's contract, or null when none is set. */
  aiCreditAllowance: number | null;
  /**
   * The percentage of unused paid bundle credits carried over to the next monthly AI billing period.
   * @min 0
   * @max 100
   */
  aiCreditRollover: number;
}

/** What support costs the organization, per ticket or per hour of agent time, used to estimate how much AI answers save in site insights. */
export type OrganizationSupportCost =
  | {
      /**
       * Cost of one support ticket, in `currency`.
       * @min 0.01
       */
      perTicket: number;
      /**
       * ISO 4217 currency code.
       * @pattern ^[A-Z]{3}$
       */
      currency: string;
    }
  | {
      /**
       * Cost of one hour of support agent time, in `currency`.
       * @min 0.01
       */
      perHour: number;
      /**
       * ISO 4217 currency code.
       * @pattern ^[A-Z]{3}$
       */
      currency: string;
    };

/**
 * A short description giving context on the reason for the block.
 * @minLength 1
 * @maxLength 255
 */
export type BlockReason = string;

export interface Organization {
  /** Type of Object, always equals to "organization" */
  object: "organization";
  /** Unique identifier for the organization */
  id: string;
  /** Name of the organization */
  title: OrganizationTitle;
  createdAt: Timestamp;
  emailDomains: OrganizationEmailDomains;
  /** Default hostname for the organization's public content, e.g. <org-hostname>.gitbook.io */
  hostname?: OrganizationHostname;
  type: OrganizationType;
  useCase?: OrganizationUseCase;
  communityType?: OrganizationCommunityType;
  /** The role of a member in an organization, null for guests */
  defaultRole?: MemberRoleOrGuest;
  /** The default content for the organization */
  defaultContent?: OrganizationDefaultContent;
  /** Whether SSO is enforced organization-wide */
  sso?: boolean;
  /** If true, the organization is configured to use all our AI features. */
  ai?: boolean;
  /** Whether the master AI setting is turned on, regardless of plan availability. Contract overrides forcing AI off take precedence. */
  aiPreference?: boolean;
  /** AI preferences. Missing feature keys leave features enabled, subject to the master AI setting and feature eligibility. */
  aiSettings?: OrganizationAISettings;
  /** Whether AI features have been paused automatically due to lack of AI credits. */
  aiPaused?: boolean;
  /** If true, invite links are enabled for this organization. */
  inviteLinks: boolean;
  /** Whether audit logs can currently be accessed for this organization. */
  auditLogs?: boolean;
  /** Name of the product */
  plan: BillingProduct;
  /** Billing details, only available for org members. */
  billing?: OrganizationBilling;
  mergeRules: MergeRulesStandaloneConfiguration;
  /** Support cost set by the organization, only available for org members. */
  supportCost?: OrganizationSupportCost;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the organization in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the organization in the application
     * @format uri
     */
    app: string;
    /** URL of the logo of this organization, if defined. */
    logo?: URL;
  };
  trial: {
    /** - notapplicable, no trial can be started for this organization. - none, no trial has been started yet. - active, trial is active. - ended, the trial has ended and the user has choosen to stay on the free plan or has upgraded to a paid plan. - expired, the trial has ended but the user hasn't deciced yet what to do. */
    status: BillingTrialStatus;
    /** Number of trials the organization has consumed. */
    count: number;
    /** The trial's end date, if the organization has or had a trial. */
    endDate?: Timestamp;
    /** The decision taken by the user at the end of the trial */
    decision?: "downgrade";
  };
  /** Custom hostname linked to this organization */
  customHostname?: string;
  /** If the organization is blocked, information about the block will appear here */
  blocked?: {
    /** Source for an organization block */
    source?: BlockSource;
    /** A short description giving context on the reason for the block. */
    reason: BlockReason;
  };
  /** The set of permissions for the organization */
  permissions: {
    /** Can the user view the organization. */
    view: boolean;
    /** Can the user view the organization in the application. */
    access: boolean;
    /** Can the user manage the title, members, etc. */
    admin: boolean;
    /** Is the user a team owner. */
    ownTeam: boolean;
    /** Can the user create new spaces/collections in the organization. */
    createContent: boolean;
    /** Can the user create new OpenAPI specifications. */
    createOpenAPISpec: boolean;
    /** Can the user view the billing details of the organization. */
    viewBilling: boolean;
    /** Can the user list the members of the organization. */
    listMembers: boolean;
    /** Can the user list the teams in the organization. */
    listTeams: boolean;
    /** Can the user list the integrations in the organization. */
    listIntegrations: boolean;
    /** Can the user list the integration installations in the organization. */
    listInstallations: boolean;
    /** Can the user install integrations in the organization. */
    installIntegration: boolean;
  };
}

/**
 * Security policy to validate the content of the integrations scripts and Contentkit. Will be sent as
 * headers when processing the script fetch event and the blocks fetch events.
 */
export type IntegrationContentSecurityPolicy =
  | string
  | {
      "base-uri"?: string;
      "block-all-mixed-content"?: string;
      "child-src"?: string;
      "connect-src"?: string;
      "default-src"?: string;
      "font-src"?: string;
      "form-action"?: string;
      "frame-ancestors"?: string;
      "frame-src"?: string;
      "img-src"?: string;
      "manifest-src"?: string;
      "media-src"?: string;
      "navigate-to"?: string;
      "object-src"?: string;
      "plugin-types"?: string;
      "prefetch-src"?: string;
      referrer?: string;
      "report-to"?: string;
      "report-uri"?: string;
      "require-sri-for"?: string;
      "require-trusted-types-for"?: string;
      sandbox?: string;
      "script-src"?: string;
      "script-src-attr"?: string;
      "script-src-elem"?: string;
      "style-src"?: string;
      "style-src-attr"?: string;
      "style-src-elem"?: string;
      "trusted-types"?: string;
      "upgrade-insecure-requests"?: string;
      "worker-src"?: string;
    };

export interface Integration {
  object: "integration";
  /** Unique named identifier for the integration */
  name: string;
  /** Version of the integration */
  version: number;
  /** Title of the integration */
  title: IntegrationTitle;
  /** Description of the integration */
  description?: IntegrationDescription;
  /** Long form markdown summary of the integration */
  summary?: IntegrationSummary;
  /**
   * URLs of images to showcase the integration
   * @maxItems 3
   */
  previewImages: string[];
  /** The target on which the integration can operate and needs to be configured for */
  target: IntegrationTarget;
  /** If true, the integration has been verified by the GitBook team */
  verified: boolean;
  visibility: IntegrationVisibility;
  /** Permissions that should be granted to the integration */
  scopes: IntegrationScopes;
  /** Categories for which the integration is listed in the marketplace */
  categories: IntegrationCategories;
  /** Custom blocks defined by this integration. */
  blocks?: IntegrationBlocks;
  contentSources?: IntegrationContentSource[];
  configurations?: IntegrationConfigurations;
  /** External urls configured by the developer of the integration */
  externalLinks: IntegrationExternalLinks;
  owner: Organization;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the integration in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the icon associated to the integration
     * @format uri
     */
    icon?: string;
    /**
     * URL of the integration in the application
     * @format uri
     */
    app: string;
    /**
     * URL of the integration's assets.
     * @format uri
     */
    assets: string;
    /**
     * Public HTTP endpoint for the integration
     * @format uri
     */
    publicEndpoint: string;
    /**
     * Public endpoint serving the integration's rendered content (e.g. WebFrames), isolated from the cookie-bearing publicEndpoint origin. Equals publicEndpoint when no separate content origin is configured.
     * @format uri
     */
    publicContentEndpoint: string;
  };
  /** The set of permissions for the integration */
  permissions: {
    admin: boolean;
  };
  /**
   * Security policy to validate the content of the integrations scripts and Contentkit. Will be sent as
   * headers when processing the script fetch event and the blocks fetch events.
   */
  contentSecurityPolicy?: IntegrationContentSecurityPolicy;
}

export type SpaceIntegrationBlocks = {
  /** Unique named identifier for the integration */
  name: string;
  blocks: IntegrationBlock[];
}[];

/**
 * Title of the collection
 * @maxLength 50
 */
export type CollectionTitle = string;

/**
 * Description of the collection
 * @minLength 0
 * @maxLength 100
 */
export type CollectionDescription = string;

export interface Collection {
  /** Type of Object, always equals to "collection" */
  object: "collection";
  /** Unique identifier for the collection */
  id: string;
  /** Title of the collection */
  title: CollectionTitle;
  /** Description of the collection */
  description?: CollectionDescription;
  /** ID of the organization owning this collection */
  organization: string;
  /** ID of the parent collection, if any */
  parent?: string;
  /** Default level for a piece of content */
  defaultLevel: DefaultLevel;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the collection in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the collection in the application
     * @format uri
     */
    app: string;
  };
  /** The set of permissions for the collection */
  permissions: {
    /** Can the user view the collection. */
    view: boolean;
    /** Can the user edit the title/description. */
    admin: boolean;
    /** Can the user view the invite links of the collection. */
    viewInviteLinks: boolean;
    /** Can the user create spaces/collections in this collection. */
    create: boolean;
  };
}

/** Secrets stored on the integration and passed at runtime. */
export type IntegrationSecrets = Record<string, string>;

export interface PublishIntegration {
  /**
   * The runtime version to use for the integration. If not specified, the integration will use the default runtime.
   * @default "v1"
   */
  runtime?: "v1" | "v2";
  /**
   * Base64 content of the icon
   * @format byte
   */
  icon?: string;
  /** Title of the integration */
  title: IntegrationTitle;
  /** Description of the integration */
  description: IntegrationDescription;
  /** Long form markdown summary of the integration */
  summary?: IntegrationSummary;
  /** @maxItems 3 */
  previewImages?: string[];
  visibility?: IntegrationVisibility;
  /** Allowed installation target for the integration. If not specified, the integration can be installed at `all` targets (org, spaces etc) */
  target?: IntegrationTarget;
  /** Permissions that should be granted to the integration */
  scopes: IntegrationScopes;
  /** Categories for which the integration is listed in the marketplace */
  categories?: IntegrationCategories;
  /** Custom blocks defined by this integration. */
  blocks?: IntegrationBlocks;
  contentSources?: IntegrationContentSource[];
  /** External urls configured by the developer of the integration */
  externalLinks?: IntegrationExternalLinks;
  configurations?: IntegrationConfigurations;
  /** Content of the script to use */
  script: string;
  /** The ID or subdomain of the organization under which the integration should be published */
  organization: string;
  /** Secrets stored on the integration and passed at runtime. */
  secrets?: IntegrationSecrets;
  /**
   * Security policy to validate the content of the integrations scripts and Contentkit. Will be sent as
   * headers when processing the script fetch event and the blocks fetch events.
   */
  contentSecurityPolicy?: IntegrationContentSecurityPolicy;
}

/** Configuration of the integration at the account level */
export type IntegrationInstallationConfiguration = Record<string, any>;

/**
 * External IDs assigned by the integration.
 * @maxItems 5
 */
export type IntegrationInstallationExternalIds = string[];

export interface OrganizationTarget {
  organization: string;
}

export type IntegrationInstallationTarget = OrganizationTarget;

/** Network configuration for the installation */
export interface IntegrationNetwork {
  /** Whether the installation is proxied through the backend */
  proxy?: boolean;
}

/** Installation of an integration on an account */
export interface IntegrationInstallation {
  id: string;
  status: IntegrationInstallationStatus;
  /** Describe whether all spaces have been selected or there's a selection involved */
  space_selection: IntegrationInstallationSpaceSelection;
  /** Describe whether all sites have been selected or there's a selection involved */
  site_selection: IntegrationInstallationSiteSelection;
  /** Count of spaces, the installation is managing */
  spaces: number;
  /** Configuration of the integration at the account level */
  configuration: IntegrationInstallationConfiguration;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the installation in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the integration's installation in the application
     * @format uri
     */
    app: string;
    /**
     * Public HTTP endpoint for the integration's installation
     * @format uri
     */
    publicEndpoint: string;
    /**
     * Public endpoint serving the integration's rendered content (e.g. WebFrames), isolated from the cookie-bearing publicEndpoint origin. Equals publicEndpoint when no separate content origin is configured.
     * @format uri
     */
    publicContentEndpoint: string;
  };
  /** External IDs assigned by the integration. */
  externalIds: IntegrationInstallationExternalIds;
  /** Target of the integration installation */
  target: IntegrationInstallationTarget;
  /** Network configuration for the installation */
  network?: IntegrationNetwork;
}

/** Common properties for all events. */
export interface BaseEvent {
  /** Unique identifier for the event. */
  eventId: string;
  /** Type of the event. */
  type: string;
}

/** Common properties for all events related to an installation */
export type InstallationEvent = BaseEvent & {
  /** ID of the integration installation */
  installationId: string;
};

/** Event received when integration has been installed or updated. */
export type InstallationSetupEvent = InstallationEvent & {
  type: "installation_setup";
  status: IntegrationInstallationStatus;
  /** The state of the installation at the account level before it was updated. */
  previous?: {
    status: IntegrationInstallationStatus;
    /** The previous configuration of the installation at the account level. */
    configuration?: object;
  };
};

/** Event received when integration has been uninstalled from an organization. */
export type InstallationDeletedEvent = InstallationEvent & {
  type: "installation_deleted";
  /** The state of the installation before it was deleted. */
  previous: {
    /** The previous configuration of the installation. */
    configuration?: object;
  };
};

/** Common properties for all events related to a specific space. */
export type SpaceEvent = InstallationEvent & {
  /** ID of the space */
  spaceId: string;
};

/** Event received when integration has been installed or updated on a space. */
export type SpaceInstallationSetupEvent = SpaceEvent & {
  type: "space_installation_setup";
  status: IntegrationInstallationStatus;
  /** The state of the Space installation before it was updated. */
  previous?: {
    status: IntegrationInstallationStatus;
    /** The previous configuration of the Space installation. */
    configuration?: object;
  };
};

/** Event received when integration has been uninstalled from a space. */
export type SpaceInstallationDeletedEvent = SpaceEvent & {
  type: "space_installation_deleted";
  /** The state of the Space installation before it was deleted. */
  previous: {
    /** The previous configuration of the Space installation. */
    configuration?: object;
  };
};

/** Common properties for all events related to a specific site. */
export type SiteEvent = InstallationEvent & {
  /** ID of the site */
  siteId: string;
};

/** Event received when integration has been installed or updated on a site. */
export type SiteInstallationSetupEvent = SiteEvent & {
  type: "site_installation_setup";
  status: IntegrationInstallationStatus;
  /** The state of the site installation before it was updated. */
  previous?: {
    status: IntegrationInstallationStatus;
    /** The previous configuration of the site installation. */
    configuration?: object;
  };
};

/** Event received when integration has been uninstalled from a site. */
export type SiteInstallationDeletedEvent = SiteEvent & {
  type: "site_installation_deleted";
  /** The state of the site installation before it was deleted. */
  previous: {
    /** The previous configuration of the site installation. */
    configuration?: object;
  };
};

/** Analytics info on the GitBook's content visitor. */
export interface EventVisitor {
  /** GitBook's unique identifier of the visitor. */
  anonymousId: string;
  /** The visitors cookies. */
  cookies: Record<string, string>;
  /** User-agent of the visitor. */
  userAgent: string;
  /** IP address of the visitor. */
  ip: string;
  /** Language of the visitor. */
  language?: string;
}

/** Event received when a page has been visited on a site. */
export type SiteViewEvent = SiteEvent & {
  type: "site_view";
  /**
   * Unique identifier of the visited space in the site.
   * @deprecated
   */
  spaceId?: string;
  /** The site-space that was viewed */
  siteSpaceId?: string;
  /** Unique identifier of the visited page. */
  pageId?: string;
  /** Analytics info on the GitBook's content visitor. */
  visitor: EventVisitor;
  /** The GitBook content's URL visited (including URL params). */
  url: string;
  /** The URL of referrer that linked to the page. */
  referrer: string;
};

/** Event when the primary content of a space has been updated. */
export type SpaceContentUpdatedEvent = SpaceEvent & {
  type: "space_content_updated";
  /** Unique identifier of the new content revision */
  revisionId: string;
  /** Users who updated the content */
  updatedBy: User[];
};

/** Event when a GitSync operation has been completed. */
export type SpaceGitSyncCompletedEvent = SpaceEvent & {
  type: "space_gitsync_completed";
  state: "success" | "failure";
  /** Unique identifier of the new content revision */
  revisionId: string;
  /** Unique identifier for the commit (sha) */
  commitId: string;
};

/** Event when a GitSync operation has been started. */
export type SpaceGitSyncStartedEvent = SpaceEvent & {
  type: "space_gitsync_started";
  /** Unique identifier of the new content revision */
  revisionId: string;
  /** Unique identifier for the commit (sha) */
  commitId: string;
};

/** Event when the visibility of the space has been changed. */
export type SpaceVisibilityUpdatedEvent = SpaceEvent & {
  type: "space_visibility_updated";
  /**
   * * `public`: Anyone can access the content, and the content is indexed by search engines.
   * * `unlisted`: Anyone can access the content, and the content is not indexed by search engines
   * * `share-link`: Anyone with a secret token in the url can access the content.
   * * `visitor-auth`: Anyone authenticated through a JWT token can access the content.
   * * `in-collection`: Anyone who can access the parent collection can access the content.
   *   Only available for spaces in a collection.
   * * `private`: Authorized members can access the content.
   */
  previousVisibility: ContentVisibility;
  /**
   * * `public`: Anyone can access the content, and the content is indexed by search engines.
   * * `unlisted`: Anyone can access the content, and the content is not indexed by search engines
   * * `share-link`: Anyone with a secret token in the url can access the content.
   * * `visitor-auth`: Anyone authenticated through a JWT token can access the content.
   * * `in-collection`: Anyone who can access the parent collection can access the content.
   *   Only available for spaces in a collection.
   * * `private`: Authorized members can access the content.
   */
  visibility: ContentVisibility;
};

/** Event representing a background task trigger for an integration. */
export type TaskEvent = BaseEvent & {
  type: "task";
  /** Payload associated with the integration task. */
  task: object;
};

export interface FetchRequest {
  method: "post" | "get" | "put" | "delete";
  url: string;
  headers: Record<string, string>;
}

/** Event representing an incoming HTTP request. */
export type FetchEvent = BaseEvent & {
  /** The space ID, if requests are specific to a single space */
  spaceId?: string;
  /** The site ID, if requests are specific to a single site */
  siteId?: string;
  /** The installation ID, if requests are specific to a single installation */
  installationId?: string;
  auth?: {
    /** The user's ID. */
    userId: string;
  };
  type: "fetch";
  request: FetchRequest;
};

/** Common properties for all events related to fetching a published script from an installation */
export type FetchPublishedScriptEvent = SiteEvent & {
  type: "fetch_published_script";
};

/** Common properties for all events related to authenticated access from an installation */
export type FetchVisitorAuthenticationEvent = SiteEvent & {
  type: "fetch_visitor_authentication";
  location?: string;
  /** Whitelisted search parameters from the visitor authentication request. */
  searchParams?: Record<string, string>;
  /** Whitelisted cookies from the visitor authentication request. */
  cookies?: Record<string, string>;
  /** The visitor authentication action to resolve. If omitted, integrations resolve to the existing login redirect. */
  action?: "logout";
};

/** Common properties for ContentKit context. */
export interface ContentKitContextBase {
  theme: "dark" | "light";
}

/** Context while rendering in an account installation's configuration. */
export type ContentKitContextConfigurationAccount = ContentKitContextBase & {
  type: "configuration_account";
  /** ID of the organization the account installation configuration is in. */
  organizationId: string;
};

/** Context while rendering in a space-installation's configuration. */
export type ContentKitContextConfigurationSpace = ContentKitContextBase & {
  type: "configuration_space";
  /** ID of the space the space-installation configuration is in. */
  spaceId: string;
};

/** Context while rendering in a site-installation's configuration. */
export type ContentKitContextConfigurationSite = ContentKitContextBase & {
  type: "configuration_site";
  /** ID of the site the site-installation configuration is in. */
  siteId: string;
};

/** Context while rendering the configuration flow of a content source. */
export type ContentKitContextConfigurationContentSource =
  ContentKitContextBase & {
    type: "configuration_contentsource";
    /** ID of the organization the content source installation configuration is in. */
    organizationId: string;
    /** Optional ID of the space the content source installation configuration is in. */
    spaceId?: string;
  };

/** Context while rendering in a document. */
export type ContentKitContextDocument = ContentKitContextBase & {
  type: "document";
  /** ID of the space content the document is in. */
  spaceId: string;
  editable: boolean;
};

/** Object representing the context in which a ContentKit component is rendered. */
export type ContentKitContext =
  | ContentKitContextConfigurationAccount
  | ContentKitContextConfigurationSpace
  | ContentKitContextConfigurationSite
  | ContentKitContextConfigurationContentSource
  | ContentKitContextDocument;

/** Event generated when rendering a UI */
export type UIRenderEvent = (SpaceEvent | SiteEvent | InstallationEvent) & {
  auth?: {
    /** The user's ID. */
    userId: string;
  };
  type: "ui_render";
  componentId: string;
  /** Properties to render the UI. */
  props: object;
  /** State of the UI. */
  state?: object;
  /** Object representing the context in which a ContentKit component is rendered. */
  context: ContentKitContext;
  action?: object;
};

/** Generic event when computing the content of a space */
export type ContentComputeEvent = SpaceEvent & {
  sourceId: string;
  /** Properties passed to the rendering. */
  props: PlainObject;
  /** Dependencies of the computation. */
  dependencies: Record<string, ComputedContentDependencyResolved>;
};

/**
 * Event generated when computing the document of a pages.
 * The integration should respond with a `Document`.
 */
export type ContentComputeDocumentEvent = ContentComputeEvent & {
  type: "content_compute_document";
};

/**
 * Event generated when computing revision in a content.
 * The integration should respond with an array of pages and files.
 */
export type ContentComputeRevisionEvent = ContentComputeEvent & {
  type: "content_compute_revision";
};

/** Event received when feedback has been submitted on a page. */
export type PageFeedbackEvent = BaseEvent & {
  type: "page_feedback";
  /** ID of the integration installation */
  installationId: string;
  /**
   * Unique identifier of the space in the site.
   * @deprecated
   */
  spaceId?: string;
  /** Unique identifier of the site. */
  siteId: string;
  /** Unique identifier of the page where feedback was submitted. */
  pageId?: string;
  /** The feedback data submitted by the visitor. */
  feedback: {
    rating: PageFeedbackRating;
    /**
     * Optional comment provided with the feedback.
     * @minLength 1
     * @maxLength 512
     */
    comment?: string;
  };
  /** Analytics info on the GitBook's content visitor. */
  visitor: EventVisitor;
  /** The GitBook content's URL where feedback was submitted. */
  url: string;
  /** The URL of referrer that linked to the page. */
  referrer: string;
};

export interface IntegrationEvent {
  /** Unique ID of the event. */
  id: string;
  /** Unique ID of the integration. */
  integrationId: string;
  /** Unique ID of the integration installation. */
  installationId?: string;
  createdAt: Timestamp;
  /** Any event that can be received from GitBook. */
  payload: Event;
  /** Status of the event. */
  status: "success" | "failed";
}

export interface IntegrationEventLog {
  /** The message of the log entry. */
  message?: string;
  timestamp?: Timestamp;
  /** The level of the log entry. */
  level?: "debug" | "info" | "warn" | "error";
}

export interface IntegrationEventTrace {
  logs: IntegrationEventLog[];
}

/** Base properties of an installation of an integration on a site or space. */
export interface IntegrationContentInstallationBase {
  /** Unique name identifier of the integration */
  integration: string;
  /** ID of the integration installation */
  installation: string;
  status: IntegrationInstallationStatus;
  /** Configuration of the integration for this site */
  configuration: object;
  /** External IDs assigned by the integration. */
  externalIds: IntegrationInstallationExternalIds;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the integration's installation in the API
     * @format uri
     */
    location: string;
    /**
     * Public HTTP endpoint for the integration's installation
     * @format uri
     */
    publicEndpoint: string;
    /**
     * Public endpoint serving the integration's rendered content (e.g. WebFrames), isolated from the cookie-bearing publicEndpoint origin. Equals publicEndpoint when no separate content origin is configured.
     * @format uri
     */
    publicContentEndpoint: string;
  };
}

export type IntegrationSpaceInstallation =
  IntegrationContentInstallationBase & {
    /** The space the integration is installed on. Using the string value is deprecated in favor of space.id */
    space: string | Space;
  };

/**
 * Title of the site
 * @minLength 2
 * @maxLength 128
 */
export type SiteTitle = string;

export interface CustomizationThemedURL {
  light: URL;
  dark: URL;
}

export type CustomizationFavicon =
  | {
      icon: CustomizationThemedURL;
    }
  | {
      /** Unicode codepoint or character of the emoji */
      emoji: Emoji;
    }
  | object;

/**
 * Custom hostname for the site, for e.g. docs.mycompany.com
 * @maxLength 512
 * @pattern ^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?[.]){2,}[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$
 */
export type SiteHostname = string;

/**
 * Basename for the site. For e.g. api
 * @minLength 1
 * @maxLength 100
 */
export type SiteBasename = string;

/**
 * Proxy URL for the site, for e.g. company.com/docs or www.company.com/developer/docs etc.
 * @maxLength 512
 * @pattern ^([\w-]+\.)*[\w-]+\.[a-zA-Z]{2,}(\/[\w-]+)+$
 */
export type SiteProxyOrigin = string;

export interface SiteProxy {
  /** Proxy URL for the site, for e.g. company.com/docs or www.company.com/developer/docs etc. */
  origin: SiteProxyOrigin;
  /** The target URL to which the requests at the origin URL should be proxied to. */
  target: string;
}

export interface SiteAdaptiveContent {
  /** Whether adaptive content should be enabled on the site. */
  enabled: boolean;
}

export type SiteAds =
  | {
      status: "pending";
      /** True if the user can submit the site for review. */
      submittable: boolean;
    }
  | {
      status: "in-review";
      /** Topic of the content */
      topic: SiteAdsTopic;
    }
  | {
      status: "rejected";
      /** Reason for the rejection */
      reason?: string;
    }
  | {
      status: "live" | "disabled";
      /** Topic of the content */
      topic: SiteAdsTopic;
      /** The ad network zone ID */
      zoneId: string;
    };

/** A site feature and the plan it is available on. */
export interface SiteFeature {
  /** The site feature identifier */
  id: SiteFeatureKey;
  /** The type of the site */
  plan: SiteType;
  /** A frozen feature is still enabled but cannot be changed or modified. */
  frozen: boolean;
  /** A list of the actual advanced customizations used (only applicable for sites-advanced-customization) */
  customizations?: SiteCustomizationFeature[];
}

export interface Site {
  object: "site";
  /** Unique identifier of the site */
  id: string;
  /** The type of the site */
  type: SiteType;
  /** The currently applied type of the site. For example, frozen sites will have this set to Basic. */
  appliedType: SiteType;
  /** Who unpublished this site last. Cleared when the site is published again. */
  unpublishedBy?: "user" | "system";
  /** Title of the site */
  title: SiteTitle;
  icon?: CustomizationFavicon | null;
  /** Custom hostname for the site, for e.g. docs.mycompany.com */
  hostname?: SiteHostname;
  /** Basename for the site. For e.g. api */
  basename?: SiteBasename;
  proxy?: SiteProxy;
  /**
   * The visibility setting of the site determines the audience of the site.
   * * `public`: Anyone can access the site, and the site is indexed by search engines.
   * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
   * * `share-link`: Anyone with a secret token in the url can access the site.
   * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
   */
  visibility: SiteVisibility;
  /** Default level for a piece of content */
  defaultLevel: DefaultLevel;
  /** The set of permissions for the site. */
  permissions: {
    /** Can the user view the site. */
    view: boolean;
    /** Can the user access the site in the application. */
    access: boolean;
    /** Can the user edit content and create draft content in the site. */
    edit: boolean;
    /** Can the user create draft content, publish content, and manage the site's content structure. */
    create: boolean;
    /** Can the user manage the site content, settings and publish the site. */
    admin: boolean;
    /** Can the user install integrations on the site. */
    installIntegration: boolean;
    /** Can the user view the adaptive schema of the site. */
    viewAdaptiveSchema: boolean;
    /** Can the user edit the adaptive schema of the site. */
    editAdaptiveSchema: boolean;
  };
  /** Whether the site is live or not. If true, the site is accessible to the audience defined by the visibility setting. */
  published: boolean;
  siteSpaces: number;
  gitSync?: GitSyncState;
  /** @format date-time */
  createdAt: string;
  /**
   * When GitBook last completed a scan of the site's content
   * gaps. Absent until the site has been scanned at least once.
   * @format date-time
   */
  lastScanAt?: string;
  adaptiveContent?: SiteAdaptiveContent;
  ads?: SiteAds;
  /**
   * Reference to a GitBook space holding the team's writing style guide.
   * When present on a site, the editing agent receives the style guide
   * table of contents in its system prompt and can fetch sections on
   * demand to check edits against the rules.
   */
  styleguide?: ContentRefSpace;
  /** A list of all premium features enabled on this site. For each feature we list the plan they belong to and whether the feature is frozen. A frozen feature is still enabled but cannot be changed or modified. */
  features: SiteFeature[];
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the site in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the site in the application
     * @format uri
     */
    app: string;
    /**
     * URL of the published version of the site. Only defined when site is published.
     * @format uri
     */
    published?: string;
    /**
     * URL of the preview version of the site.
     * @format uri
     */
    preview: string;
    /**
     * URL of the login endpoint for visitors to authenticate with the site auth backend.
     * @format uri
     */
    login?: string;
    /**
     * URL of the logout endpoint for visitors to sign out from the site auth backend.
     * @format uri
     */
    logout?: string;
  };
}

export type IntegrationSiteInstallation = IntegrationContentInstallationBase & {
  /** The site the integration is installed on. Using the string value is deprecated in favor of site.id */
  site: string | Site;
};

/** A confirm object that defines an optional confirmation dialog after the input is clicked. */
export interface ContentKitConfirm {
  /**
   * A text value that defines the dialog's title.
   * @maxLength 100
   */
  title: string;
  /**
   * A text value that defines the explanatory text that appears in the confirm dialog.
   * @maxLength 300
   */
  text: string;
  /**
   * A text value to define the text of the button that confirms the action.
   * @maxLength 30
   */
  confirm: string;
  style?: "primary" | "danger";
}

/** Pressable button triggering an action. */
export interface ContentKitButton {
  type: "button";
  style?: "primary" | "secondary" | "danger";
  /** Custom action to re-render the block. */
  onPress: ContentKitAction;
  icon?: ContentKitIcon;
  trailingIcon?: ContentKitIcon;
  label?: string;
  tooltip?: string;
  /** A confirm object that defines an optional confirmation dialog after the input is clicked. */
  confirm?: ContentKitConfirm;
  disabled?: boolean;
}

/** Text input to prompt the user. */
export interface ContentKitTextInput {
  type: "textinput";
  disabled?: boolean;
  /** State binding. The value of the input will be stored as a property in the state named after this ID. */
  state: string;
  /** Text value to initialize the input with. */
  initialValue?: string;
  /** Text that appears in the form control when it has no value set */
  placeholder?: string;
  multiline?: boolean;
  /** @default "text" */
  inputType?: "text" | "password" | "email";
}

/** Horizontal stack of boxes. */
export interface ContentKitHStack {
  type: "hstack";
  /** @default "start" */
  align?: "start" | "center" | "end";
  children: ContentKitDescendantElement[];
}

/** Vertical stack of boxes. */
export interface ContentKitVStack {
  type: "vstack";
  /** @default "start" */
  align?: "start" | "center" | "end";
  children: ContentKitDescendantElement[];
}

export interface ContentKitBox {
  type: "box";
  /** specifies how much of the remaining space in the container should be assigned to the element */
  grow?: number;
  children: ContentKitDescendantElement[];
}

/** Divider between 2 boxes in a stack. */
export interface ContentKitDivider {
  type: "divider";
  size?: "small" | "medium" | "large";
}

/** Binding between a property and a state value. */
export interface ContentKitDynamicBinding {
  /** Key in the state */
  $state: string;
}

/** Frame for a webpage */
export interface ContentKitWebFrame {
  type: "webframe";
  /** Ratio between width and height. Used to size the webframe. */
  aspectRatio?: number;
  /** Content to load in the frame. */
  source: {
    url: string;
  };
  /** Controls button shown as an overlay in a corner of the frame. */
  buttons?: ContentKitButton[];
  /** Data to communicated to the webframe's content. Each state update will cause the webframe to receive a message. */
  data?: Record<string, string | ContentKitDynamicBinding>;
}

/** Code block with syntax highlighting */
export interface ContentKitCodeBlock {
  type: "codeblock";
  /** Code content to display */
  content: ContentKitDynamicBinding | string;
  /** Syntax to use for highlighting (ex: javascript, python) */
  syntax?: string;
  /** Line number to start at. */
  lineNumbers?: boolean | number;
  /** Controls button shown as an overlay in a corner of the code block. */
  buttons?: ContentKitButton[];
  /** State binding when editable. The value of the input will be stored as a property in the state named after this ID. */
  state?: string;
  /** Custom action to re-render the block. */
  onContentChange?: ContentKitAction;
  /** Header displayed before the code lines */
  header?: ContentKitDescendantElement[];
  /** Footer displayed after the code lines */
  footer?: ContentKitDescendantElement[];
}

/** Block with rich text formatting of a markdown content. */
export interface ContentKitMarkdown {
  type: "markdown";
  /** Markdown content to display */
  content: ContentKitDynamicBinding | string;
}

/** Low level text element. */
export interface ContentKitText {
  type: "text";
  style?: "bold" | "italic" | "code" | "strikethrough";
  children: string | (string | ContentKitText | ContentKitLink)[];
}

/** Specification for an URL in ContentKit. */
export interface ContentKitURL {
  /**
   * Hostname of the URL along with the port number if required.
   * @example "api.example.com"
   */
  host: string;
  /**
   * Path of the URL prefixed with a `/`.
   * @example "/v1/options"
   */
  pathname: string;
  query?: Record<string, string | ContentKitDynamicBinding>;
}

export interface ContentKitLink {
  type: "link";
  target: {
    url: string | ContentKitURL;
  };
  children: string | string[];
}

export interface ContentKitImage {
  type: "image";
  source: {
    /** @format uri */
    url: string;
  };
  aspectRatio: number;
}

export interface ContentKitCard {
  type: "card";
  title?: string;
  hint?: string | ContentKitInlineElement[];
  icon?: ContentKitIcon | ContentKitImage;
  /** Custom action to re-render the block. */
  onPress?: ContentKitAction;
  children?: ContentKitDescendantElement[];
  /** Buttons displayed in the top right corner of the card. */
  buttons?: ContentKitButton[];
}

/** Built-in sources that can be used to provide a ContentKitSelect. */
export interface ContentKitBuiltInSource {
  source: "openapi";
}

/** An individual option in a select element */
export interface ContentKitSelectOption {
  id: string;
  label: string;
  icon?: ContentKitIcon | ContentKitImage;
}

/** Creates a drop down menu with a list of options for a user to choose. */
export interface ContentKitSelect {
  type: "select";
  disabled?: boolean;
  /** State binding. The value of the input will be stored as a property in the state named after this ID. */
  state: string;
  /** Value to initialize the select with. */
  initialValue?: string | string[];
  /** Custom action to re-render the block. */
  onValueChange?: ContentKitAction;
  /** Text that appears in the form control when it has no value set */
  placeholder?: string;
  /** Should the select accept the selection of multiple options. If true, the state will be an array. */
  multiple?: boolean;
  /** Should the filter input be allowed to be selected as an option. */
  acceptInput?: boolean;
  /** Options to be displayed in the select. */
  options:
    | ContentKitBuiltInSource
    | ContentKitSelectOption[]
    | {
        /** External source of options. The URL should respond with an array of options. */
        url: string | ContentKitURL;
      };
}

/** Renders a boolean input. */
export interface ContentKitSwitch {
  type: "switch";
  disabled?: boolean;
  /** State binding. The value of the input will be stored as a property in the state named after this ID. */
  state: string;
  /** Value to initialize the switch with. */
  initialValue?: boolean;
  /** Custom action to re-render the block. */
  onValueChange?: ContentKitAction;
  /** A confirm object that defines an optional confirmation dialog after the input is clicked. */
  confirm?: ContentKitConfirm;
}

export interface ContentKitRadio {
  type: "radio";
  disabled?: boolean;
  /** State binding. The value of the input will be stored as a property in the state named after this ID. */
  state: string;
  /** Value to store in th state when the checkbox is selected. */
  value: string | number;
  /** A confirm object that defines an optional confirmation dialog after the input is clicked. */
  confirm?: ContentKitConfirm;
}

export interface ContentKitCheckbox {
  type: "checkbox";
  /** State binding. The value of the input will be stored as a property in the state named after this ID. */
  state: string;
  /** Value to store in a state array when the checkbox is selected. */
  value: string | number;
  /** A confirm object that defines an optional confirmation dialog after the input is clicked. */
  confirm?: ContentKitConfirm;
}

/** Field for an input. */
export interface ContentKitInput {
  type: "input";
  /** Text label displayed next to the input. */
  label: string;
  hint?: string | ContentKitInlineElement;
  element:
    | ContentKitTextInput
    | ContentKitSelect
    | ContentKitSwitch
    | ContentKitRadio
    | ContentKitCheckbox
    | ContentKitButton
    | ContentKitCodeBlock;
}

/** Element used to contextualize other elements or info. */
export interface ContentKitHint {
  type: "hint";
  children: ContentKitInlineElement[];
}

export interface ContentKitStepperStep {
  type: "step";
  /** unique identifier for the step */
  id: string;
  /**
   * title of the step
   * @maxLength 50
   */
  title?: string;
  /**
   * indicates if the user can progress to the next step based on some internal validation or condition
   * @default false
   */
  next?: boolean;
  /** @minItems 1 */
  children: ContentKitDescendantElement[];
}

/** Control menu item displayed for the block. */
export interface ContentKitBlockControl {
  icon?: ContentKitIcon;
  label: string;
  /** Custom action to re-render the block. */
  onPress: ContentKitAction;
  /** A confirm object that defines an optional confirmation dialog after the input is clicked. */
  confirm?: ContentKitConfirm;
}

/** Higher level element to represent a custom block. */
export interface ContentKitBlock {
  type: "block";
  children: ContentKitDescendantElement[];
  controls?: (ContentKitBlockControl | ContentKitBlockControl[])[];
}

/** Overlay modal. */
export interface ContentKitModal {
  type: "modal";
  title?: string;
  subtitle?: ContentKitInlineElement[];
  size?: "medium" | "xlarge" | "fullscreen";
  /** Data passed back to the parent view when the modal is closed. These data are accessible in the "@ui.modal.close" */
  returnValue?: object;
  children: ContentKitDescendantElement[];
  /** Pressable button triggering an action. */
  submit?: ContentKitButton;
}

export interface ContentKitStepper {
  type: "stepper";
  /** id of the currently active step */
  activeStep: string;
  /** Custom action to re-render the block. */
  onStepChange: ContentKitAction;
  /** Custom action to re-render the block. */
  onComplete: ContentKitAction;
  /** @minItems 1 */
  children: ContentKitStepperStep[];
}

/** Higher level element to define a configuration block. Does not add any UI elements or wrappers. Must be used as a top level element for any configuration component. */
export interface ContentKitConfiguration {
  type: "configuration";
  children: ContentKitStepper[] | ContentKitDescendantElement[];
}

/** Output of type element in the lifecycle of the component. */
export interface ContentKitRenderOutputElement {
  type?: "element";
  /** Element used as root */
  element: ContentKitRootElement;
  state: object;
  props: PlainObject;
  /** Whether the rendered integration UI can receive visitor claims. */
  canAccessVisitorClaims?: boolean;
}

/** Output of completed lifecycle of the component. */
export interface ContentKitRenderOutputComplete {
  type: "complete";
  returnValue?: object;
}

/** Output of the integration when rendering a UI. */
export type ContentKitRenderOutput =
  | ContentKitRenderOutputElement
  | ContentKitRenderOutputComplete;

export interface RenderIntegrationUI {
  /** ID of the component to render in the integration. */
  componentId: string;
  /** Current properties of the UI. */
  props: PlainObject;
  /** Current local state of the UI. */
  state?: object;
  /** Object representing the context in which a ContentKit component is rendered. */
  context: ContentKitContext;
  /** Custom action to re-render the block. */
  action?: ContentKitAction;
}

export interface UpdateIntegrationInstallation {
  /** External IDs assigned by the integration. */
  externalIds?: IntegrationInstallationExternalIds;
  /** Configuration of the integration at the account level */
  configuration?: IntegrationInstallationConfiguration;
  /** Describe whether all spaces have been selected or there's a selection involved */
  space_selection?: IntegrationInstallationSpaceSelection;
  /** Describe whether all sites have been selected or there's a selection involved */
  site_selection?: IntegrationInstallationSiteSelection;
}

export interface UpdateIntegrationSpaceInstallation {
  /** External IDs assigned by the integration. */
  externalIds?: IntegrationInstallationExternalIds;
  /** Configuration of the integration at the account level */
  configuration?: IntegrationInstallationConfiguration;
}

export interface UpdateIntegrationSiteInstallation {
  /** External IDs assigned by the integration. */
  externalIds?: IntegrationInstallationExternalIds;
  /** Configuration of the integration at the account level */
  configuration?: IntegrationInstallationConfiguration;
}

/** Preferences collected from the user during site onboarding, used to tailor recommendations and to apply their initial setup choices. */
export interface SiteOnboardingPreferences {
  source: SiteOnboardingSource | null;
  audience: SiteOnboardingAudience | null;
  interests: SiteOnboardingInterest[];
}

export interface CreateOrganization {
  /** Name of the organization */
  title: OrganizationTitle;
  emailDomains?: OrganizationEmailDomains;
  /** Preferences collected from the user during onboarding, to apply to the organization's default site. Only used when `withDefaultSite` is true. */
  onboardingPreferences?: SiteOnboardingPreferences;
}

/** The current or last trial of an organization. */
export interface SubscriptionTrial {
  /** - notapplicable, no trial can be started for this organization. - none, no trial has been started yet. - active, trial is active. - ended, the trial has ended and the user has choosen to stay on the free plan or has upgraded to a paid plan. - expired, the trial has ended but the user hasn't deciced yet what to do. */
  status: BillingTrialStatus;
  /** When the trial ends, or ended. */
  endDate: Timestamp;
  /** Days left in the trial, rounded up, so 1 is its last day. 0 once it has ended. */
  daysRemaining: number;
}

/** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
export interface SubscriptionNotice {
  /** - trial_started, the operation started the organization's trial. - trial_countdown, the organization's trial ends soon. - checkout_required, the operation needs a paid plan to complete. */
  type: "trial_started" | "trial_countdown" | "checkout_required";
  /** What the user was doing when the notice was given. */
  context:
    | "trial_started"
    | "site_publishing"
    | "site_features"
    | "site_customization";
  /** Whether the organization is on a trial, the free plan, or a paid plan. */
  commercialStatus: "trial" | "free" | "paid";
  /** Message to show the user. For users who cannot upgrade, it asks them to reach out to an administrator of the organization. */
  message: string;
  /** The current or last trial of an organization. */
  trial?: SubscriptionTrial;
  /** Whether the user is an administrator of the organization, and so can upgrade. Otherwise, they have to ask an administrator to upgrade. */
  canManageBilling: boolean;
  /** Where to upgrade in the application. Only set when `canManageBilling` is true. */
  upgradeUrl?: URL;
  /** Public page comparing the GitBook plans. */
  pricingUrl: URL;
}

/** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
export type OptOutUpdate = false | null;

/** Partial AI preference update. Omitted keys are unchanged; null removes an opt-out. */
export interface OrganizationAISettingsUpdate {
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-agent"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-assistant"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-broken-links"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-content-gap"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-insight"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-import"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-platform"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-style-guide"?: OptOutUpdate;
  /** Set false to disable, or null to remove the opt-out. Omit to leave unchanged. */
  "ai-translation"?: OptOutUpdate;
}

/**
 * Title of the site section
 * @minLength 2
 * @maxLength 128
 */
export type SiteSectionTitle = string;

/** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
export type LocalizedString128 = Partial<Record<TranslationLanguage, string>>;

/**
 * Description of the site section
 * @minLength 0
 * @maxLength 256
 */
export type SiteSectionDescription = string;

/** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
export type LocalizedString256 = Partial<Record<TranslationLanguage, string>>;

/**
 * Path to the section on the site
 * @minLength 1
 * @maxLength 100
 */
export type SiteSectionPath = string;

/**
 * Path to the space on the site
 * @minLength 1
 * @maxLength 100
 */
export type SiteSpacePath = string;

export interface SiteSpace {
  /** The object type, which is always "site-space" */
  object: "site-space";
  /** Unique identifier of the site-space */
  id: string;
  /** Path to the space on the site */
  path: SiteSpacePath;
  /** ID of the section the space belongs to in the site */
  section?: string;
  space: Space;
  title: string;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Whether this is the default space for the site */
  default?: boolean;
  /** Conditional expression used to evaluate whether the site space should be shown to the site's visitor. */
  condition?: Expression;
  /** Custom home page within the space, rendered at the site space's path root instead of the space's default landing page. */
  pageId?: string | null;
  /** Whether the site space is draft and not live. */
  draft: boolean;
  /** Whether the space has advanced customization feature enabled */
  hasAdvancedCustomizationFeature?: boolean;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the published version of the site-space. Only defined when site is published.
     * @format uri
     */
    published?: string;
  };
  /** Whether the site space is hidden. If true, the site space will not be shown in the site's navigation. */
  hidden?: boolean;
}

export interface SiteSection {
  /** The object type, which is always "site-section" */
  object: "site-section";
  /** Unique identifier of the site section */
  id: string;
  /** Title of the site section */
  title: SiteSectionTitle;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Description of the site section */
  description?: SiteSectionDescription;
  /** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedDescription?: LocalizedString256;
  /** Whether this is the default section for the site */
  default?: boolean;
  /** Whether the site section is draft and not live. */
  draft: boolean;
  /** Whether the site section is hidden. It is hidden when all of its site spaces are hidden, in which case it is not shown in the site's navigation. */
  hidden?: boolean;
  /** Path to the section on the site */
  path: SiteSectionPath;
  /** Conditional expression used to evaluate whether the site section should be shown to the site's visitor. */
  condition?: Expression;
  /** ID of the section group the section belongs to in the site */
  sectionGroup?: string;
  siteSpaces: SiteSpace[];
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the published version of the site section. Only defined when site is published.
     * @format uri
     */
    published?: string;
  };
  /** Name of the icon */
  icon?: Icon;
}

/**
 * Title of the site section group
 * @minLength 1
 * @maxLength 100
 */
export type SiteSectionGroupTitle = string;

export interface SiteSectionGroup {
  /** The object type, which is always "site-section-group" */
  object: "site-section-group";
  /** Unique identifier of the site section group */
  id: string;
  /** Title of the site section group */
  title: SiteSectionGroupTitle;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /**
   * List of site section ids that are members of the group. Use `children` instead.
   * @deprecated
   */
  sections: SiteSection[];
  /** Conditional expression used to evaluate whether the site section group should be shown to the site's visitor. */
  condition?: Expression;
  /** ID of the parent section group this group belongs to */
  sectionGroup?: string;
  /** Whether the site section group is draft and not live. */
  draft: boolean;
  /** List of all child sections, groups, and external links nested under this group */
  children: (SiteSection | SiteSectionGroup | SiteExternalLink)[];
  /** Name of the icon */
  icon?: Icon;
}

export interface SiteExternalLink {
  /** The object type, which is always "site-external-link" */
  object: "site-external-link";
  /** Unique identifier of the external link */
  id: string;
  /** Title of the site section */
  title: SiteSectionTitle;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Description of the site section */
  description?: SiteSectionDescription;
  /** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedDescription?: LocalizedString256;
  /** Name of the icon */
  icon?: Icon;
  /** Absolute HTTP or HTTPS URL opened by the external link */
  url: URL;
  /** ID of the section group the external link belongs to. Omitted for a root link. */
  sectionGroup?: string;
  /** Whether the external link is draft and not live */
  draft: boolean;
  /** Conditional expression used to evaluate whether the external link should be shown to the site's visitor */
  condition?: Expression;
}

export type SiteStructure =
  | {
      type: "sections";
      structure: (SiteSection | SiteSectionGroup | SiteExternalLink)[];
    }
  | {
      type: "siteSpaces";
      structure: SiteSpace[];
    };

export interface OrganizationAllSite {
  site: Site;
  structure: SiteStructure;
}

export interface OrganizationAllCollection {
  collection: Collection;
  content: (OrganizationAllCollection | OrganizationAllSpace)[];
}

export interface OrganizationAllSpace {
  space: Space;
}

export interface OrganizationAllContent {
  sites: OrganizationAllSite[];
  spaces: (OrganizationAllCollection | OrganizationAllSpace)[];
  /** List of soft-deleted spaces. */
  deletedSpaces: OrganizationAllSpace[];
}

export interface AuditEventAction {
  object: "audit-event-action";
  /** Stable action identifier stored on audit events. */
  id: string;
  /** Human-readable label for the action. */
  label: string;
}

export interface AuditEventActor {
  /** Kind of actor that initiated the change. */
  type: "user" | "integration" | "installation" | "system" | "support";
  /** Stable identifier of the actor. */
  id: string;
  /** Display label captured when the event was recorded. */
  label?: string;
  /** GitBook staff member acting as this user. Present only for recorded impersonation; older events may not have this information. The actor ID remains the effective user for filtering. */
  impersonator?: {
    /** Stable ID of the impersonating staff member. */
    id: string;
    /** Staff display name captured when the event was recorded, if available. */
    label?: string;
  };
}

export interface AuditEventTarget {
  /** Kind of resource affected by the change. */
  type: string;
  /** Stable identifier of the affected resource. */
  id: string;
  /** Display label captured when the event was recorded. */
  label?: string;
}

export interface AuditEvent {
  object: "audit-event";
  /**
   * Unique identifier of the audit event.
   * @format uuid
   */
  id: string;
  occurredAt: Timestamp;
  /** Stable action name describing the recorded change. */
  action: string;
  actor: AuditEventActor;
  /** Entry point that initiated the change. */
  source:
    | "ui"
    | "api"
    | "integration"
    | "webhook"
    | "workflow"
    | "script"
    | "support";
  target: AuditEventTarget;
  urls: {
    /**
     * URL of the audit event in the API.
     * @format uri
     */
    location: string;
  };
}

export type AuditEventDetails = AuditEvent & {
  /** Identifier of the operation that recorded the event. */
  executionId?: string;
  /** Identifier shared by events produced by the same user action. */
  correlationId?: string;
  /**
   * Audit event that caused this later system effect.
   * @format uuid
   */
  causedByEventId?: string;
  /**
   * Version of the action payload schema.
   * @min 1
   */
  schemaVersion: number;
  /** Allowlisted details specific to the action. */
  payload: Record<string, any>;
};

/** A style guide space and all the sites referencing it. */
export interface OrganizationStyleguide {
  space: Space;
  /** Sites in the organization that reference this style guide. */
  sites: Site[];
}

export interface OrganizationStyleguides {
  styleguides: OrganizationStyleguide[];
}

/** A built-in style guide starter template used to seed and preview a style guide. */
export interface StyleguideTemplate {
  /** Identifier of the template, passed to createSiteStyleguideById to seed a style guide from it. */
  id: string;
  /** Human-readable name of the template. */
  title: string;
  /** Short one-line description of the template. */
  subtitle?: string;
  /** Emoji illustrating the template. */
  emoji?: string;
  /** Markdown content of the template, rendered as a preview. */
  markdown: string;
}

export interface StyleguideTemplates {
  templates: StyleguideTemplate[];
}

/** An organization's subscription, as needed to tell a user their plan, trial and how to upgrade. */
export interface OrganizationSubscription {
  /** Type of Object, always equals to "organization-subscription" */
  object: "organization-subscription";
  /** Whether the organization is on a trial, the free plan, or a paid plan. */
  status: "trial" | "free" | "paid";
  /** The plan in effect, which is the trial's plan while trialing. */
  plan: {
    /** Name of the product */
    id: BillingProduct;
    /** Name of the plan shown to users, e.g. Pro. */
    title: string;
  };
  /** The current or last trial. Absent when the organization never had one. */
  trial?: SubscriptionTrial;
  /** Whether the user is an administrator of the organization, and so can upgrade. Otherwise, they have to ask an administrator to upgrade. */
  canManageBilling: boolean;
  /** Where to upgrade in the application. Only set when `canManageBilling` is true. */
  upgradeUrl?: URL;
  /** Public page comparing the GitBook plans. */
  pricingUrl: URL;
}

/** Permission of a member in a content. */
export interface MemberContentPermission {
  /**
   * "The role of a member in an organization.
   * "admin": Can administrate the content: create, delete spaces, ...
   * "create": Can create content.
   * "review": Can review content.
   * "edit": Can edit the content (live or change requests).
   * "comment": Can access the content and its discussions.
   * "read": Can access the content, but cannot update it in any way.
   */
  permission: MemberRole;
  space: Space;
}

/** Permission of an organization member in a site. */
export interface MemberSitePermission {
  site: Site;
  /** The role of a member in an organization, null for guests */
  permission: MemberRoleOrGuest;
}

export interface TeamMember {
  /**
   * "The role of a team member.
   * "owner": Can manage team members.
   * "member": Is a member of the team.
   */
  role: TeamMemberRole;
}

/** A member of a team in an organization, including its relationship to it */
export interface OrganizationTeamMember {
  /** User information as an organization member */
  organization: OrganizationMember;
  /** User information as a team member */
  team: TeamMember;
  /** The set of permissions for the team member */
  permissions: {
    /** Can the user view the team member */
    view: boolean;
  };
}

export interface UpdateMembersInOrganizationTeam {
  add?: string[];
  memberships?: Record<string, TeamMember>;
  remove?: string[];
}

/**
 * User email
 * @format email
 * @example "contact@gitbook.com"
 */
export type Email = string;

export interface InviteUsersToOrganization {
  emails: (
    | Email
    | {
        /** The email address of the user to invite as a member */
        email: Email;
        /** The role of a member in an organization, null for guests */
        role: MemberRoleOrGuest;
      }
  )[];
  /** Default role to set on newly invited members. */
  role?: MemberRoleOrGuest;
  /** If true, invites the user as an SSO user of the organization. Defaults to false. */
  sso?: boolean;
}

/** An invite link to a specific collection in an organization */
export interface InviteLinkToCollection {
  /** Type of Object, always equals to "invite" */
  object: "invite";
  /** Unique identifier for the invite link to the collection */
  id: string;
  /** The level of the member in the target collection */
  level: MemberRoleOrGuest;
  /** An invite is redundant if the requesting user already has all necessary permissions. */
  redundant: boolean;
  /** The collection the member has been invited to */
  collection: Collection;
}

/** An invite link to a specific space in an organization */
export interface InviteLinkToSpace {
  /** Type of Object, always equals to "invite" */
  object: "invite";
  /** Unique identifier for the invite link to the space */
  id: string;
  /** The level of the member in the target space */
  level: MemberRoleOrGuest;
  /** An invite is redundant if the requesting user already has all necessary permissions. */
  redundant: boolean;
  /** The space the member has been invited to */
  space: Space;
}

/** An invite link to an organization */
export interface InviteLinkToOrganization {
  /** Type of Object, always equals to "invite" */
  object: "invite";
  /** Unique identifier for the invite link to the organization */
  id: string;
  /** The role in the organization the invite link is for */
  role: MemberRoleOrGuest;
  /** An invite is redundant if the requesting user already has all necessary permissions. */
  redundant: boolean;
}

export interface CreateInviteToOrganization {
  /** The role of the member in the organization */
  role: MemberRoleOrGuest;
}

export interface CreateInviteToSpace {
  /** The level of the member in the target space */
  level: MemberRoleOrGuest;
  /** The ID of space the member has been invited to */
  space: string;
}

export interface CreateInviteToCollection {
  /** The level of the member in the target collection */
  level: MemberRoleOrGuest;
  /** The ID of collection the member has been invited to */
  collection: string;
}

export type CreateOrganizationInvite =
  | CreateInviteToOrganization
  | CreateInviteToSpace
  | CreateInviteToCollection;

/** An invite link created in an organization */
export type OrganizationInviteLink =
  | InviteLinkToOrganization
  | InviteLinkToSpace
  | InviteLinkToCollection;

/** Changes to apply during a subscription upgrade or downgrade */
export interface SubscriptionChanges {
  /** A list of member identifiers to be removed */
  removeMembers: string[];
  /** A list of site updates to be applied before upgrading.  If a site is not present in this list, it'll be upgraded to whichever type matches its features and its published status will be unchanged. When downgrading to a lower type all relevant paid features will be disabled before applying the new type. */
  updateSites: (
    | {
        /** The site identifier */
        id: string;
        /** The site type to migrate to */
        type: SiteType;
      }
    | {
        /** The site identifier */
        id: string;
        /** Can be set to `false` or `true` to either unpublish or publish a site */
        isPublished: boolean;
      }
    | {
        /** The site identifier */
        id: string;
        /** The site type to migrate to */
        type: SiteType;
        /** Can be set to `false` or `true` to either unpublish or publish a site */
        isPublished: boolean;
      }
  )[];
}

/**
 * Free-text detail a user typed alongside their cancellation reason.
 * @minLength 1
 * @maxLength 500
 */
export type BillingCancellationComment = string;

/** Why an organization is cancelling its subscription, as answered by the user in the app. Recorded for analytics only: it never changes how the cancellation is applied. */
export type BillingCancellationFeedback =
  | {
      reason: "not_satisfied_with_product";
      /** The feature that was not satisfactory */
      reasonDetail: "editor" | "gitsync" | "ai_features";
    }
  | {
      reason: "not_satisfied_with_product";
      /** The feature that was not satisfactory */
      reasonDetail: "other";
      /** Free-text detail a user typed alongside their cancellation reason. */
      reasonComment: BillingCancellationComment;
    }
  | {
      reason: "will_vibe_code_our_own_app";
      /** The tool the organization is moving to */
      reasonDetail: "claude" | "codex" | "replit";
    }
  | {
      reason: "will_vibe_code_our_own_app";
      /** The tool the organization is moving to */
      reasonDetail: "other";
      /** Free-text detail a user typed alongside their cancellation reason. */
      reasonComment: BillingCancellationComment;
    }
  | {
      reason: "found_better_alternative";
      /** Free-text detail a user typed alongside their cancellation reason. */
      reasonComment: BillingCancellationComment;
    }
  | {
      reason: "company_shutdown";
    }
  | {
      reason: "other_reason";
      /** Free-text detail a user typed alongside their cancellation reason. */
      reasonComment: BillingCancellationComment;
    };

/**
 * Coupon or promotion code to apply to billing operations.
 * @minLength 1
 * @maxLength 500
 */
export type BillingCoupon = string;

export interface UpgradeOrganizationBilling {
  /** Name of the product */
  product: BillingProduct;
  /** Interval for a billing subscription */
  interval: BillingInterval;
  /** Changes to apply during a subscription upgrade or downgrade */
  changes?: SubscriptionChanges;
  /** Reason that triggered the billing upgrade */
  reason?: string;
  /** Why an organization is cancelling its subscription, as answered by the user in the app. Recorded for analytics only: it never changes how the cancellation is applied. */
  cancellationFeedback?: BillingCancellationFeedback;
  /** Coupon or promotion code to apply to the subscription */
  coupon?: BillingCoupon;
  /** Optional usage addons to apply when upgrading: - if set, apply provided billable addons (non-billable meters are ignored) - if omitted, keep current subscription addons (or billing addons for new subs) - if omitted during interval switch, keep addon selection and switch addon price interval - if empty, or all provided meters are ignored, remove all existing billable addons */
  addons?: BillingMeter[];
  /** The AI credit bundle to top up every month */
  creditsBundle?: BillingCreditsBundle;
  /** Mode to use for the upgrade (default value is `commit`): - `commit`: a checkout session is returned or the upgrade is applied directly - `preview`: a preview invoice is always returned */
  mode?: "commit" | "preview";
}

/** A product line of an invoice, enriched and normalized for the billing summary UI. */
export interface BillingInvoiceSummaryLine {
  /** How Stripe describes the line, as a fallback for lines the client cannot label itself. */
  description: string;
  amount: number;
  /** How many units the line bills, such as the number of members. */
  quantity?: number;
  /** Which kind of site a `sites` line bills for. */
  siteType?: SiteType;
  /** Price of a single unit, over the period the line covers. */
  unitAmount?: number;
  periodStart: Timestamp;
  periodEnd: Timestamp;
  /** What the invoice line is billing for, so a preview can be grouped by product area. */
  category:
    | "members"
    | "sites"
    | "addons"
    | "credits"
    | "usage"
    | "watermark_removal"
    | "other";
}

/** An amount adjusting an invoice, summed across everything of its type. */
export interface BillingInvoiceAdjustment {
  /** What adjusts the amount an invoice bills, beyond the products it lists. `proration` is the net of the mid-period changes, and `balance` the credit applied from the customer's balance. */
  type: "proration" | "watermark_removal" | "balance";
  /** The adjustment, negative when it reduces the amount billed. */
  amount: number;
}

/** A total of AI credits, and how much of it is left. */
export interface BillingCreditsTotals {
  /** Credits granted for the current AI billing period. */
  grantedCredits: number;
  /** Credits still available of those granted. */
  remainingCredits: number;
}

export interface BillingInvoicePreview {
  /** Final total owed for this invoice after discounts and credits. */
  amount: number;
  /** Sum of invoice line items before discounts and credits are applied. */
  subtotal: number;
  /** Remaining unpaid amount on this invoice, what would be charged now. */
  amountDueToday: number;
  /** Current balance, if any, being stored on the customer. If positive, the customer has credit to apply to their next invoice. */
  customerBalance: number;
  /** Current balance after potential upgrade. */
  remainingCustomerBalance: number;
  /** Details of the change happening on the subscription. */
  lines: {
    description: string;
    amount: number;
    periodStart: Timestamp;
    periodEnd: Timestamp;
  }[];
  /** Structured representation of the invoice for the current billing summary UI. */
  summary: {
    /** Product lines enriched and normalized for the billing summary UI. */
    lines: BillingInvoiceSummaryLine[];
    /** What adjusts the amount billed beyond the products listed, each summed across its type. Only the ones that apply are returned. */
    adjustments: BillingInvoiceAdjustment[];
    /** AI credits available for the current AI billing period. Empty when the organization is not billed for AI usage. */
    creditGrants: {
      /** Where AI credits come from: - `paid`: credits included in the monthly bundle - `bonus`: free credits included with the monthly bundle - `site`: credits from published paid sites - `rollover`: unused paid credits carried over from the previous period - `custom`: credits granted manually by Sales or Support */
      type: AICreditGrantType;
      /** Stripe spending priority. Lower values are consumed first. */
      priority?: number;
      /** Credits available from this grant before the current invoice usage. */
      grantedCredits: number;
      /** Credits of the grant spent by the usage metered so far. */
      usedCredits: number;
      /** Credits of the grant still available. */
      remainingCredits: number;
      /** For a `site` grant, the published sites the credits come from. */
      sites?: {
        /** The type of the site */
        siteType: SiteType;
        /** How many sites of this type are published. */
        count: number;
        /** Credits included with one site of this type. */
        creditsPerSite: number;
        /** Credits these sites contribute to the grant. */
        grantedCredits: number;
      }[];
    }[];
    /** The AI credits of the current billing period, grouped the ways the billing screens display them. */
    credits: {
      /** Credits granted across every grant. */
      grantedCredits: number;
      /** Credits spent by the usage metered so far. */
      usedCredits: number;
      /** Credits still available across every grant. */
      remainingCredits: number;
      /** Part of the metered AI usage paid by credits rather than billed, as a positive amount. */
      coveredAmount: number;
      /** The credits the organization pays for. */
      paid: BillingCreditsTotals;
      /** The bonus, site and custom credits. */
      free: BillingCreditsTotals;
      /** The credits of the monthly bundle, both paid and bonus. */
      bundle: BillingCreditsTotals;
    };
    /** When the upcoming invoice is charged. */
    chargeDate?: Timestamp;
    /** The renewal invoice, when the plan and the AI usage bill on different cadences. Absent when a single invoice covers everything. */
    renewal?: {
      /** Product lines of the renewal invoice. */
      lines: BillingInvoiceSummaryLine[];
      /** What adjusts the renewal beyond the products listed. Prorations and the customer balance are reported on the upcoming invoice instead. */
      adjustments: BillingInvoiceAdjustment[];
      /** Discounts still applying when the subscription renews. */
      discounts: {
        /** The description of the applied discount. */
        description: string;
        /** The amount of the applied discount. */
        amount: number;
      }[];
      /** Total owed for the renewal invoice. */
      amount: number;
      /** When the renewal invoice is charged. */
      chargeDate: Timestamp;
    };
  };
  /** Discounts applied to the subscription. */
  discounts?: {
    /** The description of the applied discount. */
    description: string;
    /** The amount of the applied discount. */
    amount: number;
  }[];
}

/** The AI credits of the current billing period, grouped the ways the billing screens display them. */
export interface Credits {
  /** Credits granted across every grant. */
  grantedCredits: number;
  /** Credits spent by the usage metered so far. */
  usedCredits: number;
  /** Credits still available across every grant. */
  remainingCredits: number;
  /** Part of the metered AI usage paid by credits rather than billed, as a positive amount. */
  coveredAmount: number;
  /** The credits the organization pays for. */
  paid: BillingCreditsTotals;
  /** The bonus, site and custom credits. */
  free: BillingCreditsTotals;
  /** The credits of the monthly bundle, both paid and bonus. */
  bundle: BillingCreditsTotals;
}

/** AI credits available for the current AI billing period. Empty when the organization is not billed for AI usage. */
export type CreditGrants = {
  /** Where AI credits come from: - `paid`: credits included in the monthly bundle - `bonus`: free credits included with the monthly bundle - `site`: credits from published paid sites - `rollover`: unused paid credits carried over from the previous period - `custom`: credits granted manually by Sales or Support */
  type: AICreditGrantType;
  /** Stripe spending priority. Lower values are consumed first. */
  priority?: number;
  /** Credits available from this grant before the current invoice usage. */
  grantedCredits: number;
  /** Credits of the grant spent by the usage metered so far. */
  usedCredits: number;
  /** Credits of the grant still available. */
  remainingCredits: number;
  /** For a `site` grant, the published sites the credits come from. */
  sites?: {
    /** The type of the site */
    siteType: SiteType;
    /** How many sites of this type are published. */
    count: number;
    /** Credits included with one site of this type. */
    creditsPerSite: number;
    /** Credits these sites contribute to the grant. */
    grantedCredits: number;
  }[];
}[];

/** Credit balance after an accepted bundle change, including grants pending webhook synchronization. */
export interface BillingCreditBalance {
  /** The AI credit bundle to top up every month */
  creditsBundle: BillingCreditsBundle;
  /** The AI credits of the current billing period, grouped the ways the billing screens display them. */
  credits: Credits;
  /** AI credits available for the current AI billing period. Empty when the organization is not billed for AI usage. */
  creditGrants: CreditGrants;
}

export type BillingUpgrade =
  | {
      result: "checkout";
      /** Stripe payment session ID */
      sessionId: string;
    }
  | {
      result: "preview";
      invoice: BillingInvoicePreview;
    }
  | {
      result: "upgraded";
      /** Credit balance after an accepted bundle change, including grants pending webhook synchronization. */
      creditBalance?: BillingCreditBalance;
    }
  | {
      result: "downgraded";
    }
  | {
      result: "interval_changed";
    };

export interface BillingPortal {
  /** URL to the billing portal for an organization */
  url: string;
}

export interface OrganizationAIUsage {
  /**
   * Inclusive start of the queried range.
   * @format date-time
   */
  from: string;
  /**
   * Exclusive end of the queried range, capped at the current instant.
   * @format date-time
   */
  to: string;
  /** Chronological calendar buckets. Edge buckets include only the requested dates. */
  periods: {
    /**
     * UTC date at the start of this calendar bucket.
     * @format date
     */
    date: string;
    /** Total credits used in this bucket. */
    credits: number;
    features: {
      /** AI feature category with recorded credit usage. */
      feature: string;
      credits: number;
      /** Percentage of this bucket's total credits (0 to 100). */
      creditsPercent: number;
    }[];
  }[];
}

/** Usage metrics for a billing meter */
export interface BillingMeterUsage {
  /** Total usage for the current billing period */
  total: number;
  /** Usage entries for the period */
  entries: {
    date: Timestamp;
    /** Usage value for the date */
    value: number;
  }[];
}

/** Search result representing a space. */
export interface SearchSpaceResult {
  type: "space";
  id: string;
  title: string;
  /** Relevance score for a search result. Higher is better and the score is unbounded. */
  score: SearchResultScore;
  pages: SearchPageResult[];
}

export type CreateSpace = {
  /** @maxLength 50 */
  title?: string;
  /** Unicode codepoint or character of the emoji */
  emoji?: Emoji;
  /** ID of a parent collection */
  parent?: string;
  language?: TranslationLanguage;
  /** The edit mode of the space */
  editMode?: SpaceEditMode;
} & (
  | Record<string, any>
  | (
      | {
          template: ApplySpaceTemplate;
        }
      | {
          computedSource: ComputedContentSourceRevision;
        }
      | {
          empty: true;
        }
    )
);

/** The resource on which an integration is installed. */
export type InstalledIntegrationTarget =
  | {
      type: "organization";
      organizationId: string;
    }
  | {
      type: "site";
      siteId: string;
    }
  | {
      type: "space";
      spaceId: string;
    };

/** An integration installation, its current status, and the resource it targets. */
export interface InstalledIntegration {
  status: IntegrationInstallationStatus;
  integration: Integration;
  /** The resource on which an integration is installed. */
  target: InstalledIntegrationTarget;
}

/**
 * @minLength 1
 * @maxLength 30
 */
export type SAMLProviderLabel = string;

/** @maxLength 1024 */
export type SAMLProviderEntityID = string;

/** @maxLength 10000 */
export type SAMLProviderCertificate = string;

export interface OrganizationSAMLProvider {
  /** Type of Object, always equals to "saml-provider" */
  object: "saml-provider";
  /** Unique identifier for the provider. */
  id: string;
  label: SAMLProviderLabel;
  ssoURL: URL;
  entityID: SAMLProviderEntityID;
  certificate: SAMLProviderCertificate;
  defaultTeam?: OrganizationTeam;
  /** The role of a member in an organization, null for guests */
  defaultRole: MemberRoleOrGuest;
  /** Date at which the provider was created. */
  createdAt: Timestamp;
  /**
   * Status of the provider.
   * - `active`: The provider is active and can be used to authenticate users.
   * - `pending`: The provider is pending and is not yet fully configured.
   */
  status: SAMLProviderStatus;
  /** Metadata about the service provider. */
  service: {
    /**
     * Assertion Consumer Service (ACS) URL
     * @format uri
     */
    acsURL: string;
    /**
     * Start URL for the Identity Provider
     * @format uri
     */
    startURL: string;
    entityID: SAMLProviderEntityID;
  };
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the SAML Provider in the API
     * @format uri
     */
    location: string;
  };
}

/**
 * Name of the SCIM connection, shown to organization admins.
 * @minLength 1
 * @maxLength 100
 */
export type SCIMConnectionLabel = string;

/** A SCIM connection through which an identity provider provisions organization members. */
export interface OrganizationSCIMConnection {
  /** The object type, which is always "scim-connection" */
  object: "scim-connection";
  /** Unique identifier of the SCIM connection */
  id: string;
  /** Name of the SCIM connection, shown to organization admins. */
  label: SCIMConnectionLabel;
  /** Identity provider that provisions members through the SCIM connection. */
  provider: SCIMConnectionProvider;
  /** SCIM base URL to configure in the identity provider */
  baseURL: URL;
  /** Last characters of the current token, to identify it */
  tokenHint: string;
  /** Date the current token was created */
  tokenCreatedAt: Timestamp;
  /** Date of the last request authenticated with the token */
  lastUsedAt?: Timestamp;
  /** Date of creation */
  createdAt: Timestamp;
  /** Date of the last update */
  updatedAt: Timestamp;
  /** URLs associated with the object */
  urls: {
    /** URL of the SCIM connection in the API */
    location: URL;
  };
}

/** A SCIM connection with its token, returned only when the token is created. */
export interface OrganizationSCIMConnectionWithToken {
  /** A SCIM connection through which an identity provider provisions organization members. */
  connection: OrganizationSCIMConnection;
  /** Bearer token to configure in the identity provider. It can't be retrieved again. */
  token: string;
}

export interface OrganizationSSOProviderLogin {
  /** Unique identifier for the provider. */
  id: string;
  label: SAMLProviderLabel;
  /**
   * The starting login URL for the Identity Provider
   * @format uri
   */
  startURL: string;
}

/** Spaces usage metrics of an organization */
export interface OrganizationUsageSpaces {
  /** Count of all spaces */
  total: number;
}

/** Collections usage metrics of an organization */
export interface OrganizationUsageCollections {
  /** Count of all collections */
  total: number;
}

/** Sites usage metrics of an organization */
export interface OrganizationUsageSites {
  /** Count of all sites */
  total: number;
  /** Count of all basic sites */
  basic: number;
  /** Count of all premium sites */
  premium: number;
  /** Count of all ultimate sites */
  ultimate: number;
  /** Count of all sponsored sites */
  sponsored: number;
}

/** Team members usage metrics of an organization */
export interface OrganizationUsageTeams {
  /** Count of all teams */
  total: number;
}

/** Members usage metrics of an organization */
export interface OrganizationUsageMembers {
  /** Count of all members, including disabled ones */
  total: number;
  /** Count of members that are not disabled */
  active: number;
  /** Count of disabled members, by the reason they are disabled */
  disabled: {
    billing: number;
    scim: number;
    admin: number;
  };
  /**
   * Count of paid seats. On the Free plan, it includes members disabled for billing, since
   * upgrading re-enables them. On paid plans, it only includes active members.
   */
  seats: number;
  /** Count of all admins */
  admin: number;
  /** Count of all creators */
  create: number;
  /** Count of all editors */
  edit: number;
  /** Count of all reviewers */
  review: number;
  /** Count of all commenters */
  comment: number;
  /** Count of all readers */
  read: number;
  /** Count of all guests */
  guest: number;
}

/** Team members usage metrics of an organization */
export interface OrganizationUsageTeamMembers {
  /** Count of all organization members in a team */
  total: number;
  /** Count of all team owners */
  owner: number;
  /** Count of all team members */
  member: number;
}

/** All usage metrics of an organization */
export interface OrganizationUsage {
  /** Spaces usage metrics of an organization */
  spaces: OrganizationUsageSpaces;
  /** Collections usage metrics of an organization */
  collections: OrganizationUsageCollections;
  /** Sites usage metrics of an organization */
  sites: OrganizationUsageSites;
  /** Team members usage metrics of an organization */
  teams: OrganizationUsageTeams;
  /** Members usage metrics of an organization */
  members: OrganizationUsageMembers;
  /** Team members usage metrics of an organization */
  teamMembers: OrganizationUsageTeamMembers;
  /** The set of permissions for the organization's usage. */
  permissions: {
    /** Can the user view the organization's usage. */
    view: boolean;
  };
}

export interface SearchAIQuery {
  query: string;
  /**
   * @deprecated
   * @maxItems 10
   */
  previousQueries?: string[];
}

/**
 * Page source
 * The source points to a page in a space.
 */
export interface SearchAIAnswerSourcePage {
  type: "page";
  /** Short explanation of how the source was used to answer. */
  reason?: string;
  /** The page ID of the source. */
  page: string;
  /** The revision ID where the page was extracted from. */
  revision: string;
  /** The space ID owning the page. */
  space: string;
  /** The title of the page, as of `revision`. */
  title: string;
  /** The IDs of the sections of the page that were used to answer the question. */
  sections: string[];
}

/**
 * Site context record source
 * The source points to an ingested site context record.
 */
export interface SearchAIAnswerSourceRecord {
  type: "record";
  /** Short explanation of how the source was used to answer. */
  reason?: string;
  /** The context record ID of the source. */
  record: string;
  /** The site ID owning the source record. */
  site: string;
  /** The title of the source record. */
  title: string;
  /**
   * The source URL of the context record.
   * @format uri
   */
  url: string;
}

/** Answer from AI for a question asked on a content. */
export interface SearchAIAnswer {
  answer?: Document;
  followupQuestions: string[];
  /** The sources used to generate the answer. */
  sources: SearchAIAnswerSource[];
}

/** Questions recommended by the AI for the given content. */
export interface SearchAIRecommendedQuestions {
  questions: string[];
}

export interface SearchAIRecommendedQuestionStream {
  question: string;
}

export interface SearchAIAnswerStream {
  type: "answer";
  /** Answer from AI for a question asked on a content. */
  answer: SearchAIAnswer;
}

/**
 * Slug used as reference
 * @minLength 1
 * @maxLength 100
 * @pattern ^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$
 */
export type OpenAPISpecSlug = string;

/** OpenAPI error object. */
export interface OpenAPIErrorObject {
  /** Description of the error. */
  message: string;
  /** Unique code of the error. */
  code?: string;
}

export interface OpenAPISpec {
  /** The object type, which is always "openapi-spec" */
  object: "openapi-spec";
  /** Unique identifier */
  id: string;
  /** Date of creation */
  createdAt: Timestamp;
  /** Date of the last update */
  updatedAt: Timestamp;
  /** Slug used as reference */
  slug: OpenAPISpecSlug;
  sourceURL?: URL;
  /** Processing state */
  processingState: OpenAPISpecProcessingState;
  /**
   * The visibility setting of the OpenAPI spec.
   * * `private`: The spec is not publicly available.
   * * `public`: The spec is available to anyone with a public link.
   */
  visibility?: OpenAPISpecVisibility;
  /** ID of the latest version of the OpenAPI specification */
  lastVersion?: string;
  /** Date of the last processing */
  lastProcessedAt?: Timestamp;
  /** OpenAPI processing error code */
  lastProcessErrorCode?: OpenAPISpecProcessingErrorCode;
  lastProcessedErrors?: OpenAPIErrorObject[];
  /**
   * Total number of processing errors before truncation of lastProcessedErrors.
   * @min 0
   */
  lastProcessedErrorCount: number;
  /** The set of permissions for the OpenAPI specification. */
  permissions: {
    /** Can the user view the specification. */
    view: boolean;
    /** Can the user edit the specification. */
    edit: boolean;
  };
  /** URLs associated with the object */
  urls: {
    /** URL of the OpenAPI specification in the API */
    location: URL;
    /** URL of the OpenAPI specification in the application */
    app: URL;
    /**
     * URL of the published spec. Only defined when visibility is "published."
     * @format uri
     */
    published?: string;
  };
}

/** Create a specification from an URL */
export type OpenAPISpecSource =
  | {
      url: URL;
    }
  | {
      /**
       * OpenAPI specification as text
       * @minLength 1
       */
      text: string;
    };

export interface OpenAPISpecVersion {
  /** The object type, which is always "openapi-spec-version" */
  object: "openapi-spec-version";
  /** Unique identifier */
  id: string;
  /** Date of creation */
  createdAt?: Timestamp;
  /** URL where the specification is accessible. */
  url: URL;
  /** URLs associated with the object */
  urls: {
    /** URL of the OpenAPI specification version in the API */
    location: URL;
  };
}

/** Content of the specification available through filesystem or public URL. */
export interface OpenAPISpecContent {
  /** Filesystem containing all specifications. */
  filesystem: object;
  /** URLs associated with the specification content. */
  urls: {
    source: URL;
    /** Publicly accessible URL for the specification. Available for public specs (proxy URL for stored specs, source URL for external specs). Null for private specs. Can be used for the "Try it" feature. */
    public: null | URL;
  };
}

/** Raw original content of the specification entrypoint file. */
export interface OpenAPISpecRawContent {
  /** Raw specification text, exactly as submitted. */
  text: string;
  /** Format of the raw specification text. */
  format: "json" | "yaml";
}

export interface OrganizationAgentInstructions {
  object: "agent-instructions";
  /** Document containing the Docs agent instructions. */
  instructions: JSONDocument;
  updatedAt: Timestamp;
  /** Identifier of the member who last updated the instructions. */
  updatedBy: string;
  /** URLs related to the custom instructions. */
  urls: {
    /** Relative URL to the resource in the API. */
    location: string;
  };
}

export interface TranslationSource {
  /** ID of the source space */
  space: string;
  language: TranslationLanguage;
}

export interface Translation {
  object: "translation";
  /** Unique identifier of the translation sync */
  id: string;
  status: TranslationStatus;
  source: TranslationSource;
  language: TranslationLanguage;
  instructions: JSONDocument;
  /** Result of a translation. */
  result?: TranslationResult;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  stats: {
    /** Total number of times the translation has been run */
    runs: number;
    /** Total number of words counted toward translation usage over all runs */
    totalWords: number;
    /** Total number of unique pages translated */
    totalPages: number;
    /** Total duration of all runs (in seconds) */
    totalDuration: number;
    /** Duration of the latest run (in seconds) */
    latestRunDuration: number;
    /** Number of unique pages translated in the latest run */
    latestPages: number;
    /** Number of words counted toward translation usage in the latest run */
    latestWords: number;
  };
  permissions: {
    /** Whether the user can view the object */
    view: boolean;
    /** Whether the user can edit the object */
    edit: boolean;
  };
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the translation settings in the API
     * @format uri
     */
    location: string;
  };
}

/** Mapping of language codes to translated terms */
export type GlossaryTranslations = Record<string, string>;

export interface GlossaryEntry {
  object: "glossary-entry";
  /** Unique identifier of the glossary entry */
  id: string;
  /** Mapping of language codes to translated terms */
  translations: GlossaryTranslations;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  urls: {
    /**
     * URL of the glossary entry in the API
     * @format uri
     */
    location: string;
  };
}

export type GlossaryBatchOperation =
  | {
      type: "insert";
      /** Mapping of language codes to translated terms */
      translations: GlossaryTranslations;
    }
  | {
      type: "update";
      id: string;
      /** Mapping of language codes to translated terms */
      translations: GlossaryTranslations;
    }
  | {
      type: "delete";
      id: string;
    };

export interface StorageFileMetadata {
  /** Original filename */
  name: string;
  /** MIME type of the file */
  type: string;
  /** Size of the file in bytes */
  size: number;
}

export interface StorageUploadURL {
  /** The kind of file to upload */
  object: "storage-signed-url";
  /** Presigned URL for uploading the file */
  url: URL;
  /** The bucket object key for the file */
  key: string;
}

/**
 * The human-readable font-family name used in CSS (e.g., "Open Sans", "Playfair Display").
 * @minLength 1
 * @maxLength 50
 */
export type FontFamily = string;

/**
 * Numeric representation of the font weight (400=regular, 500=medium, 700=bold, 900=black).
 * @min 1
 * @max 1000
 */
export type FontWeight = number;

/** A font file referenced within a font-face declaration, specifying the file's location and format. */
export interface FontSource {
  /** The absolute or relative URL pointing to the font file. */
  url: URL;
  /** The format of the font file. Prefer 'woff2' for modern browsers. */
  format?: "woff2" | "woff";
}

/** A single font-face declaration specifying the weight and source files for a particular variation of the font. */
export interface FontFace {
  /** Numeric representation of the font weight (400=regular, 500=medium, 700=bold, 900=black). */
  weight: FontWeight;
  /**
   * Font source files provided in supported formats (e.g., woff2, woff).
   * @minItems 1
   */
  sources: FontSource[];
}

/** Defines a font family along with its various font-face declarations for use in CSS '@font-face' rules. */
export interface CustomizationFontDefinitionInput {
  /** A globally unique identifier for the font definition. */
  id: string;
  /** Whether the font is a custom font. If false, this font is provided by GitBook. */
  custom: boolean;
  /** The human-readable font-family name used in CSS (e.g., "Open Sans", "Playfair Display"). */
  fontFamily: FontFamily;
  /**
   * A list of font-face definitions, specifying variations such as weight and style.
   * @minItems 1
   */
  fontFaces: FontFace[];
}

export type CustomizationFontDefinition = CustomizationFontDefinitionInput & {
  /** The set of permissions for the font definition */
  permissions: {
    /** Can the user edit the font definition */
    edit: boolean;
  };
};

/**
 * The path of the file in the storage bucket
 * @minLength 1
 * @maxLength 512
 */
export type StorageFileKey = string;

/** A response to a request to preview the publishing of a site. It indicates whether the operation can proceed immediately, requires checkout, if a trial is available or if a trial extension is available. */
export type SitePublishOperationPreviewResponse =
  | {
      /** User can go ahead with the operation without any additional steps. Their subscription will be updated to reflect the new changes. */
      type: "go-ahead";
    }
  | {
      /** By going ahead with this operation, the user will be starting a trial in GitBook. */
      type: "trial-available";
    }
  | {
      /** The organization is eligible for an additional trial when publishing the site. */
      type: "extended-trial-available";
    }
  | {
      /** User must checkout to complete the operation. */
      type: "checkout";
      invoice?: BillingInvoicePreview;
    };

/** Common setup fields for a Git Sync installation. */
export interface GitSyncInstallationSetupCommon {
  /** Optional directory used when syncing a monorepo subdirectory. */
  projectDirectory?: string;
  /** Optional template used when generating commit messages. */
  commitMessageTemplate?: string;
  /** Whether previews should be generated from branches outside the configured branch. For space installations belonging to a parent installation, this field is inherited from the parent installation and cannot be set. */
  previewExternalBranches?: boolean;
  /** Agent instruction files GitBook should always export at the repository root. For space installations belonging to a parent installation, this field is inherited from the parent installation and cannot be set. */
  agentInstructions?: ("agents" | "claude")[];
  /** Which side should be treated as the source of truth when Git Sync is configured. */
  priority?: GitSyncInstallationPriority;
}

/** GitHub provider configuration for a Git Sync installation. */
export interface GitSyncInstallationSetupGitHub {
  provider: "github";
  /** GitHub specific configuration for the Git Sync installation. */
  providerConfiguration: {
    /** GitHub repository identifier. */
    repositoryId?: number;
    /**
     * GitHub repository branch ref.
     * @pattern ^refs/heads/.+$
     */
    branch?: string;
  };
}

/** GitLab provider configuration for a Git Sync installation. */
export interface GitSyncInstallationSetupGitLab {
  provider: "gitlab";
  /** GitLab specific configuration for the Git Sync installation. */
  providerConfiguration: {
    /** GitLab project identifier. */
    projectId?: number;
    /** GitLab access token with appropriate scopes for repository access. */
    accessToken?: string;
    /** Custom GitLab instance URL, if using a self-hosted GitLab. Use null to clear a self-hosted URL. */
    customInstanceURL?: string | null;
    /**
     * GitLab repository branch ref.
     * @pattern ^refs/heads/.+$
     */
    branch?: string;
  };
}

/** Provider-specific setup payload for a Git Sync installation. */
export type GitSyncInstallationSetup = GitSyncInstallationSetupCommon &
  (GitSyncInstallationSetupGitHub | GitSyncInstallationSetupGitLab);

export interface GitRepositoryConnection {
  object: "git-repository-connection";
  /** Unique identifier of the repository connection. */
  id: string;
  /** The provider of the Git Sync installation. */
  provider: GitSyncInstallationProvider;
  /** Repository identifier assigned by the provider. */
  repositoryId: string;
  /** Full repository name assigned by the provider. */
  repositoryName: string;
  /**
   * URL of the repository on the provider.
   * @format uri
   */
  repositoryUrl: string;
  /** Default branch reported by the provider. */
  defaultBranch?: string;
  authState: "pending" | "active" | "unauthenticated";
  /** Provider operations available to this repository connection. */
  capabilities: {
    /** Whether the connection can create and update GitHub pull requests or GitLab merge requests. */
    pullRequests: boolean;
    /** Whether the connection can publish GitBook synchronization results as provider commit statuses. */
    commitStatuses: boolean;
  };
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface GitRepositoryRef {
  object: "git-repository-ref";
  /** Unique identifier of the repository ref. */
  id: string;
  /** Fully qualified provider ref name. */
  name: string;
  type: "branch" | "tag" | "change-request-head";
  latestObservedCommitId?: string;
  latestImportedCommitId?: string;
  updatedAt: Timestamp;
}

/** A repository-backed review and permission boundary for GitBook content. */
export interface GitSyncRoot {
  object: "git-sync-root";
  /** Unique identifier of the Sync Root. */
  id: string;
  /** Unique identifier of the top-level installation that owns this Sync Root. */
  installationId: string;
  /** Resource targeted by a Git Sync installation. */
  target: GitSyncInstallationTarget;
  /** System responsible for completing merges by default for this Sync Root. */
  defaultMergeAuthorityPolicy: "provider" | "gitbook";
  status: "active" | "disabled";
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export type GitSyncInstallation = GitSyncInstallationSetup & {
  object: "git-sync-installation";
  /** Unique identifier of the Git Sync installation. */
  id: string;
  /** The ID of the parent Git Sync installation, if any. */
  parentInstallationId?: string;
  /** Resource targeted by a Git Sync installation. */
  target: GitSyncInstallationTarget;
  status: GitSyncInstallationStatus;
  repositoryConnection?: GitRepositoryConnection;
  repositoryRef?: GitRepositoryRef;
  /** Effective Sync Root for this installation, inherited from its parent when present. */
  syncRoot?: GitSyncRoot;
  createdAt: Timestamp;
  /** Identifier of the user who created the installation. */
  createdBy: string;
  updatedAt: Timestamp;
  /** URLs associated with the installation */
  urls: {
    /**
     * URL of the installation endpoint in the API
     * @format uri
     */
    location: string;
  };
};

export interface Error {
  error: {
    /** @format int32 */
    code: number;
    message: string;
  };
}

/** Groups of countries exposed to adaptive content as `visitor.region`. The key of each entry is the region name; `visitor.region` is undefined for a visitor whose country is in none of the regions. A site can declare at most 10 regions. */
export type SiteAdaptiveRegions = Partial<
  Record<
    any,
    {
      /** ISO 3166-1 alpha-2 codes of the countries in the region. */
      countries: (
        | "AD"
        | "AE"
        | "AF"
        | "AG"
        | "AI"
        | "AL"
        | "AM"
        | "AO"
        | "AQ"
        | "AR"
        | "AS"
        | "AT"
        | "AU"
        | "AW"
        | "AX"
        | "AZ"
        | "BA"
        | "BB"
        | "BD"
        | "BE"
        | "BF"
        | "BG"
        | "BH"
        | "BI"
        | "BJ"
        | "BL"
        | "BM"
        | "BN"
        | "BO"
        | "BQ"
        | "BR"
        | "BS"
        | "BT"
        | "BV"
        | "BW"
        | "BY"
        | "BZ"
        | "CA"
        | "CC"
        | "CD"
        | "CF"
        | "CG"
        | "CH"
        | "CI"
        | "CK"
        | "CL"
        | "CM"
        | "CN"
        | "CO"
        | "CR"
        | "CU"
        | "CV"
        | "CW"
        | "CX"
        | "CY"
        | "CZ"
        | "DE"
        | "DJ"
        | "DK"
        | "DM"
        | "DO"
        | "DZ"
        | "EC"
        | "EE"
        | "EG"
        | "EH"
        | "ER"
        | "ES"
        | "ET"
        | "FI"
        | "FJ"
        | "FK"
        | "FM"
        | "FO"
        | "FR"
        | "GA"
        | "GB"
        | "GD"
        | "GE"
        | "GF"
        | "GG"
        | "GH"
        | "GI"
        | "GL"
        | "GM"
        | "GN"
        | "GP"
        | "GQ"
        | "GR"
        | "GS"
        | "GT"
        | "GU"
        | "GW"
        | "GY"
        | "HK"
        | "HM"
        | "HN"
        | "HR"
        | "HT"
        | "HU"
        | "ID"
        | "IE"
        | "IL"
        | "IM"
        | "IN"
        | "IO"
        | "IQ"
        | "IR"
        | "IS"
        | "IT"
        | "JE"
        | "JM"
        | "JO"
        | "JP"
        | "KE"
        | "KG"
        | "KH"
        | "KI"
        | "KM"
        | "KN"
        | "KP"
        | "KR"
        | "KW"
        | "KY"
        | "KZ"
        | "LA"
        | "LB"
        | "LC"
        | "LI"
        | "LK"
        | "LR"
        | "LS"
        | "LT"
        | "LU"
        | "LV"
        | "LY"
        | "MA"
        | "MC"
        | "MD"
        | "ME"
        | "MF"
        | "MG"
        | "MH"
        | "MK"
        | "ML"
        | "MM"
        | "MN"
        | "MO"
        | "MP"
        | "MQ"
        | "MR"
        | "MS"
        | "MT"
        | "MU"
        | "MV"
        | "MW"
        | "MX"
        | "MY"
        | "MZ"
        | "NA"
        | "NC"
        | "NE"
        | "NF"
        | "NG"
        | "NI"
        | "NL"
        | "NO"
        | "NP"
        | "NR"
        | "NU"
        | "NZ"
        | "OM"
        | "PA"
        | "PE"
        | "PF"
        | "PG"
        | "PH"
        | "PK"
        | "PL"
        | "PM"
        | "PN"
        | "PR"
        | "PS"
        | "PT"
        | "PW"
        | "PY"
        | "QA"
        | "RE"
        | "RO"
        | "RS"
        | "RU"
        | "RW"
        | "SA"
        | "SB"
        | "SC"
        | "SD"
        | "SE"
        | "SG"
        | "SH"
        | "SI"
        | "SJ"
        | "SK"
        | "SL"
        | "SM"
        | "SN"
        | "SO"
        | "SR"
        | "SS"
        | "ST"
        | "SV"
        | "SX"
        | "SY"
        | "SZ"
        | "TC"
        | "TD"
        | "TF"
        | "TG"
        | "TH"
        | "TJ"
        | "TK"
        | "TL"
        | "TM"
        | "TN"
        | "TO"
        | "TR"
        | "TT"
        | "TV"
        | "TW"
        | "TZ"
        | "UA"
        | "UG"
        | "UM"
        | "US"
        | "UY"
        | "UZ"
        | "VA"
        | "VC"
        | "VE"
        | "VG"
        | "VI"
        | "VN"
        | "VU"
        | "WF"
        | "WS"
        | "XK"
        | "YE"
        | "YT"
        | "ZA"
        | "ZM"
        | "ZW"
      )[];
    }
  >
>;

export type SiteAdaptiveDeterministicJSONSchemaPrimitives =
  | {
      type: "boolean";
      description: string;
    }
  | {
      type: "string";
      enum: string[];
      description: string;
    };

export type SiteAdaptiveJSONSchemaPrimitives =
  | SiteAdaptiveDeterministicJSONSchemaPrimitives
  | {
      type: "string";
      description: string;
    }
  | {
      type: "number";
      description: string;
    };

export type SiteAdaptiveJSONSchemaClaimsProperties =
  | SiteAdaptiveJSONSchemaPrimitives
  | {
      type: "array";
      description: string;
      items: SiteAdaptiveJSONSchemaPrimitives;
    }
  | {
      type: "object";
      description: string;
      properties: Record<string, SiteAdaptiveJSONSchemaClaimsProperties>;
      additionalProperties: false;
    };

/** JSON schema describing the expected attributes of an Adaptive site schema, with the regions `visitor.region` is resolved from. */
export interface SiteAdaptiveJSONSchemaWithRegions {
  /** Groups of countries exposed to adaptive content as `visitor.region`. The key of each entry is the region name; `visitor.region` is undefined for a visitor whose country is in none of the regions. A site can declare at most 10 regions. */
  regions?: SiteAdaptiveRegions;
  $schema?: "http://json-schema.org/draft-07/schema#";
  type: "object";
  properties: {
    /** Unsigned claims of the site visitor. */
    unsigned?: {
      type: "object";
      description: "Unsigned claims of the site visitor.";
      properties: Record<string, SiteAdaptiveJSONSchemaClaimsProperties>;
      additionalProperties: false;
    };
    [key: string]: any;
  };
  additionalProperties: false;
}

export interface SiteAdaptiveSchema {
  object: "site-adaptive-schema";
  /** JSON schema describing the expected attributes of an Adaptive site schema, with the regions `visitor.region` is resolved from. */
  jsonSchema: SiteAdaptiveJSONSchemaWithRegions;
  /** When the adaptive schema was updated. */
  updatedAt: Timestamp;
}

/** A template condition based on the site visitor schema. */
export interface SiteAdaptiveTemplateCondition {
  /** A short description of the suggested condition. */
  description: string;
  /** The suggested condition. */
  condition: string;
}

/** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
export type Color = string;

export interface CustomizationThemedColor {
  light: Color;
  dark: Color;
}

export interface CustomizationTint {
  color: CustomizationThemedColor;
}

export type CustomizationFont =
  | CustomizationDefaultFont
  | CustomizationFontDefinitionInput;

/** Font used for headings. `null` means headings use the main font (`styling.font`). */
export type CustomizationHeadingFont =
  | CustomizationDefaultFont
  | CustomizationFontDefinitionInput
  | null;

export type CustomizationMonospaceFont =
  | CustomizationDefaultMonospaceFont
  | CustomizationFontDefinitionInput;

export interface CustomizationThemedCodeTheme {
  light: CustomizationCodeTheme;
  dark: CustomizationCodeTheme;
}

/** Localized string value, keyed by locale. Contains overrides for non-default languages only. */
export type LocalizedString = Partial<Record<TranslationLanguage, string>>;

/** @maxLength 64 */
export type CustomizationContentLinkTitle = string;

/** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
export type LocalizedString64 = Partial<Record<TranslationLanguage, string>>;

export interface CustomizationContentLink {
  title: CustomizationContentLinkTitle;
  /** Localized overrides for the link title, keyed by locale. */
  localizedTitle?: LocalizedString64;
  /** A relative reference to content in GitBook. */
  to: ContentRef;
}

export interface CustomizationHeaderItem {
  title: string;
  /** Localized overrides for the header item title, keyed by locale. */
  localizedTitle?: LocalizedString;
  style?: "link" | "button-primary" | "button-secondary";
  to: ContentRef | null;
  links: CustomizationContentLink[];
  /** Conditional expression used to evaluate whether the header item should be shown to the site's visitor. */
  condition?: Expression;
}

export interface CustomizationFooterGroup {
  title: string;
  /** Localized overrides for the footer group title, keyed by locale. */
  localizedTitle?: LocalizedString;
  links: CustomizationContentLink[];
}

/**
 * The text content of the announcement.
 * @minLength 2
 * @maxLength 128
 */
export type CustomizationAnnouncementMessage = string;

export interface CustomizationAnnouncement {
  /** Whether to show the site's announcement. */
  enabled: boolean;
  /** The text content of the announcement. */
  message: CustomizationAnnouncementMessage;
  /** Localized overrides for the announcement message, keyed by locale. */
  localizedMessage?: LocalizedString128;
  /** The content or URL the announcement links to when clicked. */
  link?: CustomizationContentLink;
  /** The style of the announcement. Used to style the banner with the right semantic color and enable/disable features like hiding the banner. */
  style: "info" | "warning" | "danger" | "success";
}

/**
 * Initial greeting displayed by the AI Assistant when a visitor starts a conversation.
 * @maxLength 256
 */
export type CustomizationAIGreeting = string;

/**
 * @minLength 3
 * @maxLength 64
 */
export type CustomizationSuggestedQuestion = string;

/**
 * Suggested questions to display at the start of the chosen AI mode.
 * @maxItems 5
 */
export type CustomizationSuggestedQuestions = CustomizationSuggestedQuestion[];

/**
 * Additional instructions for the AI Assistant, injected after the base system prompt. Use them to adjust tone of voice and contribute site-specific knowledge. These instructions refine, but never override, the assistant's built-in guardrails. Only available to site admins and never exposed on the published site.
 * @maxLength 10000
 */
export type CustomizationAIInstructions = string;

/**
 * A handle on a social platform, without prefixes like the @ symbol.
 * @minLength 1
 * @maxLength 128
 */
export type SiteSocialAccountHandle = string;

export interface SiteSocialAccount {
  /** The platform of the social handle. */
  platform: SiteSocialAccountPlatform;
  /** A handle on a social platform, without prefixes like the @ symbol. */
  handle: SiteSocialAccountHandle;
  display: {
    /** @default true */
    footer: boolean;
    /** @default false */
    header: boolean;
  };
}

/**
 * The social accounts of the site.
 * @maxItems 10
 */
export type SiteSocialAccounts = SiteSocialAccount[];

export interface SiteCustomizationSettingsBase {
  /** Title to use for the published site. If not defined, it'll fallback to the default content title. */
  title?: SiteTitle;
  /** Localized titles for the site, keyed by locale. If not defined, the localized title will not be changed. */
  localizedTitle?: LocalizedString128;
  styling: {
    /**
     * The theme to apply to the site. Supercedes the old header preset themes.
     * - `clean`: Modern theme featuring translucency and minimally-styled elements.
     * - `muted`: Sophisticated theme with decreased contrast between elements.
     * - `bold`: High-impact theme with prominent colors and strong contrasts.
     * - `gradient`: Trendy theme featuring colorful gradients and splashes of color.
     */
    theme: CustomizationTheme;
    primaryColor: CustomizationThemedColor;
    /** Secondary brand color, used for secondary buttons and for content colored with `$secondary`. When not set, these elements use the neutral colors of the site. */
    secondaryColor?: CustomizationThemedColor;
    tint?: CustomizationTint;
    infoColor: CustomizationThemedColor;
    successColor: CustomizationThemedColor;
    warningColor: CustomizationThemedColor;
    dangerColor: CustomizationThemedColor;
    corners: CustomizationCorners;
    /**
     * The degree of visual depth (through shadows, gradients and elevation effects) of elements on the site.
     * - `subtle`: Subtle shadows and minimal elevation.
     * - `flat`: Flat elements, no shadows and no elevation.
     */
    depth: CustomizationDepth;
    /**
     * The style used for regular links in the main content, header and footer. Sidebar items are styled separately.
     * - `default`: Links are colored in the primary color and feature an underline in the same color.
     * - `accent`: Links are colored the same as body text and feature an underline in the primary color.
     */
    links: CustomizationLinksStyle;
    font: CustomizationFont;
    /** Font used for headings. `null` means headings use the main font (`styling.font`). */
    headingFont?: CustomizationHeadingFont;
    monospaceFont: CustomizationMonospaceFont;
    /**
     * The background style has been deprecated and will be removed in a future release. Use the `tint` settings instead.
     * @deprecated
     */
    background: CustomizationBackground;
    icons: CustomizationIconsStyle;
    codeTheme: {
      default: CustomizationThemedCodeTheme;
      openapi: CustomizationThemedCodeTheme;
    };
    sidebar: {
      /**
       * - `default`: No background, content sits directly against sidebar edge.
       * - `filled`: Muted background color that extends to sidebar edges.
       */
      background: CustomizationSidebarBackgroundStyle;
      /**
       * - `default`: Simple list items without special styling, groups are inset with a line.
       * - `pill`: Rounded capsule shape around selected/active items.
       * - `line`: Continuous line next to all items, with colored line part for selected/active items.
       */
      list: CustomizationSidebarListStyle;
    };
    /**
     * The style of the search button.
     * - `prominent`: large search bar in the middle of the header, with less room for other header items,
     * - `subtle`: small search bar in the corner of the header, with more room for other header items.
     */
    search: CustomizationSearchStyle;
  };
  /** @deprecated */
  internationalization: {
    /** Language for the UI element */
    locale: CustomizationLocale;
  };
  favicon: CustomizationFavicon;
  header: {
    /** The header preset to use for the site. This is a legacy setting and the site styling theme should be used instead. */
    preset: CustomizationHeaderPreset;
    logo?: CustomizationThemedURL;
    /** Destination to open when visitors click the site title/logo in the header. */
    primaryLink?: ContentRef;
    /**
     * Color of the background in the header. This value is now deprecated in favour of the new theming colors.
     * @deprecated
     */
    backgroundColor?: CustomizationThemedColor;
    /**
     * Color of the links in the header. This value is now deprecated and will be phased out in favour of the new theming colors.
     * @deprecated
     */
    linkColor?: CustomizationThemedColor;
    links: CustomizationHeaderItem[];
  };
  footer: {
    logo?: CustomizationThemedURL;
    groups: CustomizationFooterGroup[];
    /** @maxLength 512 */
    copyright?: string;
  };
  announcement?: CustomizationAnnouncement;
  /** Customization options for the dark/light theme modes. */
  themes: {
    default: CustomizationDefaultThemeMode;
    /** Should the reader be able to switch between dark and light mode */
    toggeable: boolean;
  };
  feedback: {
    /** If true, feedback gathering is enabled */
    enabled: boolean;
  };
  ai: {
    mode: CustomizationAIMode;
    /** Initial greeting displayed by the AI Assistant when a visitor starts a conversation. */
    greeting?: CustomizationAIGreeting;
    /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
    localizedGreeting?: LocalizedString128;
    /** Suggested questions to display at the start of the chosen AI mode. */
    suggestions?: CustomizationSuggestedQuestions;
    /** Additional instructions for the AI Assistant, injected after the base system prompt. Use them to adjust tone of voice and contribute site-specific knowledge. These instructions refine, but never override, the assistant's built-in guardrails. Only available to site admins and never exposed on the published site. */
    instructions?: CustomizationAIInstructions;
  };
  advancedCustomization: {
    /** If true, Advanced customization is enabled */
    enabled: boolean;
  };
  pageActions: {
    /**
     * Ordered list of the page actions enabled in the page menu. This is the source of truth for
     * which actions are enabled and in which order: the position defines the display order, the
     * first action is the default one, surfaced as the main button on the page, and actions not
     * present in the list are disabled. An empty list turns the page menu off entirely: no action
     * is shown, not even the `assistant`. On a non-empty list the `assistant` action follows the
     * `ai.mode` setting rather than its own presence: it is kept (prepended by default if missing,
     * otherwise keeping its position) when the assistant is enabled and absent when it is disabled.
     * When the menu is off, the assistant stays reachable from the header via `ai.mode`.
     */
    items: CustomizationPageActionType[];
  };
  externalLinks: {
    /**
     * How external links should open when clicked.
     * - `self`: External links open in the current tab.
     * - `blank`: External links open in a new browser tab.
     */
    target: SiteExternalLinksTarget;
  };
  pagination: {
    /** Whether the pagination navigation should be displayed on pages. */
    enabled: boolean;
  };
  trademark: {
    /** Whether the GitBook trademark ("Powered by GitBook") should be visible */
    enabled: boolean;
  };
  privacyPolicy: {
    url?: URL;
  };
  socialPreview: {
    url?: URL;
  };
  /** The social accounts of the site. */
  socialAccounts: SiteSocialAccounts;
  insights: {
    /**
     * Whether GitBook identifies the visitor on the site using a cookie.
     * @default true
     */
    trackingCookie: boolean;
  };
}

export type SiteCustomizationSettings = SiteCustomizationSettingsBase & {
  /** When the customization settings were updated. If missing, customization was not updated. */
  updatedAt?: Timestamp;
};

export interface SiteIntegrationScript {
  /** Script URL to load. */
  script: URL;
  /** Content Security Policy to secure the loading of this script. */
  contentSecurityPolicy?: string;
  /** If true, the script will potentially load use cookies and visitors should be aware. */
  cookies: boolean;
}

export interface PublishedContentSite {
  object: "published-content-site";
  site: Site;
  structure: SiteStructure;
  customizations: {
    site: SiteCustomizationSettings;
    siteSpaces: Record<string, SiteCustomizationSettings>;
  };
  scripts: SiteIntegrationScript[];
}

/** Steps to set up a site, each completed or not from the site's current data. */
export interface SiteSetup {
  /** Every setup step, in order. Empty once the site has been published, which ends the setup even if other steps are not completed. */
  steps: {
    /** A step of the setup of a site, in the order they are done. */
    id: SiteSetupStepId;
    completed: boolean;
    /** How to complete the step. Only present when it is not completed. */
    action?: string;
  }[];
}

/** State shared by every resource changed by a site change request. Each resource is versioned independently; the change request reviews and merges them as one. */
export interface SiteChangeRequestMember {
  object: "site-change-request-member";
  /** Unique identifier for the member */
  id: string;
  /** Whether the member is part of the change request, or a tombstone kept so that a member removed and later re-added keeps its identity, comments and history. */
  status: SiteChangeRequestMemberStatus;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

/** Content of one space changed by a site change request. */
export type SiteChangeRequestContentMember = SiteChangeRequestMember & {
  /** ID of the space whose content changes. */
  space: string;
  /** ID of the revision in the space's main content this member diverged from. */
  baseRevisionId: string;
  /** ID of the revision currently proposed for the space. */
  headRevisionId: string;
  /** ID of the revision produced in the space's main content when this member was merged. Only present once the change request has been merged. */
  mergedRevisionId?: string;
};

/** Structure of the site changed by a site change request: its space membership, sections, ordering and paths. */
export type SiteChangeRequestStructureMember = SiteChangeRequestMember & {
  /** The live site structure this member diverged from. */
  base?: SiteStructure;
  /** The site structure currently proposed. */
  head?: SiteStructure;
};

/** Customization settings of the site changed by a site change request. */
export type SiteChangeRequestCustomizationMember = SiteChangeRequestMember & {
  /** The live customization settings this member diverged from. */
  base?: SiteCustomizationSettings;
  /** The customization settings currently proposed. */
  head?: SiteCustomizationSettings;
};

/** A change request reviewing a site as a whole. It groups every proposed change — the site's structure and its content — into one review, one lifecycle and one merge decision. */
export interface SiteChangeRequest {
  object: "site-change-request";
  /** Unique identifier for the change request */
  id: string;
  /** ID of the organization owning the change request. */
  organization: string;
  /** ID of the site reviewed by the change request. */
  site: string;
  /** Incremental identifier of the change request within the site. */
  number: number;
  /** Identity of the complete set of member states currently exposed. It increments once per completed update, so a review can detect that it applies to outdated content. */
  version: number;
  status: ChangeRequestStatus;
  /** Subject of the change request */
  subject: ChangeRequestSubject;
  description?: JSONDocument;
  /** External links associated with the change request. */
  links?: ChangeRequestLinks;
  /** Spaces whose content the change request changes, one entry per space. Empty when it only changes the site itself. */
  content: SiteChangeRequestContentMember[];
  /** Only present when the change request changes the site structure. */
  structure?: SiteChangeRequestStructureMember;
  /** Only present when the change request changes the site customization settings. */
  customization?: SiteChangeRequestCustomizationMember;
  /** Count of opened comments across all members of the change request. */
  comments: number;
  createdBy: User;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  /** User who merged the change request. Only present when it has been merged. */
  mergedBy?: User;
  /** Date at which the change request was merged. Only present when it has been merged. */
  mergedAt?: Timestamp;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the change request in the application
     * @format uri
     */
    app: string;
    /**
     * URL of the change request in the API
     * @format uri
     */
    location: string;
  };
}

/**
 * Name of the share link
 * @minLength 0
 * @maxLength 50
 */
export type ShareLinkName = string;

export interface ShareLink {
  /** Type of Object, always equals to "share-link" */
  object: "share-link";
  /** Unique identifier for the share-link */
  id: string;
  createdAt: Timestamp;
  /** Name of the share link */
  name?: ShareLinkName;
  active?: boolean;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the published version of the share-link.
     * @format uri
     */
    published?: string;
  };
}

export interface SiteStructureItemPointer {
  type:
    | "site-space"
    | "site-section"
    | "site-section-group"
    | "site-external-link";
  /** Unique identifier for the site structure item (site space, site section, site section group, or external link). */
  id: string;
}

/** Position at which to move the site structure item relative to any sibling of the same structure level. */
export interface SiteStructureItemMovePosition {
  before?: SiteStructureItemPointer;
  after?: SiteStructureItemPointer;
}

/**
 * Site Structure Item
 * A site structure item can be a site space, a site section, a site section group, or an external link.
 * It is used to represent the structure of a site.
 */
export type SiteStructureItem =
  | SiteSpace
  | SiteSection
  | SiteSectionGroup
  | SiteExternalLink;

/** A response to a request to preview a paid operation or action. A user might preview an operation before executing it to see which billing steps would be required (if any). This schema defines the response of that preview request. */
export type BillingOperationPreviewResponse =
  | {
      /** User can go ahead with the operation without any additional steps. Their subscription will be updated to reflect the new changes. */
      type: "go-ahead";
    }
  | {
      /** By going ahead with this operation, the user will be starting a trial in GitBook. */
      type: "trial-available";
    }
  | {
      /** User must checkout to complete the operation. */
      type: "checkout";
      invoice?: BillingInvoicePreview;
    };

/** The reason or feature that triggered the site upgrade */
export type SiteUpgradeReason =
  | SiteFeatureKey
  | BillingMeter
  | "settings"
  | "billing-page"
  | "end-of-trial";

export type SitePublishingAuth = (
  | VisitorAuthCustomBackend
  | VisitorAuthIntegrationBackend
) & {
  /** Type of Object, always equals to "publishing-auth" */
  object: "publishing-auth";
  /** Private key used to sign JWT tokens. */
  privateKey: string;
  /**
   * URL to redirect to when the authenticated access secret is invalid.
   * @format uri
   */
  fallbackURL?: string;
  /**
   * URL used to log visitors out from the upstream custom auth backend.
   * @format uri
   */
  logoutURL?: string;
  /**
   * Name of the authenticated access integration installed on the site (if any).
   * It is also the one being used as VA backend when the published auth settings are configured to use "integration" as backend.
   */
  integration?: string;
};

export type SitePublishingAuthUpdate = (
  | VisitorAuthCustomBackend
  | VisitorAuthIntegrationBackend
) & {
  /**
   * A fallback URL that will be used if authentication fails. If not provided, the fallback URL will not be changed. If set to null, the fallback URL will be unset.
   * @format uri
   */
  fallbackURL?: string | null;
  /**
   * A logout URL used to log visitors out from the upstream custom auth backend. If not provided, the logout URL will not be changed. If set to null, the logout URL will be unset.
   * @format uri
   */
  logoutURL?: string | null;
};

export type SiteCustomizationSettingsInput = SiteCustomizationSettingsBase;

export type SiteSearchScope =
  | {
      /** Search across all sections of a site, only including the default content of each section. This scope is wide and shallow. You may optionally specify a list of additional site spaces to search in alongside the default content. */
      mode: "default";
      /** The ID of the site space that must always be included in the search results. The language of this site space will be used to match other site spaces with the same language, if applicable. */
      currentSiteSpace?: string;
      /**
       * Must not be provided when searching the entire default scope. To restrict the search to a subset of the default scope, provide `restrictTo` along with `currentSiteSpace`.
       * @minLength 2
       * @maxLength 1
       */
      restrictTo?: never;
    }
  | {
      /** Search a subset of the default scope of the site, relative to the current site space. */
      mode: "default";
      /** The ID of the site space the search is made from. The language of this site space will be used to match other site spaces with the same language, if applicable. */
      currentSiteSpace: string;
      /** Restrict the search to a subset of the default scope. With `currentSiteSpace`, only the current site space is searched. With `otherSiteSpaces`, the current site space is excluded and only the other site spaces in the default scope are searched. */
      restrictTo: "currentSiteSpace" | "otherSiteSpaces";
    }
  | {
      /** Only search in the provided site spaces. */
      mode: "specific";
      /** @minLength 1 */
      siteSpaceIds: string[];
    }
  | {
      /** Search in all sections and site spaces. This scope is wide and deep. */
      mode: "all";
    };

/** Search result representing a site context record. */
export interface SearchRecordResult {
  type: "record";
  /** The ID of the context record. */
  id: string;
  /** The title of the record. */
  title: string;
  /** Relevance score for a search result. Higher is better and the score is unbounded. */
  score: SearchResultScore;
  /** The description of the record. */
  description?: string;
  /**
   * URL of the record in the source system.
   * @format uri
   */
  url: string;
}

/**
 * The end goal the agent is trying to accomplish on behalf of the user. Unlike the immediate query, the goal describes the broader task or outcome the agent is working towards.
 * @maxLength 1024
 */
export type AgentGoal = string;

/** The agent that reported the feedback. It must never identify the end user the agent is acting on behalf of. */
export interface AgentFeedbackReportedBy {
  /**
   * Self-reported model powering the agent.
   * @maxLength 100
   */
  model?: string;
  /**
   * User-Agent the agent itself presented, for example `claude-code/1.2.3`. It is what identifies the harness the agent ran in.
   * @maxLength 512
   */
  userAgent?: string;
  /**
   * Identifier the surface gave the agent for the call being reported, used to find that call in the surface's own logs. Not an identifier of this report.
   * @maxLength 100
   */
  correlationId?: string;
  /**
   * Whether the user explicitly asked the agent to submit this feedback.
   * @default false
   */
  onDemand?: boolean;
}

/** Feedback about a tool exposed by an MCP server. */
export interface AgentFeedbackSubjectMCPTool {
  kind: "mcp-tool";
  /**
   * Name of the tool the agent called, as it was exposed to the agent.
   * @maxLength 200
   */
  toolName: string;
  /**
   * What the tool was pointed at, for a tool that dispatches to something else rather than doing one fixed thing. For a tool that invokes an API operation, the identifier of that operation.
   * @maxLength 200
   */
  target?: string;
}

/** Feedback about a command exposed by a command line interface. */
export interface AgentFeedbackSubjectCliCommand {
  kind: "cli-command";
  /**
   * The command the agent ran, without its arguments. Do not include any auth or other sensitive information.
   * @maxLength 200
   */
  command: string;
  /**
   * Names of the flags passed to the command. It must never contain their values.
   * @maxItems 50
   */
  flags?: string[];
}

/** Feedback about an API endpoint the agent called directly, without an MCP server or a command line interface in between. */
export interface AgentFeedbackSubjectApiEndpoint {
  kind: "api-endpoint";
  /** HTTP method of the endpoint. */
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE" | "HEAD" | "OPTIONS";
  /**
   * Templated path of the endpoint, for example `/v1/orders/{orderId}/fulfill`. It must never contain resolved identifiers or query string values.
   * @maxLength 500
   */
  path: string;
}

/** Feedback about published documentation, such as a page that is outdated, incorrect, or missing information the agent needed to help its user. */
export interface AgentFeedbackSubjectDocumentation {
  kind: "documentation";
  /** URL of the content the feedback is about. */
  url: URL;
}

/** Feedback with no single tool, command, endpoint, or page behind it, such as product friction or a capability the agent expected to find and could not. */
export interface AgentFeedbackSubjectGeneric {
  kind: "generic";
}

/** The content of the feedback. It must never contain parameter values, request or response bodies, credentials, or anything identifying the end user the agent acted for. */
export interface AgentFeedbackContent {
  /**
   * Classification of the feedback:
   *   - Usability: The subject was hard to understand or use correctly, such as a confusing name or unclear parameters.
   *   - Reliability: The subject behaved inconsistently, failed unexpectedly, or returned unusable results.
   *   - Documentation: The description, schema, or guidance about the subject was missing, unclear, or misleading.
   *   - Efficiency: Reaching the outcome took more calls, steps, or tokens than it should have.
   *   - Interoperability: The subject did not compose well with other tools, operations, or formats.
   *   - Could not accomplish: Nothing exposed to the agent could accomplish what it needed to do.
   */
  category:
    | "usability"
    | "reliability"
    | "documentation"
    | "efficiency"
    | "interoperability"
    | "could-not-accomplish";
  /** How much the issue impeded the agent. */
  severity?: "low" | "medium" | "high";
  /** What the agent was working towards when it ran into the issue. */
  goal?: AgentGoal;
  /**
   * A short summary of what went wrong, in the agent's own words.
   * @minLength 1
   * @maxLength 256
   */
  summary: string;
  /**
   * Additional explanation of the issue and how the agent ran into it.
   * @maxLength 4096
   */
  detail?: string;
  /**
   * How the agent worked around the issue, when it managed to.
   * @maxLength 2048
   */
  workaround?: string;
  /** How the agent interacted with the subject before reporting. */
  metrics?: {
    /**
     * Number of times the agent used the subject.
     * @min 0
     */
    callCount?: number;
    /**
     * Number of those uses that produced a usable result.
     * @min 0
     */
    successCount?: number;
    /**
     * Number of those uses that were retries after a failure.
     * @min 0
     */
    retryCount?: number;
  };
}

/** Feedback submitted by an AI agent about a tool, command, endpoint or page it worked with. `reportedBy` and `feedback` have the same shape whatever the feedback is about; only `subject` varies. */
export interface AgentFeedbackInput {
  /** The agent that reported the feedback. It must never identify the end user the agent is acting on behalf of. */
  reportedBy?: AgentFeedbackReportedBy;
  /** What the feedback is about. `kind` determines both the shape of the subject and the surface the agent was working through. */
  subject: AgentFeedbackSubject;
  /** The content of the feedback. It must never contain parameter values, request or response bodies, credentials, or anything identifying the end user the agent acted for. */
  feedback: AgentFeedbackContent;
}

/** Identifiers for a GitBook site session, used for analytics and adaptive content. */
export interface SiteInsightsSession {
  /** GitBook's unique identifier of the visitor. */
  visitorId: string;
  /** GitBook's unique identifier of the visitor's session. */
  sessionId: string;
}

/** Integration source */
export type ContextConnector =
  | `integration:${string}`
  | "builtin:email"
  | "builtin:api"
  | "builtin:website"
  | "builtin:youtube"
  | "builtin:github-discussions"
  | "builtin:github-issues"
  | "builtin:intercom"
  | "builtin:front"
  | "builtin:zendesk"
  | "builtin:zoho-desk"
  | "builtin:freshdesk"
  | "builtin:pylon"
  | "builtin:hubspot"
  | "builtin:linear"
  | "builtin:jira";

/**
 * Title for the context record
 * @minLength 1
 * @maxLength 256
 */
export type ContextRecordTitle = string;

/**
 * Optional short description of the context record
 * @maxLength 512
 */
export type ContextRecordDescription = string;

export interface ContextRecord {
  object: "context-record";
  /** The ID of the record */
  id: string;
  /** Title for the context record */
  title: ContextRecordTitle;
  /** Optional short description of the context record */
  description?: ContextRecordDescription;
  type: ContextRecordType;
  createdAt: Timestamp;
  processedAt?: Timestamp;
  /** The connection ID associated with the record */
  connection: string;
  /** The connector type associated with the record */
  connector: ContextConnector;
  /** The associated topics of the record */
  topics?: string[];
  /** URLs associated with the record */
  urls: {
    /**
     * URL of the record in the API
     * @format uri
     */
    location: string;
    /**
     * URL of the record in the source
     * @format uri
     */
    source?: string;
  };
}

/** Input to ingest a new context record */
export interface ContextRecordInput {
  /** Unique local identifier for the record */
  id: string;
  type: ContextRecordType;
  /** Title for the context record */
  title: ContextRecordTitle;
  /** Optional short description of the context record */
  description?: ContextRecordDescription;
  /** Body content of the record as markdown */
  body: string;
  /**
   * URL of the record
   * @format uri
   */
  url?: string;
  /** Date of the record creation in the original source */
  createdAt?: Timestamp;
  metadata?: Record<string, string | number>;
}

/** Number of findings created by the scan, grouped by severity. */
export interface SiteScanFindings {
  low: number;
  medium: number;
  high: number;
}

export interface SiteScan {
  object: "site-scan";
  /** The ID of the scan */
  id: string;
  /** Status of a persisted site scan. */
  status: SiteScanStatus;
  /** The site topic ID associated with the scan. It is null for scans that are not associated with a current topic in the site. */
  topic: string | null;
  createdAt: Timestamp;
  startedAt?: Timestamp;
  finishedAt?: Timestamp;
  /** Number of findings created by the scan, grouped by severity. */
  findings: SiteScanFindings;
  /** Failure message for failed scans */
  failureMessage?: string;
  /** URLs associated with the scan */
  urls: {
    /**
     * URL of the scan endpoint in the API
     * @format uri
     */
    location: string;
  };
}

/**
 * Findings source filter matching evidence coming from a given connection,
 * encoded as `connection:<connectionId>`.
 * @pattern ^connection:.+$
 */
export type SiteTriageFilterConnections = string;

/**
 * Short finding title
 * @maxLength 256
 */
export type SiteFindingTitle = string;

/**
 * Serving redirect
 * The live redirect serving a `broken-link` finding's path.
 */
export interface SiteFindingServingRedirect {
  /** ID of the redirect. */
  redirect: string;
  /** Whether a wildcard redirect covers the path rather than one at the path itself. Reopening the finding would delete it, so `reopen` isn't offered. */
  wildcard: boolean;
  /** Whether GitBook created the redirect on its own. */
  createdByAgent: boolean;
}

/**
 * Awaiting change request
 * The change request GitBook drafted to fix an `outbound-link-error` finding, waiting to be approved or rejected. Approving it means merging it. Reject it with `applySiteFindingAction`.
 */
export interface SiteFindingAwaitingChangeRequest {
  /** ID of the space the change request is in. */
  space: string;
  /** ID of the change request. */
  changeRequest: string;
  /** Number of open outbound links on the site the change request fixes. */
  findings: number;
}

/**
 * Available action
 * An action a finding allows now, with the site permission it needs.
 */
export interface SiteFindingAvailableAction {
  /**
   * An action that moves a finding to another state. A finding's `actions` lists the ones it allows.
   *   - `approve` makes the redirect GitBook drafted for a broken link live, which resolves the finding. A change request GitBook drafted for an outbound link is approved by merging it.
   *   - `reject` deletes the redirect GitBook drafted for a broken link; the finding stays open and GitBook won't draft a fix for it again. For an outbound link, it archives the change request GitBook drafted (`awaitingChangeRequest`) and unlinks every link it fixes. They are open again, marked `undone`, and GitBook won't draft a fix for them again.
   *   - `create-redirect` creates a redirect for a broken link's path with `createSiteRedirect`, prefilled with the suggestion; it resolves the finding.
   *   - `mark-resolved` resolves it. A broken link resolved this way has no redirect: visitors still get a 404.
   *   - `reopen` reopens a resolved finding. For a broken link, it deletes the live redirect at its path; for a fix GitBook applied, this undoes the fix and GitBook won't fix the link again.
   *   - `ignore` dismisses it.
   *   - `restore` reopens a dismissed finding.
   */
  action: SiteFindingAction;
  /** Site permission the action needs. */
  permission: "edit" | "admin";
}

/**
 * The source path to redirect from.
 * @maxLength 512
 * @pattern ^\/(?!\*)(?!.*\*.+)(?:[A-Za-z0-9\-._~+]|%[0-9A-Fa-f]{2})+(?:\/(?:[A-Za-z0-9\-._~+]|%[0-9A-Fa-f]{2})+)*(?:\/\*|\*)?$
 */
export type SiteRedirectSourcePath = string;

export interface SiteRedirectInputDestinationPath {
  kind: "path";
  /** Unique identifier for the space containing the page referenced by the path. */
  spaceId: string;
  /** Path to the page within the space revision to resolve. */
  path: string;
}

/** Suggested fix for a broken-link finding, shaped as the input for `createSiteRedirect` so it can be applied directly. Absent when the finding has no directly applicable redirect (for example, a suggestion to create a new page). The destination is absent when the audit judged the URL and found no page to redirect to: a redirect can still be created from the source with a destination of your choosing. */
export interface SiteFindingBrokenLinkAction {
  /** The source path to redirect from. */
  source: SiteRedirectSourcePath;
  /** Whether the redirect appends the wildcard-matched suffix of the source path to the destination. */
  captureWildcard?: boolean;
  destination?: SiteRedirectInputDestinationPath;
}

/** Details of an `outbound-link-error` finding: the failing external URL, or the domain when it doesn't resolve, and the observed failure, sourced from the site's outbound link checks. A resolved finding has either `url` or `host` and no other field. Absent on findings of any other type. */
export interface SiteFindingOutboundLink {
  /**
   * The external URL that fails. Absent when `host` is set.
   * @format uri
   */
  url?: string;
  /** The domain that doesn't resolve, set instead of `url` when the finding covers every link to that domain on the site. */
  host?: string;
  /** Current health status of the URL or domain for this site. */
  status?:
    | "pending"
    | "healthy"
    | "suspect"
    | "failed"
    | "recovering"
    | "canceled";
  /** Classification of the confirmed failure. */
  failureKind?:
    | "client-error"
    | "server-error"
    | "redirect"
    | "dns"
    | "tls"
    | "connection"
    | "timeout";
  /** HTTP status code of the last observation, when one was received. */
  httpStatus?: number;
  /** When the URL or domain was last observed. */
  checkedAt?: Timestamp;
}

export interface SiteFinding {
  object: "site-finding";
  /** The ID of the finding */
  id: string;
  /** The site scan ID associated with the finding */
  scan: string;
  /** The site topic ID associated with the finding. It is null for findings that are not associated with a current topic in the site. */
  topic: string | null;
  /** Short finding title */
  title: SiteFindingTitle;
  /** Number of change requests linked to the finding */
  changeRequests: number;
  /** Number of pages linked to the finding */
  pages: number;
  /** Number of records linked to the finding */
  records: number;
  /** Number of questions linked to the finding */
  questions: number;
  /**
   * Status of a site finding.
   *   - `candidate` is a finding that has been raised but not yet confirmed. Typically these are not shown to users.
   *   - `open` is a finding that has been surfaced to users and is still under investigation.
   *   - `done` is a finding that has been resolved and is no longer under investigation.
   *   - `canceled` is a finding that has been canceled and is no longer under investigation.
   */
  status: SiteFindingStatus;
  /**
   * Classification of a site finding:
   *   - Outdated content: The content was correct but is no longer up to date with external context and may be misleading or incorrect.
   *   - Incorrect content: The content is factually wrong or misleading, leading users astray regardless of whether it was ever correct.
   *   - Content gap: The content is missing important information that should be present to answer user questions effectively.
   *   - Broken link: A URL on the site returns a 404, and can be resolved by creating a redirect or a new page.
   *   - Outbound link error: An external URL used by the site's content fails to resolve, and can be fixed by replacing or removing the link.
   *   - Other: Any other type of finding not covered by the above categories.
   */
  type: SiteFindingType;
  /** Estimated end-user severity of a site finding. */
  severity: SiteFindingSeverity;
  description: JSONDocument;
  /** Whether an AI agent should be able to fix this finding directly */
  autoFixable: boolean;
  /** What GitBook did on its own to resolve the finding. Null when it never acted on the finding. */
  autoResolution: SiteFindingAutoResolution | null;
  /**
   * Where a link finding stands, from its status and what GitBook did with it.
   *   - `open` needs a fix.
   *   - `awaiting-approval` has a fix GitBook drafted, waiting to be approved or rejected: a redirect at a `broken-link` finding's path, or an unmerged change request for an `outbound-link-error` finding (`awaitingChangeRequest`).
   *   - `resolved` was fixed or closed: `servingRedirect` says whether a live redirect serves its path.
   *   - `ignored` was dismissed.
   */
  state?: SiteFindingState;
  /** The live redirect serving a `broken-link` finding's path. */
  servingRedirect?: SiteFindingServingRedirect;
  /** The change request GitBook drafted to fix an `outbound-link-error` finding, waiting to be approved or rejected. Approving it means merging it. Reject it with `applySiteFindingAction`. */
  awaitingChangeRequest?: SiteFindingAwaitingChangeRequest;
  /** Actions the finding allows now, applied with `applySiteFindingAction`. */
  actions?: SiteFindingAvailableAction[];
  /** Suggested fix for a broken-link finding, shaped as the input for `createSiteRedirect` so it can be applied directly. Absent when the finding has no directly applicable redirect (for example, a suggestion to create a new page). The destination is absent when the audit judged the URL and found no page to redirect to: a redirect can still be created from the source with a destination of your choosing. */
  brokenLinkAction?: SiteFindingBrokenLinkAction;
  /** Details of an `outbound-link-error` finding: the failing external URL, or the domain when it doesn't resolve, and the observed failure, sourced from the site's outbound link checks. A resolved finding has either `url` or `host` and no other field. Absent on findings of any other type. */
  outboundLink?: SiteFindingOutboundLink;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  /** URLs associated with the finding */
  urls: {
    /**
     * URL of the finding list endpoint in the API
     * @format uri
     */
    location: string;
  };
}

export interface SiteFindingPage {
  object: "site-finding-page";
  /** The space ID containing the linked page. */
  spaceId: string;
  page: ChangedRevisionPage;
}

/** Aggregated feedback for answers linked to a site question. */
export interface SiteQuestionStatsFeedback {
  /** Count of answers with positive feedback. */
  positive: number;
  /** Count of answers with negative feedback. */
  negative: number;
  /** Count of answers without feedback. */
  unrated: number;
}

/** Aggregated answered assessment for answers linked to a site question. */
export interface SiteQuestionStatsAnswered {
  /** Count of answers assessed as fully answered. */
  yes: number;
  /** Count of answers assessed as partially answered. */
  partially: number;
  /** Count of answers assessed as not answered. */
  no: number;
}

export interface SiteQuestionStatsRelevance {
  relevant: number;
  spam: number;
  "off-topic": number;
  unclear: number;
}

export interface SiteQuestionStatsTypes {
  exploring: number;
  "how-to": number;
  troubleshooting: number;
  reference: number;
  unknown: number;
}

/** Count of answers by site channel type, including core channels. */
export type SiteQuestionStatsChannelTypes = Record<string, number>;

/** Count of answers by site channel ID. */
export type SiteQuestionStatsChannels = Record<string, number>;

/** Count of answers by visitor type. */
export interface SiteQuestionStatsVisitorTypes {
  human: number;
  agent: number;
  bot: number;
  unknown: number;
}

/** Aggregated stats for questions and linked answers. */
export interface SiteQuestionStats {
  /** Total count of questions included in the aggregation. */
  total: number;
  /** Total count of answers linked to the questions. */
  answers: number;
  /** Aggregated feedback for answers linked to a site question. */
  feedback: SiteQuestionStatsFeedback;
  /** Aggregated answered assessment for answers linked to a site question. */
  answered: SiteQuestionStatsAnswered;
  relevance: SiteQuestionStatsRelevance;
  types: SiteQuestionStatsTypes;
  /** Count of answers by site channel type, including core channels. */
  channelTypes: SiteQuestionStatsChannelTypes;
  /** Count of answers by site channel ID. */
  channels: SiteQuestionStatsChannels;
  /** Count of answers by visitor type. */
  visitorTypes: SiteQuestionStatsVisitorTypes;
  /**
   * Weekly count of related question answers for the past 3 months.
   * @maxItems 13
   * @minItems 13
   */
  weeklyPulse: number[];
}

export interface SiteQuestion {
  object: "site-question";
  /** The ID of the site question. */
  id: string;
  /** Canonical text for the unique site question. */
  question: string;
  /** Type classification of the user question. */
  type: SiteQuestionType;
  createdAt: Timestamp;
  askedAt: Timestamp;
  /** Aggregated stats for questions and linked answers. */
  stats: SiteQuestionStats;
  /** URLs associated with the site question. */
  urls: {
    /**
     * URL of the site question in the API.
     * @format uri
     */
    location: string;
  };
}

/** Count of findings by status. Candidate findings are never counted. */
export interface SiteFindingStatsStatuses {
  /** Count of findings surfaced to users and still under investigation. */
  open: number;
  /** Count of findings that have been resolved. */
  done: number;
  /** Count of findings that have been canceled. */
  canceled: number;
}

/** Count of findings by estimated end-user severity. */
export interface SiteFindingStatsSeverities {
  /** Count of findings with a low estimated severity. */
  low: number;
  /** Count of findings with a medium estimated severity. */
  medium: number;
  /** Count of findings with a high estimated severity. */
  high: number;
}

/** Count of findings by the connector their evidence came from, keyed by connector (e.g. `builtin:intercom`). A finding is counted once per connector that contributed at least one piece of evidence to it, so the counts can add up to more than the total. */
export type SiteFindingStatsConnectors = Record<string, number>;

/** Breakdown of the broken-link findings included in the aggregation. */
export interface SiteFindingStatsBrokenLinks {
  /** Broken URLs the audit found a page to redirect to. */
  redirectSuggested: number;
  /** Broken URLs the audit judged and found no page to redirect to. */
  noMatchingPage: number;
}

/** Aggregated stats for the findings identified on a site. */
export interface SiteFindingStats {
  /** Total count of findings included in the aggregation. */
  total: number;
  /** Count of findings by status. Candidate findings are never counted. */
  statuses: SiteFindingStatsStatuses;
  /** Count of findings by estimated end-user severity. */
  severities: SiteFindingStatsSeverities;
  /** Count of findings by the connector their evidence came from, keyed by connector (e.g. `builtin:intercom`). A finding is counted once per connector that contributed at least one piece of evidence to it, so the counts can add up to more than the total. */
  connectors: SiteFindingStatsConnectors;
  /** Breakdown of the broken-link findings included in the aggregation. */
  brokenLinks: SiteFindingStatsBrokenLinks;
  /** Count of findings with at least one piece of evidence coming from a site question. */
  questions: number;
  /** Count of change requests created to fix a finding that have been merged. */
  mergedChangeRequests: number;
}

/**
 * Optional label for the connection
 * @minLength 0
 * @maxLength 128
 */
export type ContextConnectionLabel = string;

/**
 * Optional filter used to restrict which items are ingested from the source. Its meaning depends on the connector: it can be a tag, label, or an expression. When empty or omitted, all resolved items are ingested.
 * @minLength 0
 * @maxLength 1024
 */
export type ContextConnectionFilter = string;

export interface ContextUsageSettings {
  /** Whether to use context to propose change requests */
  changeRequests: boolean;
  /** Whether to expose records in search results */
  search: boolean;
  /** Whether the connection syncs GitBook change-request state outward to the connected external system (outbound write). Requires a write-capable token or role. */
  sync?: boolean;
  /** Relative score adjustment applied to records from a connection when searching. */
  searchBoost: ContextSearchBoost;
}

/**
 * A YouTube channel ID starting with "UC".
 * @pattern ^UC[A-Za-z0-9_-]{22}$
 */
export type YoutubeChannelId = string;

/**
 * A YouTube channel handle starting with "@".
 * @pattern ^@[A-Za-z0-9._-]{3,100}$
 */
export type YoutubeChannelName = string;

/** A YouTube channel identifier, either a channel ID or a channel handle. */
export type YoutubeChannelPattern = YoutubeChannelId | YoutubeChannelName;

export interface JiraConnectorSetupSettings {
  /**
   * Base URL of the Jira Cloud site, e.g. https://your-team.atlassian.net.
   * @format uri
   * @minLength 1
   * @maxLength 2048
   */
  baseUrl: string;
  /**
   * Email of the Atlassian account whose API token is used.
   * @format email
   * @minLength 1
   * @maxLength 254
   */
  apiEmail: string;
  /**
   * Atlassian API token used for outbound writes. Redacted when read back. Omit it when updating a connection to keep the stored token; required when the site URL or account email changes.
   * @minLength 1
   * @maxLength 1024
   */
  apiToken: string;
  /**
   * Projects where GitBook handles issues. Empty means all accessible projects.
   * @maxItems 100
   * @uniqueItems true
   */
  projectKeys?: string[];
  /** Jira status to move the linked issue to when the change request reaches a given status, e.g. `{ "merged": "Done" }`. A status left out is not synced. */
  statusMapping?: Partial<Record<ChangeRequestStatus, string>>;
}

export type ContextConnectorSetup =
  | {
      connector: "builtin:email";
    }
  | {
      connector: "builtin:api";
    }
  | {
      /** @pattern ^integration:[^:]+$ */
      connector: `integration:${string}`;
    }
  | {
      connector: "builtin:website";
      setupSettings: {
        /** @format uri */
        url: string;
      };
    }
  | {
      connector: "builtin:youtube";
      setupSettings: {
        /** A YouTube channel identifier, either a channel ID or a channel handle. */
        channelId: YoutubeChannelPattern;
      };
    }
  | {
      connector: "builtin:github-discussions";
      setupSettings: {
        /** @pattern ^[A-Za-z0-9_.-]+/[A-Za-z0-9_.-]+$ */
        repository: string;
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:github-issues";
      setupSettings: {
        /** @pattern ^[A-Za-z0-9_.-]+/[A-Za-z0-9_.-]+$ */
        repository: string;
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:intercom";
      setupSettings: {
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:front";
      setupSettings: {
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:zendesk";
      setupSettings: {
        /** @minLength 1 */
        subdomain: string;
        /** @minLength 1 */
        email: string;
        /** @minLength 1 */
        apiToken: string;
      };
    }
  | {
      connector: "builtin:zoho-desk";
      setupSettings: {
        /**
         * Zoho data center hosting the account, given as its API domain suffix (e.g. `com`, `eu`, `in`, `com.au`). Zoho scopes both the accounts and desk API hosts by data center.
         * @minLength 1
         */
        dataCenter: string;
        /**
         * Zoho Desk organization id the tickets belong to.
         * @minLength 1
         */
        orgId: string;
        /** @minLength 1 */
        clientId: string;
        /** @minLength 1 */
        clientSecret: string;
        /** @minLength 1 */
        refreshToken: string;
      };
    }
  | {
      connector: "builtin:freshdesk";
      setupSettings: {
        /**
         * Freshdesk domain hosting the account, e.g. `mycompany.freshdesk.com` or just `mycompany`. Tickets and the API are scoped by this domain.
         * @minLength 1
         */
        domain: string;
        /**
         * Freshdesk API key with permission to read tickets. Sent as HTTP Basic auth and redacted when read back.
         * @minLength 1
         */
        apiKey: string;
      };
    }
  | {
      connector: "builtin:pylon";
      setupSettings: {
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:hubspot";
      setupSettings: {
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:linear";
      setupSettings: {
        /** @minLength 1 */
        token: string;
      };
    }
  | {
      connector: "builtin:jira";
      setupSettings: JiraConnectorSetupSettings;
    };

export type ContextConnection = {
  object: "context-connection";
  /** The ID of the connection */
  id: string;
  createdAt: Timestamp;
  syncedAt?: Timestamp;
  /** Optional label for the connection */
  label?: ContextConnectionLabel;
  /** Optional filter used to restrict which items are ingested from the source. Its meaning depends on the connector: it can be a tag, label, or an expression. When empty or omitted, all resolved items are ingested. */
  filter?: ContextConnectionFilter;
  status: ContextConnectionStatus;
  /** Number of records ingested from this connection */
  records: number;
  /** Failure message when synchronization fails */
  failureMessage?: string;
  /** Why a synchronization failed, indicating who can resolve it. `authentication` and `misconfigured` need the connection to be reconfigured; `rate_limited` and `upstream_unavailable` are the source's own limits or downtime and are retried; `unknown` could not be attributed to the source's response. */
  failureReason?: ContextConnectionFailureReason;
  /**
   * Why an AI task was skipped before execution.
   *
   * - `ai_unavailable_for_organization`: The organization's effective plan does not include AI or a
   *   required feature. Takes precedence when both the organization and site plans block the task.
   * - `ai_unavailable_for_site`: The site's effective plan does not include the required feature.
   *   The site's applied plan takes precedence over its own plan.
   * - `ai_paused`: AI usage is temporarily paused by automatic usage controls.
   * - `ai_disabled`: AI or a required AI feature has been turned off in the organization's settings.
   * - `ai_restricted`: AI is blocked by GitBook or a contractual restriction and cannot be enabled
   *   through organization settings.
   */
  skipReason?: AISkipReason;
  /** Parameters associated with the connection when it is an email connection */
  email?: {
    /**
     * Inbound email address for the connection
     * @format email
     */
    ingestionAddress?: string;
  };
  usageSettings: ContextUsageSettings;
  /** URLs associated with the connection */
  urls: {
    /**
     * URL of the connection in the API
     * @format uri
     */
    location: string;
  };
} & ContextConnectorSetup;

/**
 * Base URL of the Jira Cloud site, e.g. https://your-team.atlassian.net.
 * @format uri
 * @minLength 1
 * @maxLength 2048
 */
export type BaseUrl = string;

/**
 * Email of the Atlassian account whose API token is used.
 * @format email
 * @minLength 1
 * @maxLength 254
 */
export type ApiEmail = string;

/**
 * Atlassian API token used for outbound writes. Redacted when read back. Omit it when updating a connection to keep the stored token; required when the site URL or account email changes.
 * @minLength 1
 * @maxLength 1024
 */
export type ApiToken = string;

/**
 * Projects where GitBook handles issues. Empty means all accessible projects.
 * @maxItems 100
 * @uniqueItems true
 */
export type ProjectKeys = string[];

/** Jira status to move the linked issue to when the change request reaches a given status, e.g. `{ "merged": "Done" }`. A status left out is not synced. */
export type StatusMapping = Partial<Record<ChangeRequestStatus, string>>;

export interface ContextConnectionTestResult {
  object: "context-connection-test-result";
  /** Whether the stored credentials authenticated successfully. */
  success: boolean;
  /** A human-readable reason for the failure, when the test failed. */
  error?: string;
}

export type SiteChannelType = SiteCoreChannelType | SiteConfigurableChannelType;

export interface SiteTopicUsageSettings {
  /** Whether to use context to propose change requests */
  changeRequests: boolean;
}

export interface SiteTopic {
  object: "context-topic";
  /** The ID of the topic */
  id: string;
  /** The label of the topic */
  label: string;
  /** The parent topic when this topic is nested under another one */
  parent?: {
    /** The ID of the parent topic */
    id: string;
    /** The label of the parent topic */
    label: string;
  };
  createdAt: Timestamp;
  updatedAt: Timestamp;
  /** Name of the icon */
  icon: Icon;
  summary: JSONDocument;
  usageSettings: SiteTopicUsageSettings;
  /** The number of pages associated with the topic */
  pages: number;
  /** The number of records in the topic */
  records: number;
  /** The number of findings linked to the topic */
  findings: {
    /** The number of open findings linked to the topic */
    open: number;
    /** The total number of findings linked to the topic */
    total: number;
  };
  /** Aggregated stats for questions and linked answers. */
  questions: SiteQuestionStats;
  /** URLs associated with the topic */
  urls: {
    /**
     * URL of the topic in the API
     * @format uri
     */
    location: string;
  };
}

export interface SiteQuestionAnswerSourceBase {
  object: "site-question-answer-source";
  /** The ID of the source. */
  id: string;
  /** Relative weight of this source in the generated answer. */
  weight: number;
  /** The title of the source. */
  title: string;
  /** URLs associated with the site question answer. */
  urls: {
    /**
     * URL of the site question answer in the API.
     * @format uri
     */
    location: string;
  };
}

/** Source data pointing to a page used for a site question answer. */
export type SiteQuestionAnswerSourcePage = SiteQuestionAnswerSourceBase & {
  type: "page";
  /** The space ID of the source page. */
  space: string;
  /** The revision ID used for this source page. */
  revision: string;
  /** The page ID of the source page. */
  page: string;
};

export type SiteQuestionAnswerSourceRecord = SiteQuestionAnswerSourceBase & {
  type: "record";
  /** The site context record ID. */
  record: string;
  /** Integration source */
  connector?: ContextConnector;
};

export interface SiteQuestionTimelineBucket {
  /** Start of the bucket. */
  time: Timestamp;
  /** Count of answers given during the bucket. */
  answers: number;
  /** Count of distinct visitors who received those answers. */
  visitors: number;
}

/** Ask AI answers counted per bucket, oldest first. */
export interface SiteQuestionTimeline {
  items: SiteQuestionTimelineBucket[];
}

export interface SiteQuestionAnswer {
  object: "site-question-answer";
  /** The ID of the site question answer. */
  id: string;
  question: {
    /** The ID of the parent site question. */
    id: string;
    /** Type classification of the user question. */
    type: SiteQuestionType;
  };
  /** The IDs of the associated site topics. */
  topics: string[];
  input: {
    /** Normalized question text for this answer. */
    text: string;
    /** Raw question text as asked by the user. */
    raw: string;
  };
  thread?: {
    /** The ID of the thread this answer belongs to. */
    id: string;
    /** ID of the previous answer in the same thread. */
    previous: string;
  };
  /** Identifiers for a GitBook site session, used for analytics and adaptive content. */
  session?: SiteInsightsSession;
  feedback?: {
    /** Feedback rating provided by the user. */
    rating: -1 | 1;
  };
  /** The response identifier for this answer. */
  responseId: string;
  /** ISO language code of the question. */
  language: string;
  /** Whether the response answered the question. */
  answered: SiteQuestionAnswerResolution;
  /** Helpfulness of the response for the end user need. */
  helpfulness: SiteQuestionAnswerHelpfulness;
  /** Relevance classification of the user question. */
  relevance: SiteQuestionAnswerRelevance;
  channel:
    | {
        type: SiteCoreChannelType;
      }
    | {
        type: SiteConfigurableChannelType;
        /** ID of the associated site channel when the answer originates from a configurable channel. Null if the channel has been deleted. */
        id: string | null;
      };
  /** Who asked the question: `human` for a person using a web browser, `agent` for an AI agent, `bot` for another automated client that names itself, such as a search engine crawler, and `unknown` when it can't be told, such as for a script calling the API. */
  visitorType: SiteQuestionVisitorType;
  createdAt: Timestamp;
  updatedAt?: Timestamp;
  /** URLs associated with the site question answer. */
  urls: {
    /**
     * URL of the site question answer in the API.
     * @format uri
     */
    location: string;
  };
}

export interface AIToolCallGetPageContent {
  tool: "getPageContent";
  /** The ID of the space being accessed. */
  spaceId: string;
  /** The ID of the revision within which the page content is being fetched. */
  revisionId: string;
  page: ChangedRevisionPage;
}

/** Tool to read the body of an external record. */
export interface AIToolCallGetRecordContent {
  tool: "getRecordContent";
  /** The ID of the site owning the context record. */
  siteId: string;
  /** The ID of the context record. */
  recordId: string;
  /** The title of the record. */
  title: string;
  /**
   * URL of the record in the source system.
   * @format uri
   */
  url?: string;
}

export interface AIToolCallGetPages {
  tool: "getPages";
  /** The ID of the space being accessed. */
  spaceId: string;
  /** The revision ID of the space. */
  revisionId: string;
}

export interface AIToolCallGetReusableContents {
  tool: "getReusableContents";
  /** The ID of the space being accessed. */
  spaceId: string;
  /** The revision ID of the space. */
  revisionId: string;
}

/**
 * Page result
 * Result of a search matching a page.
 */
export interface AIToolCallSearchResultPage {
  type: "page";
  /** The ID of the space */
  spaceId: string;
  /** The ID of the page */
  pageId: string;
  /** The revision ID of the result */
  revisionId: string;
  /** The path of the page within its space, as the published site serves it. */
  path?: string;
  /** The anchor of the result */
  anchor?: string;
  /** The title of the result */
  title: string;
  /** The description of the result */
  description?: string;
}

/**
 * Site context record result
 * Result of a search matching a site context record.
 */
export interface AIToolCallSearchResultRecord {
  type: "record";
  /** The ID of the site owning the context record */
  siteId: string;
  /** The ID of the context record */
  recordId: string;
  /** The title of the record */
  title: string;
  /** The description of the record */
  description?: string;
  /**
   * URL of the record in its original source
   * @format uri
   */
  url?: string;
}

/** Tool to search for content */
export interface AIToolCallSearch {
  tool: "search";
  /** The query that has been searched for. */
  query: string;
  results: AIToolCallSearchResult[];
}

export interface AIToolCallEditPage {
  tool: "editPage";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the page change in the current conversation. */
  baseRevisionId: string;
  page: ChangedRevisionPage;
  /** The ID of the change request the edit was made in. Absent when the space itself was edited, through its unlocked live edits. */
  changeRequestId?: string;
}

export interface AIToolCallCreatePage {
  tool: "createPage";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the page change in the current conversation. */
  baseRevisionId: string;
  page: ChangedRevisionPage;
  /** The ID of the change request the edit was made in. Absent when the space itself was edited, through its unlocked live edits. */
  changeRequestId?: string;
}

export interface AIToolCallDeletePage {
  tool: "deletePage";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the page deletion in the current conversation. */
  baseRevisionId: string;
  page: ChangedRevisionPage;
  /** The ID of the change request the edit was made in. Absent when the space itself was edited, through its unlocked live edits. */
  changeRequestId?: string;
}

export interface AIToolCallRenamePage {
  tool: "renamePage";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the page rename in the current conversation. */
  baseRevisionId: string;
  page: ChangedRevisionPage;
  /** The ID of the change request the edit was made in. Absent when the space itself was edited, through its unlocked live edits. */
  changeRequestId?: string;
  /** The new title of the page. */
  title: string;
}

export interface AIToolCallMovePage {
  tool: "movePage";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the page move in the current conversation. */
  baseRevisionId: string;
  page: ChangedRevisionPage;
  /** The ID of the change request the edit was made in. Absent when the space itself was edited, through its unlocked live edits. */
  changeRequestId?: string;
  to?: ChangedRevisionPage;
  /**
   * Indicates how the page was moved relative to the "to" page.
   * - `within`: moved as the last child of the target page (or to the root when `to` is omitted)
   * - `before`: moved directly before the target page
   * - `after`: moved directly after the target page
   */
  moveType: "within" | "before" | "after";
}

export interface AIToolCallListModifiedPages {
  tool: "listModifiedPages";
  /** The ID of the space being accessed. */
  spaceId: string;
}

export interface AIToolCallGetPageDiff {
  tool: "getPageDiff";
  /** The ID of the space being accessed. */
  spaceId: string;
  page: ChangedRevisionPage;
}

export interface AIToolCallCreateReusableContent {
  tool: "createReusableContent";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the reusable content change in the current conversation. */
  baseRevisionId: string;
  reusableContent: ChangedRevisionReusableContent;
}

export interface AIToolCallEditReusableContent {
  tool: "editReusableContent";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the reusable content change in the current conversation. */
  baseRevisionId: string;
  reusableContent: ChangedRevisionReusableContent;
}

export interface AIToolCallGetReusableContent {
  tool: "getReusableContent";
  /** The ID of the space being accessed. */
  spaceId: string;
  /** The ID of the revision within which the reusable content is being fetched. */
  revisionId: string;
  reusableContent: ChangedRevisionReusableContent;
}

export interface AIToolCallGetVariables {
  tool: "getVariables";
  /** The ID of the space being accessed. */
  spaceId: string;
  /** The revision ID of the space. */
  revisionId: string;
}

export interface AIToolCallUpdateVariables {
  tool: "updateVariables";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the change in the current conversation. */
  baseRevisionId: string;
  /** The page whose variables are being updated. Omitted when updating space variables. */
  page?: ChangedRevisionPage;
}

export interface AIToolCallGetTags {
  tool: "getTags";
  /** The ID of the space being accessed. */
  spaceId: string;
  /** The revision ID of the space. */
  revisionId: string;
}

export interface AIToolCallUpdateTags {
  tool: "updateTags";
  /** The ID of the space being edited. */
  spaceId: string;
  /** The base revision ID used to compare the change in the current conversation. */
  baseRevisionId: string;
}

export interface AIToolCallCreateChangeRequest {
  tool: "createChangeRequest";
  /** The ID of the space the change request belongs to. */
  spaceId: string;
  action: "create" | "update";
  changeRequest: {
    /** The unique identifier of the change request. */
    id: string;
    /** Incremental identifier of the change request. */
    number: number;
    /** A brief summary of the change request. */
    subject: string;
  };
}

export interface AIToolCallGetChangeRequestDetails {
  tool: "getChangeRequestDetails";
  /** The ID of the space the change request belongs to. */
  spaceId: string;
  /** The ID of the change request. */
  changeRequestId: string;
}

export interface AIToolCallSetChangeRequestDetails {
  tool: "setChangeRequestDetails";
  /** The ID of the space the change request belongs to. */
  spaceId: string;
  /** The ID of the change request. */
  changeRequestId: string;
}

export interface AIToolCallArchiveChangeRequest {
  tool: "archiveChangeRequest";
  /** The ID of the space the change request belongs to. */
  spaceId: string;
  /** The ID of the change request. */
  changeRequestId: string;
  /** Why the agent gave up on implementing the change request. */
  reason: string;
}

export interface AIToolCallMergeChangeRequest {
  tool: "mergeChangeRequest";
  /** The ID of the space the change request belongs to. */
  spaceId: string;
  /** The ID of the change request that was merged. */
  changeRequestId: string;
}

export interface AIToolCallComment {
  tool: "comment";
  /** The ID of the space being commented. */
  spaceId: string;
  /** The page being commented. */
  page?: ChangedRevisionPage;
  /** The ID of the comment being posted. */
  commentId: string;
}

export interface AIToolCallReplyToComment {
  tool: "replyToComment";
  /** The ID of the space being commented. */
  spaceId: string;
  /** The page being commented. */
  page?: ChangedRevisionPage;
  /** The ID of the comment being replied to. */
  commentId: string;
  /** The ID of the reply being posted. */
  replyId: string;
}

export interface AIToolCallGetComments {
  tool: "getComments";
  /** The ID of the space the comments were read from. */
  spaceId: string;
  /** The ID of the comment that was read, when a single comment was requested by URL or ID. */
  commentId?: string;
  /** The number of comments that were read. */
  count?: number;
}

export interface AIToolCallSubmitChangeRequestReview {
  tool: "submitChangeRequestReview";
  /** The ID of the space where the review was submitted. */
  spaceId: string;
  /** The ID of the change request being reviewed. */
  changeRequestId: string;
  /** Result of the review. */
  status: ChangeRequestReviewStatus;
  /** Identifier of the review that was created. */
  reviewId: string;
  /** Identifier of the comment that was created as part of the review. */
  commentId: string;
}

export interface AIToolCallStartContentImport {
  tool: "startContentImport";
  /** The ID of the space the content is imported into. */
  spaceId: string;
  /** The ID of the change request the content is imported into. */
  changeRequestId: string;
  /** The ID of the import run. */
  runId: string;
  /** The URL the content is imported from, when importing a website. */
  url?: string;
  /** Names of the attached files the content is imported from, when importing files. */
  files?: string[];
}

export interface AIToolCallCheckContentImport {
  tool: "checkContentImport";
  /** The ID of the import run. */
  runId: string;
  /** Status of the import when it was checked. */
  status: "pending" | "in-progress" | "completed" | "failed" | "cancelled";
  /** Number of pages imported when the import was checked. */
  importedPages: number;
  /** Number of pages the import has discovered so far. */
  totalPages: number;
}

export interface AIToolCallImportOpenAPISpec {
  tool: "importOpenAPISpec";
  /** The ID of the space the API reference is added to. */
  spaceId: string;
  /** The ID of the change request the API reference is added to. */
  changeRequestId: string;
  /** The slug of the OpenAPI spec the reference is generated from. */
  specSlug: string;
  /** The URL the spec is imported from, when importing from a URL. */
  url?: string;
  /** Name of the attached file the spec is imported from, when importing a file. */
  file?: string;
}

export interface AIToolCallSiteSetupStep {
  tool: "siteSetupStep";
  /** A step of the setup of a site, in the order they are done. */
  step: SiteSetupStepId;
  /**
   * Where the setup step stands in the conversation.
   * * `current`: The step is being worked on.
   * * `done`: The step is completed.
   * * `skipped`: The user skipped the step.
   * * `pending`: The step is not started: it waits again after the user went back to an earlier step.
   */
  status: "current" | "done" | "skipped" | "pending";
}

/** Tool call recording that the agent started a background agent: a child conversation running one bounded task on its own, in parallel with the conversation that started it. The client renders its live status from `AgentState.backgroundAgents`, matched on `agentId`, and can open the child conversation to read what it did. */
export interface AIToolCallStartBackgroundAgent {
  tool: "startBackgroundAgent";
  /** Identifier of the background agent within the conversation that started it. */
  agentId: string;
  /** The child conversation holding the background agent's transcript. It can only be read, never continued. */
  conversationId: string;
  /** A few words naming what the background agent is doing, for a tab and a line of a transcript. The task itself is a brief and far too long to label anything with. */
  title: string;
  /** The task the background agent was given. */
  task: string;
  /** IDs of the pages the background agent owns, when it was started to change content. Two background agents of the same conversation never own the same page. */
  pages?: string[];
}

/** Tool called from an MCP server */
export interface AIToolCallMCP {
  tool: "mcp";
  /** The ID of the MCP server that has been called. */
  mcpServerId: string;
  /** The name of the tool that has been called. */
  mcpToolName: string;
  /** The title of the tool that has been called. */
  mcpToolTitle?: string;
}

/** Summary of a generic tool call. */
export interface AIToolCallOtherSummary {
  /** Name of the icon */
  icon: Icon;
  /** Text to display to the user to describe the tool call. */
  text: string;
}

/** Any tool call that is unknown by GitBook */
export interface AIToolCallOther {
  tool: "other";
  /** Summary of a generic tool call. */
  summary: AIToolCallOtherSummary;
}

export type AIToolCall =
  | AIToolCallGetPageContent
  | AIToolCallGetRecordContent
  | AIToolCallGetPages
  | AIToolCallGetReusableContents
  | AIToolCallSearch
  | AIToolCallEditPage
  | AIToolCallCreatePage
  | AIToolCallDeletePage
  | AIToolCallRenamePage
  | AIToolCallMovePage
  | AIToolCallListModifiedPages
  | AIToolCallGetPageDiff
  | AIToolCallCreateReusableContent
  | AIToolCallEditReusableContent
  | AIToolCallGetReusableContent
  | AIToolCallGetVariables
  | AIToolCallUpdateVariables
  | AIToolCallGetTags
  | AIToolCallUpdateTags
  | AIToolCallCreateChangeRequest
  | AIToolCallGetChangeRequestDetails
  | AIToolCallSetChangeRequestDetails
  | AIToolCallArchiveChangeRequest
  | AIToolCallMergeChangeRequest
  | AIToolCallComment
  | AIToolCallReplyToComment
  | AIToolCallGetComments
  | AIToolCallSubmitChangeRequestReview
  | AIToolCallStartContentImport
  | AIToolCallCheckContentImport
  | AIToolCallImportOpenAPISpec
  | AIToolCallSiteSetupStep
  | AIToolCallStartBackgroundAgent
  | AIToolCallMCP
  | AIToolCallOther;

export interface Timerange {
  start: Timestamp;
  end: Timestamp;
}

export interface AIAttachmentImage {
  type: "image";
  url: URL;
  /** Name of the image file. */
  filename?: string;
}

export interface AIAttachmentFile {
  type: "file";
  url: URL;
  /** Name of the file. */
  filename: string;
  /** MIME type of the file. Must be a file type supported by the underlying model (see the OpenAI file-inputs documentation). */
  contentType: string;
}

/** A file attached for the sole purpose of being imported. Its content is never given to the model — the type is one the importer accepts but the model cannot read, such as a ZIP archive — so the model only learns that the file is attached and can import it. */
export interface AIAttachmentImportFile {
  type: "import-file";
  url: URL;
  /** Name of the file. */
  filename: string;
  /** MIME type of the file. Must be a file type supported by the content import. */
  contentType: string;
}

export type AIAttachment =
  | AIAttachmentImage
  | AIAttachmentFile
  | AIAttachmentImportFile;

/** Context about the current user sending a message. */
export interface AIMessageContext {
  location?: {
    /** ID of the current space. */
    spaceId: string;
    /** ID of the current page. */
    pageId: string;
  };
  /** Comments on the content the user is referring to in the message. */
  comments?: {
    /** ID of the comment. */
    id: string;
    /** Snapshot of the comment for display. */
    content?: string;
  }[];
  /** Range of the current selection in a document. */
  selection?: {
    anchorKey: string | null;
    anchorOffset: number;
    focusKey: string | null;
    focusOffset: number;
    /** Snapshot of the selection for display. */
    content?: string;
  };
}

/** A step in a message from the AI agent. */
export interface AIMessageStep {
  /** Describe the state in which the steps started. */
  startCondition?: AIMessageStepStartCondition;
  content?: JSONDocument;
  reasoning?: JSONDocument;
  toolCalls?: AIToolCall[];
  /** The phase of a step in a message from the AI agent. */
  phase?: AIMessageStepPhase;
  /** The timing of the step. */
  timing?: {
    reasoning?: Timerange;
  };
  attachments?: AIAttachment[];
  /** Context about the current user sending a message. */
  context?: AIMessageContext;
}

/** When the agent is responding to a comment. */
export type AIMessageTask =
  | {
      type: "respond_to_comment";
      /** The ID of the space to respond to the comment in. */
      spaceId: string;
      /** The ID of the change request to respond to the comment in. */
      changeRequestId?: string;
      /** The ID of the comment to respond to. */
      commentId: string;
    }
  | {
      type: "review_change_request";
      /** The ID of the space the change request is in. */
      spaceId: string;
      /** The ID of the change request to review. */
      changeRequestId: string;
    }
  | {
      type: "implement_change_request";
      /** The ID of the space the change request is in. */
      spaceId: string;
      /** The ID of the change request to implement the task in. */
      changeRequestId: string;
    }
  | {
      type: "background_agent";
      /** The conversation that started this background agent. */
      parentConversationId: string;
    };

/** The response that generated this message. */
export interface AIMessageResponseMetadata {
  /** The reason the response was stopped. If not defined, the response finished normally. */
  stopReason?: "aborted";
  /** The ID of the response that generated this message. It can be undefined if the stream was aborted. */
  id?: string;
  /** The ID of the previous response that this message is based on. */
  previous?: string;
}

export interface AIMessage {
  id: string;
  role: AIMessageRole;
  steps: AIMessageStep[];
  /** When the agent is responding to a comment. */
  task?: AIMessageTask;
  /** The response that generated this message. */
  response?: AIMessageResponseMetadata;
  /**
   * When the message was added to the conversation. Absent on messages recorded before this field existed.
   * @format date-time
   */
  createdAt?: string;
  /** The identifier the client gave the message when it sent it. Absent on messages the agent wrote, and on messages sent without one. */
  clientMessageId?: string;
}

export type SiteQuestionAnswerWithResponse = SiteQuestionAnswer & {
  response: AIMessage;
  /** Claims of the site visitor who asked, as recorded by site insights. Absent when the visitor sent no claims. */
  visitorClaims?: PlainObject;
};

export type SiteSpaceCustomizationSettings = SiteCustomizationSettings & {
  /** Indicates whether the site customization settings have been overridden. */
  hasOverrides: boolean;
};

export interface SiteSectionGroupPointer {
  type: "site-section" | "site-section-group";
  /** Unique identifier for the site section */
  id: string;
}

/** Position at which to move the site section group. */
export interface SiteSectionGroupMovePosition {
  before?: SiteSectionGroupPointer;
  after?: SiteSectionGroupPointer;
}

export interface SiteSectionPointer {
  type: "site-section";
  /** Unique identifier for the site section */
  siteSection: string;
}

/** Position at which to move the site section to. */
export interface SiteSectionMovePosition {
  before?: SiteSectionPointer;
  after?: SiteSectionPointer;
}

export interface SiteSpacePointer {
  type: "site-space";
  /** Unique identifier for the site space */
  siteSpace: string;
}

/** Position at which to move the site space to. */
export interface SiteSpaceMovePosition {
  before?: SiteSpacePointer;
  after?: SiteSpacePointer;
}

export type InviteSiteUsersAndTeams = (
  | {
      /** @minItems 1 */
      teams: string[];
    }
  | {
      /** @minItems 1 */
      users: string[];
    }
) & {
  /** Role to set. */
  role: MemberRoleOrGuest;
};

export interface OrganizationPointer {
  type: "organization";
  /** Unique identifier for the organization */
  organization: string;
}

/** Direct site permission origin. */
export interface UserSitePermissionSiteOrigin {
  type: "site";
  /** Unique identifier for the site */
  site: string;
  /** Why the permission was enforced at the site level. */
  reason: "member" | "team" | "default";
  /** Unique identifier for the team when the permission comes from a team override. */
  team?: string;
}

/** The origin that enforced the effective permission level for a user in a site. */
export type UserSitePermissionOrigin =
  | SpacePointer
  | OrganizationPointer
  | UserSitePermissionSiteOrigin;

/** Permission of a user in a site. */
export interface UserSitePermission {
  /** The role of a member in an organization, null for guests */
  permission: MemberRoleOrGuest;
  user: User;
  /** The origin that enforced the effective permission level for a user in a site. */
  origin: UserSitePermissionOrigin;
  /** Why the member is disabled, or false when the member is active. A disabled member cannot access the organization or its content. */
  disabled: MemberDisabled;
  /** Date at which the user was last seen */
  lastSeenAt?: Timestamp;
}

/** Permission override of a user in a site. */
export interface UserSitePermissionOverride {
  /** The role of a member in an organization, null for guests */
  permission: MemberRoleOrGuest;
  user: User;
}

/** Permission override of a team in a site. */
export interface TeamSitePermissionOverride {
  /** The role of a member in an organization, null for guests */
  permission: MemberRoleOrGuest;
  team: OrganizationTeam;
}

/** Input version of an AI message. */
export interface AIMessageInput {
  role: AIMessageRole;
  content: string | JSONDocument;
  /** Context about the current user sending a message. */
  context?: AIMessageContext;
  attachments?: AIAttachment[];
  /**
   * Identifier the client gives the message it sends, echoed on the message the agent adds to the conversation, so the client can tell its own message apart from any other.
   * @maxLength 64
   */
  clientMessageId?: string;
}

/** Description of a tool that can be called from an AI agent. */
export interface AIToolDefinition {
  /** The name of the tool. It should be unique within the agent. */
  name: string;
  /** The description of the tool, passed to the AI agent. */
  description: string;
  /** JSON schema describing the input of the tool. */
  inputSchema?: {
    type: "object";
    properties: Record<
      string,
      {
        type: "string" | "number" | "boolean" | "array" | "object";
        /** Description of the property. */
        description: string;
        [key: string]: any;
      }
    >;
  };
}

/** Result of a tool call. */
export interface AIToolCallResult {
  /** The name of the tool that was called. */
  tool: string;
  /** The ID of the tool call. */
  toolCallId: string;
  /** The output to the tool call. */
  output: object;
  /** Summary of a generic tool call. */
  summary?: AIToolCallOtherSummary;
}

/** Message emitted by the server to indicate the start of the AI response. */
export interface AIStreamResponseStart {
  type: "response_start";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** When the agent is responding to a comment. */
  task?: AIMessageTask;
}

/** Message emitted by the server to indicate the start of a step in the AI response. */
export interface AIStreamResponseStepStart {
  type: "response_step_start";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The index of the step of the message that this event is composing. */
  stepIndex: number;
  /** The phase of a step in a message from the AI agent. */
  phase?: AIMessageStepPhase;
}

/** Message emitted by the server to indicate the end of the AI response. It contains the ID of the response to be referenced for followup requests. */
export interface AIStreamResponseFinish {
  type: "response_finish";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /**
   * The ID of the response
   * @deprecated
   */
  responseId?: string;
  /** The response metadata associated with the message. */
  response: AIMessageResponseMetadata;
}

/** Message emitted by the server to indicate the latest block of the document. The block can either be a new block or an update to the previous block. */
export interface AIStreamResponseDocument {
  type: "response_document" | "response_reasoning";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The index of the step of the message that this event is composing. */
  stepIndex: number;
  operation: "insert" | "update";
  blocks: DocumentBlocksTopLevels[];
}

/** Message emitted by the server to indicate a chunk of the JSON object response. */
export interface AIStreamResponseObject {
  type: "response_object";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The chunk of the JSON object response */
  jsonChunk: string;
}

/** Message emitted by the server to indicate that the AI has called a tool. */
export interface AIStreamResponseToolCall {
  type: "response_tool_call";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The index of the step of the message that this event is composing. */
  stepIndex: number;
  toolCall: AIToolCall;
}

/** Message emitted by the server to indicate that the AI is calling a client-side tool. */
export interface AIStreamResponseToolCallPending {
  type: "response_tool_call_pending";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The index of the step of the message that this event is composing. */
  stepIndex: number;
  /** The tool call that the AI is calling. */
  toolCall: {
    /** The name of the tool that the AI is calling. */
    tool: string;
    /** The input to the tool call. */
    input: object;
  };
  /** The ID of the tool call that the AI is calling. */
  toolCallId: string;
}

/** Message emitted by the server to suggest a followup message the user could respond with. */
export interface AIStreamResponseFollowupSuggestion {
  type: "response_followup_suggestion";
  /** The ID of the message that this event is composing. */
  messageId: string;
  suggestions: string[];
}

/** Message emitted by the server to indicate that the AI has attached an image. */
export interface AIStreamResponseAttachment {
  type: "response_attachment";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The index of the step of the message that this event is composing. */
  stepIndex: number;
  attachment: AIAttachment;
}

/** Message emitted by the server to indicate a context compaction event. */
export interface AIStreamResponseCompaction {
  type: "response_compaction";
  /** The ID of the message that this event is composing. */
  messageId: string;
  /** The index of the step of the message that this event is composing. */
  stepIndex: number;
}

export type AIStreamResponse =
  | AIStreamResponseStart
  | AIStreamResponseStepStart
  | AIStreamResponseFinish
  | AIStreamResponseDocument
  | AIStreamResponseObject
  | AIStreamResponseToolCall
  | AIStreamResponseToolCallPending
  | AIStreamResponseFollowupSuggestion
  | AIStreamResponseAttachment
  | AIStreamResponseCompaction;

/** Settings for how GitBook resolves the broken links it finds on a site. */
export interface SiteSettingsBrokenLinks {
  /** Whether GitBook resolves broken links automatically. */
  autoResolve: boolean;
  /**
   * How much GitBook may do on its own when it resolves broken links automatically. GitBook never
   * applies a fix it isn't sure about, at any level.
   *   - `suggest-fixes` drafts fixes for approval and applies none.
   *   - `fix-clear-matches` applies the clearest fixes and drafts the less certain ones for approval.
   *   - `fix-close-matches` applies the clear and the close fixes.
   * At every level, GitBook drafts change requests that fix broken links to other sites, and never
   * merges them.
   */
  autonomyLevel: SiteSettingsBrokenLinksAutonomyLevel;
}

export interface SiteAgentSettingsInput {
  /** Settings related to scanning for a site. */
  scans: {
    /** Controls when topics are being scanned for findings. */
    topics: SiteSettingsScanTopics;
  };
  /** Settings related to processing of findings for a site. */
  findings: {
    /** Controls how issue remediation change requests should be handled for a site. */
    changeRequests: SiteSettingsFindingChangeRequests;
  };
  /** Site-specific instructions for the editing agent. */
  editing: {
    customInstructions: JSONDocument;
  };
  /** Settings for how GitBook resolves the broken links it finds on a site. */
  brokenLinks?: SiteSettingsBrokenLinks;
}

export type SiteAgentSettings = {
  object: "site-agent-settings";
  /** Settings for how GitBook resolves the broken links it finds on a site. */
  brokenLinks: SiteSettingsBrokenLinks;
  updatedAt?: Timestamp;
  /** Identifier of the member who last updated the settings. */
  updatedBy?: string;
  urls: {
    /** Relative URL to the resource in the API. */
    location: string;
  };
} & SiteAgentSettingsInput;

/** A style guide check run: one time a user asked GitBook Agent to check a set of the site's spaces against the site's style guide, opening a change request for each. */
export interface SiteStyleguideRun {
  object: "styleguide-run";
  /** The ID of the run */
  id: string;
  /** ID of the site the run belongs to */
  site: string;
  /** ID of the style guide space the run checked against */
  styleguide: string;
  /** IDs of the spaces the run was asked to check. A change request may have failed to open for one of them, so this is the intent rather than the result. */
  spaces: string[];
  createdAt: Timestamp;
  createdBy: User;
}

/**
 * User agent of the visitor.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
 */
export type SiteInsightsUserAgent = string;

/** Analytics info on the GitBook's site session. */
export type SiteInsightsEventSession = SiteInsightsSession & {
  /** The visitors cookies. */
  cookies: Record<string, string>;
  /**
   * IP address of the visitor.
   * If not defined, it'll default to the IP executing the request.
   */
  ip?: string;
  /**
   * User agent of the visitor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
   */
  userAgent: SiteInsightsUserAgent;
  /**
   * Language of the visitor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/language
   */
  language: string | null;
  /** Referrer of the session */
  referrer: null | "" | URL;
  /**
   * Deprecated, use visitorAuthClaims instead.
   * @deprecated
   */
  visitorAuthToken?: string | null;
  /**
   * Claims of the visitor.
   * This is used to identify the visitor with adaptive content.
   */
  visitorAuthClaims?: PlainObject;
};

/** Location of the event. */
export interface SiteInsightsEventLocation {
  /** URL of the location. */
  url: URL;
  /** URL of the page of the site the visitor was on before this one, if any. Unlike the session referrer, it follows navigation within the site. Only recorded when it has the same origin as `url`; any other value is discarded. */
  previousUrl?: null | URL;
  /**
   * Whether the event was tracked on the site, the server, or an embed widget.
   * @default "site"
   */
  displayContext?: SiteInsightsDisplayContext;
  /** ID of the concerned site section. */
  siteSection: string | null;
  /** ID of the concerned site space. */
  siteSpace: string | null;
  /** ID of the concerned site share key. */
  siteShareKey: string | null;
  /** ID of the concerned space. */
  space: string | null;
  /** ID of the concerned revision. */
  revision: string | null;
  /** ID of the concerned page. */
  page: string | null;
}

export interface SiteInsightsEventBase {
  /** Analytics info on the GitBook's site session. */
  session: SiteInsightsEventSession;
  /** Location of the event. */
  location: SiteInsightsEventLocation;
  /** Optional timestamp of the event. If not provided, the current timestamp will be used. Must be within 5 minutes of the current time. */
  timestamp?: Timestamp;
}

export type SiteInsightsEventPageView = SiteInsightsEventBase & {
  type: "page_view";
};

export type SiteInsightsEventPageMarkdownRequest = SiteInsightsEventBase & {
  type: "page_markdown_request";
  /** How a page's markdown was requested. `page-action` means a reader used the site's page-actions menu — its copy or view-as-markdown action — rather than a client fetching the URL directly. */
  markdownSource?: SiteInsightsMarkdownSource;
};

export type SiteInsightsEventSearchOpen = SiteInsightsEventBase & {
  type: "search_open";
};

export type SiteInsightsEventSearchTypeQuery = SiteInsightsEventBase & {
  type: "search_type_query";
  /** Query of the search. */
  query: string;
};

export type SiteInsightsEventSearchOpenResult = SiteInsightsEventBase & {
  type: "search_open_result";
  /** Query of the search. */
  query: string;
  /** Target of the opened search result. */
  result:
    | {
        /** ID of the concerned space. */
        spaceId: string;
        /** ID of the concerned page. */
        pageId: string;
      }
    | {
        /** ID of the concerned record. */
        recordId: string;
      };
};

export type SiteInsightsEventPagePostFeedback = SiteInsightsEventBase & {
  type: "page_post_feedback";
  feedback: {
    rating: PageFeedbackRating;
  };
};

export type SiteInsightsEventPagePostFeedbackComment = SiteInsightsEventBase & {
  type: "page_post_feedback_comment";
  feedback: {
    rating: PageFeedbackRating;
    /**
     * @minLength 1
     * @maxLength 512
     */
    comment: string;
  };
};

export type SiteInsightsEventAgentFeedback = SiteInsightsEventBase & {
  type: "agent_feedback";
};

export type SiteInsightsEventAskQuestion = SiteInsightsEventBase & {
  type: "ask_question";
  /** Question being asked. */
  query: string;
  /** The end goal the calling agent is trying to accomplish on behalf of the user, when provided alongside the question. Used to measure the goal→completion lifecycle per agent. */
  goal?: string;
};

/** Event when a user views the ask UI. */
export type SiteInsightsEventAskView = SiteInsightsEventBase & {
  type: "ask_view";
  trigger?: "hover" | "selection" | "site" | "page" | "code" | "embed";
};

/** Event when a user clicks an entry point that opens the ask UI. */
export type SiteInsightsEventAskTriggerClick = SiteInsightsEventBase & {
  type: "ask_trigger_click";
  trigger: "hover" | "selection" | "site" | "page" | "code";
};

export type SiteInsightsEventAskRateResponse = SiteInsightsEventBase & {
  type: "ask_rate_response";
  /** Question asked. */
  query: string;
  rating: 1 | -1;
  /** ID of the AI response. */
  responseId: string;
};

export type SiteInsightsEventLinkClick = SiteInsightsEventBase & {
  type: "link_click";
  link: {
    /** A relative reference to content in GitBook. */
    target: ContentRef;
    position: SiteInsightsLinkPosition;
  };
};

export type SiteInsightsEventAPIClientOpen = SiteInsightsEventBase & {
  type: "api_client_open";
  /** Pointer to an operation in the OpenAPI spec. */
  operation: OpenAPIOperationPointer;
};

export type SiteInsightsEventAPIClientRequest = SiteInsightsEventBase & {
  type: "api_client_request";
  /** Pointer to an operation in the OpenAPI spec. */
  operation: OpenAPIOperationPointer;
};

export type SiteInsightsEventTrademarkClick = SiteInsightsEventBase & {
  type: "trademark_click";
  placement: SiteInsightsTrademarkPlacement;
};

export interface SiteInsightsAd {
  domain: string;
  zoneId: string;
  placement: SiteInsightsAdPlacement;
}

export type SiteInsightsEventAdClick = SiteInsightsEventBase & {
  type: "ad_click";
  ad: SiteInsightsAd;
};

export type SiteInsightsEventAdDisplay = SiteInsightsEventBase & {
  type: "ad_display";
  ad: SiteInsightsAd;
};

export type SiteInsightsEventLLMSRequest = SiteInsightsEventBase & {
  type: "llms_request";
  llmsVariant: SiteInsightsLLMSVariant;
};

export type SiteInsightsEventMCPRequest = SiteInsightsEventBase & {
  type: "mcp_request";
};

export type SiteInsightsEventRSSRequest = SiteInsightsEventBase & {
  type: "rss_request";
};

export type SiteInsightsEvent =
  | SiteInsightsEventPageView
  | SiteInsightsEventPageMarkdownRequest
  | SiteInsightsEventSearchOpen
  | SiteInsightsEventSearchTypeQuery
  | SiteInsightsEventSearchOpenResult
  | SiteInsightsEventPagePostFeedback
  | SiteInsightsEventPagePostFeedbackComment
  | SiteInsightsEventAgentFeedback
  | SiteInsightsEventAskQuestion
  | SiteInsightsEventAskView
  | SiteInsightsEventAskTriggerClick
  | SiteInsightsEventAskRateResponse
  | SiteInsightsEventLinkClick
  | SiteInsightsEventAPIClientOpen
  | SiteInsightsEventAPIClientRequest
  | SiteInsightsEventTrademarkClick
  | SiteInsightsEventAdClick
  | SiteInsightsEventAdDisplay
  | SiteInsightsEventLLMSRequest
  | SiteInsightsEventMCPRequest
  | SiteInsightsEventRSSRequest;

export interface SiteInsightsQueryDateTimeColumn {
  column: "datetime";
  interval?: "hour" | "day" | "week" | "month";
}

/** Day of the week the event happened in `timezone`, from 1 (Monday) to 7 (Sunday). Group by it alongside `hourOfDay` to fold any range into a weekly activity profile. */
export type SiteInsightsQueryEventsColumn =
  | SiteInsightsQueryDateTimeColumn
  | {
      column: "dayOfWeek";
      /**
       * IANA time zone the event is read in, UTC when omitted.
       * @example "Europe/Paris"
       */
      timezone?: string;
    }
  | {
      column: "hourOfDay";
      /**
       * IANA time zone the event is read in, UTC when omitted.
       * @example "Europe/Paris"
       */
      timezone?: string;
    }
  | {
      column: "url";
    }
  | {
      column: "urlPath";
    }
  | {
      column: "eventType";
    }
  | {
      column: "eventsCount";
    }
  | {
      column: "sessionsCount";
    }
  | {
      column: "visitorsCount";
    }
  | {
      column: "siteSection";
    }
  | {
      column: "siteSpace";
    }
  | {
      column: "siteShareKey";
    }
  | {
      column: "displayContext";
    }
  | {
      column: "page";
    }
  | {
      column: "visitorGeoCountry";
    }
  | {
      column: "visitorGeoPoint";
      /**
       * @min 0
       * @max 15
       */
      precision?: number;
    }
  | {
      column: "visitorDevice";
    }
  | {
      column: "visitorBrowser";
    }
  | {
      column: "visitorOS";
    }
  | {
      column: "visitorBot";
    }
  | {
      column: "visitorLanguage";
    }
  | {
      column: "visitorUserAgent";
    }
  | {
      column: "visitorId";
    }
  | {
      column: "eventLinkTargetValue";
    }
  | {
      column: "eventLinkTargetKind";
    }
  | {
      column: "eventLinkTargetDomain";
    }
  | {
      column: "eventLinkPosition";
    }
  | {
      column: "eventAPIOperationPath";
    }
  | {
      column: "eventAPIOperationMethod";
    }
  | {
      column: "eventLLMSVariant";
    }
  | {
      column: "eventPageNotFoundType";
    }
  | {
      column: "eventMarkdownSource";
    }
  | {
      column: "eventSearchQuery";
    }
  | {
      column: "eventSearchResultRecordId";
    }
  | {
      column: "eventPageFeedbackRating";
    }
  | {
      column: "eventPageFeedbackComment";
    }
  | {
      column: "eventAskResponseRating";
    }
  | {
      column: "pageFeedbackRating";
    }
  | {
      column: "askResponseRating";
    }
  | {
      column: "referrer";
    }
  | {
      column: "referrerDomain";
    }
  | {
      column: "previousUrl";
    }
  | {
      column: "utmSource";
    }
  | {
      column: "utmMedium";
    }
  | {
      column: "utmCampaign";
    }
  | {
      column: "utmTerm";
    }
  | {
      column: "utmContent";
    }
  | {
      column: "visitorAuthenticated";
    }
  | {
      column: "visitorClaimProperty";
    }
  | {
      column: "visitorClaim";
      claim: string;
    }
  | {
      column: "eventAdDomain";
    }
  | {
      column: "eventAdPlacement";
    }
  | {
      column: "eventTrademarkPlacement";
    };

/**
 * Ratings submitted on a page, counted once per rating a reader submitted rather than once
 * per event.
 */
export type SiteInsightsQueryEventsValues =
  | {
      column: "datetime";
      values: Timestamp[];
    }
  | {
      column: "dayOfWeek";
      values: number[];
    }
  | {
      column: "hourOfDay";
      values: number[];
    }
  | {
      column: "url";
      values: URL[];
    }
  | {
      column: "urlPath";
      values: string[];
    }
  | {
      column: "eventsCount";
      values: number[];
    }
  | {
      column: "sessionsCount";
      values: number[];
    }
  | {
      column: "visitorsCount";
      values: number[];
    }
  | {
      column: "eventType";
      values: SiteInsightsEventType[];
    }
  | {
      column: "visitorClaim";
      claim: string;
      values: string[];
    }
  | {
      column: "visitorAuthenticated";
      values: (boolean | null)[];
    }
  | {
      column: "visitorClaimProperty";
      values: string[];
    }
  | {
      column: "visitorBrowser";
      values: SiteInsightsVisitorBrowser[];
    }
  | {
      column: "visitorDevice";
      values: SiteInsightsVisitorDevice[];
    }
  | {
      column: "visitorOS";
      values: SiteInsightsVisitorOS[];
    }
  | {
      column: "visitorBot";
      values: (SiteInsightsVisitorBot | "")[];
    }
  | {
      column: "eventLinkTargetValue";
      values: ContentRef[];
    }
  | {
      column: "eventLinkTargetKind";
      values: (
        | "url"
        | "page"
        | "file"
        | "anchor"
        | "space"
        | "collection"
        | "user"
        | "reusable-content"
      )[];
    }
  | {
      column: "eventLinkPosition";
      values: SiteInsightsLinkPosition[];
    }
  | {
      column: "siteSection";
      values: (string | null)[];
    }
  | {
      column: "eventLLMSVariant";
      values: (null | SiteInsightsLLMSVariant)[];
    }
  | {
      column: "eventPageNotFoundType";
      values: (null | SiteInsightsPageNotFoundType)[];
    }
  | {
      column: "eventMarkdownSource";
      values: (null | SiteInsightsMarkdownSource)[];
    }
  | {
      column: "siteSpace";
      values: (string | null)[];
    }
  | {
      column: "siteShareKey";
      values: (string | null)[];
    }
  | {
      column: "displayContext";
      values: SiteInsightsDisplayContext[];
    }
  | {
      column: "page";
      /** Pages to match. `null` matches events that resolved to no page, which for `page_view` events is a 404 (a broken URL). */
      values: (null | {
        page: string | null;
        space: string;
      })[];
    }
  | {
      column: "visitorGeoCountry";
      values: (string | null)[];
    }
  | {
      column: "visitorGeoPoint";
      values: {
        latitude: number;
        longitude: number;
        h3: string;
      }[];
    }
  | {
      column: "visitorLanguage";
      values: (string | null)[];
    }
  | {
      column: "visitorUserAgent";
      values: string[];
    }
  | {
      column: "visitorId";
      values: string[];
    }
  | {
      column: "eventLinkTargetDomain";
      values: (string | null)[];
    }
  | {
      column: "eventAPIOperationPath";
      values: (string | null)[];
    }
  | {
      column: "eventAPIOperationMethod";
      values: (string | null)[];
    }
  | {
      column: "eventSearchQuery";
      values: string[];
    }
  | {
      column: "eventSearchResultRecordId";
      values: (string | null)[];
    }
  | {
      column: "pageFeedbackRating";
      values: {
        ok: number;
        good: number;
        bad: number;
      }[];
    }
  | {
      column: "askResponseRating";
      values: {
        positive: number;
        negative: number;
      }[];
    }
  | {
      column: "eventPageFeedbackRating";
      values: PageFeedbackRating[];
    }
  | {
      column: "eventAskResponseRating";
      values: number[];
    }
  | {
      column: "eventPageFeedbackComment";
      values: string[];
    }
  | {
      column: "referrer";
      values: string[];
    }
  | {
      column: "referrerDomain";
      values: string[];
    }
  | {
      column: "previousUrl";
      values: string[];
    }
  | {
      column: "utmSource";
      values: string[];
    }
  | {
      column: "utmMedium";
      values: string[];
    }
  | {
      column: "utmCampaign";
      values: string[];
    }
  | {
      column: "utmTerm";
      values: string[];
    }
  | {
      column: "utmContent";
      values: string[];
    }
  | {
      column: "eventAdDomain";
      values: string[];
    }
  | {
      column: "eventAdPlacement";
      values: SiteInsightsAdPlacement[];
    }
  | {
      column: "eventTrademarkPlacement";
      values: SiteInsightsTrademarkPlacement[];
    };

export type SiteInsightsQueryEventsFilter = SiteInsightsQueryEventsValues & {
  operator?: SiteInsightsQueryOperator;
};

export interface SiteInsightsQueryRangeCustom {
  from: Timestamp;
  to: Timestamp;
}

export type SiteInsightsQueryRange =
  | SiteInsightsQueryRangePreset
  | SiteInsightsQueryRangeCustom;

export interface SiteInsightsQueryEventsAggregation {
  select?: SiteInsightsQueryEventsColumn[];
  where?: SiteInsightsQueryEventsFilter[];
  groupBy?: SiteInsightsQueryEventsColumn[];
  order?: {
    /** Day of the week the event happened in `timezone`, from 1 (Monday) to 7 (Sunday). Group by it alongside `hourOfDay` to fold any range into a weekly activity profile. */
    by: SiteInsightsQueryEventsColumn;
    direction: "asc" | "desc";
  };
  range: SiteInsightsQueryRange;
  /**
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
}

export interface SiteInsightsQueryEventsAggregationResult {
  columns: SiteInsightsQueryEventsValues[];
}

/** A segment of visitors with the same characteristics. */
export interface SiteInsightsVisitorSegment {
  /** The title of the visitor profile. */
  title: string;
  claims: PlainObject;
  /** The number of events for this visitor profile. */
  events: number;
  /** The number of visitors for this visitor profile. */
  visitors: number;
  /** The number of sessions for this visitor profile. */
  sessions: number;
}

export interface SiteAdsStats {
  impressions: number;
  clicks: number;
  revenue: string;
}

export interface SiteRedirectDestinationSiteSection {
  kind: "site-section";
  /** Unique identifier for the site section to redirect to */
  siteSectionId: string;
}

export interface SiteRedirectDestinationSiteSpace {
  kind: "site-space";
  /** Unique identifier for the site space to redirect to */
  siteSpaceId: string;
}

export interface SiteRedirectDestinationPage {
  kind: "site-page";
  /** Unique identifier for the site space of the page */
  siteSpaceId: string;
  /** Unique identifier for the page within the site space to redirect to */
  pageId: string;
}

export interface SiteRedirectDestinationExternal {
  kind: "external";
  url: URL;
}

export type SiteRedirectDestination =
  | SiteRedirectDestinationSiteSection
  | SiteRedirectDestinationSiteSpace
  | SiteRedirectDestinationPage
  | SiteRedirectDestinationExternal;

export interface SiteRedirect {
  object: "site-redirect";
  /** The unique identifier for the redirect. */
  id: string;
  /** The source path to redirect from. */
  source: SiteRedirectSourcePath;
  /** Whether the redirect is draft and not live. */
  draft: boolean;
  /** Capture and append the wildcard-matched suffix to the destination URL. */
  captureWildcard: boolean;
  /** Whether the redirect is configured as permanent. Permanent redirects are served as HTTP 308 for public live traffic and HTTP 307 in non-public contexts. */
  permanent: boolean;
  destination: SiteRedirectDestination;
  /**
   * When the redirect was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * When the redirect was last updated. Absent if never updated since creation.
   * @format date-time
   */
  updatedAt?: string;
}

export type SiteRedirectInputDestination =
  | SiteRedirectDestination
  | SiteRedirectInputDestinationPath;

/**
 * Name of the MCP server
 * @minLength 1
 * @maxLength 100
 */
export type SiteMcpServerName = string;

/** HTTP headers sent with requests to this server */
export type SiteMcpServerHeaders = Record<string, string>;

export interface SiteMcpServer {
  object: "site-mcp-server";
  /** Unique identifier for the MCP server */
  id: string;
  /** Name of the MCP server */
  name: SiteMcpServerName;
  url: URL;
  /** Transport protocol used to connect to the MCP server */
  transport: SiteMcpServerTransport;
  /** HTTP headers sent with requests to this server */
  headers: SiteMcpServerHeaders;
  /** Conditional expression used to evaluate whether the MCP server should be available to the site's visitor. */
  condition?: Expression;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the MCP server in the API
     * @format uri
     */
    location: string;
  };
}

/**
 * A generic channel name or pattern. For example, "general" or "support-*".
 * @pattern ^[a-zA-Z0-9_\*-]+$
 */
export type GenericChannelPattern = string;

/**
 * A GitHub repository name or pattern in the format "owner/repository". For example, "my-org/my-repo" or "my-org/*" to allow all repositories under "my-org".
 * @pattern ^[a-zA-Z0-9._*-]+\/[a-zA-Z0-9._*-]+$
 */
export type GitHubRepositoryPattern = string;

export type SiteChannelSetup =
  | {
      type: "builtin:slack";
      setupSettings: {
        /** List of allowed Slack channel names or patterns. If empty, all channels are allowed. */
        allowedChannels?: GenericChannelPattern[];
      };
    }
  | {
      type: "builtin:linear";
      setupSettings: {
        /** List of allowed Linear team keys or patterns. If empty, all teams are allowed. */
        allowedTeams?: GenericChannelPattern[];
      };
    }
  | {
      type: "builtin:github";
      setupSettings: {
        /** List of allowed GitHub repository names or patterns. If empty, all repositories are allowed. */
        allowedRepositories?: GitHubRepositoryPattern[];
      };
    }
  | {
      type: "builtin:discord";
      setupSettings: {
        /** List of allowed Discord channel names or patterns. If empty, all channels are allowed. */
        allowedChannels?: GenericChannelPattern[];
      };
    };

export type SiteChannel = SiteChannelSetup & {
  object: "site-channel";
  /** Unique identifier for the site channel. */
  id: string;
  status: SiteChannelStatus;
  role: SiteChannelRole;
  /**
   * Number of answers linked to this channel.
   * @min 0
   */
  answers: number;
  createdAt: Timestamp;
  urls: {
    /**
     * URL of the site channel in the API.
     * @format uri
     */
    location: string;
  };
};

export interface Subdomain {
  object: "subdomain";
  /**
   * The GitBook subdomain, for example "my-company" in "my-company.gitbook.io"
   * @minLength 3
   * @maxLength 32
   * @pattern ^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$
   */
  subdomain: string;
  target: OrganizationPointer;
  isActive: boolean;
}

export type CustomHostnameStatus =
  | CustomHostnameDnsStatus
  | CustomHostnameSslStatus
  | CustomHostnameErrorStatus;

export interface CustomHostname {
  object: "custom-hostname";
  /** Custom hostname for the site, for e.g. docs.mycompany.com */
  hostname: SiteHostname;
  target: OrganizationPointer | SitePointer;
  isActive: boolean;
  status?: CustomHostnameStatus;
  /** URLs associated with the object */
  urls: {
    /**
     * URL of the custom hostname in the API
     * @format uri
     */
    location: string;
  };
}

export interface UnsplashImage {
  kind: "unsplash_image";
  id: string;
  description: string;
  downloadLocation: string;
  urls: {
    full: string;
    small: string;
  };
  author: {
    name: string;
    url: string;
  };
}

/** JWT tokens to authenticate in Hive for all content. */
export interface HiveAccessToken {
  contents: Record<string, string>;
}

export interface APIIntercomMessengerToken {
  /** Short-lived JWT used to authenticate the user with Intercom Messenger */
  token: string;
  /** Unix timestamp in seconds when the token expires */
  expiresAt: number;
}

export interface SignedURL {
  /** The kind of signed URL */
  object: "signed-url";
  /** Signed URL that can be opened by the browser */
  url: URL;
  /** Expiration time of the signed URL */
  expiresAt: Timestamp;
}

export interface APIProfilingSession {
  object: "api_cpu_profiling_session";
  /** @format uuid */
  id: string;
  status: "active" | "stopped" | "expired";
  /** The profiler selected for this session. Earlier sessions without this field use CPU profiling. */
  mode?: "cpu" | "allocations";
  releaseVersion: string;
  releaseBuild: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  stoppedAt?: string;
  startedBy: string;
  urls: {
    location: string;
  };
}

export interface APICPUProfile {
  object: "api_cpu_profile" | "api_allocation_profile";
  mode?: "cpu" | "allocations";
  /** @format uuid */
  id: string;
  instanceId: string;
  /** @format date-time */
  startedAt: string;
  /** @format date-time */
  endedAt: string;
  bytes: number;
  urls: {
    location: string;
    /** Download the raw .cpuprofile or .heapprofile for Chrome DevTools. */
    devtools?: string;
  };
}

/** The context to send when purging the CDN Cache */
export interface PurgeCDNCacheContext {
  /** The list of tags to purge */
  tags: string[];
}

/** The Cloudflare Hostname TLS certificate */
export interface CloudflareHostnameTLSCertificate {
  issuer?: string;
  expiresOn?: string;
  issuedOn?: string;
}

/** The Cloudflare Hostname TLS validation error */
export interface CloudflareHostnameTLSValidationError {
  message: string;
}

/** The Cloudflare Hostname TLS information */
export interface CloudflareHostnameTLSInfo {
  /** The Cloudflare Hostname TLS status */
  status: CloudflareHostnameTLSStatus;
  /** The Cloudflare Hostname TLS validation method */
  method: CloudflareHostnameTLSValidationMethod;
  certificateAuthority?: string;
  certificates: CloudflareHostnameTLSCertificate[];
  validationErrors: CloudflareHostnameTLSValidationError[];
}

/** Cloudflare Custom Domain's information */
export interface CustomDomainInfo {
  hostname: string;
  /** The Cloudflare Hostname status */
  status: CloudflareHostnameStatus;
  createdAt: string;
  /** The Cloudflare Hostname TLS information */
  ssl?: CloudflareHostnameTLSInfo;
  verificationErrors: string[];
}

/** The User Firebase Auth Info. */
export interface FirebaseUserInfo {
  uid: string;
  displayName?: string;
  email?: string;
  phoneNumber?: string;
  photoUrl?: string;
  providerId?: string;
}

/** The GitBook User info shown in the BackOffice. */
export interface UserBackOfficeInfo {
  id: string;
  authProviders: FirebaseUserInfo[];
  createdAt: string;
  lastSignInAt: string;
  disabled: boolean;
}

/** The context to send when blocking/unblocking */
export interface BlockContext {
  block: boolean;
  /** A short description giving context on the reason for the block. */
  reason?: BlockReason;
}

/** The GitBook User impersonation info. */
export interface UserImpersonationInfo {
  authURL: string;
  impersonatorId: string;
}

/** The info returned when impersonating a GitBook User. */
export type UserImpersonation = UserBackOfficeInfo & {
  /** The GitBook User impersonation info. */
  impersonation: UserImpersonationInfo;
};

/** The teams permissions of a user */
export interface UserOrganizationsTeamsPermissions {
  /**
   * "The role of a team member.
   * "owner": Can manage team members.
   * "member": Is a member of the team.
   */
  role: TeamMemberRole;
}

/** The organizations permissions of a user */
export interface UserOrganizationsPermissions {
  /** The role of a member in an organization, null for guests */
  role: MemberRoleOrGuest;
  teams: Record<string, UserOrganizationsTeamsPermissions>;
  disabled?: boolean;
}

/** The collections permissions of a user */
export interface UserCollectionsPermissions {
  organization: string;
  /** The role of a member in an organization, null for guests */
  level: MemberRoleOrGuest;
  collection?: string;
}

/** The spaces permissions of a user */
export interface UserSpacesPermissions {
  organization: string;
  /** The role of a member in an organization, null for guests */
  level: MemberRoleOrGuest;
  collection?: string;
}

/** All the permissions of a user */
export interface Index {
  updatedAt: Timestamp;
  organizations: Record<string, UserOrganizationsPermissions>;
  collections: Record<string, UserCollectionsPermissions>;
  spaces: Record<string, UserSpacesPermissions>;
}

/** Date-based billing override value, either indefinite or a timestamp. */
export type OrganizationBillingDateOverride = true | Timestamp;

/**
 * Current numeric billing override, when set.
 * @min 0
 */
export type OrganizationBillingNumericOverride = number;

/**
 * A percentage from 0 to 100.
 * @min 0
 * @max 100
 */
export type Percentage = number;

export interface OrganizationBillingOverrides {
  overrides: {
    /** Current interval-change override, when set. */
    frozenInterval?: OrganizationBillingDateOverride;
    /** Current SAML override, when set. */
    enableSAML?: OrganizationBillingDateOverride;
    /** Contractual AI credit allowance for Enterprise organizations only. */
    aiCreditAllowance?: OrganizationBillingNumericOverride;
    /** Percentage of remaining paid AI credits carried into the next billing period. Paid self-serve organizations default to 50% when unset. */
    aiCreditRollover?: Percentage;
    /** Percentage of total AI credits remaining at which to send a low-balance alert. */
    aiCreditAlertThreshold?: Percentage;
    /** Whether AI features pause automatically once all AI credits are used, before usage is billed as overage. */
    aiCreditPauseEnabled?: boolean;
    /** False when the organization's contract requires AI to stay off, regardless of the admin setting. */
    hasAI?: false;
    /** Current minimum users override, when set. */
    minUsers?: OrganizationBillingNumericOverride;
    /** Current maximum users override, when set. */
    maxUsers?: OrganizationBillingNumericOverride;
    /** Current minimum premium sites override, when set. */
    minPremiumSites?: OrganizationBillingNumericOverride;
    /** Current maximum premium sites override, when set. */
    maxPremiumSites?: OrganizationBillingNumericOverride;
    /** Current minimum ultimate sites override, when set. */
    minUltimateSites?: OrganizationBillingNumericOverride;
    /** Current maximum ultimate sites override, when set. */
    maxUltimateSites?: OrganizationBillingNumericOverride;
  };
}

/** A percentage threshold, or null when disabled. */
export type PercentageThreshold = Percentage | null;

export type BackOfficeSite = Site & {
  /** ID of the organization owning this site */
  organization: string;
};

/** Site Content */
export interface PublishedSiteContent {
  /** ID of the site matching. */
  site: string;
  /** ID of the site-section matching. */
  siteSection?: string;
  /** ID of the site-space matching. */
  siteSpace: string;
  /** ID of the space matching. */
  space: string;
  /** Identifier of the change request being previewed in this URL. */
  changeRequest?: string;
  /** Identifier of the revision being previewed in this URL. */
  revision?: string;
  /** Path of the content relative to the input URL being resolved */
  pathname: string;
  /** Prefix of the path in the input URL being resolved */
  basePath: string;
  /** Prefix of the site path in the input URL being resolved */
  siteBasePath: string;
  /** Short-lived API token to fetch content related to the space in the context of the URL. */
  apiToken: string;
  /** ID of the organization. */
  organization: string;
  /** Share link key of the site in case the site was published with share-links. */
  shareKey?: string;
  /** Whether the resolved site URL is complete and at it's terminal point, meaning no more site path segments can be further expected before any page path segments. */
  complete: boolean;
  /** Context returned only for a authenticated access session to track changes in the visitor session context that affect content rendering (used for cache invalidation). */
  contextId?: string;
  /** The canonical URL of the resolution. */
  canonicalUrl: string;
  /** Whether the URL is a preview URL */
  preview?: boolean;
}

export type PublishedSiteContentLookup =
  | PublishedContentRedirect
  | PublishedSiteContent;

/** An object that describes the payload of site visitor info. It can include a jwt token with signed claims and/or a record of its unsigned claims. */
export interface SiteVisitorPayload {
  /** Whether the visitor is a human or an AI agent. Defaults to human when omitted. */
  type?: "human" | "agent";
  /** JWT token generated for a authenticated access session. */
  jwtToken?: string;
  /** ISO 3166-1 alpha-2 code of the country the visitor is browsing from, as detected by the renderer. */
  country?: string;
  unsignedClaims?: PlainObject;
}

export interface PublishedContentRoutingInput {
  /** @minLength 1 */
  hostname: string;
}

/** Path of a site space or a site section, with only the fields the edge resolution reads. */
export interface PublishedContentSitePath {
  id: number;
  siteId: number;
  path: string;
  siteSpaceId: number | null;
  siteSpaceSectionId: number | null;
  siteSectionId: number | null;
  isActive: "true" | null;
  isSiteSpacePath: "sitespace" | null;
  isSiteSectionPath: "sitesection" | null;
  isConflictingWithPagePath: boolean;
  isConflictingWithTopLevelPath: boolean;
  [key: string]: any;
}

/**
 * Unfiltered structure of a site, including every site path and the space metadata. The bundle
 * stores the whole structure: only the fields the edge resolution reads are described, with dates
 * as the strings they are once serialized.
 */
export interface PublishedContentSiteStructure {
  site: {
    id: number;
    _gid: string;
    legacyOrgKey: string;
    /**
     * The visibility setting of the site determines the audience of the site.
     * * `public`: Anyone can access the site, and the site is indexed by search engines.
     * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
     * * `share-link`: Anyone with a secret token in the url can access the site.
     * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
     */
    visibility: SiteVisibility;
    isPublished: boolean;
    hasAdaptiveContent: boolean | null;
    customHostname: string | null;
    customProxy: string | null;
    [key: string]: any;
  };
  siteBasename: {
    basename: string;
    [key: string]: any;
  } | null;
  siteVisitorAuth: {
    backend: "custom" | "integration";
    integrationId: string | null;
    fallbackURL: string | null;
    [key: string]: any;
  } | null;
  siteAdaptiveSchema: {
    /** JSON schema describing the expected attributes of an Adaptive site schema, with the regions `visitor.region` is resolved from. */
    jsonSchema: SiteAdaptiveJSONSchemaWithRegions;
    [key: string]: any;
  } | null;
  organization: {
    key: string;
    /** True, or the timestamp the organization was blocked at. */
    blocked?: boolean | Record<string, any>;
    hostname?: string | null;
    customHostname?: string | null;
    [key: string]: any;
  };
  siteSpaces: {
    siteSpace: {
      id: number;
      _gid: string;
      spaceId: string;
      pageId: string | null;
      siteSectionId: number | null;
      isDefault: "true" | null;
      draft: boolean;
      condition: string | null;
      orderIndex: string;
      [key: string]: any;
    };
    /** Path of a site space or a site section, with only the fields the edge resolution reads. */
    siteSpacePath: PublishedContentSitePath;
    spaceRelatedData: {
      space: {
        legacyKey: string;
        legacyOrgKey: string;
        blockedAt: string | null;
        deletedAt: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    [key: string]: any;
  }[];
  siteSections: {
    siteSection: {
      id: number;
      _gid: string;
      siteSectionGroupId: number | null;
      isDefault: "true" | null;
      draft: boolean;
      condition: string | null;
      orderIndex: string;
      [key: string]: any;
    };
    /** Path of a site space or a site section, with only the fields the edge resolution reads. */
    siteSectionPath: PublishedContentSitePath;
    [key: string]: any;
  }[];
  siteSectionGroups: {
    id: number;
    parentSectionGroupId: number | null;
    condition: string | null;
    [key: string]: any;
  }[];
  siteExternalLinks: {
    siteSectionGroupId: number | null;
    condition: string | null;
    [key: string]: any;
  }[];
  sitePaths: PublishedContentSitePath[];
  [key: string]: any;
}

/** JSON schema describing the expected attributes of an Adaptive site schema. */
export interface SiteAdaptiveJSONSchema {
  $schema?: "http://json-schema.org/draft-07/schema#";
  type: "object";
  properties: {
    /** Unsigned claims of the site visitor. */
    unsigned?: {
      type: "object";
      description: "Unsigned claims of the site visitor.";
      properties: Record<string, SiteAdaptiveJSONSchemaClaimsProperties>;
      additionalProperties: false;
    };
    [key: string]: any;
  };
  additionalProperties: false;
}

/**
 * Visitor-independent data needed to resolve any URL of a site.
 * It holds secrets (visitor auth keys, share links) and must never reach a client.
 */
export interface PublishedContentSiteBundle {
  /**
   * Version of the routing and site bundle formats. It is part of their cache keys, so a worker never
   * decodes an entry written in a format it does not know during a deploy.
   */
  formatVersion: 1;
  /**
   * Unfiltered structure of a site, including every site path and the space metadata. The bundle
   * stores the whole structure: only the fields the edge resolution reads are described, with dates
   * as the strings they are once serialized.
   */
  siteStructure: PublishedContentSiteStructure;
  /** Deterministic JSON schema used to normalize visitor claims. */
  claimsSchema: SiteAdaptiveJSONSchema;
  /** Organizations owning spaces of the site, other than the site's, that are suspended. */
  blockedOrganizations: string[];
  /** Share links of the site, with their stored key. */
  shareLinks: {
    key: string;
    active: boolean;
  }[];
  /** Key verifying visitor tokens, resolved for integration backends. */
  visitorAuthSigningKey:
    | {
        type: "key";
        key: string;
      }
    | {
        type: "error";
        status: number;
        message: string;
      }
    | null;
  /** Public URL of the visitor-auth integration installation, for authentication redirects. */
  visitorAuthIntegrationURL: string | null;
  /**
   * Custom homepage path of each site space (by GID) that has one: null when the page is not a
   * visible document, `unavailable` when its revision could not be computed.
   */
  customHomepages: Record<
    string,
    | {
        path: string;
      }
    | "unavailable"
    | null
  >;
  /** Whether the site filters content token claims by page, which only the API supports yet. */
  minimalPageClaimsEnabled: boolean;
}

/**
 * How a hostname maps to sites, independently of the pathname and the visitor.
 * It can embed a site bundle, so like it, it must never reach a client.
 */
export type PublishedContentRouting =
  | {
      kind: "site";
      siteId: number;
      deprecated: boolean;
      /**
       * Visitor-independent data needed to resolve any URL of a site.
       * It holds secrets (visitor auth keys, share links) and must never reach a client.
       */
      bundle: PublishedContentSiteBundle;
    }
  | {
      kind: "organization";
      organization: string;
      deprecated: boolean;
      basenames: {
        basename: string;
        siteId: number;
        isActive: boolean;
      }[];
      /**
       * What a URL without a matching basename resolves to. Top-level site-space paths are
       * tried before the default content.
       */
      organizationPointer: {
        /**
         * Content an organization pointer resolves to when no top-level site-space path
         * matches: a site (by GID), a space with no published site (shown in the app), or nothing.
         */
        defaultContent:
          | {
              type: "site";
              site: string;
            }
          | {
              type: "space";
              space: string;
            }
          | null;
        topLevelSiteSpacePaths: {
          siteId: number;
          siteSpaceId: number | null;
          isActive: "true" | null;
          path: string;
          isSiteSpacePath: "sitespace" | null;
          isConflictingWithPagePath: boolean;
        }[];
      };
    }
  | {
      kind: "custom-proxy";
      sites: {
        siteId: number;
        customProxy: string;
      }[];
    }
  | {
      kind: "proxy";
    }
  | {
      kind: "error";
      status: number;
      message: string;
    }
  | {
      kind: "unsupported";
      reason: string;
    };

export interface PublishedContentSiteBundleInput {
  /** @min 1 */
  siteId: number;
}

export interface PublishedContentPublishedSiteInput {
  /** @min 1 */
  siteId: number;
  /** Encode the site with a placeholder share key in its URLs, for the edge to replace with the share key of a request. */
  withShareKey: boolean;
}

/**
 * Response of `getPublishedContentSite` for a site content token granting every space of the site
 * and carrying no claims, with what the edge needs to filter it for a visitor.
 */
export interface PublishedContentSiteEntry {
  /** Version of the routing and site bundle formats, part of the entry's cache key. */
  formatVersion: 1;
  body: PublishedContentSite;
  /**
   * Encoded site spaces whose URLs change when adaptive filtering reassigns a default, by
   * site space ID and the default state they end up in. Only for sites with conditional
   * content, the only ones where defaults can be reassigned.
   */
  siteSpaceVariants: Record<
    string,
    {
      nonDefault: SiteSpace;
      default: SiteSpace;
      defaultInDefaultSection: SiteSpace;
    }
  >;
  /**
   * Encoded site sections by site section ID and the default state they end up in, without
   * their site spaces, which are filtered separately.
   */
  siteSectionVariants: Record<
    string,
    {
      nonDefault: SiteSection;
      default: SiteSection;
    }
  >;
  maxAge: number;
  staleWhileRevalidate: number;
  cacheTags: string[];
  /** Headers of the realtime channels the response subscribes to. */
  headers: Record<string, string>;
}

export interface PublishedContentCallerInput {
  /** @minLength 1 */
  token: string;
}

/** Content token settings of a caller of GitBook Open. */
export interface PublishedContentCaller {
  /** Duration of the content tokens minted for this caller, in seconds. */
  contentTokenDuration?: number | null;
  /** Rate-limit multiplier copied into the content token, none for an anonymous caller. */
  rateLimitMultiplier?: number;
  /** The caller is a content token with claims, which the API evaluates the custom homepage against. */
  hasContentClaims?: boolean;
}

/**
 * Caller of GitBook Open, identified by its API token: only personal API tokens and content tokens
 * are resolved at the edge, any other kind is left to the API.
 */
export type PublishedContentCallerContext =
  | ({
      type: "user";
    } & PublishedContentCaller)
  | ({
      type: "content";
      /** Expiration of the token, in seconds, which can come before its cache entry's. */
      expiresAt: number;
    } & PublishedContentCaller)
  | {
      type: "invalid";
    }
  | {
      type: "unsupported";
    };

export interface PublishedContentRevisionMetaLinksInput {
  /** @minLength 1 */
  spaceId: string;
  /** @minLength 1 */
  revisionId: string;
  /**
   * Site the content token is scoped to, as a gid.
   * @minLength 1
   */
  site?: string;
  /**
   * Site space the content token is scoped to, as a gid.
   * @minLength 1
   */
  siteSpace?: string;
}

/**
 * Meta links data of every page in a revision, with the alternates of the site space it is
 * published in: enough to serve the meta links of any page of the revision.
 */
export interface PublishedContentRevisionMetaLinks {
  /**
   * Version of the format. It is part of the cache key, so a worker never decodes an entry
   * written in a format it does not know during a deploy.
   */
  formatVersion: 2;
  /** Meta links data of each page of the revision. */
  pages: Record<
    string,
    {
      /** Meta links of the page, or null when it is not a document. */
      metaLinks: RevisionPageMetaLinks | null;
      /** Conditions of the page and its ancestors, from the root; all must hold for a visitor. */
      conditions?: string[];
    }
  >;
  /** Variables of the revision, which conditions can read. Only set when a page has conditions. */
  variables?: Record<string, any>;
  /** Alternates of each page resolved across the sibling site spaces. */
  siteSpaceAlternates?: Record<string, ContentRefPage[]>;
  /** Tags purging responses derived from this data. */
  cacheTags: string[];
}

export interface PublishedContentCustomHomepageInput {
  /**
   * Content token of the preview, which the revision is read with.
   * @minLength 1
   */
  token: string;
  /** @minLength 1 */
  spaceId: string;
  /** @minLength 1 */
  pageId: string;
  revisionId?: string;
  changeRequestId?: string;
}

/** Custom homepage of a space revision. */
export interface PublishedContentCustomHomepage {
  /** Absolute path of the page, null when it cannot be shown to visitors. */
  path: string | null;
}

/** GitHub repository that can be selected for Git Sync. */
export interface GitSyncGitHubRepository {
  id: number;
  accountName: string;
  repositoryName: string;
  fullName: string;
  defaultBranch: string | null;
}

/** Branch that can be used for Git Sync. */
export interface GitSyncBranch {
  name: string;
  ref: string;
}

/** A file found in a Git Sync repository at a specific ref. */
export interface GitSyncRepositoryFile {
  name: string;
  path: string;
  sha: string;
  size: number;
}

/** GitLab project that can be selected for Git Sync. */
export interface GitSyncGitLabProject {
  id: number;
  accountName: string;
  repositoryName: string;
  fullName: string;
  defaultBranch: string | null;
}

/**
 * @minLength 64
 * @maxLength 64
 */
export type SHA256 = string;

export interface SpaceTrackPageView {
  /** Unique identifier of the page. */
  pageId?: string;
  /** Analytics info on the GitBook's content visitor. */
  visitor: {
    /** GitBook's unique identifier of the visitor. */
    anonymousId: string;
    /** The visitors cookies. */
    cookies: Record<string, string>;
    /**
     * IP address of the visitor.
     * If undefined, it'll default to the IP executing the request.
     */
    ip?: string;
    /**
     * User-agent of the visitor.
     * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
     */
    userAgent: string;
    /**
     * Language of the visitor.
     * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/language
     */
    language?: string;
  };
  /** The GitBook content's URL visited (including URL params). */
  url: string;
  /** The URL of referrer that linked to the page. */
  referrer: string;
}

export type SiteTrackPageView = {
  /** Unique identifier of the page. */
  pageId?: string;
  /** Analytics info on the GitBook's content visitor. */
  visitor: {
    /** GitBook's unique identifier of the visitor. */
    anonymousId: string;
    /** The visitors cookies. */
    cookies: Record<string, string>;
    /**
     * IP address of the visitor.
     * If undefined, it'll default to the IP executing the request.
     */
    ip?: string;
    /**
     * User-agent of the visitor.
     * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
     */
    userAgent: string;
    /**
     * Language of the visitor.
     * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/language
     */
    language?: string;
  };
  /** The GitBook content's URL visited (including URL params). */
  url: string;
  /** The URL of referrer that linked to the page. */
  referrer: string;
} & (
  | {
      /** Unique identifier of the space. */
      spaceId: string;
    }
  | {
      /** The site-space that was viewed */
      siteSpaceId: string;
    }
);

export interface UpdateContentPublishingAuth {
  /**
   * A fallback URL that will be used if authentication fails.
   * @format uri
   */
  fallbackURL?: string;
}

export interface ContentLocationRevisionContext {
  type: "revision";
  revision: Revision;
}

export interface ContentLocationChangeRequestContext {
  type: "changeRequest";
  changeRequest: ChangeRequest;
}

export interface ContentLocationFile {
  kind: "file";
  organization: Organization;
  space: Space;
  versionContext?:
    | ContentLocationRevisionContext
    | ContentLocationChangeRequestContext;
  file: RevisionFile;
}

export interface ContentLocationURL {
  kind: "url";
  url: string;
}

export interface ContentLocationPageAnchor {
  type: "anchor";
  /** The anchor within the page. */
  anchor: string;
}

export interface ContentLocationPageNode {
  type: "node";
  /** The node id within the page. */
  node: string;
}

export interface ContentLocationPage {
  kind: "page";
  organization: Organization;
  page: RevisionPage;
  space: Space;
  versionContext?:
    | ContentLocationRevisionContext
    | ContentLocationChangeRequestContext;
  internalLocation?: ContentLocationPageAnchor | ContentLocationPageNode;
}

export interface ContentLocationUser {
  kind: "user";
  user: User;
}

export interface ContentLocationCollection {
  kind: "collection";
  organization: Organization;
  collection: Collection;
}

export interface ContentLocationSpace {
  kind: "space";
  organization: Organization;
  space: Space;
}

export interface ContentLocationReusableContent {
  kind: "reusable-content";
  organization: Organization;
  space: Space;
  versionContext?:
    | ContentLocationRevisionContext
    | ContentLocationChangeRequestContext;
  reusableContent: RevisionReusableContent;
}

export interface ContentLocationOpenAPI {
  kind: "openapi";
  organization: Organization;
  openAPISpec: OpenAPISpec;
}

export interface SpaceTemplate {
  id: string;
  contentId: string;
  /** A title of the template. */
  title: string;
  /** A subtitle for the template. */
  subtitle: string;
  /** An emoji representing the template. */
  emoji: Emoji;
  /** An optional OpenAPI spec to create along with the template. */
  openAPISpec?: {
    /** Slug used as reference */
    slug: OpenAPISpecSlug;
    sourceURL: URL;
  };
  /** A list of features that the template supports. */
  features: string[];
  previewImage: {
    light: URL;
    dark: URL;
  };
  /** URLs associated with the object */
  urls: {
    preview: URL;
  };
}

export type ComputedContentSource =
  | ComputedContentSourceDocument
  | ComputedContentSourceRevision;

export type InputPageBase = {
  /**
   * Optional unique identifier for the page.
   * It can be used to reference pages in document links.
   * @pattern ^[a-zA-Z0-9]{1,40}$
   */
  id?: string;
  /** @minLength 1 */
  title: string;
  /**
   * Optional custom title for the page ToC and mention entries instead of the page title.
   * @minLength 1
   * @maxLength 100
   */
  linkTitle?: string;
} & (
  | {
      /** Emoji of the page. */
      emoji: Emoji;
    }
  | {
      /** Icon of the page. */
      icon?: Icon;
    }
);

export type InputPageDocument = InputPageBase & {
  type: "document";
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string;
  /**
   * Optional custom title overriding only the page-title segment of the composed `<title>` tag (`<tagTitle || title> | <section> | <site>`).
   * @minLength 0
   * @maxLength 100
   */
  tagTitle?: string;
  /** Page's slug in its direct parent */
  slug?: string;
  pages?: (InputPageDocument | InputPageLink | InputPageComputed)[];
  computed?: ComputedContentSourceDocument;
};

export type InputPageLink = InputPageBase & {
  type: "link";
  /** A relative reference to content in GitBook. */
  target: ContentRef;
};

export type InputPageComputed = InputPageBase & {
  type: "computed";
  computed: ComputedContentSourceRevision;
};

export type InputPageGroup = InputPageBase & {
  type: "group";
  /** Page's slug in its direct parent */
  slug?: string;
  /** @minLength 1 */
  pages: (InputPageDocument | InputPageLink | InputPageComputed)[];
};

export type InputPage =
  | InputPageDocument
  | InputPageLink
  | InputPageComputed
  | InputPageGroup;

export interface InputFile {
  id?: string;
  name: string;
  contentType: string;
  downloadURL: string;
  size: number;
  /** For images, it contains the dimensions of it. */
  dimensions?: {
    width: number;
    height: number;
  };
}

export interface GitSyncSpaceOperation {
  /**
   * * `running`: The operation is still running
   * * `failure`: The operation failed
   * * `success`: The operation was successful
   * * `timeout`: The operation timed out
   */
  state: GitSyncOperationState;
  direction: GitSyncOperationDirection;
  /**
   * Core stages of a Git Sync process. This is not exhaustive, but should cover
   * the important ones.
   * - repo_fetch: Includes fetching the latest repository contents from remote provider.
   * - config_check: Includes checking if the YAML config is valid, etc.
   * - content_process: Includes processing of pages & files to be imported/exported.
   * - finalize: Includes finalizing the sync process like creating the commit on git, or
   * creating a new revision.
   */
  stage: GitSyncOperationStage;
  /**
   * Always `0`. Task-level progress is no longer tracked; read `stage` instead.
   * @deprecated
   */
  dispatchedTasks: number;
  /**
   * Always `0`. Task-level progress is no longer tracked; read `stage` instead.
   * @deprecated
   */
  completedTasks: number;
  /** Date when the operation was started */
  startedAt: Timestamp;
  /** Date when the operation was last updated */
  updatedAt: Timestamp;
  /** Date when the operation was successful (when state is `success`) */
  completedAt?: Timestamp;
  /** Error details, defined if state is `failure`. */
  error?: string;
  /** An action the user can take to resolve a failed Git Sync operation. */
  errorAction?: GitSyncOperationErrorAction;
}

/**
 * Deprecated. Use `GitSyncSpaceOperation` instead.
 * @deprecated
 */
export type GitSyncOperation = GitSyncSpaceOperation;

export interface GitSyncSiteOperation {
  /**
   * * `running`: The operation is still running
   * * `failure`: The operation failed
   * * `success`: The operation was successful
   * * `timeout`: The operation timed out
   */
  state: GitSyncOperationState;
  direction: GitSyncOperationDirection;
  /**
   * Core stages of a Git Sync process. This is not exhaustive, but should cover
   * the important ones.
   * - repo_fetch: Includes fetching the latest repository contents from remote provider.
   * - config_check: Includes checking if the YAML config is valid, etc.
   * - content_process: Includes processing of pages & files to be imported/exported.
   * - finalize: Includes finalizing the sync process like creating the commit on git, or
   * creating a new revision.
   */
  stage: GitSyncOperationStage;
  /** Date when the operation was started */
  startedAt: Timestamp;
  /** Date when the operation was last updated */
  updatedAt: Timestamp;
  /** Date when the operation was successful (when state is `success`) */
  completedAt?: Timestamp;
  /** Error details, defined if state is `failure`. */
  error?: string;
  /** An action the user can take to resolve a failed Git Sync operation. */
  errorAction?: GitSyncOperationErrorAction;
  spaces?: Record<string, GitSyncSpaceOperation>;
}

/**
 * A section group — a container that nests sections (and other section
 * groups). Discriminated by `type: section-group`. Up to one level of nested
 * section groups is allowed.
 */
export interface GitSyncSiteStructureSectionGroup {
  /** Discriminator for a section group node. */
  type: "section-group";
  /**
   * Stable identifier for this section group, used as the Git Sync key.
   * Must be unique amongst all other section groups of the site. For
   * example: `section-group-product` or `section-group-1`.
   * You can nest section groups only one level deep. For example, `section-group-1` can have a child section group `section-group-1-1`, but `section-group-1-1` cannot have a child section group.
   * @minLength 1
   */
  key: string;
  /** Title of the site section group */
  title: SiteSectionGroupTitle;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Name of the icon */
  icon?: Icon;
  /** Expression to evaluate */
  condition?: Expression;
  /** Whether the section group is draft and not live. */
  draft?: boolean;
  /** Section, section group, or external link nodes nested under this group. */
  children?: (
    | GitSyncSiteStructureSectionGroup
    | GitSyncSiteStructureSection
    | GitSyncSiteStructureExternalLink
  )[];
}

/**
 * A space — a single content unit in the site's navigation tree. Discriminated
 * by `type: space`.
 *
 * The space's content either lives in the synced repository at the directory
 * pointed to by `content.directory`, or does not inherit the site's repository
 * when `content.directory` is `null`. Hierarchy comes from where the space
 * appears in the YAML (under a section, a section group, or at the root), not
 * from an explicit parent reference.
 *
 * The directory is read as one book — the Markdown files it holds become the
 * pages of the space.
 */
export interface GitSyncSiteStructureSpace {
  /** Discriminator for a space node. */
  type: "space";
  /**
   * Stable identifier for this space, used as the Git Sync key. Must be
   * unique amongst all other spaces of the site. For example: `space-docs`
   * or `space-1`.
   * @minLength 1
   */
  key: string;
  /** @minLength 1 */
  title: string;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Path to the space on the site */
  path: SiteSpacePath;
  /**
   * Whether this is the default space of its parent — the one opened when the
   * site or the section is visited without a space path. Exactly one space
   * among each set of siblings carries it.
   */
  default?: boolean;
  /** Whether the space is hidden from the site's navigation. */
  hidden?: boolean;
  /** Whether the space is draft and not live. */
  draft?: boolean;
  /** Expression to evaluate */
  condition?: Expression;
  /** Where the space's content is managed. */
  content: {
    /**
     * Directory holding this space's content, resolved from the site's
     * project directory — `./guides` under a site rooted at `docs/`
     * reads `docs/guides`. A leading slash escapes to the repository
     * root instead, so `/guides` always reads `guides`. Parent-directory
     * segments (`..`) are rejected.
     */
    directory: string | null;
    language?: TranslationLanguage;
  };
}

/**
 * A section — a group of spaces sharing a top-level navigation entry.
 * Discriminated by `type: section`.
 *
 * Spaces inside a section are listed inline under `children`; a section holds
 * nothing else — nest sections under a section group instead. A site with
 * sections must mark exactly one section with `default: true`, and cannot also
 * list spaces at the top level of its structure.
 */
export interface GitSyncSiteStructureSection {
  /** Discriminator for a section node. */
  type: "section";
  /**
   * Stable identifier for this section, used as the Git Sync key. Must be
   * unique amongst all other sections of the site. For example:
   * `section-guides` or `section-1`.
   * @minLength 1
   */
  key: string;
  /** Title of the site section */
  title: SiteSectionTitle;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Description of the site section */
  description?: SiteSectionDescription;
  /** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedDescription?: LocalizedString256;
  /** Name of the icon */
  icon?: Icon;
  /** Whether this is the default section for the site. */
  default?: boolean;
  /** Path to the section on the site */
  path: SiteSectionPath;
  /** Expression to evaluate */
  condition?: Expression;
  /** Space nodes nested under this section. */
  children?: GitSyncSiteStructureSpace[];
}

/**
 * Title of the external link
 * @minLength 2
 * @maxLength 128
 */
export type SiteExternalLinkTitle = string;

/**
 * Description of the external link
 * @minLength 0
 * @maxLength 256
 */
export type SiteExternalLinkDescription = string;

/**
 * An external link — a leaf that navigates away from the site to an absolute
 * HTTP(S) URL. Discriminated by `type: external-link`.
 *
 * An external link only exists in a section-based site structure: it may sit
 * at the root alongside sections and section groups, or nested under a
 * section group, but never inside a section.
 */
export interface GitSyncSiteStructureExternalLink {
  /** Discriminator for an external link node. */
  type: "external-link";
  /**
   * Stable identifier for this external link, used as the Git Sync key.
   * Must be unique amongst all other nodes of the site. For example:
   * `link-status` or `link-1`.
   * @minLength 1
   */
  key: string;
  /** Title of the external link */
  title: SiteExternalLinkTitle;
  /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedTitle?: LocalizedString128;
  /** Description of the external link */
  description?: SiteExternalLinkDescription;
  /** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
  localizedDescription?: LocalizedString256;
  /** Name of the icon */
  icon?: Icon;
  /** Absolute HTTP or HTTPS URL opened by the external link. */
  url: URL;
  /** Whether the external link is draft and not live. */
  draft?: boolean;
  /** Expression to evaluate */
  condition?: Expression;
}

/**
 * A single node in a Git Sync site structure tree — a section group, a
 * section, a space, or an external link, discriminated by `type`.
 */
export type GitSyncSiteStructureNode =
  | GitSyncSiteStructureSectionGroup
  | GitSyncSiteStructureSection
  | GitSyncSiteStructureSpace
  | GitSyncSiteStructureExternalLink;

/**
 * Hierarchical structure of a site in a Git Sync YAML. Each entry is one of
 * four node types: a section group, a section, a space, or an external link.
 *
 * A **space** is a leaf holding content, pointed at a repository directory. A
 * **section** gathers spaces behind one top-level navigation entry. A
 * **section group** gathers sections. An **external link** is a leaf that
 * navigates away from the site to an absolute HTTP(S) URL — it may sit at the
 * root or under a section group, but never inside a section, and only exists
 * in a site that also has at least one section. A site either uses sections
 * (optionally alongside external links) or lists its spaces at the top level,
 * never both.
 *
 * ```yaml
 * structure:
 *   - type: space
 *     key: space-guides
 *     title: Guides
 *     path: guides
 *     default: true
 *     content:
 *       directory: ./guides
 *   - type: space
 *     key: space-api
 *     title: API reference
 *     path: api
 *     content:
 *       directory: ./api
 * ```
 *
 * The same two spaces behind top-level navigation entries:
 *
 * ```yaml
 * structure:
 *   - type: section
 *     key: section-product
 *     title: Product
 *     path: product
 *     default: true
 *     children:
 *       - type: space
 *         key: space-guides
 *         title: Guides
 *         path: guides
 *         default: true
 *         content:
 *           directory: ./guides
 *   - type: section
 *     key: section-reference
 *     title: Reference
 *     path: reference
 *     children:
 *       - type: space
 *         key: space-api
 *         title: API reference
 *         path: api
 *         default: true
 *         content:
 *           directory: ./api
 * ```
 *
 * Rules checked on import — a violation fails the sync, naming the offending
 * node:
 *
 * - Every `key` is unique across the file, whatever the node type. Git Sync
 *   recognises a node from one sync to the next by its key, so a reused key
 *   leaves two nodes indistinguishable.
 * - Each section marks exactly one of its spaces `default: true`, and a site
 *   without sections marks one among its top-level spaces. The default is the
 *   space that opens when the site or the section is visited without a space
 *   path of its own.
 * - A site declaring any section marks exactly one of those sections
 *   `default: true`, and lists no space at the top level: once a section
 *   exists, every space belongs inside one.
 * - Sections hold only spaces. Section groups hold only sections, nested
 *   section groups (one further level), or external links — nothing nests
 *   deeper than that.
 * - External links are only valid at the root or nested in a section group,
 *   never inside a section. A site containing an external link must use
 *   sections, with at least one section declared.
 * - Spaces pointed at the same `content.directory` declare the same
 *   `content.language`. One directory is read once, so it cannot produce two
 *   languages at the same time.
 */
export type GitSyncSiteStructure = GitSyncSiteStructureNode[];

/**
 * Schema for a site `gitbook-docs.yaml` file — the canonical contract for what
 * can be authored in Git Sync to drive a site's structure.
 *
 * The file lives at the root of the site's project directory in the synced
 * repository. It names the site and maps the repository's content directories
 * onto the site's navigation.
 */
export interface GitSyncSiteConfig {
  /**
   * URL of the schema used by editors to validate the site configuration.
   * @format uri
   */
  $schema?: string;
  /**
   * Reserved for future use. When a breaking schema change ships, this
   * field lets the parser branch on the version; absence means v1.
   * @default 1
   */
  version?: 1;
  site: {
    /**
     * Display title for the site.
     * @minLength 1
     */
    title: string;
    /**
     * Hierarchical structure of a site in a Git Sync YAML. Each entry is one of
     * four node types: a section group, a section, a space, or an external link.
     *
     * A **space** is a leaf holding content, pointed at a repository directory. A
     * **section** gathers spaces behind one top-level navigation entry. A
     * **section group** gathers sections. An **external link** is a leaf that
     * navigates away from the site to an absolute HTTP(S) URL — it may sit at the
     * root or under a section group, but never inside a section, and only exists
     * in a site that also has at least one section. A site either uses sections
     * (optionally alongside external links) or lists its spaces at the top level,
     * never both.
     *
     * ```yaml
     * structure:
     *   - type: space
     *     key: space-guides
     *     title: Guides
     *     path: guides
     *     default: true
     *     content:
     *       directory: ./guides
     *   - type: space
     *     key: space-api
     *     title: API reference
     *     path: api
     *     content:
     *       directory: ./api
     * ```
     *
     * The same two spaces behind top-level navigation entries:
     *
     * ```yaml
     * structure:
     *   - type: section
     *     key: section-product
     *     title: Product
     *     path: product
     *     default: true
     *     children:
     *       - type: space
     *         key: space-guides
     *         title: Guides
     *         path: guides
     *         default: true
     *         content:
     *           directory: ./guides
     *   - type: section
     *     key: section-reference
     *     title: Reference
     *     path: reference
     *     children:
     *       - type: space
     *         key: space-api
     *         title: API reference
     *         path: api
     *         default: true
     *         content:
     *           directory: ./api
     * ```
     *
     * Rules checked on import — a violation fails the sync, naming the offending
     * node:
     *
     * - Every `key` is unique across the file, whatever the node type. Git Sync
     *   recognises a node from one sync to the next by its key, so a reused key
     *   leaves two nodes indistinguishable.
     * - Each section marks exactly one of its spaces `default: true`, and a site
     *   without sections marks one among its top-level spaces. The default is the
     *   space that opens when the site or the section is visited without a space
     *   path of its own.
     * - A site declaring any section marks exactly one of those sections
     *   `default: true`, and lists no space at the top level: once a section
     *   exists, every space belongs inside one.
     * - Sections hold only spaces. Section groups hold only sections, nested
     *   section groups (one further level), or external links — nothing nests
     *   deeper than that.
     * - External links are only valid at the root or nested in a section group,
     *   never inside a section. A site containing an external link must use
     *   sections, with at least one section declared.
     * - Spaces pointed at the same `content.directory` declare the same
     *   `content.language`. One directory is read once, so it cannot produce two
     *   languages at the same time.
     */
    structure: GitSyncSiteStructure;
  };
}

export type IntegrationEnvironmentSpaceInstallation =
  IntegrationContentInstallationBase & {
    /** The space the integration is installed on. */
    space: string;
  };

export type IntegrationEnvironmentSiteInstallation =
  IntegrationContentInstallationBase & {
    /** The site the integration is installed on. */
    site: string;
  };

/** Runtime environment provided during the execution of integration's code. */
export interface IntegrationEnvironment {
  /**
   * Authentication token to use with the HTTP API. Depending on the context, the token might be representing the installation or the integration.
   * @deprecated
   */
  authToken?: string;
  integration: Integration;
  /** Installation of an integration on an account */
  installation?: IntegrationInstallation;
  spaceInstallation?: IntegrationEnvironmentSpaceInstallation;
  siteInstallation?: IntegrationEnvironmentSiteInstallation;
  /** Secrets stored on the integration and passed at runtime. */
  secrets: IntegrationSecrets;
  /**
   * Secret that can be used to verify the authenticity of incoming HTTP requests to the integration.
   * @deprecated
   */
  signingSecret?: string;
  signingSecrets: {
    /** Secret that can be used to verify the authenticity of incoming HTTP requests to the integration. */
    integration: string;
    /** Secret that can be used to verify the authenticity of incoming HTTP requests to the installation. */
    installation?: string;
    /** Secret that can be used to verify the authenticity of incoming HTTP requests to the space installation. */
    spaceInstallation?: string;
    /** Secret that can be used to verify the authenticity of incoming HTTP requests to the site installation. */
    siteInstallation?: string;
  };
  /** URL of the HTTP API */
  apiEndpoint: string;
  apiTokens: {
    /** API authentication token representing the integration. */
    integration: string;
    /** API authentication token representing the current installation. */
    installation?: string;
  };
  /** Network configuration for the integration environment */
  network?: IntegrationNetwork;
}

export interface SpaceIntegrationScript {
  /** Script URL to load. */
  script: URL;
  /** Content Security Policy to secure the loading of this script. */
  contentSecurityPolicy?: string;
  /** If true, the script will potentially load use cookies and visitors should be aware. */
  cookies: boolean;
}

/** Response expected for an event of type `content_compute_document`. */
export interface ContentComputeDocumentEventResponse {
  document: Document;
}

/** Response expected for an event of type `content_compute_pages`. */
export interface ContentComputeRevisionEventResponse {
  pages?: InputPage[];
  files?: InputFile[];
}

export interface BillingDiscount {
  /** How many months the discount will last */
  duration: number;
  /** Percent that will be deducted from the subtotal of the invoice */
  percentOff: number;
}

export type APIScope = IntegrationScope | APIIntegrationScope;

/** Common properties for all Content API tokens. */
export interface ContentAPIBaseToken {
  /** ID of the organization that owns the content. A content token is always scoped to spaces from the same organization. */
  organization: string;
  /** List of spaces that the token is allowed to access. */
  spaces: string[];
  /** Whether the visitor, for which the token was generated, is a human or an AI agent. Defaults to human when omitted. */
  visitorType?: "human" | "agent";
  /** Whether the visitor is authenticated. Only set for sites with adaptive content enabled when token verification succeeded. */
  visitorIsAuthenticated?: boolean;
  /** The region containing the country of the visitor for whom the token was generated. Omitted if the country isn't in any region. */
  visitorRegion?: string;
  /** Attributes or assertions that provide specific details about the visitor for which the token was generated. */
  claims?: Record<string, any>;
  /** Multiplier for the rate limit applied to the token. */
  rateLimitMultiplier?: number;
}

export type SpaceAPIToken = ContentAPIBaseToken & {
  kind: "space";
  /** ID of the space that the token is allowed to access. */
  space: string;
};

export type CollectionAPIToken = ContentAPIBaseToken & {
  kind: "collection";
  /** ID of the collection that the token is allowed to access. */
  collection: string;
};

export type SiteAPIToken = ContentAPIBaseToken & {
  kind: "site";
  /** ID of the site that the token is allowed to access. */
  site: string;
  /** ID of the site-space to be used when using this token for rendering published content. */
  siteSpace: string;
  /** ID of the site-section to be used when using this token for rendering published content. Only defined for section sites. */
  siteSection?: string;
  /** ID of the space to be used when using this token for rendering published content. */
  space: string;
  /**
   * Whether to include draft data when using this token for rendering content. If false, only live data will be included when rendering content with this token.
   * @default false
   */
  draft?: boolean;
};

/** Content properties stored in a Content API token. */
export type ContentAPITokenPayload =
  | SpaceAPIToken
  | CollectionAPIToken
  | SiteAPIToken;

export interface APIChannelSpaceInfo {
  channel: "space";
  space: string;
}

/** Channel notified when the main content of a space is changed. */
export interface APIChannelSpaceContent {
  channel: "space-content";
  space: string;
}

export interface APIChannelSpaceGitInfo {
  channel: "space-git-info";
  space: string;
}

export interface APIChannelSpacePublishingAuth {
  channel: "space-publishing-auth";
  space: string;
}

export interface APIChannelSpacePublishingCustomization {
  channel: "space-publishing-customization";
  space: string;
}

export interface APIChannelSpaceIntegrations {
  channel: "space-integrations";
  space: string;
}

export interface APIChannelUserAPITokens {
  channel: "user-api-tokens";
  user: string;
}

export interface APIChannelUserOrganizations {
  channel: "user-organizations";
  user: string;
}

export interface APIChannelUserProfile {
  channel: "user-profile";
  user: string;
}

export interface APIChannelChangeRequest {
  channel: "space-change-request";
  space: string;
  changeRequest: string;
}

export interface APIChannelChangeRequests {
  channel: "space-change-requests";
  space: string;
}

export interface APIChannelChangeRequestReviews {
  channel: "space-change-request-reviews";
  space: string;
  changeRequest: string;
}

export interface APIChannelCollection {
  channel: "collection";
  collection: string;
}

export interface APIChannelCollectionPublishingCustomization {
  channel: "collection-publishing-customization";
  collection: string;
}

export interface APIChannelOrganizationInfo {
  channel: "organization";
  organization: string;
}

/** Subscription channel for changes in Docs Agent data in an organization. */
export interface APIChannelOrganizationAgentData {
  channel: "organization-agent-data";
  organization: string;
}

export interface APIChannelOrganizationInviteLinks {
  channel: "organization-link-invites";
  organization: string;
}

export interface APIChannelOrganizationMembers {
  channel: "organization-members";
  organization: string;
}

export interface APIChannelOrganizationMember {
  channel: "organization-member";
  organization: string;
  user: string;
}

export interface APIChannelOrganizationSAML {
  channel: "organization-saml";
  organization: string;
}

export interface APIChannelOrganizationTeams {
  channel: "organization-teams";
  organization: string;
}

export interface APIChannelOrganizationTeam {
  channel: "organization-team";
  organization: string;
  team: string;
}

export interface APIChannelOrganizationTeamMembers {
  channel: "organization-team-members";
  organization: string;
  team: string;
}

export interface APIChannelOrganizationTeamMember {
  channel: "organization-team-member";
  organization: string;
  team?: string;
  member: string;
}

/** Subscription channel for changes in spaces in an organization. */
export interface APIChannelOrganizationSpaces {
  channel: "organization-spaces";
  organization: string;
}

/** Subscription channel for changes in collections in an organization. */
export interface APIChannelOrganizationCollections {
  channel: "organization-collections";
  organization: string;
}

export interface APIChannelOrganizationIntegrations {
  channel: "organization-integrations";
  organization: string;
}

export interface APIChannelOrganizationInstallations {
  channel: "organization-installations";
  organization: string;
}

/** Subscription channel for changes in sites in an organization. */
export interface APIChannelOrganizationSites {
  channel: "organization-sites";
  organization: string;
}

/** Subscription channel for changes in OpenAPI specifications in an organization. */
export interface APIChannelOrganizationOpenAPISpecs {
  channel: "organization-openapi-specs";
  organization: string;
}

/** Subscription channel for changes in translations in an organization. */
export interface APIChannelOrganizationTranslations {
  channel: "organization-translations";
  organization: string;
}

/** Subscription channel for changes in the glossary in an organization. */
export interface APIChannelOrganizationTranslationsGlossary {
  channel: "organization-translations-glossary";
  organization: string;
}

/** Subscription channel for changes in the SCIM connections of an organization. */
export interface APIChannelOrganizationSCIMConnections {
  channel: "organization-scim-connections";
  organization: string;
}

/** Subscription channel for changes in custom fonts in an organization. */
export interface APIChannelOrganizationCustomFonts {
  channel: "organization-fonts";
  organization: string;
}

/** Subscription channel for Docs agent instructions changes in an organization. */
export interface APIChannelOrganizationAgentInstructions {
  channel: "organization-agent-instructions";
  organization: string;
}

/** Subscription channel for all change requests in an organization. */
export interface APIChannelOrganizationChangeRequests {
  channel: "organization-change-requests";
  organization: string;
}

export interface APIChannelSpaceComments {
  channel: "space-comments";
  space: string;
}

export interface APIChannelChangeRequestComments {
  channel: "space-change-request-comments";
  space: string;
  changeRequest: string;
}

export interface APIChannelCommentInfo {
  channel: "space-comment";
  space: string;
  comment: string;
}

export interface APIChannelCommentReplies {
  channel: "space-comment-replies";
  space: string;
  comment: string;
}

export interface APIChannelIntegration {
  channel: "integration";
  integration: string;
}

export interface APIChannelIntegrationInstallation {
  channel: "integration-installation";
  integration: string;
  installation: string;
}

export interface APIChannelIntegrationSpaceInstallation {
  channel: "integration-space-installation";
  integration: string;
  installation: string;
  space: string;
}

export interface APIChannelIntegrationSpaceInstallations {
  channel: "integration-space-installations";
  integration: string;
  installation: string;
}

export interface APIChannelIntegrationSiteInstallation {
  channel: "integration-site-installation";
  integration: string;
  installation: string;
  site: string;
}

export interface APIChannelIntegrationSiteInstallations {
  channel: "integration-site-installations";
  integration: string;
  installation: string;
}

export interface APIChannelPublishedContentSite {
  channel: "published-content-site";
  site: string;
}

export interface APIChannelSiteRedirects {
  channel: "site-redirects";
  site: string;
}

export interface APIChannelSite {
  channel: "site";
  site: string;
}

/** Subscription channel for changes in site channels. */
export interface APIChannelSiteChannels {
  channel: "site-channels";
  site: string;
}

/** Subscription channel for changes in site context. */
export interface APIChannelSiteContext {
  channel: "site-context";
  site: string;
}

export interface APIChannelSiteCustomization {
  channel: "site-customization";
  site: string;
}

export interface APIChannelSiteAgentSettings {
  channel: "site-agent-settings";
  site: string;
}

export interface APIChannelSiteIntegrations {
  channel: "site-integrations";
  site: string;
}

export interface APIChannelSiteSpace {
  channel: "site-space";
  site: string;
  siteSpace: string;
}

export interface APIChannelSiteSpaceCustomization {
  channel: "site-space-customization";
  site: string;
  siteSpace: string;
}

/** Subscription channel for changes in site structure in an organization. */
export interface APIChannelSiteStructure {
  channel: "site-structure";
  site: string;
}

export interface APIChannelSiteAdaptiveSchema {
  channel: "site-adaptive-schema";
  site: string;
}

export interface APIChannelSitePublishingAuth {
  channel: "site-publishing-auth";
  site: string;
}

/** Subscription channel for changes in share links in a site */
export interface APIChannelSiteShareLinks {
  channel: "site-share-links";
  site: string;
}

export interface APIChannelSiteShareLink {
  channel: "site-share-link";
  site: string;
  siteShareLink: string;
}

export interface APIChannelSiteMcpServers {
  channel: "site-mcp-servers";
  site: string;
}

export interface APIChannelSiteMcpServer {
  channel: "site-mcp-server";
  site: string;
  siteMcpServer: string;
}

export interface APIChannelSiteSection {
  channel: "site-section";
  site: string;
  siteSection: string;
}

export interface APIChannelCustomHostname {
  channel: "custom-hostname";
  customHostname: string;
}

export interface APIChannelGitSyncInstallation {
  channel: "git-sync-installation";
  installation: string;
}

export interface APIChannelGitSyncOperation {
  channel: "space-gitsync-operation";
  space: string;
}

export interface APIChannelGitSyncSiteOperation {
  channel: "site-gitsync-operation";
  site: string;
}

/** Subscription channel for changes in OpenAPI specification. */
export interface APIChannelOpenAPISpec {
  channel: "openapi-spec";
  openAPISpec: string;
}

export interface APIChannelSubdomain {
  channel: "subdomain";
  subdomain: string;
}

export interface APIChannelTranslation {
  channel: "translation";
  translation: string;
}

export interface APIChannelTranslationRun {
  channel: "translation-run";
  translation: string;
}

export interface APIChannelImportRun {
  channel: "import-run";
  runId: string;
}

export interface APIChannelTranslationRunData {
  channel: "translation-run";
  data: {
    /** The progress of the translation run, between 0 and 100. */
    progress: number;
    startedAt: Timestamp;
    updatedAt: Timestamp;
  };
}

export interface APIChannelImportRunData {
  channel: "import-run";
  data: ContentImportRun;
}

export interface APIChannelGitSyncOperationData {
  channel: "space-gitsync-operation";
  data: GitSyncSpaceOperation;
}

export interface APIChannelGitSyncSiteOperationData {
  channel: "site-gitsync-operation";
  data: GitSyncSiteOperation;
}

export interface APIChannelMutationData {
  channel: "*";
  /** Data passed on the channels associated to API endpoints. */
  data: {
    /** ID of the API execution that triggered the mutation. */
    executionId: string;
  };
}

export type SiteAdaptiveDeterministicJSONSchemaClaimsProperties =
  | SiteAdaptiveDeterministicJSONSchemaPrimitives
  | {
      type: "object";
      description: string;
      properties: Record<
        string,
        SiteAdaptiveDeterministicJSONSchemaClaimsProperties
      >;
      additionalProperties: false;
    };

export interface Seat {
  object: "seat";
  /** The unique ID of the organization */
  organization: string;
  /** The unique ID of the organization member */
  member: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** Payload emitted by the agent to reset the messages. */
export interface AgentStreamMessages {
  type: "messages";
  operation: "append" | "replace";
  messages: AIMessage[];
}

/** Payload emitted by the agent with a partial message. */
export interface AgentStreamMessageResponse {
  type: "message_response";
  response: AIStreamResponse;
}

/** A message waiting for the agent's current response to finish, held in the order it will be processed. The identifier addresses the entry to remove it from the queue or run it immediately. */
export interface AgentQueuedMessage {
  /** Identifier of the queue entry, unique within the conversation. */
  id: string;
  /** Input version of an AI message. */
  message: AIMessageInput;
  /**
   * When the message entered the queue.
   * @format date-time
   */
  queuedAt: string;
}

/** Describes what the agent is currently doing while processing, used to display a live activity indicator in the conversation. */
export interface AgentActivity {
  /** The kind of activity the agent is currently performing. `thinking` while it reasons or decides on a next action, `tool` while it runs a tool, and `responding` while it writes its answer. */
  type: "thinking" | "tool" | "responding";
  /** When `type` is `tool`, the name of the tool being called (matches `AIToolCall.tool`). */
  tool?: string;
  /** What to show the user instead of a label derived from `tool`, for a tool whose name means nothing to them — an MCP server's, say, where it reads "Searching documentation". */
  label?: string;
}

/** An option the user can pick when answering a question asked by the agent. */
export interface AgentQuestionOption {
  /** Short label for the option, displayed as a button and used as the answer. */
  label: string;
  /** Optional longer description to clarify what the option means. */
  description?: string;
}

/** A question the agent is waiting for the user to answer. While set, the client replaces the prompt with a choice control. The user can pick one of the options or answer with a custom free-text message; either way the answer resolves the pending tool call. */
export interface AgentPendingQuestion {
  /** ID of the tool call this question resolves, used to continue the conversation. */
  toolCallId: string;
  /** The question to display to the user. */
  question: string;
  /** The options the user can choose from. */
  options: AgentQuestionOption[];
}

/** Where the agent's content edits land. Usually a change request, which is how published content is changed; a space whose live edits are unlocked is the exception, and is edited in place. Carries identifiers only: the client resolves the change request's number and subject, or the space's title, through the API. */
export interface AgentEditTarget {
  /** The ID of the space the edits are made in. */
  spaceId: string;
  /** The ID of the change request the edits are made in. Absent when the space itself is the target, through its unlocked live edits. */
  changeRequestId?: string;
}

/** A background agent of the conversation: a child running one task on its own. Carries what a client shows about it and nothing of what it produced — the report it writes goes to the agent that started it, and its transcript is read by opening its conversation. */
export interface AgentBackgroundAgent {
  /** Identifier of the background agent within the conversation that started it. */
  id: string;
  /** The child conversation holding its transcript, which can only be read. */
  conversationId: string;
  /** A few words naming what it is doing, for a tab and a line of a transcript. */
  title: string;
  /** The task it was given. */
  task: string;
  /**
   * What became of a background agent.
   * `running` while it works, `completed` when it reported its result, `failed` when it crashed without recovering or its request was refused, and `stopped` when someone stopped it.
   */
  status: AgentBackgroundAgentStatus;
  /**
   * When it was started.
   * @format date-time
   */
  startedAt: string;
  /**
   * When it stopped running. Absent while it still runs.
   * @format date-time
   */
  finishedAt?: string;
  /** Why it failed, when it did. */
  error?: string;
}

export interface AgentState {
  status: AgentStatus;
  /** List of response suggestions for the user to select from. */
  suggestions: string[];
  /** List of messages sent by the users queued to processed. Superseded by `queue`, which carries the same messages with the identifiers needed to act on them; kept for compatibility with clients that predate it. */
  queuedMessages: AIMessageInput[];
  /** Messages waiting for the current response to finish, in the order they will be processed. */
  queue?: AgentQueuedMessage[];
  /** What the agent is currently doing. Only set while the agent is processing. */
  activity?: AgentActivity;
  /** A question the agent is waiting for the user to answer. While set, the client replaces the prompt with a choice control. */
  pendingQuestion?: AgentPendingQuestion;
  /** Where the agent currently edits content. Absent until something is attached: the organization agent starts read-only, while a change request agent always edits the change request it belongs to. */
  editTarget?: AgentEditTarget;
  /** How far this conversation should reach when it changes content. */
  editScope?: AgentEditScope;
  /** The background agents this conversation has started, oldest first. Present on every state event so a client can render each one's live status against the tool call that started it. */
  backgroundAgents?: AgentBackgroundAgent[];
  /** Whether this conversation can only be read. Set on a transcript the agent produced on its own — an agent review — which is published for its requester to consult rather than to be continued: the client shows no composer and the agent refuses a message sent to it anyway. */
  consultOnly?: boolean;
}

/** Payload emitted by the agent with its current state. */
export interface AgentStreamState {
  type: "state";
  state: AgentState;
}

/** Payload emitted by the agent is responding to a RPC call. */
export interface AgentStreamRPC {
  type: "rpc";
  message: string | object;
}

export type AgentStream =
  | AgentStreamMessages
  | AgentStreamMessageResponse
  | AgentStreamState
  | AgentStreamRPC;

/** Context available when evaluating merge rules expressions. */
export interface MergeRulesEvaluationContext {
  space: Space;
  changeRequest: ChangeRequest;
  /** The reviews posted on the change request. */
  reviews: ChangeRequestReview[];
  /** The user who is attempting to merge the change request. */
  actor: User;
}

/** Localized content reference, keyed by locale. Contains overrides for non-default languages only. */
export type LocalizedContentRef = Partial<
  Record<TranslationLanguage, ContentRef>
>;

export type RequestSpaceTrackPageView = SpaceTrackPageView;

export type RequestSiteTrackPageView = SiteTrackPageView;

export type RequestPublishIntegration = PublishIntegration;

export type RequestUpdateIntegrationInstallation =
  UpdateIntegrationInstallation;

export type RequestUpdateIntegrationSpaceInstallation =
  UpdateIntegrationSpaceInstallation;

export type RequestUpdateIntegrationSiteInstallation =
  UpdateIntegrationSiteInstallation;

export type RequestUpgradeOrganizationBilling = UpgradeOrganizationBilling;

export type RequestInviteUsersToOrganization = InviteUsersToOrganization;

export type RequestImportGitRepository = ImportGitRepository;

export type RequestExportToGitRepository = ExportToGitRepository;

export type RequestCreateSpace = CreateSpace;

export type RequestRenderIntegrationUI = RenderIntegrationUI;

export type RequestUpdateContentPublishingAuth = UpdateContentPublishingAuth;

export type RequestCreateOrganization = CreateOrganization;

export type RequestUpdateSpaceGitInfo = UpdateSpaceGitInfo;

export type RequestPurgeCDNCacheContext = PurgeCDNCacheContext;

export type DocumentTextBackgroundColor = DocumentTextColor;

export type SpaceVisitorAuth = VisitorAuth;

export type SpaceVisitorAuthCustomBackend = VisitorAuthCustomBackend;

export type SpaceVisitorAuthIntegrationBackend = VisitorAuthIntegrationBackend;

export type IngegrationPropertyTitle = IntegrationPropertyTitle;

export type UserPermissions = Index;

export type SiteRedirectDestinationSpace = SiteRedirectDestinationSiteSpace;

export type OpenAPISpecSourceURL = URL;

import { EventIterator } from "event-iterator";
import { createParser, type EventSourceMessage } from "eventsource-parser";

import { createHTTPError, HTTPStatusCode, Trace } from "@gitbook/util-debug";

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

/** Controls whether an operation returns its full representation or only response headers. */
export type ReturnPreference = "minimal" | "representation";

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** the path with its parameters left uninterpolated, for tracing */
  routeTemplate?: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** Preferred response detail for operations that support it. */
  returnPreference?: ReturnPreference;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "path" | "routeTemplate" | "cf"
>;

/** Resolves the response body from the return preference supplied to an operation. */
export type PreferredResponse<
  T,
  P extends RequestParams,
> = P["returnPreference"] extends "minimal"
  ? undefined
  : "minimal" extends P["returnPreference"]
    ? T | undefined
    : T;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
    mode: "streaming" | "request",
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "{host}/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    // @ts-ignore - `credentials` is not compatible typechecking for cloudflare workers
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any, array: boolean) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key], false);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v, true)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];

        if (property instanceof Blob) {
          formData.append(key, property);
        } else if (typeof property === "object" && property !== null) {
          formData.append(key, JSON.stringify(property));
        } else {
          formData.append(key, `${property}`);
        }
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      query: {
        ...((params1.query && params1.query) || {}),
        ...((params2 && params2.query) || {}),
      },
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E extends Error = Error>({
    body,
    secure,
    path,
    routeTemplate,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    returnPreference,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const trace = new Trace(`api.request(${routeTemplate ?? path})`);
    return trace.wrap(async () => {
      const secureParams =
        ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
          this.securityWorker &&
          (await this.securityWorker(this.securityData, "request"))) ||
        {};
      const { query: requestQuery, ...requestParams } = this.mergeRequestParams(
        params,
        secureParams,
      );
      const queryString =
        query || requestQuery
          ? this.toQueryString({ ...query, ...requestQuery })
          : undefined;
      const payloadFormatter = this.contentFormatters[type || ContentType.Json];
      let responseFormat = format || requestParams.format;

      return this.customFetch(
        `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
        {
          ...requestParams,
          headers: {
            ...(type && type !== ContentType.FormData
              ? { "Content-Type": type }
              : {}),
            ...(returnPreference
              ? { Prefer: `return=${returnPreference}` }
              : {}),
            ...(requestParams.headers || {}),
            ...trace.headers(),
          },
          signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
          body:
            typeof body === "undefined" || body === null
              ? null
              : payloadFormatter(body),
        },
      ).then(async (response) => {
        const r = response as HttpResponse<T, E>;
        r.data = null as unknown as T;
        r.error = null as unknown as E;

        const hasResponseBody =
          response.status !== 204 && response.status !== 205;
        if (!hasResponseBody) {
          r.data = undefined as unknown as T;
        }

        // GITBOOK: auto-detect the response format when the operation has no declared body.
        if (
          !responseFormat &&
          response.headers.get("content-type")?.includes("application/json")
        ) {
          responseFormat = "json";
        }

        const data =
          !hasResponseBody || !responseFormat
            ? r
            : await response[responseFormat]().then((data) => {
                if (r.ok) {
                  r.data = data;
                } else {
                  r.error = data;
                }
                trace.label("data", data ? "valid" : "none");
                return r;
              });

        if (cancelToken) {
          this.abortControllers.delete(cancelToken);
        }

        if (!response.ok) {
          // defend against TypeErrors from destructuring where there is no error object on data.
          const {
            error = {
              code: response.status || HTTPStatusCode.UnprocessableEntity,
              message: response.statusText || "Unknown error",
            },
          } = data.error ?? {};
          const httpError = createHTTPError.fromStatusCode(
            error.code,
            error.message,
          );
          // @ts-ignore - TS sometimes complains that `.entries()` is not a function
          httpError.headers = Object.fromEntries(response.headers.entries());
          // Keep the upgrade of a `feature-not-available` error.
          if ("upgrade" in error) {
            Object.assign(httpError, { upgrade: error.upgrade });
          }
          throw httpError;
        }
        return data;
      });
    });
  };

  public streamRequest = <
    T,
    // @ts-ignore - unused error type
    E = any,
  >({
    path,
    routeTemplate,
    baseUrl,
    cancelToken,
    secure,
    type,
    body,
    ...params
  }: FullRequestParams) => {
    return new EventIterator<T>((queue) => {
      const trace = new Trace(`api.streamRequest(${routeTemplate ?? path})`);
      trace.wrap(() =>
        (async () => {
          const secureParams =
            ((typeof secure === "boolean"
              ? secure
              : this.baseApiParams.secure) &&
              this.securityWorker &&
              (await this.securityWorker(this.securityData, "request"))) ||
            {};
          const requestQuery = params.query;
          const requestParams = this.mergeRequestParams(params, secureParams);
          const queryString = requestQuery
            ? this.toQueryString(requestQuery)
            : undefined;
          const payloadFormatter =
            this.contentFormatters[type || ContentType.Json];

          const response = await this.customFetch(
            `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
            {
              ...requestParams,
              headers: {
                ...(type && type !== ContentType.FormData
                  ? { "Content-Type": type }
                  : {}),
                ...(requestParams.headers || {}),
                ...trace.headers(),
              },
              body:
                typeof body === "undefined" || body === null
                  ? null
                  : payloadFormatter(body),
              signal: cancelToken
                ? this.createAbortSignal(cancelToken)
                : requestParams.signal,
            },
          );

          if (!response.ok) {
            throw new Error(`${response.status} ${response.statusText}`);
          }

          if (!response.body) {
            throw new Error("Response body is empty");
          }

          const reader = response.body.getReader();

          const stop = () => {
            reader.cancel();
            queue.stop();
          };

          const parser = createParser({
            onEvent: (event: EventSourceMessage) => {
              if (event.event === "done") {
                stop();
              } else if (event.event === "error") {
                const data = JSON.parse(event.data);
                const httpError = createHTTPError.fromStatusCode(
                  data.error.code,
                  data.error.message,
                );
                reader.cancel();
                queue.fail(httpError);
              } else {
                const data = JSON.parse(event.data);
                queue.push(data);
              }
            },
            onError: (error) => {
              reader.cancel();
              queue.fail(error);
            },
          });

          const decoder = new TextDecoder();
          while (true) {
            const { done, value } = await reader.read();

            if (value) {
              parser.feed(decoder.decode(value));
            }

            if (done) {
              break;
            }
          }

          stop();
        })().catch((error) => {
          queue.fail(error);
        }),
      );
    });
  };
}

/**
 * @title GitBook API
 * @version 0.0.1-beta
 * @termsOfService https://policies.gitbook.com
 * @baseUrl {host}/v1
 * @contact API Support <support@gitbook.com> (https://gitbook.com/support)
 *
 * The GitBook API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  system = {
    /**
     * @description Access the release version and build date of the GitBook codebase.
     *
     * @tags system
     * @name GetApiInformation
     * @summary Get API information
     * @request GET:/
     * @secure
     */
    getApiInformation: (params: RequestParams = {}) =>
      this.request<ApiInformation, any>({
        path: `/`,
        routeTemplate: "/",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * @description Returns details about the user associated with the authentication provided in the request's authorization header.
     *
     * @tags users, critical
     * @name GetAuthenticatedUser
     * @summary Get profile of authenticated user
     * @request GET:/user
     * @secure
     */
    getAuthenticatedUser: (params: RequestParams = {}) =>
      this.request<
        User,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/user`,
        routeTemplate: "/user",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, internal
     * @name GetUserTokenInfo
     * @summary Get info about the token authenticating the request
     * @request GET:/user/token-info
     * @secure
     */
    getUserTokenInfo: (params: RequestParams = {}) =>
      this.request<UserTokenInfo, any>({
        path: `/user/token-info`,
        routeTemplate: "/user/token-info",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates a JWT for the authenticated user. This token is used by the frontend notifications client to access user endpoints.
     *
     * @tags users
     * @name CreateUserNotificationsToken
     * @summary Create a JWT to access the in-app notifications service
     * @request POST:/user/notifications/token
     * @secure
     */
    createUserNotificationsToken: (params: RequestParams = {}) =>
      this.request<APITemporaryToken, any>({
        path: `/user/notifications/token`,
        routeTemplate: "/user/notifications/token",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, internal
     * @name ListApiTokens
     * @summary List API tokens for the currently authenticated user
     * @request GET:/user/tokens
     * @secure
     */
    listApiTokens: (
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: UserAPIToken[];
        },
        any
      >({
        path: `/user/tokens`,
        routeTemplate: "/user/tokens",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, internal
     * @name CreateApiToken
     * @summary Create a new API token for the currently authenticated user
     * @request POST:/user/tokens
     * @secure
     */
    createApiToken: (
      data: {
        /** The label for the API token */
        label: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserAPITokenExtended, any>({
        path: `/user/tokens`,
        routeTemplate: "/user/tokens",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, internal
     * @name DeleteApiToken
     * @summary Delete an API token for user
     * @request DELETE:/user/tokens/{tokenId}
     * @secure
     */
    deleteApiToken: (tokenId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/tokens/${tokenId}`,
        routeTemplate: "/user/tokens/{tokenId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Provides publicly available information about someone with a GitBook account.
     *
     * @tags users, critical
     * @name GetUserById
     * @summary Get a user by its ID
     * @request GET:/users/{userId}
     * @secure
     */
    getUserById: (userId: string, params: RequestParams = {}) =>
      this.request<
        User,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/users/${userId}`,
        routeTemplate: "/users/{userId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a GitBook account's details.
     *
     * @tags users, critical
     * @name UpdateUserById
     * @summary Update a user by its ID
     * @request PATCH:/users/{userId}
     * @secure
     */
    updateUserById: (
      userId: string,
      data: {
        /**
         * Full name for the user
         * @minLength 1
         * @maxLength 64
         */
        displayName?: string;
        photoURL?: URL;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        User,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/users/${userId}`,
        routeTemplate: "/users/{userId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, critical, internal
     * @name CreateIntercomMessengerToken
     * @summary Create an Intercom Messenger authentication token
     * @request POST:/internal/intercom/messenger-token
     * @secure
     */
    createIntercomMessengerToken: (params: RequestParams = {}) =>
      this.request<APIIntercomMessengerToken, any>({
        path: `/internal/intercom/messenger-token`,
        routeTemplate: "/internal/intercom/messenger-token",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, critical, internal
     * @name SyncProfileWithAuth
     * @summary Sync the user's profile in the DB with their authentication account.
     * @request POST:/internal/profile/sync
     * @secure
     */
    syncProfileWithAuth: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/internal/profile/sync`,
        routeTemplate: "/internal/profile/sync",
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  spaces = {
    /**
     * @description Returns the full metadata for a space. Use this to resolve a spaceId into a complete Space object. If you only need content, use the content endpoint instead.
     *
     * @tags spaces, critical
     * @name GetSpaceById
     * @summary Get full details of a space by its ID
     * @request GET:/spaces/{spaceId}
     * @secure
     */
    getSpaceById: (
      spaceId: EntityId,
      query?: {
        /** For sites published via share-links, the share key is useful to resolve published URLs. */
        shareKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Space, any>({
        path: `/spaces/${spaceId}`,
        routeTemplate: "/spaces/{spaceId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a space's metadata and settings. To update page content, use the change-request workflow instead.
     *
     * @tags spaces
     * @name UpdateSpaceById
     * @summary Update a space's title, icon, or settings
     * @request PATCH:/spaces/{spaceId}
     * @secure
     */
    updateSpaceById: (
      spaceId: EntityId,
      data: {
        /**
         * Determines how a Space can be edited.
         * * `live`: Users can directly edit the space
         * * `locked`: All edits are locked for this space.
         */
        editMode?: SpaceEditMode;
        /** Title of the space */
        title?: SpaceTitle;
        /** Default level for a piece of content */
        defaultLevel?: DefaultLevel;
        language?: TranslationLanguage;
        mergeRules?: MergeRulesSpaceConfiguration;
      } & (
        | {
            /** Unicode codepoint or character of the emoji */
            emoji: Emoji;
          }
        | {
            icon: URL;
          }
        | {
            emoji?: null;
            icon?: null;
          }
      ),
      params: RequestParams = {},
    ) =>
      this.request<Space, any>({
        path: `/spaces/${spaceId}`,
        routeTemplate: "/spaces/{spaceId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deleted spaces will be permanently removed after 7 days.
     *
     * @tags spaces
     * @name DeleteSpaceById
     * @summary Delete a space
     * @request DELETE:/spaces/{spaceId}
     * @secure
     */
    deleteSpaceById: (spaceId: EntityId, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}`,
        routeTemplate: "/spaces/{spaceId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Creates a new space that is a complete copy of the specified space, including all pages and their content. The duplicate is created in the same organization. It does not preserve or create a placement in a site. When duplicating from a site context, use duplicateSiteSpace instead. Use this operation for an organization-level or orphan-space copy.
     *
     * @tags spaces
     * @name DuplicateSpace
     * @summary Create a full copy of a space
     * @request POST:/spaces/{spaceId}/duplicate
     * @secure
     */
    duplicateSpace: (spaceId: EntityId, params: RequestParams = {}) =>
      this.request<Space, any>({
        path: `/spaces/${spaceId}/duplicate`,
        routeTemplate: "/spaces/{spaceId}/duplicate",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Restores a previously deleted space, making it active again. Only spaces deleted within the last 7 days can be restored; after that they are permanently removed. Returns the restored space object. To delete a space, use the space delete endpoint.
     *
     * @tags spaces
     * @name RestoreSpace
     * @summary Restore a recently deleted space from the trash
     * @request POST:/spaces/{spaceId}/restore
     * @secure
     */
    restoreSpace: (spaceId: EntityId, params: RequestParams = {}) =>
      this.request<Space, any>({
        path: `/spaces/${spaceId}/restore`,
        routeTemplate: "/spaces/{spaceId}/restore",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Moves a space to a new parent collection and/or a new position within the hierarchy.
     *
     * @tags spaces
     * @name MoveSpace
     * @summary Move a space to a different collection or position
     * @request POST:/spaces/{spaceId}/move
     * @secure
     */
    moveSpace: (
      spaceId: EntityId,
      data: {
        /** The unique id of the parent collection */
        parent?: string | null;
        /** Where to move the space. By default, it will be moved at the end. */
        position?: ContentPosition;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Space,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/spaces/${spaceId}/move`,
        routeTemplate: "/spaces/{spaceId}/move",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of all spaces belonging to the organization. A space is a collection of documentation pages with its own content tree and revision history. Use this to discover spaces before reading their content, adding them to a site, or performing operations on specific spaces.
     *
     * @tags spaces
     * @name ListSpacesInOrganizationById
     * @summary List all spaces in an organization
     * @request GET:/orgs/{organizationId}/spaces
     * @secure
     */
    listSpacesInOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Space[];
        },
        any
      >({
        path: `/orgs/${organizationId}/spaces`,
        routeTemplate: "/orgs/{organizationId}/spaces",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new space within the organization. A space is the primary container for documentation content, holding pages, files, and revisions. After creation, add the space to a site to make it publicly accessible, or start adding content directly via the space content endpoints.
     *
     * @tags spaces
     * @name CreateSpace
     * @summary Create a new documentation space in an organization
     * @request POST:/orgs/{organizationId}/spaces
     * @secure
     */
    createSpace: (
      organizationId: EntityId,
      data: CreateSpace,
      params: RequestParams = {},
    ) =>
      this.request<Space, any>({
        path: `/orgs/${organizationId}/spaces`,
        routeTemplate: "/orgs/{organizationId}/spaces",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  spaceEmbeds = {
    /**
     * @description Resolves an external URL to an oEmbed representation (title, thumbnail, HTML snippet) within the context of a space. Use this to preview or embed third-party content referenced in a space's pages. Requires the URL as a query parameter.
     *
     * @tags space-embeds
     * @name GetEmbedByUrlInSpace
     * @summary Resolve a URL to an oEmbed object within a space
     * @request GET:/spaces/{spaceId}/embed
     * @secure
     */
    getEmbedByUrlInSpace: (
      spaceId: EntityId,
      query: {
        /** URL to resolve */
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Embed, any>({
        path: `/spaces/${spaceId}/embed`,
        routeTemplate: "/spaces/{spaceId}/embed",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  spaceContent = {
    /**
     * @description Searches the full text of all published pages in a space and returns matching pages with ranked excerpts. Use this to find pages by topic or keyword within a specific space. For site-wide search across all spaces in a site, use the site search endpoint instead.
     *
     * @tags space-content
     * @name SearchSpaceContent
     * @summary Full-text search across all pages in a space
     * @request GET:/spaces/{spaceId}/search
     * @secure
     */
    searchSpaceContent: (
      spaceId: EntityId,
      query: {
        /** @maxLength 512 */
        query: string;
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SearchPageResult[];
        },
        any
      >({
        path: `/spaces/${spaceId}/search`,
        routeTemplate: "/spaces/{spaceId}/search",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the live published revision of a space, which includes the full page tree structure and associated files. Use this to inspect the currently published content state of a space. For in-progress edits, use the change-request content endpoint instead.
     *
     * @tags space-content
     * @name GetCurrentRevision
     * @summary Get the current published content revision of a space
     * @request GET:/spaces/{spaceId}/content
     * @secure
     */
    getCurrentRevision: (
      spaceId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Revision, any>({
        path: `/spaces/${spaceId}/content`,
        routeTemplate: "/spaces/{spaceId}/content",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Populates a space with pages and structure from a specified template, bootstrapping it with a standard documentation layout. Use this to initialise a new space rather than creating pages manually. Optionally apply the template to a specific change request instead of main content by providing the changeRequestId field.
     *
     * @tags space-content
     * @name ApplyTemplateToSpace
     * @summary Apply a content template to populate a space with initial pages
     * @request POST:/spaces/{spaceId}/content/template
     * @secure
     */
    applyTemplateToSpace: (
      spaceId: EntityId,
      data: ApplySpaceTemplate & {
        /** The ID of the change request to apply the template to. If not provided, the template is applied to the main content. */
        changeRequestId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/content/template`,
        routeTemplate: "/spaces/{spaceId}/content/template",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the complete list of all pages in a space's current revision, including their titles, URL paths, and parent-child relationships. Use this to understand the full content structure of a space or build navigation. For the content of a single page, use getPageById or getPageByPath instead.
     *
     * @tags space-content
     * @name ListPages
     * @summary List all pages in a space with their hierarchy and metadata
     * @request GET:/spaces/{spaceId}/content/pages
     * @secure
     */
    listPages: (
      spaceId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          pages: RevisionPage[];
        },
        any
      >({
        path: `/spaces/${spaceId}/content/pages`,
        routeTemplate: "/spaces/{spaceId}/content/pages",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of all files (images, attachments, and other assets) uploaded to a space's current revision. Use this to discover available assets or audit file usage across a space.
     *
     * @tags space-content
     * @name ListFiles
     * @summary List all uploaded files and assets in a space
     * @request GET:/spaces/{spaceId}/content/files
     * @secure
     */
    listFiles: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: RevisionFile[];
        },
        any
      >({
        path: `/spaces/${spaceId}/content/files`,
        routeTemplate: "/spaces/{spaceId}/content/files",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves metadata and download URL for a single file (image, attachment, or other asset) in a space's current revision by its file ID. Use this when you have a specific file ID and need its URL, MIME type, or other metadata.
     *
     * @tags space-content
     * @name GetFileById
     * @summary Get a specific uploaded file from a space by its ID
     * @request GET:/spaces/{spaceId}/content/files/{fileId}
     * @secure
     */
    getFileById: (
      spaceId: EntityId,
      fileId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionFile, any>({
        path: `/spaces/${spaceId}/content/files/${fileId}`,
        routeTemplate: "/spaces/{spaceId}/content/files/{fileId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a page's metadata, content, and document structure from a space's current revision by its page ID. Use this when you know the exact page ID and need its content or path. For lookup by URL path, use the content/path endpoint instead.
     *
     * @tags space-content
     * @name GetPageById
     * @summary Get a single page from a space by its ID
     * @request GET:/spaces/{spaceId}/content/page/{pageId}
     * @secure
     */
    getPageById: (
      spaceId: EntityId,
      pageId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
         *
         * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
         * - `stable`: Format content references as stable idempotent refs containing their identifiers.
         * @default "relative"
         */
        "format.markdown.refs"?: "relative" | "stable";
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionPage, any>({
        path: `/spaces/${spaceId}/content/page/${pageId}`,
        routeTemplate: "/spaces/{spaceId}/content/page/{pageId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns structural navigation metadata for a page, including references to the previous page, next page, and parent page within the space's hierarchy. Use this to implement or inspect linear navigation flows in a docs site without fetching the full page tree.
     *
     * @tags space-content
     * @name ListSpacePageMetaLinks
     * @summary Get navigation metadata links for a page (previous, next, parent)
     * @request GET:/spaces/{spaceId}/content/page/{pageId}/meta-links
     * @secure
     */
    listSpacePageMetaLinks: (
      spaceId: EntityId,
      pageId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<RevisionPageMetaLinks, any>({
        path: `/spaces/${spaceId}/content/page/${pageId}/meta-links`,
        routeTemplate: "/spaces/{spaceId}/content/page/{pageId}/meta-links",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a page by its URL path (e.g. /guides/getting-started) from the space's current revision. Use this when you have a page's path rather than its ID. Returns either a document page or a group/section page depending on the path.
     *
     * @tags space-content
     * @name GetPageByPath
     * @summary Get a page from a space by its URL path
     * @request GET:/spaces/{spaceId}/content/path/{pagePath}
     * @secure
     */
    getPageByPath: (
      spaceId: EntityId,
      pagePath: string,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
         *
         * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
         * - `stable`: Format content references as stable idempotent refs containing their identifiers.
         * @default "relative"
         */
        "format.markdown.refs"?: "relative" | "stable";
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `true` is passed, mutable Git metadata may be served from a cache.
         * @default false
         */
        cachedMetadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionPageDocument | RevisionPageGroup, any>({
        path: `/spaces/${spaceId}/content/path/${pagePath}`,
        routeTemplate: "/spaces/{spaceId}/content/path/{pagePath}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a reusable content block (a shared snippet that can be embedded across multiple pages) from a space's current revision by its ID. Use this to read the content of a reusable block when you have its ID.
     *
     * @tags space-content
     * @name GetReusableContentById
     * @summary Get a reusable content block from a space by its ID
     * @request GET:/spaces/{spaceId}/content/reusable-contents/{reusableContentId}
     * @secure
     */
    getReusableContentById: (
      spaceId: EntityId,
      reusableContentId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionReusableContent, any>({
        path: `/spaces/${spaceId}/content/reusable-contents/${reusableContentId}`,
        routeTemplate:
          "/spaces/{spaceId}/content/reusable-contents/{reusableContentId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Server-renders a document from a provided content source definition, evaluating template expressions and resolving variables to produce a fully computed document. Use this to preview how dynamic content will look without publishing a full revision.
     *
     * @tags space-content
     * @name GetComputedDocument
     * @summary Compute and render a document from a structured content source
     * @request POST:/spaces/{spaceId}/content/computed/document
     * @secure
     */
    getComputedDocument: (
      spaceId: EntityId,
      data: {
        source: ComputedContentSourceDocument;
        /** Seed to use for the generation of IDs. */
        seed: string;
      },
      query?: {
        /** Version of the schema used for the document. */
        schema?: "current" | "next";
      },
      params: RequestParams = {},
    ) =>
      this.request<JSONDocument, any>({
        path: `/spaces/${spaceId}/content/computed/document`,
        routeTemplate: "/spaces/{spaceId}/content/computed/document",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Server-renders an entire revision — pages, files, and reusable contents — from a provided content source definition, resolving all template expressions and variables. Use this to evaluate and preview computed content before publishing. Returns the full set of pages and files with all dynamic content fully resolved.
     *
     * @tags space-content
     * @name GetComputedRevision
     * @summary Compute and render a full revision from a structured content source
     * @request POST:/spaces/{spaceId}/content/computed/revision
     * @secure
     */
    getComputedRevision: (
      spaceId: EntityId,
      data: {
        source: ComputedContentSourceRevision;
        /** Seed to use for the generation of IDs. */
        seed: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          pages: RevisionPage[];
          files: RevisionFile[];
          reusableContents: RevisionReusableContent[];
        },
        any
      >({
        path: `/spaces/${spaceId}/content/computed/revision`,
        routeTemplate: "/spaces/{spaceId}/content/computed/revision",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the structured JSON document for a specific document ID within a space. Documents are the low-level block-based representation of page content. Use this when you have a documentId and need the raw block structure. To retrieve a page's document by pageId, use the page document endpoint instead.
     *
     * @tags space-content
     * @name GetDocumentById
     * @summary Get a raw document from a space by its document ID
     * @request GET:/spaces/{spaceId}/documents/{documentId}
     * @secure
     */
    getDocumentById: (
      spaceId: EntityId,
      documentId: string,
      query?: {
        /** Version of the schema used for the document. */
        schema?: "current" | "next";
      },
      params: RequestParams = {},
    ) =>
      this.request<JSONDocument, any>({
        path: `/spaces/${spaceId}/documents/${documentId}`,
        routeTemplate: "/spaces/{spaceId}/documents/{documentId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a specific revision snapshot of a space by its revision ID, including the page tree structure and revision metadata. Use this to inspect a historical state of a space. To access the current live content, use the space content endpoint instead.
     *
     * @tags space-content
     * @name GetRevisionById
     * @summary Get a specific historical revision of a space
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}
     * @secure
     */
    getRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Revision, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}`,
        routeTemplate: "/spaces/{spaceId}/revisions/{revisionId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a structured diff of the semantic changes introduced by a revision compared to its parent revision, such as added, removed, or updated pages and blocks. Use this to understand what changed in a specific revision.
     *
     * @tags space-content
     * @name GetRevisionSemanticChanges
     * @summary Get semantic content changes introduced by a revision
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/changes
     * @secure
     */
    getRevisionSemanticChanges: (
      spaceId: EntityId,
      revisionId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
        /**
         * Limit the number of changes returned
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionSemanticChanges, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/changes`,
        routeTemplate: "/spaces/{spaceId}/revisions/{revisionId}/changes",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the full flat list of all pages (document pages and group pages) in a specific historical revision of a space. Use this to inspect the complete page tree of a past snapshot. For the current live content pages, use the space content pages endpoint.
     *
     * @tags space-content
     * @name ListPagesInRevisionById
     * @summary List all pages in a specific historical revision of a space
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/pages
     * @secure
     */
    listPagesInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          pages: RevisionPage[];
        },
        any
      >({
        path: `/spaces/${spaceId}/revisions/${revisionId}/pages`,
        routeTemplate: "/spaces/{spaceId}/revisions/{revisionId}/pages",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of files (images and other binary assets) attached to a specific revision of a space. Use this to enumerate all media assets present in a historical snapshot. To get a single file, use the revision file by ID endpoint.
     *
     * @tags space-content
     * @name ListFilesInRevisionById
     * @summary List all files (images, assets) in a specific space revision
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/files
     * @secure
     */
    listFilesInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: RevisionFile[];
        },
        any
      >({
        path: `/spaces/${spaceId}/revisions/${revisionId}/files`,
        routeTemplate: "/spaces/{spaceId}/revisions/{revisionId}/files",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the metadata for a single file (image or binary asset) within a specific revision of a space. Use this to retrieve download URL, MIME type, and dimensions for a known file ID. To list all files in a revision, use the revision files list endpoint.
     *
     * @tags space-content
     * @name GetFileInRevisionById
     * @summary Get a specific file from a space revision by its file ID
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/files/{fileId}
     * @secure
     */
    getFileInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      fileId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionFile, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/files/${fileId}`,
        routeTemplate:
          "/spaces/{spaceId}/revisions/{revisionId}/files/{fileId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the full page object (metadata and optionally document content) for a specific page within a historical revision. Use documentFormat to control whether content is returned as blocks or markdown. To get a page from the current live revision, use the space content page endpoint.
     *
     * @tags space-content
     * @name GetPageInRevisionById
     * @summary Get a page from a specific historical revision by its page ID
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}
     * @secure
     */
    getPageInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      pageId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
         *
         * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
         * - `stable`: Format content references as stable idempotent refs containing their identifiers.
         * @default "relative"
         */
        "format.markdown.refs"?: "relative" | "stable";
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionPage, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/page/${pageId}`,
        routeTemplate: "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the structured JSON document (block tree) for a specific page within a historical revision of a space. Use this when you need the low-level block representation of historical page content. For the current live content, use the space content page document endpoint.
     *
     * @tags space-content
     * @name GetPageDocumentInRevisionById
     * @summary Get the raw document body of a page in a historical revision
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/document
     * @secure
     */
    getPageDocumentInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      pageId: EntityId,
      query?: {
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
      },
      params: RequestParams = {},
    ) =>
      this.request<JSONDocument, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/page/${pageId}/document`,
        routeTemplate:
          "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/document",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a page from a historical revision looked up by its URL path (e.g. "getting-started/installation") rather than its ID. Useful when you know the page path but not the ID. Use documentFormat to control whether content is returned as blocks or markdown. For the current live revision, use the content path endpoint.
     *
     * @tags space-content
     * @name GetPageInRevisionByPath
     * @summary Get a page from a specific historical revision by its URL path
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/path/{pagePath}
     * @secure
     */
    getPageInRevisionByPath: (
      spaceId: EntityId,
      revisionId: EntityId,
      pagePath: string,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
         *
         * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
         * - `stable`: Format content references as stable idempotent refs containing their identifiers.
         * @default "relative"
         */
        "format.markdown.refs"?: "relative" | "stable";
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `true` is passed, mutable Git metadata may be served from a cache.
         * @default false
         */
        cachedMetadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionPageDocument | RevisionPageGroup, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/path/${pagePath}`,
        routeTemplate:
          "/spaces/{spaceId}/revisions/{revisionId}/path/{pagePath}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the meta navigation links for a specific page within a historical revision, including the previous and next page in the space's reading order. Use this to implement sequential navigation across historical content or to build a reading flow for a specific revision.
     *
     * @tags space-content
     * @name ListRevisionPageMetaLinks
     * @summary List all meta links (prev/next navigation) for a page in a revision
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/meta-links
     * @secure
     */
    listRevisionPageMetaLinks: (
      spaceId: EntityId,
      revisionId: EntityId,
      pageId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<RevisionPageMetaLinks, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/page/${pageId}/meta-links`,
        routeTemplate:
          "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/meta-links",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns metadata for a specific reusable content block within a historical revision of a space. Reusable content blocks are shared content snippets referenced across multiple pages. To get the actual document body of the reusable content, use the reusable content document endpoint.
     *
     * @tags space-content
     * @name GetReusableContentInRevisionById
     * @summary Get a reusable content block from a historical revision by its ID
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}
     * @secure
     */
    getReusableContentInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      reusableContentId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionReusableContent, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/reusable-contents/${reusableContentId}`,
        routeTemplate:
          "/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the structured JSON document (block tree) for a reusable content block within a specific historical revision of a space. Use this to read the actual content of a shared snippet at a point in time. For the metadata, use the reusable content by ID endpoint.
     *
     * @tags space-content
     * @name GetReusableContentDocumentInRevisionById
     * @summary Get the document body of a reusable content block in a historical revision
     * @request GET:/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}/document
     * @secure
     */
    getReusableContentDocumentInRevisionById: (
      spaceId: EntityId,
      revisionId: EntityId,
      reusableContentId: EntityId,
      query?: {
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
      },
      params: RequestParams = {},
    ) =>
      this.request<JSONDocument, any>({
        path: `/spaces/${spaceId}/revisions/${revisionId}/reusable-contents/${reusableContentId}/document`,
        routeTemplate:
          "/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}/document",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a short-lived URL (valid for 1 hour) to download the space's content as a PDF file.
     *
     * @tags space-content
     * @name GetSpacePdf
     * @summary Get a temporary URL to download a space or page as PDF
     * @request GET:/spaces/{spaceId}/pdf
     * @secure
     */
    getSpacePdf: (
      spaceId: EntityId,
      query?: {
        /** Generate a PDF only for the provided page. */
        only?: boolean;
        /** ID of a specific page to generate a PDF for. */
        page?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Temporary URL to print the content. The URL will work for 1h. */
          url: URL;
        },
        any
      >({
        path: `/spaces/${spaceId}/pdf`,
        routeTemplate: "/spaces/{spaceId}/pdf",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  spaceGit = {
    /**
     * @description Triggers an import from provided Git repository into the space, updating the space's content to match the repository (if not standalone). This is an async operation — it runs in the background after the request returns 204.
     *
     * @tags space-git
     * @name ImportGitRepository
     * @summary Pull content into a space from a connected Git repository
     * @request POST:/spaces/{spaceId}/git/import
     * @secure
     */
    importGitRepository: (
      spaceId: EntityId,
      data: ImportGitRepository,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/git/import`,
        routeTemplate: "/spaces/{spaceId}/git/import",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Triggers an export of the space's current content to the provided Git repository. This is an async operation — the export runs in the background after the request returns 204.
     *
     * @tags space-git
     * @name ExportToGitRepository
     * @summary Push space content to a connected Git repository
     * @request POST:/spaces/{spaceId}/git/export
     * @secure
     */
    exportToGitRepository: (
      spaceId: EntityId,
      data: ExportToGitRepository,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/git/export`,
        routeTemplate: "/spaces/{spaceId}/git/export",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns metadata about the Git Sync provider connected to the space. Returns 404 if no Git provider is configured. Use this to check sync state before triggering an import or export.
     *
     * @tags space-git
     * @name GetSpaceGitInfo
     * @summary Get the Git Sync configuration and status for a space
     * @request GET:/spaces/{spaceId}/git/info
     * @secure
     */
    getSpaceGitInfo: (spaceId: EntityId, params: RequestParams = {}) =>
      this.request<
        GitSyncState,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/git/info`,
        routeTemplate: "/spaces/{spaceId}/git/info",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  spacePermissions = {
    /**
     * No description
     *
     * @tags space-permissions
     * @name InviteToSpace
     * @summary Invite a user or a team to a space
     * @request POST:/spaces/{spaceId}/permissions
     * @secure
     */
    inviteToSpace: (
      spaceId: EntityId,
      data: InviteUsersAndTeams,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/permissions`,
        routeTemplate: "/spaces/{spaceId}/permissions",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name UpdateTeamPermissionInSpace
     * @summary Update an org team's permission in a space
     * @request PATCH:/spaces/{spaceId}/permissions/teams/{teamId}
     * @secure
     */
    updateTeamPermissionInSpace: (
      spaceId: EntityId,
      teamId: EntityId,
      data: {
        /** The role of a member in an organization, null for guests */
        role?: MemberRoleOrGuest;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/permissions/teams/${teamId}`,
        routeTemplate: "/spaces/{spaceId}/permissions/teams/{teamId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name RemoveTeamFromSpace
     * @summary Remove an org team from a space
     * @request DELETE:/spaces/{spaceId}/permissions/teams/{teamId}
     * @secure
     */
    removeTeamFromSpace: (
      spaceId: EntityId,
      teamId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/permissions/teams/${teamId}`,
        routeTemplate: "/spaces/{spaceId}/permissions/teams/{teamId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name ListUserPermissionsInSpace
     * @summary List space user permissions
     * @request GET:/spaces/{spaceId}/permissions/users
     * @secure
     */
    listUserPermissionsInSpace: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: UserContentPermission[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/permissions/users`,
        routeTemplate: "/spaces/{spaceId}/permissions/users",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name UpdateUserPermissionInSpace
     * @summary Update space user permissions
     * @request PATCH:/spaces/{spaceId}/permissions/users/{userId}
     * @secure
     */
    updateUserPermissionInSpace: (
      spaceId: EntityId,
      userId: string,
      data: {
        /** The role of a member in an organization, null for guests */
        role?: MemberRoleOrGuest;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/permissions/users/${userId}`,
        routeTemplate: "/spaces/{spaceId}/permissions/users/{userId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name RemoveUserFromSpace
     * @summary Remove a space user
     * @request DELETE:/spaces/{spaceId}/permissions/users/{userId}
     * @secure
     */
    removeUserFromSpace: (
      spaceId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/permissions/users/${userId}`,
        routeTemplate: "/spaces/{spaceId}/permissions/users/{userId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name ListTeamPermissionsInSpace
     * @summary List an org team's permission in a space
     * @request GET:/spaces/{spaceId}/permissions/teams
     * @secure
     */
    listTeamPermissionsInSpace: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: {
            /**
             * "The role of a member in an organization.
             * "admin": Can administrate the content: create, delete spaces, ...
             * "create": Can create content.
             * "review": Can review content.
             * "edit": Can edit the content (live or change requests).
             * "comment": Can access the content and its discussions.
             * "read": Can access the content, but cannot update it in any way.
             */
            permission: MemberRole;
            team: OrganizationTeam;
          }[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/permissions/teams`,
        routeTemplate: "/spaces/{spaceId}/permissions/teams",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name ListPermissionsAggregateInSpace
     * @summary List all space users permissions
     * @request GET:/spaces/{spaceId}/permissions/aggregate
     * @secure
     */
    listPermissionsAggregateInSpace: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** If defined, only members with this role will be returned. */
        role?: MemberRole;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: UserContentPermission[];
        },
        any
      >({
        path: `/spaces/${spaceId}/permissions/aggregate`,
        routeTemplate: "/spaces/{spaceId}/permissions/aggregate",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-permissions
     * @name ListPermissionsAggregateInCollection
     * @summary List all collections users permissions
     * @request GET:/collections/{collectionId}/permissions/aggregate
     * @secure
     */
    listPermissionsAggregateInCollection: (
      collectionId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** If defined, only members with this role will be returned. */
        role?: MemberRole;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: UserContentPermission[];
        },
        any
      >({
        path: `/collections/${collectionId}/permissions/aggregate`,
        routeTemplate: "/collections/{collectionId}/permissions/aggregate",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  changeRequests = {
    /**
     * @description Creates a new change request, which is a draft working copy of the space's content — similar to a Git branch or pull request. Use this before making content edits to avoid modifying the live published content directly. Optionally supply a subject and a template to pre-populate the change request with content. Once created, use the change-request content endpoints to read and modify pages within the draft, then merge it when ready. Pass `siteFindingIds` to link the documentation findings this change request fixes. Outbound broken links are resolved by the outbound checker, rather than by merging.
     *
     * @tags change-requests
     * @name CreateChangeRequest
     * @summary Create a new change request in a space
     * @request POST:/spaces/{spaceId}/change-requests
     * @secure
     */
    createChangeRequest: (
      spaceId: EntityId,
      data: {
        /** Subject of the change request */
        subject?: string;
        /** Template to apply to the change request */
        template?: ApplySpaceTemplate;
        /** Description of the change request, explaining what it changes and why, for whoever reviews it. Only paragraphs and lists are kept; other blocks are stripped along with their text. */
        description?: JSONDocument;
        /**
         * The site finding this change request fixes. Use `siteFindingIds` instead. The finding's site must contain this space.
         * @deprecated
         */
        siteFindingId?: string;
        /**
         * Site findings this change request fixes. Each finding's site must contain this space, and the caller must have edit permission on each site. Takes precedence over `siteFindingId` when both are supplied.
         * @maxItems 25
         */
        siteFindingIds?: string[];
        [key: string]: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangeRequest, any>({
        path: `/spaces/${spaceId}/change-requests`,
        routeTemplate: "/spaces/{spaceId}/change-requests",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of change requests for the given space. Use this to discover existing change requests before creating a new one, or to find change requests assigned to a specific user for review.
     *
     * @tags change-requests
     * @name ListChangeRequestsForSpace
     * @summary List all change requests for a space
     * @request GET:/spaces/{spaceId}/change-requests
     * @secure
     */
    listChangeRequestsForSpace: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If defined, only change requests matching this status will be returned.
         * @default "open"
         */
        status?: ChangeRequestStatus;
        /** If defined, only change requests created by this user will be returned. */
        creator?: string;
        /** If defined, only change requests with contributions from this user will be returned. */
        contributor?: string;
        /** If defined, only change requests with a requested reviewer for this user will be returned. */
        requestedReviewer?: string;
        /** If defined, only change requests linked to this site topic will be returned. */
        topic?: string;
        /** The field to sort change requests by. Defaults to 'updatedAt'. */
        orderBy?: ChangeRequestOrderBy;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ChangeRequest[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests`,
        routeTemplate: "/spaces/{spaceId}/change-requests",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the full details of a single change request, including its status, subject, description, and metadata. Use this to check the current state of a change request before deciding to merge, update, or request a review.
     *
     * @tags change-requests
     * @name GetChangeRequestById
     * @summary Get a change request by its ID
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}
     * @secure
     */
    getChangeRequestById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        ChangeRequest,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}`,
        routeTemplate: "/spaces/{spaceId}/change-requests/{changeRequestId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the metadata of a change request. Use this to rename a change request, add context before requesting a review, or change the workflow status without merging. To update page content within the change request, use the content endpoint instead. Set `siteFindingIds` to replace the documentation findings linked to the change request. Outbound broken links are resolved by the outbound checker, rather than by merging.
     *
     * @tags change-requests
     * @name UpdateChangeRequestById
     * @summary Update a change request's subject, description, or status
     * @request PATCH:/spaces/{spaceId}/change-requests/{changeRequestId}
     * @secure
     */
    updateChangeRequestById: <TRequestParams extends RequestParams = {}>(
      spaceId: EntityId,
      changeRequestId: EntityId,
      data: {
        /** Subject of the change request */
        subject?: ChangeRequestSubject;
        description?: JSONDocument;
        /**
         * External links associated with the change request.
         * @maxItems 10
         */
        links?: ChangeRequestLinkInput[];
        status?: "draft" | "open" | "archived";
        /**
         * The site finding this change request fixes. Use `siteFindingIds` instead. The finding's site must contain this space. Replaces the whole set of linked findings with this finding. Pass null to unlink all findings.
         * @deprecated
         */
        siteFindingId?: string | null;
        /**
         * Replaces the linked site findings. Each finding's site must contain this space, and the caller must have edit permission on each site. Pass null or an empty list to unlink all findings. Omit to keep the current links. Takes precedence over `siteFindingId` when both are supplied.
         * @maxItems 25
         */
        siteFindingIds?: string[] | null;
      },
      params?: TRequestParams,
    ) =>
      this.request<PreferredResponse<ChangeRequest, TRequestParams>, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}`,
        routeTemplate: "/spaces/{spaceId}/change-requests/{changeRequestId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Merges the change request's draft content into the space's primary (published) content, making all changes live. If the result is "conflicts", the merge was still applied but the space may need manual conflict resolution. Consider running updateChangeRequest first to sync with the latest live content and reduce conflicts.
     *
     * @tags change-requests
     * @name MergeChangeRequest
     * @summary Merge a change request into the space's live content
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/merge
     * @secure
     */
    mergeChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** ID of the resulting revision */
          revision: string;
          result: "merge" | "conflicts";
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/merge`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/merge",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Rebases the change request onto the latest primary revision of the space, pulling in any changes that were merged to the live space since this change request was created. Run this before merging to minimise conflicts, especially if the change request has been open for a while.
     *
     * @tags change-requests
     * @name UpdateChangeRequest
     * @summary Sync a change request with the latest live space content
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/update
     * @secure
     */
    updateChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** ID of the resulting revision */
          revision: string;
          result: "update" | "conflicts";
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/update`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/update",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates a temporary URL (valid for 1 hour) to download the change request's draft content as a PDF. Optionally scope the export to a single page using the page and only parameters. Use this to share or archive the draft content before merging.
     *
     * @tags change-requests
     * @name GetChangeRequestPdf
     * @summary Get a temporary URL to download a change request's content as PDF
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/pdf
     * @secure
     */
    getChangeRequestPdf: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Generate a PDF only for the provided page. */
        only?: boolean;
        /** ID of a specific page to generate a PDF for. */
        page?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Temporary URL to print the content. The URL will work for 1h. */
          url: URL;
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/pdf`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/pdf",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of change requests across all spaces in the organization. Use this for an organization-wide view of open drafts — for example, to find all change requests needing a specific reviewer's attention. For a single space's change requests, use the space-scoped endpoint instead.
     *
     * @tags change-requests
     * @name ListChangeRequestsForOrganization
     * @summary List all change requests across an entire organization
     * @request GET:/orgs/{organizationId}/change-requests
     * @secure
     */
    listChangeRequestsForOrganization: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If defined, only change requests matching the statuses will be returned.
         * @default ["open"]
         */
        status?: ChangeRequestStatus[];
        /** If defined, only change requests created by this user will be returned. */
        creator?: string;
        /** If defined, only change requests with contributions from this user will be returned. */
        contributor?: string;
        /** If defined, only change requests with a requested reviewer for this user will be returned. */
        requestedReviewer?: string;
        /** If defined, only change requests linked to this site will be returned. */
        site?: string;
        /** If defined, only change requests from this space will be returned. */
        space?: string;
        /** If defined, only change requests linked to this site topic will be returned. */
        topic?: string;
        /** If defined, only change requests opened by this style guide check run will be returned. */
        styleguideRun?: string;
        /** Controls whether change requests from triage are included. Pass `none` to exclude change requests from triage, or `all` to include them. Default is `none`. */
        finding?: "none" | "all";
        /** The field to sort change requests by. Defaults to 'updatedAt'. */
        orderBy?: ChangeRequestOrderBy;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ChangeRequest[];
        },
        any
      >({
        path: `/orgs/${organizationId}/change-requests`,
        routeTemplate: "/orgs/{organizationId}/change-requests",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  changeRequestsReviews = {
    /**
     * @description Returns a paginated list of reviews submitted for the change request. Use this to check the current review status and whether all requested reviewers have responded before merging.
     *
     * @tags change-requests-reviews
     * @name GetReviewsByChangeRequestId
     * @summary List all formal reviews submitted for a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews
     * @secure
     */
    getReviewsByChangeRequestId: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /** Filter reviews marked as outdated. */
        outdated?: boolean;
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ChangeRequestReview[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/reviews`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Submits a formal review decision (approved or changes-requested) on the change request, optionally with a rich-text comment. Use this to complete a review you were requested to perform. Only users who are requested reviewers or have space review permissions can submit a review.
     *
     * @tags change-requests-reviews
     * @name SubmitChangeRequestReview
     * @summary Submit an approve or request-changes review for a change request
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews
     * @secure
     */
    submitChangeRequestReview: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      data: {
        /** The status of the submitted review. */
        status: ChangeRequestReviewStatus;
        /** Optionally, provide a comment along with the review. */
        comment?: Document;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangeRequestReview, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/reviews`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns how many reviews were approved and how many requested changes, for the same reviews the list endpoint returns under the same filters. Use this to summarise where a change request stands without paginating through every review.
     *
     * @tags change-requests-reviews
     * @name GetReviewStatsByChangeRequestId
     * @summary Get review totals for a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/stats
     * @secure
     */
    getReviewStatsByChangeRequestId: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Filter reviews marked as outdated. */
        outdated?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ChangeRequestReviewStats,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/reviews/stats`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/stats",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the full details of a single review submission on a change request, including the decision status (approved/changes-requested), reviewer, and any attached comment. Use this when you have a review ID and need its full details.
     *
     * @tags change-requests-reviews
     * @name GetChangeRequestReviewById
     * @summary Get a specific review on a change request by its ID
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/{reviewId}
     * @secure
     */
    getChangeRequestReviewById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      reviewId: string,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ChangeRequestReview,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/reviews/${reviewId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/{reviewId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  changeRequestReviewers = {
    /**
     * @description Returns a paginated list of users who have been explicitly requested to review the change request. Use this to check who is currently assigned as a reviewer before adding or removing reviewer requests.
     *
     * @tags change-request-reviewers
     * @name GetRequestedReviewersByChangeRequestId
     * @summary List all users requested to review a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers
     * @secure
     */
    getRequestedReviewersByChangeRequestId: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ChangeRequestRequestedReviewer[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/requested-reviewers`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sends review request notifications to one or more users, asking them to review the change request. Optionally updates the change request subject and description at the same time. Use this to move the change request into the review workflow after finishing edits. The users array must contain at least one valid user ID.
     *
     * @tags change-request-reviewers
     * @name RequestReviewersForChangeRequest
     * @summary Send review requests to users for a change request
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers
     * @secure
     */
    requestReviewersForChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      data: {
        /** An array of user ids that will be requested. */
        users: string[];
        /** Optionally, update the subject of the change request when requesting reviewers. */
        subject?: string;
        /** Optionally, update the description of the change request when requesting reviewers. */
        description?: JSONDocument;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** The user requests that were sent. */
          users?: ChangeRequestRequestedReviewer[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/requested-reviewers`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags change-request-reviewers
     * @name RemoveRequestedReviewerFromChangeRequest
     * @summary Remove a reviewer from a change request
     * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers/{userId}
     * @secure
     */
    removeRequestedReviewerFromChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/requested-reviewers/${userId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers/{userId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  changeRequestConversations = {
    /**
     * @description Returns a paginated list of AI agent conversations that were created in the context of this change request. These conversations capture the AI-assisted editing sessions that contributed to the draft. Use this to review the history of AI interactions on a change request before merging.
     *
     * @tags change-request-conversations
     * @name ListChangeRequestConversations
     * @summary List AI agent conversations associated with a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/conversations
     * @secure
     */
    listChangeRequestConversations: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: AgentConversation[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/conversations`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/conversations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a specific AI agent conversation associated with a change request. Use this to rename the conversation.
     *
     * @tags change-request-conversations
     * @name UpdateChangeRequestConversation
     * @summary Update an AI agent conversation on a change request
     * @request PATCH:/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}
     * @secure
     */
    updateChangeRequestConversation: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      conversationId: string,
      data: {
        /** The new title of the conversation. */
        title: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentConversation, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/conversations/${conversationId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags change-request-conversations
     * @name DeleteChangeRequestConversation
     * @summary Delete an agent conversation
     * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}
     * @secure
     */
    deleteChangeRequestConversation: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/conversations/${conversationId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  changeRequestComments = {
    /**
     * @description Returns a paginated list of comments posted on the change request, optionally filtered by status, target page, or author. Comments can be anchored to a specific page or be general change-request-level comments. Use this to read the review discussion before responding. To fetch replies to a comment, use the comment replies endpoint.
     *
     * @tags change-request-comments
     * @name ListCommentsInChangeRequest
     * @summary List all top-level comments in a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments
     * @secure
     */
    listCommentsInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * When provided, only comments with the given status are returned. Defaults to "all".
         * @default "all"
         */
        status?: "all" | "open" | "resolved";
        /** The target page of the comment */
        targetPage?: string;
        /** User IDs to filter queried comments on */
        authors?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Comment[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Posts a new top-level comment on the change request. Comments can be general or anchored to a specific page and inline location within the change request content. Use this to provide review feedback, ask questions, or flag issues. To reply to an existing comment, use the comment replies endpoint instead.
     *
     * @tags change-request-comments
     * @name PostCommentInChangeRequest
     * @summary Post a new comment on a change request
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/comments
     * @secure
     */
    postCommentInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      data: PostCommentSchema,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific comment from a change request, including its content, author, and anchor location. Use this when you have a comment ID (e.g., from a notification or list) and need its full details.
     *
     * @tags change-request-comments
     * @name GetCommentInChangeRequest
     * @summary Get a single comment from a change request by its ID
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
     * @secure
     */
    getCommentInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags change-request-comments
     * @name DeleteCommentInChangeRequest
     * @summary Delete a change request comment
     * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
     * @secure
     */
    deleteCommentInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Replaces the body or status of an existing change request comment. Use this to edit the text of a comment you previously posted, or to resolve/reopen a comment thread. Only the comment author or space admins can update a comment.
     *
     * @tags change-request-comments
     * @name UpdateCommentInChangeRequest
     * @summary Update the content or status of a change request comment
     * @request PUT:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
     * @secure
     */
    updateCommentInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      data: UpdateCommentSchema,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of replies to a specific top-level comment in a change request. Use this to read the full thread of a review discussion on a particular comment before adding a reply.
     *
     * @tags change-request-comments
     * @name ListCommentRepliesInChangeRequest
     * @summary List all replies to a change request comment
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies
     * @secure
     */
    listCommentRepliesInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: CommentReply[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}/replies`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Adds a reply to an existing comment thread on a change request. Use this to respond to review feedback or continue a discussion on a specific comment. To start a new top-level comment rather than replying, use the change request comments endpoint.
     *
     * @tags change-request-comments
     * @name PostCommentReplyInChangeRequest
     * @summary Post a reply to a change request comment
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies
     * @secure
     */
    postCommentReplyInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      data: PostCommentReplySchema,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<CommentReply, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}/replies`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific reply within a change request comment thread. Use this when you have a reply ID and need its full content and author details.
     *
     * @tags change-request-comments
     * @name GetCommentReplyInChangeRequest
     * @summary Get a single reply to a change request comment
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
     * @secure
     */
    getCommentReplyInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      commentReplyId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<CommentReply, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}/replies/${commentReplyId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Replaces the body of an existing reply in a change request comment thread. Use this to correct or amend a reply you previously posted. Only the reply author or space admins can update a reply.
     *
     * @tags change-request-comments
     * @name UpdateCommentReplyInChangeRequest
     * @summary Update the content of a change request comment reply
     * @request PUT:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
     * @secure
     */
    updateCommentReplyInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      commentReplyId: EntityId,
      data: UpdateCommentSchema,
      params: RequestParams = {},
    ) =>
      this.request<CommentReply, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}/replies/${commentReplyId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags change-request-comments
     * @name DeleteCommentReplyInChangeRequest
     * @summary Delete a change request comment reply
     * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
     * @secure
     */
    deleteCommentReplyInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      commentId: EntityId,
      commentReplyId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/comments/${commentId}/replies/${commentReplyId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a paginated list of organization members who have posted at least one comment in the change request. Use this to identify who is actively engaged in the review discussion before adding or directing comments.
     *
     * @tags change-request-comments, critical
     * @name ListCommentersInChangeRequest
     * @summary List all users who have commented in a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/commenters
     * @secure
     */
    listCommentersInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationMember[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/commenters`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/commenters",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  changeRequestContributors = {
    /**
     * @description Returns a list of users who have contributed content edits to the change request. Use this to identify who has been actively editing the draft, for example when deciding who to notify before merging.
     *
     * @tags change-request-contributors
     * @name GetContributorsByChangeRequestId
     * @summary List all users who have made edits to a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/contributors
     * @secure
     */
    getContributorsByChangeRequestId: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ChangeRequestUserContributor[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/contributors`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/contributors",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  changeRequestContent = {
    /**
     * @description Returns the current revision snapshot of the change request, including the full page tree structure and metadata. Use this to inspect the overall state of the change request's content, such as the list of pages and their hierarchy, without fetching each page individually. For page content (body text), use the individual page endpoints.
     *
     * @tags change-request-content
     * @name GetRevisionOfChangeRequestById
     * @summary Get the latest content revision of a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content
     * @secure
     */
    getRevisionOfChangeRequestById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Revision, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Applies an ordered array of content changes (up to 50) to the change request atomically, creating a single new revision. Changes are applied sequentially; if any single change is invalid the entire batch is rejected and no revision is created. Use this to create, update, rename, move, or delete pages within a change request before merging to live. This is the primary way to programmatically author content in a change request. **Renaming a page** — `update_page` can change a page's `title` and/or its `slug` (the path segment used to build its URL within its current parent). Both fields are independent: to rename only the title without changing the URL, set `title` and omit `slug`; to change the URL without changing the title, set `slug` and omit `title`. **Moving a page** — `update_page` can also change a page's parent and/or its position among siblings with `into`/`at`. Set `into` to the new parent's page ID, or `null` to move the page to the root of the tree; omit `into` to leave the parent unchanged. Set `at` to place the page at a specific zero-based index among its new siblings; omit it to leave the position unchanged (when the parent isn't changing) or append at the end (when it is). A page cannot be moved under itself or one of its own descendants. `insert_page`'s `into`/`at` remain the way to place a **new** page at creation time. **Tags**: create flat tag definitions with `insert_tags` and a `tags` array of 1-50 entries, edit their label or appearance with `update_tag`, and remove definitions with `delete_tag`. Slugs are immutable and generated from the label when omitted on insertion. Operations apply in order, so later updates or deletions can target newly inserted tags. Set `icon` or `emoji` to `null` to clear that field; omission preserves it. A non-null icon takes precedence over a non-null emoji. Deleting a tag leaves references in content unresolved. For example: `{"changes":[{"operation":"insert_tags","tags":[{"label":"Beta"}]}, {"operation":"update_tag","tag":"beta","color":"blue"}]}`. To put an image or attachment in a page, upload it with an `insert_files` change. Give the file a `ref` and a page inserted in the same batch can reference it as `![Alt](./<ref>)` or `[File](./<ref>)`, which resolves to the file's ID at apply time regardless of operation order. Uploaded files are also listed as `insertedFiles` when `compat=false`, and a file already in the change request can be referenced directly as `/files/<fileId>`. Inline `data:` URIs in markdown are not ingested and large image blocks are dropped, so upload the bytes with `insert_files` instead. **Reusable content** (snippets shared by several pages, Git Sync's `.gitbook/includes/`) is created with `insert_reusable_contents`, changed with `update_reusable_content` and removed with `delete_reusable_content`. A page includes one in markdown as `{% include "/reusable-content/<reusableContentId>" %}`; give a new one a `ref` and a page in the same batch can include it as `{% include "./<ref>" %}`, regardless of operation order. Created reusable contents are listed as `insertedReusableContents` when `compat=false`. An update keeps the ID, so every page including it shows the change. Deleting one leaves the includes in pages unresolved, as in the editor: remove them from those pages too. Reusable content cannot include other reusable content, so an include in its document is dropped. Unlike a link, an include that matches no reusable content of the change request (or of the batch) rejects the batch, since dropping it would remove it from the page silently. **Variables** (space variables, Git Sync's `.gitbook/vars.yaml`) are created with `insert_variables`, changed with `update_variable` and removed with `delete_variable`. A variable is identified by its name, which content references as an expression: `<code class="expression">space.vars.<name></code>` in markdown. Inserting a name the change request already uses, or updating or deleting one it does not, rejects the batch. Deleting a variable keeps the expressions referencing it, as in the editor: remove them from those pages too. A page's own variables (`page.vars.<name>`) are set with `insert_page`/`update_page`'s `variables`, or the `vars` frontmatter of a markdown document, which replace all of that page's variables. To change one of them without resending the rest, give `insert_variables`, `update_variable` or `delete_variable` a `page`; the same rules apply to that page's variables. **Publishing an OpenAPI spec** — an OpenAPI spec belongs to the organization (see `createOpenAPISpec`) and appears in a space only through a page that renders it. Insert that page with an `insert_computed_page` change: `{ "operation": "insert_computed_page", "title": "API reference", "computed": { "type": "builtin:openapi", "props": { "models": true }, "dependencies": { "spec": { "ref": { "kind": "openapi", "spec": "<spec slug>" } } } } }`. GitBook replaces that page, at its position, with the API reference: one page per tag (or per operation with `"grouping": "by-operation"` in `props`), plus a models page when `models` is true, regenerated whenever the spec changes. Use `into` to nest the reference under an existing page. Do not recreate a spec with `insert_page`: `openapi-operation` blocks in a document only render the operations they name. When page content is provided as markdown, links to other pages are resolved against the change request's current page tree. You can link a page by: - Page ID — `/pages/<pageId>` (also `/pages/<pageId>#anchor`). - Page slug path — `/pages/<slug>` for a top-level page, or `/pages/<parent-slug>/<slug>` for a nested page (e.g. `/pages/guides/getting-started`). - Markdown file path — the path the page would have in Git: `/pages/<slug>.md` for a page, or `/pages/<slug>/README.md` for a page that has child pages. The space's root page is `/pages/README.md`. - Relative markdown link — resolved against the page being edited, e.g. `./sibling.md`, `../other.md`, or `../README.md` (the parent page). Folder-style links without an extension (e.g. `./section`) resolve to that folder's page. External URLs (`https://…`) are kept as-is. A link that does not match any page in the change request is left as plain text rather than causing the request to fail. GitBook normalizes submitted content, so the stored page may differ from what was sent. To help callers reconcile local state with the stored result, the response can list each created and modified page with its resolved ID and a `urls.location` to fetch the page's persisted content. For change requests with frequent concurrent edits, consider `expectedRevision` to protect against overwriting changes made since your read. If the branch has changed since the supplied revision, the batch is rejected with HTTP 409 and none of the submitted changes are applied. **Response shape (`compat`)** — this endpoint is changing what it returns: - `compat=true` (current default) returns the updated change request, matching the endpoint's original behavior. - `compat=false` returns the updated change request **and** the list of affected pages (see the response schema). The default is `true` for now to preserve backwards compatibility, but **will switch to `false` in a future release**, at which point the affected-page list is always included. You should pass `compat=false` if you want the new behavior today and avoid unexpected errors when the default flips in the future.
     *
     * @tags change-request-content
     * @name UpdateChangeRequestContent
     * @summary Apply a batch of content changes to a change request
     * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/content
     * @secure
     */
    updateChangeRequestContent: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      data: {
        /**
         * The saved branch revision on which these changes are based, available in getChangeRequestById's revision field. If the branch has changed, including pending realtime edits, the batch is rejected with 409 and none of the submitted changes are applied. This field is optional and most changes can omit it.
         * @minLength 1
         */
        expectedRevision?: string;
        /**
         * @maxItems 50
         * @minItems 1
         */
        changes: ChangeRequestContentChange[];
      },
      query?: {
        /**
         * When `true`, the updated change request is returned. When `false`, the updated change request and the list of affected pages are returned.
         * @default true
         */
        compat?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ChangeRequest | ChangeRequestContentUpdate,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the full flat list of all pages in the change request's current draft revision, including page groups. Does not include page body content — use the individual page endpoint to fetch content. Use this to get an overview of the draft's page structure before reading or modifying specific pages.
     *
     * @tags change-request-content
     * @name ListPagesInChangeRequest
     * @summary List all pages in a change request as a flat list
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/pages
     * @secure
     */
    listPagesInChangeRequest: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          pages: RevisionPage[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/pages`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/pages",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of files (images and other attachments) stored in the change request's current revision. Use this to inspect uploaded assets within a draft before merging. For files in the live published space, use the space content files endpoint.
     *
     * @tags change-request-content
     * @name ListFilesInChangeRequestById
     * @summary List all files (images/attachments) in a change request
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files
     * @secure
     */
    listFilesInChangeRequestById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: RevisionFile[];
        },
        any
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/files`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves metadata for a single file (image or attachment) stored in the change request's current revision. Use this to get the download URL or details of a specific asset referenced by a page in the change request.
     *
     * @tags change-request-content
     * @name GetFileInChangeRequestById
     * @summary Get a specific file in a change request by its ID
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}
     * @secure
     */
    getFileInChangeRequestById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      fileId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionFile, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/files/${fileId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific page from a change request's draft content, including its title, metadata, and body document. Use the documentFormat parameter to control the format of the returned document (e.g., markdown). This reflects the draft state of the page, not the live published version — use the space content page endpoint for live content.
     *
     * @tags change-request-content
     * @name GetPageInChangeRequestById
     * @summary Get a page in a change request by its ID
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}
     * @secure
     */
    getPageInChangeRequestById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      pageId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
         *
         * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
         * - `stable`: Format content references as stable idempotent refs containing their identifiers.
         * @default "relative"
         */
        "format.markdown.refs"?: "relative" | "stable";
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionPage, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/page/${pageId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the structural navigation links for a specific page within a change request, such as its parent page, previous sibling, and next sibling in the page tree. Use this to understand a page's position within the content hierarchy of the draft.
     *
     * @tags change-request-content
     * @name ListChangeRequestPageMetaLinks
     * @summary Get navigation meta-links (prev/next/parent) for a change request page
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/meta-links
     * @secure
     */
    listChangeRequestPageMetaLinks: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      pageId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<RevisionPageMetaLinks, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/page/${pageId}/meta-links`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/meta-links",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific reusable content block (a shared snippet that can be embedded across multiple pages) from the change request's draft revision. Use this to inspect the current draft state of a shared content block before merging.
     *
     * @tags change-request-content
     * @name GetReusableContentInChangeRequestById
     * @summary Get a reusable content block in a change request by its ID
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/reusable-contents/{reusableContentId}
     * @secure
     */
    getReusableContentInChangeRequestById: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      reusableContentId: EntityId,
      query?: {
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionReusableContent, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/reusable-contents/${reusableContentId}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/reusable-contents/{reusableContentId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the semantic diff between the change request's current content and the base revision it branched from. Each item describes a logical change such as a page added, removed, or modified. Use this to summarise what a change request changes before merging or reviewing. The default limit is 10 — increase it if the change request is large.
     *
     * @tags change-request-content
     * @name GetChangeRequestChanges
     * @summary List semantic content changes in a change request vs its base
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/changes
     * @secure
     */
    getChangeRequestChanges: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      query?: {
        /**
         * Limit the number of changes returned
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RevisionSemanticChanges,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/changes`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/changes",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific page from a change request's draft content using its URL path (e.g., "getting-started/installation") rather than its ID. Use this when you know the path of a page but not its ID. Returns either a document page or a page group, depending on the path. Supports the same format and evaluation options as the ID-based endpoint.
     *
     * @tags change-request-content
     * @name GetPageInChangeRequestByPath
     * @summary Get a page in a change request by its URL path
     * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/path/{pagePath}
     * @secure
     */
    getPageInChangeRequestByPath: (
      spaceId: EntityId,
      changeRequestId: EntityId,
      pagePath: string,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /**
         * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
         *
         * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
         * - `stable`: Format content references as stable idempotent refs containing their identifiers.
         * @default "relative"
         */
        "format.markdown.refs"?: "relative" | "stable";
        /**
         * Controls whether the document should be evaluated.
         * - When set to `true`, the entire document will be evaluated.
         * - When set to `deterministic-only`, only expressions that depend
         *   exclusively on deterministic inputs will be evaluated.
         * @default false
         */
        evaluated?: boolean | "deterministic-only";
        /**
         * Controls whether references to other content are resolved and expanded.
         * - When set to `false`, references are preserved, including reusable content includes in Markdown.
         * - When set to `true`, all supported content references are expanded.
         * - When set to `reusable-contents`, only reusable content references are expanded.
         * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
         */
        dereferenced?: boolean | "reusable-contents";
        /**
         * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
         * @default true
         */
        metadata?: boolean;
        /**
         * If `true` is passed, mutable Git metadata may be served from a cache.
         * @default false
         */
        cachedMetadata?: boolean;
        /**
         * If `false` is passed, content will not be computed
         * @default true
         */
        computed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RevisionPageDocument | RevisionPageGroup, any>({
        path: `/spaces/${spaceId}/change-requests/${changeRequestId}/content/path/${pagePath}`,
        routeTemplate:
          "/spaces/{spaceId}/change-requests/{changeRequestId}/content/path/{pagePath}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  spaceComments = {
    /**
     * @description Returns a paginated list of comments posted directly on the space (not inside a change request). To read replies to a specific comment, use the comment replies endpoint.
     *
     * @tags space-comments, critical
     * @name ListCommentsInSpace
     * @summary List all top-level comments posted on a space
     * @request GET:/spaces/{spaceId}/comments
     * @secure
     */
    listCommentsInSpace: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
        /**
         * When provided, only comments with the given status are returned. Defaults to "all".
         * @default "all"
         */
        status?: "all" | "open" | "resolved";
        /** Output format for the content. */
        format?: "document" | "markdown";
        /** The target page of the comment */
        targetPage?: string;
        /** User IDs to filter queried comments on */
        authors?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Comment[];
        },
        any
      >({
        path: `/spaces/${spaceId}/comments`,
        routeTemplate: "/spaces/{spaceId}/comments",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new top-level comment on the space, optionally anchored to a specific page or a text selection within a page. Use this to leave feedback, start a review thread, or annotate content. To reply to an existing comment, use the comment replies endpoint.
     *
     * @tags space-comments
     * @name PostCommentInSpace
     * @summary Post a new comment on a space or a specific page
     * @request POST:/spaces/{spaceId}/comments
     * @secure
     */
    postCommentInSpace: (
      spaceId: EntityId,
      data: PostCommentSchema,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/spaces/${spaceId}/comments`,
        routeTemplate: "/spaces/{spaceId}/comments",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a specific comment posted on a space. To list all comments in a space, use the space comments list endpoint.
     *
     * @tags space-comments
     * @name GetCommentInSpace
     * @summary Get a single comment from a space by its ID
     * @request GET:/spaces/{spaceId}/comments/{commentId}
     * @secure
     */
    getCommentInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/spaces/${spaceId}/comments/${commentId}`,
        routeTemplate: "/spaces/{spaceId}/comments/{commentId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-comments
     * @name DeleteCommentInSpace
     * @summary Delete a space comment
     * @request DELETE:/spaces/{spaceId}/comments/{commentId}
     * @secure
     */
    deleteCommentInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/comments/${commentId}`,
        routeTemplate: "/spaces/{spaceId}/comments/{commentId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Updates the content or resolution status of an existing comment on a space. Only the comment author or a space admin can update a comment. Use this to edit a comment's text, mark it as resolved, or reopen it.
     *
     * @tags space-comments
     * @name UpdateCommentInSpace
     * @summary Update the body or status of a space comment
     * @request PUT:/spaces/{spaceId}/comments/{commentId}
     * @secure
     */
    updateCommentInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      data: UpdateCommentSchema,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/spaces/${spaceId}/comments/${commentId}`,
        routeTemplate: "/spaces/{spaceId}/comments/{commentId}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a reply to an existing comment on a space. Use this to continue a discussion thread started by a top-level comment. To start a new thread, use the space comment creation endpoint instead.
     *
     * @tags space-comments
     * @name PostCommentReplyInSpace
     * @summary Post a reply to an existing space comment
     * @request POST:/spaces/{spaceId}/comments/{commentId}/replies
     * @secure
     */
    postCommentReplyInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      data: PostCommentReplySchema,
      params: RequestParams = {},
    ) =>
      this.request<CommentReply, any>({
        path: `/spaces/${spaceId}/comments/${commentId}/replies`,
        routeTemplate: "/spaces/{spaceId}/comments/{commentId}/replies",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a specific reply to a comment in a space. To list all replies for a comment, use the comment replies list endpoint.
     *
     * @tags space-comments
     * @name GetCommentReplyInSpace
     * @summary Get a single reply to a space comment by its ID
     * @request GET:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
     * @secure
     */
    getCommentReplyInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      commentReplyId: EntityId,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<CommentReply, any>({
        path: `/spaces/${spaceId}/comments/${commentId}/replies/${commentReplyId}`,
        routeTemplate:
          "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the content of an existing reply to a comment in a space. Only the reply author or a space admin can update the reply. To update the parent comment, use the space comment update endpoint.
     *
     * @tags space-comments
     * @name UpdateCommentReplyInSpace
     * @summary Update the body of a reply to a space comment
     * @request PUT:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
     * @secure
     */
    updateCommentReplyInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      commentReplyId: EntityId,
      data: UpdateCommentReplySchema,
      params: RequestParams = {},
    ) =>
      this.request<CommentReply, any>({
        path: `/spaces/${spaceId}/comments/${commentId}/replies/${commentReplyId}`,
        routeTemplate:
          "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags space-comments
     * @name DeleteCommentReplyInSpace
     * @summary Delete a space comment reply
     * @request DELETE:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
     * @secure
     */
    deleteCommentReplyInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      commentReplyId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/spaces/${spaceId}/comments/${commentId}/replies/${commentReplyId}`,
        routeTemplate:
          "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a paginated list of organization members who have posted at least one comment in the space. Use this to identify participants in a space's review or annotation workflow. For the actual comment content, use the space comments endpoint.
     *
     * @tags space-comments, critical
     * @name ListCommentersInSpace
     * @summary List all users who have posted comments in a space
     * @request GET:/spaces/{spaceId}/commenters
     * @secure
     */
    listCommentersInSpace: (
      spaceId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationMember[];
        },
        any
      >({
        path: `/spaces/${spaceId}/commenters`,
        routeTemplate: "/spaces/{spaceId}/commenters",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  spaceComment = {
    /**
     * @description Returns a paginated list of replies posted under a specific comment in a space. Use this to read the full conversation thread for a comment. To get the parent comment itself, use the space comment by ID endpoint.
     *
     * @tags space-comment
     * @name ListCommentRepliesInSpace
     * @summary List all replies to a comment in a space
     * @request GET:/spaces/{spaceId}/comments/{commentId}/replies
     * @secure
     */
    listCommentRepliesInSpace: (
      spaceId: EntityId,
      commentId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: CommentReply[];
        },
        any
      >({
        path: `/spaces/${spaceId}/comments/${commentId}/replies`,
        routeTemplate: "/spaces/{spaceId}/comments/{commentId}/replies",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  spaceIntegrations = {
    /**
     * @description Returns a paginated list of integrations that are currently installed and enabled on the space. Use the query parameter to filter by integration name. Use this to check which integrations are active before interacting with integration-specific features or blocks.
     *
     * @tags space-integrations
     * @name ListSpaceIntegrations
     * @summary List all third-party integrations enabled on a space
     * @request GET:/spaces/{spaceId}/integrations
     * @secure
     */
    listSpaceIntegrations: (
      spaceId: EntityId,
      query?: {
        /** A search string to filter integrations by name */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Integration[];
        },
        any
      >({
        path: `/spaces/${spaceId}/integrations`,
        routeTemplate: "/spaces/{spaceId}/integrations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns all custom block types contributed by integrations installed on the space. Integration blocks are custom content elements (e.g. embedded widgets, code runners) that integrations register for use in pages. Use this to discover what custom block types are available in a given space.
     *
     * @tags space-integrations
     * @name ListSpaceIntegrationsBlocks
     * @summary List all custom content blocks provided by integrations in a space
     * @request GET:/spaces/{spaceId}/integration-blocks
     * @secure
     */
    listSpaceIntegrationsBlocks: (
      spaceId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        SpaceIntegrationBlocks,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/spaces/${spaceId}/integration-blocks`,
        routeTemplate: "/spaces/{spaceId}/integration-blocks",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  collections = {
    /**
     * No description
     *
     * @tags collections
     * @name GetCollectionById
     * @summary Get a collection by its ID
     * @request GET:/collections/{collectionId}
     * @secure
     */
    getCollectionById: (collectionId: EntityId, params: RequestParams = {}) =>
      this.request<Collection, any>({
        path: `/collections/${collectionId}`,
        routeTemplate: "/collections/{collectionId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name UpdateCollectionById
     * @summary Update a collection
     * @request PATCH:/collections/{collectionId}
     * @secure
     */
    updateCollectionById: (
      collectionId: EntityId,
      data: {
        /** Title of the collection */
        title?: CollectionTitle;
        /** Description of the collection */
        description?: CollectionDescription;
        /** Default level for a piece of content */
        defaultLevel?: DefaultLevel;
      },
      params: RequestParams = {},
    ) =>
      this.request<Collection, any>({
        path: `/collections/${collectionId}`,
        routeTemplate: "/collections/{collectionId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name DeleteCollectionById
     * @summary Delete a collection
     * @request DELETE:/collections/{collectionId}
     * @secure
     */
    deleteCollectionById: (
      collectionId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/collections/${collectionId}`,
        routeTemplate: "/collections/{collectionId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name ListSpacesInCollectionById
     * @summary List all collection spaces
     * @request GET:/collections/{collectionId}/spaces
     * @secure
     */
    listSpacesInCollectionById: (
      collectionId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Space[];
        },
        any
      >({
        path: `/collections/${collectionId}/spaces`,
        routeTemplate: "/collections/{collectionId}/spaces",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name MoveCollection
     * @summary Move a collection to a new position.
     * @request POST:/collections/{collectionId}/move
     * @secure
     */
    moveCollection: (
      collectionId: EntityId,
      data: {
        /** The unique id of the parent collection */
        parent?: string | null;
        /** Where to move the collection. By default, it will be moved at the end. */
        position?: ContentPosition;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Collection,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/collections/${collectionId}/move`,
        routeTemplate: "/collections/{collectionId}/move",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name TransferCollection
     * @summary Transfer a collection
     * @request POST:/collections/{collectionId}/transfer
     * @secure
     */
    transferCollection: (
      collectionId: EntityId,
      data: {
        /** The unique id of the target organization */
        organization: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Collection,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 412;
              message: string;
            };
          }
      >({
        path: `/collections/${collectionId}/transfer`,
        routeTemplate: "/collections/{collectionId}/transfer",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name ListCollectionsInOrganizationById
     * @summary List all collections
     * @request GET:/orgs/{organizationId}/collections
     * @secure
     */
    listCollectionsInOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If true, all nested collections will be listed
         * @default true
         */
        nested?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Collection[];
        },
        any
      >({
        path: `/orgs/${organizationId}/collections`,
        routeTemplate: "/orgs/{organizationId}/collections",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collections
     * @name CreateCollection
     * @summary Create a collection
     * @request POST:/orgs/{organizationId}/collections
     * @secure
     */
    createCollection: (
      organizationId: EntityId,
      data: {
        /** @maxLength 50 */
        title?: string;
        /** ID of a parent collection */
        parent?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Collection, any>({
        path: `/orgs/${organizationId}/collections`,
        routeTemplate: "/orgs/{organizationId}/collections",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  collectionPermissions = {
    /**
     * No description
     *
     * @tags collection-permissions
     * @name InviteToCollection
     * @summary Invite to a collection
     * @request POST:/collections/{collectionId}/permissions
     * @secure
     */
    inviteToCollection: (
      collectionId: EntityId,
      data: InviteUsersAndTeams,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/collections/${collectionId}/permissions`,
        routeTemplate: "/collections/{collectionId}/permissions",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags collection-permissions
     * @name ListTeamPermissionsInCollection
     * @summary List an org team's permission in collection
     * @request GET:/collections/{collectionId}/permissions/teams
     * @secure
     */
    listTeamPermissionsInCollection: (
      collectionId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: {
            /**
             * "The role of a member in an organization.
             * "admin": Can administrate the content: create, delete spaces, ...
             * "create": Can create content.
             * "review": Can review content.
             * "edit": Can edit the content (live or change requests).
             * "comment": Can access the content and its discussions.
             * "read": Can access the content, but cannot update it in any way.
             */
            permission: MemberRole;
            team: OrganizationTeam;
          }[];
        },
        any
      >({
        path: `/collections/${collectionId}/permissions/teams`,
        routeTemplate: "/collections/{collectionId}/permissions/teams",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collection-permissions
     * @name UpdateTeamPermissionInCollection
     * @summary Update an org team's permission in a collection
     * @request PATCH:/collections/{collectionId}/permissions/teams/{teamId}
     * @secure
     */
    updateTeamPermissionInCollection: (
      collectionId: EntityId,
      teamId: EntityId,
      data: {
        /** The role of a member in an organization, null for guests */
        role?: MemberRoleOrGuest;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/collections/${collectionId}/permissions/teams/${teamId}`,
        routeTemplate: "/collections/{collectionId}/permissions/teams/{teamId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags collection-permissions
     * @name RemoveTeamFromCollection
     * @summary Remove an org team from a collection
     * @request DELETE:/collections/{collectionId}/permissions/teams/{teamId}
     * @secure
     */
    removeTeamFromCollection: (
      collectionId: EntityId,
      teamId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/collections/${collectionId}/permissions/teams/${teamId}`,
        routeTemplate: "/collections/{collectionId}/permissions/teams/{teamId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags collection-permissions
     * @name ListUserPermissionsInCollection
     * @summary List collection user permissions
     * @request GET:/collections/{collectionId}/permissions/users
     * @secure
     */
    listUserPermissionsInCollection: (
      collectionId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: UserContentPermission[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/collections/${collectionId}/permissions/users`,
        routeTemplate: "/collections/{collectionId}/permissions/users",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags collection-permissions
     * @name UpdateUserPermissionInCollection
     * @summary Update a collection user permission
     * @request PATCH:/collections/{collectionId}/permissions/users/{userId}
     * @secure
     */
    updateUserPermissionInCollection: (
      collectionId: EntityId,
      userId: string,
      data: {
        /** The role of a member in an organization, null for guests */
        role?: MemberRoleOrGuest;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/collections/${collectionId}/permissions/users/${userId}`,
        routeTemplate: "/collections/{collectionId}/permissions/users/{userId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags collection-permissions
     * @name RemoveUserFromCollection
     * @summary Remove a user from a collection
     * @request DELETE:/collections/{collectionId}/permissions/users/{userId}
     * @secure
     */
    removeUserFromCollection: (
      collectionId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/collections/${collectionId}/permissions/users/${userId}`,
        routeTemplate: "/collections/{collectionId}/permissions/users/{userId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  integrations = {
    /**
     * @description Returns a paginated list of the integrations published in the GitBook marketplace. Use this to discover an integration by name, category, or the blocks and content sources it provides, before installing it on an organization, space or site.
     *
     * @tags integrations
     * @name ListIntegrations
     * @summary List all public integrations
     * @request GET:/integrations
     * @secure
     */
    listIntegrations: (
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** A search string to filter integrations by name */
        search?: string;
        /** Filter the integrations by category */
        category?: IntegrationCategory;
        /**
         * Filter the integrations by block's domains
         * @maxLength 100
         * @pattern ^[a-zA-Z0-9-_.]+$
         */
        blockDomain?: string;
        /** If true, returns only integrations with blocks. If false, returns only integrations without blocks. */
        blocks?: boolean;
        /** If true, returns only integrations with contentSources. If false, returns only integrations without contentSources. */
        contentSources?: boolean;
        /** If defined, only list integrations owned by the given organization. */
        owner?: string;
        /** Filter the integrations by scope */
        scope?: IntegrationScope;
        /** Filter the integrations by target */
        target?: IntegrationTarget;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Integration[];
        },
        any
      >({
        path: `/integrations`,
        routeTemplate: "/integrations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a single integration by its unique name, including the configuration it expects, the targets it can be installed on, and the permissions it requests. Private integrations are only readable by the organization that owns them.
     *
     * @tags integrations
     * @name GetIntegrationByName
     * @summary Get an integration by its name
     * @request GET:/integrations/{integrationName}
     * @secure
     */
    getIntegrationByName: (
      integrationName: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Integration,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}`,
        routeTemplate: "/integrations/{integrationName}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name PublishIntegration
     * @summary Publish an integration
     * @request POST:/integrations/{integrationName}
     * @secure
     */
    publishIntegration: (
      integrationName: string,
      data: PublishIntegration,
      params: RequestParams = {},
    ) =>
      this.request<
        Integration,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}`,
        routeTemplate: "/integrations/{integrationName}",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name UnpublishIntegration
     * @summary Unpublish an integration
     * @request DELETE:/integrations/{integrationName}
     * @secure
     */
    unpublishIntegration: (
      integrationName: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/integrations/${integrationName}`,
        routeTemplate: "/integrations/{integrationName}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name ListIntegrationInstallations
     * @summary List all integration installations
     * @request GET:/integrations/{integrationName}/installations
     * @secure
     */
    listIntegrationInstallations: (
      integrationName: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** External Id to filter by */
        externalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: IntegrationInstallation[];
        },
        any
      >({
        path: `/integrations/${integrationName}/installations`,
        routeTemplate: "/integrations/{integrationName}/installations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Installs an integration on an organization, creating the account-level installation that space and site installations hang off. Configure it with the update operation, then enable it on individual spaces or sites.
     *
     * @tags integrations
     * @name InstallIntegration
     * @summary Install an integration
     * @request POST:/integrations/{integrationName}/installations
     * @secure
     */
    installIntegration: (
      integrationName: string,
      data: OrganizationTarget,
      params: RequestParams = {},
    ) =>
      this.request<
        IntegrationInstallation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations`,
        routeTemplate: "/integrations/{integrationName}/installations",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name ListIntegrationEvents
     * @summary List all integration events
     * @request GET:/integrations/{integrationName}/events
     * @secure
     */
    listIntegrationEvents: (
      integrationName: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: IntegrationEvent[];
        },
        any
      >({
        path: `/integrations/${integrationName}/events`,
        routeTemplate: "/integrations/{integrationName}/events",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name GetIntegrationEvent
     * @summary Get an integration event by its ID
     * @request GET:/integrations/{integrationName}/events/{eventId}
     * @secure
     */
    getIntegrationEvent: (
      integrationName: string,
      eventId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          event: IntegrationEvent;
          trace?: IntegrationEventTrace;
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/events/${eventId}`,
        routeTemplate: "/integrations/{integrationName}/events/{eventId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name ListIntegrationSpaceInstallations
     * @summary List all integration space installations
     * @request GET:/integrations/{integrationName}/spaces
     * @secure
     */
    listIntegrationSpaceInstallations: (
      integrationName: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** External Id to filter by */
        externalId?: string;
        /**
         * If true, returns the space object in each items. If false, returns the space ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: IntegrationSpaceInstallation[];
        },
        any
      >({
        path: `/integrations/${integrationName}/spaces`,
        routeTemplate: "/integrations/{integrationName}/spaces",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name ListIntegrationSiteInstallations
     * @summary List all integration site installations
     * @request GET:/integrations/{integrationName}/sites
     * @secure
     */
    listIntegrationSiteInstallations: (
      integrationName: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** External ID to filter by */
        externalId?: string;
        /**
         * If true, returns the site object in each items. If false, returns the site ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: IntegrationSiteInstallation[];
        },
        any
      >({
        path: `/integrations/${integrationName}/sites`,
        routeTemplate: "/integrations/{integrationName}/sites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name SetIntegrationDevelopmentMode
     * @summary Enable integration dev mode
     * @request PUT:/integrations/{integrationName}/dev
     * @secure
     */
    setIntegrationDevelopmentMode: (
      integrationName: string,
      data: {
        /**
         * URL of the tunnel to dispatch integration events to
         * @minLength 1
         * @maxLength 256
         */
        tunnelUrl: string;
        /**
         * If set to true, all requests will be forwarded to the tunnel, not just from the owning organization.
         * @default false
         */
        all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/dev`,
        routeTemplate: "/integrations/{integrationName}/dev",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name DisableIntegrationDevelopmentMode
     * @summary Disable integration dev mode
     * @request DELETE:/integrations/{integrationName}/dev
     * @secure
     */
    disableIntegrationDevelopmentMode: (
      integrationName: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/integrations/${integrationName}/dev`,
        routeTemplate: "/integrations/{integrationName}/dev",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name RenderIntegrationUiWithGet
     * @summary Render an integration UI with GET method
     * @request GET:/integrations/{integrationName}/render
     * @secure
     */
    renderIntegrationUiWithGet: (
      integrationName: string,
      query: {
        /** LZ-string compressed JSON request */
        request: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContentKitRenderOutput, any>({
        path: `/integrations/${integrationName}/render`,
        routeTemplate: "/integrations/{integrationName}/render",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name RenderIntegrationUiWithPost
     * @summary Render an integration UI with POST method
     * @request POST:/integrations/{integrationName}/render
     * @secure
     */
    renderIntegrationUiWithPost: (
      integrationName: string,
      data: RenderIntegrationUI,
      params: RequestParams = {},
    ) =>
      this.request<ContentKitRenderOutput, any>({
        path: `/integrations/${integrationName}/render`,
        routeTemplate: "/integrations/{integrationName}/render",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name QueueIntegrationTask
     * @summary Queue an integration task
     * @request POST:/integrations/{integrationName}/tasks
     * @secure
     */
    queueIntegrationTask: (
      integrationName: string,
      data: {
        /** Payload for the integration task */
        task: object;
        /**
         * Number of seconds to wait before executing the task, defaults to 0
         * @min 0
         * @max 86400
         */
        schedule?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/tasks`,
        routeTemplate: "/integrations/{integrationName}/tasks",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the organization-level installation of an integration, including its account configuration and how many spaces it manages. The configuration can contain credentials the integration stored for third-party services.
     *
     * @tags integrations
     * @name GetIntegrationInstallationById
     * @summary Get an integration installation by its ID
     * @request GET:/integrations/{integrationName}/installations/{installationId}
     * @secure
     */
    getIntegrationInstallationById: (
      integrationName: string,
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        IntegrationInstallation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations/${installationId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the account-level configuration of an installation, and which spaces or sites it applies to.
     *
     * @tags integrations
     * @name UpdateIntegrationInstallation
     * @summary Update an integration installation
     * @request PATCH:/integrations/{integrationName}/installations/{installationId}
     * @secure
     */
    updateIntegrationInstallation: (
      integrationName: string,
      installationId: string,
      data: UpdateIntegrationInstallation,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationInstallation, any>({
        path: `/integrations/${integrationName}/installations/${installationId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name UninstallIntegration
     * @summary Uninstall an integration
     * @request DELETE:/integrations/{integrationName}/installations/{installationId}
     * @secure
     */
    uninstallIntegration: (
      integrationName: string,
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/integrations/${integrationName}/installations/${installationId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Creates a temporary API token of an integration's installation that has access to the installation and it's scopes. You must be authenticated as the integration to obtain this token.
     *
     * @tags integrations
     * @name CreateIntegrationInstallationToken
     * @summary Create an integration installation API token
     * @request POST:/integrations/{integrationName}/installations/{installationId}/tokens
     * @secure
     */
    createIntegrationInstallationToken: (
      integrationName: string,
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        APITemporaryToken,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/tokens`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/tokens",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of the spaces an installation is enabled on, with the configuration of the integration for each of them. Pass extended to get the full space object instead of its ID.
     *
     * @tags integrations
     * @name ListIntegrationInstallationSpaces
     * @summary List all space integration installations
     * @request GET:/integrations/{integrationName}/installations/{installationId}/spaces
     * @secure
     */
    listIntegrationInstallationSpaces: (
      integrationName: string,
      installationId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If true, returns the space object in each items. If false, returns the space ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: IntegrationSpaceInstallation[];
        },
        any
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/spaces`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/spaces",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Enables an existing organization-level installation on one space. The organization must already have the integration installed.
     *
     * @name InstallIntegrationOnSpace
     * @summary Install an integration on a space
     * @request POST:/integrations/{integrationName}/installations/{installationId}/spaces
     * @secure
     */
    installIntegrationOnSpace: (
      integrationName: string,
      installationId: string,
      data: {
        /** ID of the space to install the integration on */
        space: string;
      },
      query?: {
        /**
         * If true, returns the space object in each items. If false, returns the space ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        IntegrationSpaceInstallation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/spaces`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/spaces",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the installation of an integration on one space, including the configuration of the integration for that space.
     *
     * @tags integrations
     * @name GetIntegrationSpaceInstallation
     * @summary Get an integration space installation
     * @request GET:/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}
     * @secure
     */
    getIntegrationSpaceInstallation: (
      integrationName: string,
      installationId: string,
      spaceId: EntityId,
      query?: {
        /**
         * If true, returns the space object in each items. If false, returns the space ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        IntegrationSpaceInstallation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/spaces/${spaceId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the configuration of an integration for one space.
     *
     * @tags integrations
     * @name UpdateIntegrationSpaceInstallation
     * @summary Update an integration space installation
     * @request PATCH:/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}
     * @secure
     */
    updateIntegrationSpaceInstallation: (
      integrationName: string,
      installationId: string,
      spaceId: EntityId,
      data: UpdateIntegrationSpaceInstallation,
      query?: {
        /**
         * If true, returns the space object in each items. If false, returns the space ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IntegrationSpaceInstallation, any>({
        path: `/integrations/${integrationName}/installations/${installationId}/spaces/${spaceId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}",
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name UninstallIntegrationFromSpace
     * @summary Uninstall an integration from a space
     * @request DELETE:/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}
     * @secure
     */
    uninstallIntegrationFromSpace: (
      integrationName: string,
      installationId: string,
      spaceId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/integrations/${integrationName}/installations/${installationId}/spaces/${spaceId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a paginated list of the sites an installation is enabled on, with the configuration of the integration for each of them. Pass extended to get the full site object instead of its ID.
     *
     * @tags integrations
     * @name ListIntegrationInstallationSites
     * @summary List all site integration installations
     * @request GET:/integrations/{integrationName}/installations/{installationId}/sites
     * @secure
     */
    listIntegrationInstallationSites: (
      integrationName: string,
      installationId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If true, returns the site object in each items. If false, returns the site ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: IntegrationSiteInstallation[];
        },
        any
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/sites`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/sites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Enables an existing organization-level installation on one site. The organization must already have the integration installed.
     *
     * @tags integrations
     * @name InstallIntegrationOnSite
     * @summary Install an integration on a site
     * @request POST:/integrations/{integrationName}/installations/{installationId}/sites
     * @secure
     */
    installIntegrationOnSite: (
      integrationName: string,
      installationId: string,
      data: {
        /** ID of the site to install the integration on */
        siteId: string;
      },
      query?: {
        /**
         * If true, returns the site object in each items. If false, returns the site ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        IntegrationSiteInstallation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/sites`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/sites",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the installation of an integration on one site, including the configuration of the integration for that site.
     *
     * @tags integrations
     * @name GetIntegrationSiteInstallation
     * @summary Get an integration site installation
     * @request GET:/integrations/{integrationName}/installations/{installationId}/sites/{siteId}
     * @secure
     */
    getIntegrationSiteInstallation: (
      integrationName: string,
      installationId: string,
      siteId: string,
      query?: {
        /**
         * If true, returns the site object in each items. If false, returns the site ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        IntegrationSiteInstallation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/integrations/${integrationName}/installations/${installationId}/sites/${siteId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/sites/{siteId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the configuration of an integration for one site.
     *
     * @tags integrations
     * @name UpdateIntegrationSiteInstallation
     * @summary Update an integration site installation
     * @request PATCH:/integrations/{integrationName}/installations/{installationId}/sites/{siteId}
     * @secure
     */
    updateIntegrationSiteInstallation: (
      integrationName: string,
      installationId: string,
      siteId: string,
      data: UpdateIntegrationSiteInstallation,
      query?: {
        /**
         * If true, returns the site object in each items. If false, returns the site ID in each items.
         * @default false
         */
        extended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IntegrationSiteInstallation, any>({
        path: `/integrations/${integrationName}/installations/${installationId}/sites/${siteId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/sites/{siteId}",
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name UninstallIntegrationFromSite
     * @summary Uninstall an integration from a site
     * @request DELETE:/integrations/{integrationName}/installations/{installationId}/sites/{siteId}
     * @secure
     */
    uninstallIntegrationFromSite: (
      integrationName: string,
      installationId: string,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/integrations/${integrationName}/installations/${installationId}/sites/${siteId}`,
        routeTemplate:
          "/integrations/{integrationName}/installations/{installationId}/sites/{siteId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a paginated list of the integrations available to the organization: every publicly published integration plus the private ones the organization owns or is trusted with. Prefer this over the public listing when acting inside an organization.
     *
     * @tags integrations
     * @name ListOrganizationIntegrations
     * @summary List all public integrations along with private ones trusted by the specific org.
     * @request GET:/orgs/{organizationId}/integrations
     * @secure
     */
    listOrganizationIntegrations: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** A search string to filter integrations by name */
        search?: string;
        /** Filter the integrations by category */
        category?: IntegrationCategory;
        /**
         * Filter the integrations by block's domains
         * @maxLength 100
         * @pattern ^[a-zA-Z0-9-_.]+$
         */
        blockDomain?: string;
        /** If true, returns only integrations with blocks. If false, returns only integrations without blocks. */
        blocks?: boolean;
        /** If true, returns only integrations with contentSources. If false, returns only integrations without contentSources. */
        contentSources?: boolean;
        /** If defined, only list integrations owned by the given organization. */
        owner?: string;
        /** Filter the integrations by scope */
        scope?: IntegrationScope;
        /** Filter the integrations by target */
        target?: IntegrationTarget;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Integration[];
        },
        any
      >({
        path: `/orgs/${organizationId}/integrations`,
        routeTemplate: "/orgs/{organizationId}/integrations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns whether an integration is installed for the organization and the status of that installation. Use this for a single integration instead of listing every status.
     *
     * @tags integrations
     * @name GetOrganizationIntegrationStatus
     * @summary Get the status of an integration
     * @request GET:/orgs/{organizationId}/integrations/{integrationName}/installation_status
     * @secure
     */
    getOrganizationIntegrationStatus: (
      organizationId: EntityId,
      integrationName: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: IntegrationInstallationStatus;
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/integrations/${integrationName}/installation_status`,
        routeTemplate:
          "/orgs/{organizationId}/integrations/{integrationName}/installation_status",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags integrations
     * @name ListOrganizationInstallations
     * @summary List all integration installations
     * @request GET:/orgs/{organizationId}/installations
     * @secure
     */
    listOrganizationInstallations: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** A search string to filter integrations by name */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: {
            /** Installation of an integration on an account */
            installation: IntegrationInstallation;
            integration: Integration;
          }[];
        },
        any
      >({
        path: `/orgs/${organizationId}/installations`,
        routeTemplate: "/orgs/{organizationId}/installations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns integration installations in the organization. Use site or space with the matching target to efficiently scope the result to one resource. The target of each installation says whether it is installed on the organization, a space or a site.
     *
     * @tags integrations, critical
     * @name ListOrganizationIntegrationsStatus
     * @summary List all integration statuses
     * @request GET:/orgs/{organizationId}/integrations/installations-status
     * @secure
     */
    listOrganizationIntegrationsStatus: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * Filter installations by their target (organization, space, or site). When not provided, defaults to organization-level installations for backwards compatibility
         * @default "organization"
         */
        target?: "organization" | "space" | "site";
        /** Return installations for this site. Only valid when target is site. */
        site?: string;
        /** Return installations for this space. Only valid when target is space. */
        space?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: InstalledIntegration[];
        },
        any
      >({
        path: `/orgs/${organizationId}/integrations/installations-status`,
        routeTemplate:
          "/orgs/{organizationId}/integrations/installations-status",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns all integration scripts configured to be injected into the published pages of a site, such as analytics trackers, chat widgets, or custom JavaScript. Use this to audit which third-party scripts are active on the site.
     *
     * @tags integrations, sites
     * @name ListSiteIntegrationScripts
     * @summary List custom scripts injected into a site's published pages
     * @request GET:/orgs/{organizationId}/sites/{siteId}/integration-scripts
     * @secure
     */
    listSiteIntegrationScripts: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteIntegrationScript[],
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/integration-scripts`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/integration-scripts",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of integrations currently enabled on the site. Integrations extend site functionality with third-party services such as analytics, support, or authentication providers. Use this to audit which integrations are active, or to find an integration before updating its settings.
     *
     * @tags integrations, sites
     * @name ListSiteIntegrations
     * @summary List third-party integrations enabled on a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/integrations
     * @secure
     */
    listSiteIntegrations: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** A search string to filter integrations by name */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Integration[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/integrations`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/integrations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @tags organizations, critical
     * @name ListOrganizationsForAuthenticatedUser
     * @summary Get the list of organizations for the currently authenticated user
     * @request GET:/orgs
     * @secure
     */
    listOrganizationsForAuthenticatedUser: (
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** The property to sort the list by. With `lastSeenAt`, only the organizations the user has opened are returned, most recently opened first. It returns at most `limit` items with no next page, and cannot be combined with `page`, because the order changes every time the user opens an organization. */
        sort?: "lastSeenAt";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Organization[];
        },
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs`,
        routeTemplate: "/orgs",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name CreateOrganization
     * @summary Create an organization
     * @request POST:/orgs
     * @secure
     */
    createOrganization: (
      data: CreateOrganization,
      query?: {
        /** If true, also creates a default documentation site for the organization. */
        withDefaultSite?: boolean;
        /** URL of an OpenAPI/Swagger specification to import and attach to the default site as a reference. Only used when `withDefaultSite` is true. */
        openapiUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Organization & {
          /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
          subscriptionNotice?: SubscriptionNotice;
        },
        any
      >({
        path: `/orgs`,
        routeTemplate: "/orgs",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations, critical
     * @name GetOrganizationById
     * @summary Get an organization by its ID
     * @request GET:/orgs/{organizationId}
     * @secure
     */
    getOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        Organization,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}`,
        routeTemplate: "/orgs/{organizationId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations, internal
     * @name DeleteOrganizationById
     * @summary Delete an organization
     * @request DELETE:/orgs/{organizationId}
     * @secure
     */
    deleteOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}`,
        routeTemplate: "/orgs/{organizationId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name UpdateOrganizationById
     * @summary Update an organization
     * @request PATCH:/orgs/{organizationId}
     * @secure
     */
    updateOrganizationById: (
      organizationId: EntityId,
      data: {
        /** Name of the organization */
        title?: OrganizationTitle;
        emailDomains?: OrganizationEmailDomains;
        /** Default hostname for the organization's public content, e.g. <org-hostname>.gitbook.io */
        hostname?: OrganizationHostname;
        /** The role of a member in an organization, null for guests */
        defaultRole?: MemberRoleOrGuest;
        defaultContent?: OrganizationDefaultContent | null;
        logo?: URL | null;
        sso?: boolean;
        ai?: boolean;
        /** Partial AI preference update. Omitted keys are unchanged; null removes an opt-out. */
        aiSettings?: OrganizationAISettingsUpdate;
        inviteLinks?: boolean;
        mergeRules?: MergeRulesStandaloneConfiguration;
        supportCost?: OrganizationSupportCost | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Organization,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}`,
        routeTemplate: "/orgs/{organizationId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists all spaces, collections, sites accessible by current user in the current organization. This endpoint is internal for now as the data structure is optimized for the sidebar.
     *
     * @tags organizations, critical, internal
     * @name GetOrganizationAllContent
     * @summary List all content in an organization
     * @request GET:/orgs/{organizationId}/content
     * @secure
     */
    getOrganizationAllContent: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationAllContent, any>({
        path: `/orgs/${organizationId}/content`,
        routeTemplate: "/orgs/{organizationId}/content",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the supported audit event action identifiers and their display labels. Access is restricted to organization administrators and GitBook staff. The organization must be activated and on an active Enterprise plan, except for GitBook's own organization.
     *
     * @tags organizations
     * @name ListOrganizationAuditEventActions
     * @summary List organization audit event actions
     * @request GET:/orgs/{organizationId}/audit-event-actions
     * @secure
     */
    listOrganizationAuditEventActions: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: AuditEventAction[];
        },
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 403;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/audit-event-actions`,
        routeTemplate: "/orgs/{organizationId}/audit-event-actions",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists recorded changes for an activated organization. Access is restricted to organization administrators and GitBook staff, and results are ordered by occurrence time, newest first. An active Enterprise plan is required except for GitBook's own organization.
     *
     * @tags organizations
     * @name ListOrganizationAuditEvents
     * @summary List organization audit events
     * @request GET:/orgs/{organizationId}/audit-events
     * @secure
     */
    listOrganizationAuditEvents: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * Number of events to return, up to 100.
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number;
        /**
         * Include events occurring at or after this time.
         * @format date-time
         */
        from?: string;
        /**
         * Include events occurring at or before this time.
         * @format date-time
         */
        to?: string;
        /** Filter by an exact audit action name. */
        action?: string;
        /** Filter by an exact stable actor identifier. */
        actor?: string;
        /** Filter by an exact stable target identifier. */
        target?: string;
        /** Include matching counts for action and actor options, excluding the option's own filter. */
        includeFacets?: boolean;
        /**
         * Include any of these action names. Combined with other filters using AND.
         * @maxItems 100
         */
        actions?: string[];
        /**
         * Include any of these stable actor identifiers, including system actors. Combined with other filters using AND.
         * @maxItems 100
         */
        actors?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          facets?: {
            actions: Record<string, number>;
            actors: Record<string, number>;
          };
          items: AuditEvent[];
        },
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 403;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/audit-events`,
        routeTemplate: "/orgs/{organizationId}/audit-events",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the full allowlisted payload for one recorded organization change. Access is restricted to organization administrators and GitBook staff. The organization must be activated and on an active Enterprise plan, except for GitBook's own organization.
     *
     * @tags organizations
     * @name GetOrganizationAuditEvent
     * @summary Get an organization audit event
     * @request GET:/orgs/{organizationId}/audit-events/{auditEventId}
     * @secure
     */
    getOrganizationAuditEvent: (
      organizationId: EntityId,
      auditEventId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AuditEventDetails,
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 403;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/audit-events/${auditEventId}`,
        routeTemplate: "/orgs/{organizationId}/audit-events/{auditEventId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists every style guide (a space holding a team's writing style guide) in the organization, along with every site that references each one. Style guides that are not referenced by any site are still returned with an empty `sites` list.
     *
     * @tags organizations
     * @name ListOrganizationStyleguides
     * @summary List all style guides in an organization
     * @request GET:/orgs/{organizationId}/styleguides
     * @secure
     */
    listOrganizationStyleguides: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationStyleguides, any>({
        path: `/orgs/${organizationId}/styleguides`,
        routeTemplate: "/orgs/{organizationId}/styleguides",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the built-in style guide starter templates that can seed a new styleguide, including the markdown content used to render each template's preview.
     *
     * @tags organizations
     * @name ListStyleguideTemplates
     * @summary List all built-in style guide templates
     * @request GET:/orgs/{organizationId}/styleguide-templates
     * @secure
     */
    listStyleguideTemplates: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<StyleguideTemplates, any>({
        path: `/orgs/${organizationId}/styleguide-templates`,
        routeTemplate: "/orgs/{organizationId}/styleguide-templates",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns whether the organization is on a trial, the free plan or a paid plan, when its trial ends, and where to upgrade. Use it to answer questions about the plan or the trial, or to find how to upgrade.
     *
     * @tags organizations
     * @name GetOrganizationSubscription
     * @summary Get an organization's subscription
     * @request GET:/orgs/{organizationId}/subscription
     * @secure
     */
    getOrganizationSubscription: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationSubscription,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/subscription`,
        routeTemplate: "/orgs/{organizationId}/subscription",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name DeleteOrganizationInviteById
     * @summary Deletes an organization invite.
     * @request DELETE:/orgs/{organizationId}/link-invites/{inviteId}
     * @secure
     */
    deleteOrganizationInviteById: (
      organizationId: EntityId,
      inviteId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/link-invites/${inviteId}`,
        routeTemplate: "/orgs/{organizationId}/link-invites/{inviteId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Join an organization if the user's verified email domain matches one of the organization's allowed email domains. This endpoint allows existing users to join organizations they're eligible for based on their email domain.
     *
     * @tags organizations
     * @name JoinOrganization
     * @summary Join an organization
     * @request POST:/orgs/{organizationId}/join
     * @secure
     */
    joinOrganization: (organizationId: EntityId, params: RequestParams = {}) =>
      this.request<
        void,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/join`,
        routeTemplate: "/orgs/{organizationId}/join",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Send a request to ask the organization's admin to upgrade it.
     *
     * @tags organizations, internal
     * @name RequestOrganizationUpgrade
     * @summary Request organization upgrade
     * @request POST:/orgs/{organizationId}/request_upgrade
     * @secure
     */
    requestOrganizationUpgrade: (
      organizationId: EntityId,
      data: {
        /** The feature key the user is asking an organization upgrade for */
        featureKey?: OrganizationFeature;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/orgs/${organizationId}/request_upgrade`,
        routeTemplate: "/orgs/{organizationId}/request_upgrade",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name SearchOrganizationContent
     * @summary Search content in an organization
     * @request GET:/orgs/{organizationId}/search
     * @secure
     */
    searchOrganizationContent: (
      organizationId: EntityId,
      query: {
        /** @maxLength 512 */
        query: string;
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SearchSpaceResult[];
        },
        any
      >({
        path: `/orgs/${organizationId}/search`,
        routeTemplate: "/orgs/{organizationId}/search",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations, agents
     * @name GetOrganizationAgentInstructions
     * @summary Get Docs agent instructions for an organization
     * @request GET:/orgs/{organizationId}/agent-instructions
     * @secure
     */
    getOrganizationAgentInstructions: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationAgentInstructions, any>({
        path: `/orgs/${organizationId}/agent-instructions`,
        routeTemplate: "/orgs/{organizationId}/agent-instructions",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations, agents
     * @name UpdateOrganizationAgentInstructions
     * @summary Update Docs agent instructions for an organization
     * @request PUT:/orgs/{organizationId}/agent-instructions
     * @secure
     */
    updateOrganizationAgentInstructions: (
      organizationId: EntityId,
      data: {
        /** Document describing the Docs agent instructions. */
        instructions: JSONDocument;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationAgentInstructions, any>({
        path: `/orgs/${organizationId}/agent-instructions`,
        routeTemplate: "/orgs/{organizationId}/agent-instructions",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of the calling user's AI agent conversations with the organization agent. Unlike change request conversations, these are not tied to a single change request: the agent works across the organization and only attaches a change request when it needs to edit content. A conversation belongs to the user who started it and is never visible to anyone else.
     *
     * @tags organizations, agents
     * @name ListOrganizationAgentConversations
     * @summary List AI agent conversations in an organization
     * @request GET:/orgs/{organizationId}/agent/conversations
     * @secure
     */
    listOrganizationAgentConversations: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: AgentConversation[];
        },
        any
      >({
        path: `/orgs/${organizationId}/agent/conversations`,
        routeTemplate: "/orgs/{organizationId}/agent/conversations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Prepares a conversation so the client can connect to it, giving the agent the credentials it acts with. Call this before opening a conversation; connecting to one that was never provisioned yields an agent whose tools all fail. The conversation itself is only recorded once the user sends a first message, so opening the agent and closing it again leaves nothing behind. Safe to call again to refresh an expiring session.
     *
     * @tags organizations, agents
     * @name ProvisionOrganizationAgentConversation
     * @summary Provision an AI agent conversation in an organization
     * @request PUT:/orgs/{organizationId}/agent/conversations/{conversationId}
     * @secure
     */
    provisionOrganizationAgentConversation: (
      organizationId: EntityId,
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/agent/conversations/${conversationId}`,
        routeTemplate:
          "/orgs/{organizationId}/agent/conversations/{conversationId}",
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * @description Updates one of the calling user's conversations with the organization agent. Use this to rename it.
     *
     * @tags organizations, agents
     * @name UpdateOrganizationAgentConversation
     * @summary Update an AI agent conversation in an organization
     * @request PATCH:/orgs/{organizationId}/agent/conversations/{conversationId}
     * @secure
     */
    updateOrganizationAgentConversation: (
      organizationId: EntityId,
      conversationId: string,
      data: {
        /** The new title of the conversation. */
        title: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentConversation, any>({
        path: `/orgs/${organizationId}/agent/conversations/${conversationId}`,
        routeTemplate:
          "/orgs/{organizationId}/agent/conversations/{conversationId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes one of the calling user's conversations with the organization agent, destroying the messages it holds. This cannot be undone.
     *
     * @tags organizations, agents
     * @name DeleteOrganizationAgentConversation
     * @summary Delete an agent conversation in an organization
     * @request DELETE:/orgs/{organizationId}/agent/conversations/{conversationId}
     * @secure
     */
    deleteOrganizationAgentConversation: (
      organizationId: EntityId,
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/agent/conversations/${conversationId}`,
        routeTemplate:
          "/orgs/{organizationId}/agent/conversations/{conversationId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name GetOrganizationsForEmailDomain
     * @summary Get all organizations by email domain
     * @request GET:/email-domains/{emailDomain}/orgs
     * @secure
     */
    getOrganizationsForEmailDomain: (
      emailDomain: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          organizations: Organization[];
        },
        any
      >({
        path: `/email-domains/${emailDomain}/orgs`,
        routeTemplate: "/email-domains/{emailDomain}/orgs",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  organizationMembers = {
    /**
     * @description Lists the members of the organization. Guests can list members too, but the list they get leaves out every guest, themselves included, and filtering by the `guest` role returns no one.
     *
     * @tags organization-members
     * @name ListMembersInOrganizationById
     * @summary List all organization members
     * @request GET:/orgs/{organizationId}/members
     * @secure
     */
    listMembersInOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
        /** The role to filter the list by */
        role?: MemberRole | "guest";
        /** A query to filter the list by display name and email */
        search?: string;
        /**
         * The property to sort the list by
         * @default "joinedAt"
         */
        sort?: "joinedAt" | "lastSeenAt" | "name";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationMember[];
        },
        any
      >({
        path: `/orgs/${organizationId}/members`,
        routeTemplate: "/orgs/{organizationId}/members",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a member of the organization. Guests can get any member who isn't a guest, and themselves. Another guest is reported as not found.
     *
     * @tags organization-members, critical
     * @name GetMemberInOrganizationById
     * @summary Get an organization member by its ID
     * @request GET:/orgs/{organizationId}/members/{userId}
     * @secure
     */
    getMemberInOrganizationById: (
      organizationId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationMember, any>({
        path: `/orgs/${organizationId}/members/${userId}`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-members
     * @name UpdateMemberInOrganizationById
     * @summary Update an organization member
     * @request PATCH:/orgs/{organizationId}/members/{userId}
     * @secure
     */
    updateMemberInOrganizationById: (
      organizationId: EntityId,
      userId: string,
      data: {
        /** The role of a member in an organization, null for guests */
        role?: MemberRoleOrGuest;
        /** Disable or re-enable the member. Only members disabled by an admin can be re-enabled. */
        disabled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationMember, any>({
        path: `/orgs/${organizationId}/members/${userId}`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Users cannot remove their own membership. Ask another organization admin to remove it.
     *
     * @tags organization-members
     * @name RemoveMemberFromOrganizationById
     * @summary Remove an organization member or request an organization admin to do it
     * @request DELETE:/orgs/{organizationId}/members/{userId}
     * @secure
     */
    removeMemberFromOrganizationById: (
      organizationId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/members/${userId}`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-members
     * @name UpdateOrganizationMemberLastSeenAt
     * @summary Update an organization member last seen at
     * @request POST:/orgs/{organizationId}/ping
     * @secure
     */
    updateOrganizationMemberLastSeenAt: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** A JTW token containing the claims to attach to this user. */
          gitbookVisitorClaims?: string;
        },
        any
      >({
        path: `/orgs/${organizationId}/ping`,
        routeTemplate: "/orgs/{organizationId}/ping",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-members
     * @name SetUserAsSsoMemberForOrganization
     * @summary Set a user as an SSO member of an organization
     * @request POST:/orgs/{organizationId}/members/{userId}/sso
     * @secure
     */
    setUserAsSsoMemberForOrganization: (
      organizationId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationMember, any>({
        path: `/orgs/${organizationId}/members/${userId}/sso`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}/sso",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-members
     * @name ListSpacesForOrganizationMember
     * @summary List an organization member space permissions
     * @request GET:/orgs/{organizationId}/members/{userId}/spaces
     * @secure
     */
    listSpacesForOrganizationMember: (
      organizationId: EntityId,
      userId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: MemberContentPermission[];
        },
        any
      >({
        path: `/orgs/${organizationId}/members/${userId}/spaces`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}/spaces",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-members, internal
     * @name ListSitesForOrganizationMember
     * @summary List all organization sites and the specified member's access level for each. Includes sites the member does not yet have access to, so administrators can grant access if needed.
     * @request GET:/orgs/{organizationId}/members/{userId}/sites
     * @secure
     */
    listSitesForOrganizationMember: (
      organizationId: EntityId,
      userId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
        /** Filter sites by their title */
        title?: string;
        /** Filter by site type */
        type?: SiteType[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: MemberSitePermission[];
        },
        any
      >({
        path: `/orgs/${organizationId}/members/${userId}/sites`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}/sites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-members
     * @name ListTeamsForOrganizationMember
     * @summary List all organization member teams
     * @request GET:/orgs/{organizationId}/members/{userId}/teams
     * @secure
     */
    listTeamsForOrganizationMember: (
      organizationId: EntityId,
      userId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** If provided, only teams whose name contains the given parameter will be returned. Case insensitive. */
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: {
            team: OrganizationTeam;
            member: TeamMember;
          }[];
        },
        any
      >({
        path: `/orgs/${organizationId}/members/${userId}/teams`,
        routeTemplate: "/orgs/{organizationId}/members/{userId}/teams",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  teams = {
    /**
     * No description
     *
     * @tags teams
     * @name ListTeamsInOrganizationById
     * @summary List all teams
     * @request GET:/orgs/{organizationId}/teams
     * @secure
     */
    listTeamsInOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** The unique identifier of a member of the organization. Only teams they can manage will be returned. */
        owner?: string;
        /** If provided, only teams whose name contains the given parameter will be returned. Case insensitive. */
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationTeam[];
        },
        any
      >({
        path: `/orgs/${organizationId}/teams`,
        routeTemplate: "/orgs/{organizationId}/teams",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name CreateOrganizationTeam
     * @summary Create a team
     * @request PUT:/orgs/{organizationId}/teams
     * @secure
     */
    createOrganizationTeam: (
      organizationId: EntityId,
      data: {
        /** Title of the team */
        title: OrganizationTeamTitle;
        /** A list of organization member identifiers */
        members?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationTeam, any>({
        path: `/orgs/${organizationId}/teams`,
        routeTemplate: "/orgs/{organizationId}/teams",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name GetTeamInOrganizationById
     * @summary Get a team
     * @request GET:/orgs/{organizationId}/teams/{teamId}
     * @secure
     */
    getTeamInOrganizationById: (
      organizationId: EntityId,
      teamId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationTeam, any>({
        path: `/orgs/${organizationId}/teams/${teamId}`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name UpdateTeamInOrganizationById
     * @summary Update a team
     * @request PATCH:/orgs/{organizationId}/teams/{teamId}
     * @secure
     */
    updateTeamInOrganizationById: (
      organizationId: EntityId,
      teamId: EntityId,
      data: {
        /** Title of the team */
        title: OrganizationTeamTitle;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationTeam, any>({
        path: `/orgs/${organizationId}/teams/${teamId}`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name RemoveTeamFromOrganizationById
     * @summary Delete a team
     * @request DELETE:/orgs/{organizationId}/teams/{teamId}
     * @secure
     */
    removeTeamFromOrganizationById: (
      organizationId: EntityId,
      teamId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/teams/${teamId}`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  teamMembers = {
    /**
     * @description Updates members of an organization team, either adding or removing them. If a the same user is included as both an add and a remove, they will be removed from the team.
     *
     * @tags team-members
     * @name UpdateMembersInOrganizationTeam
     * @summary Updates members of a team
     * @request PUT:/orgs/{organizationId}/teams/{teamId}/members
     * @secure
     */
    updateMembersInOrganizationTeam: (
      organizationId: EntityId,
      teamId: EntityId,
      data: UpdateMembersInOrganizationTeam,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/teams/${teamId}/members`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}/members",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Lists members, and their roles, for the specified organization team.
     *
     * @tags team-members
     * @name ListTeamMembersInOrganizationById
     * @summary List all team members
     * @request GET:/orgs/{organizationId}/teams/{teamId}/members
     * @secure
     */
    listTeamMembersInOrganizationById: (
      organizationId: EntityId,
      teamId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationTeamMember[];
        },
        any
      >({
        path: `/orgs/${organizationId}/teams/${teamId}/members`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}/members",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add or updates member in the specified organization team.
     *
     * @tags team-members
     * @name AddMemberToOrganizationTeamById
     * @summary Add a team member
     * @request PUT:/orgs/{organizationId}/teams/{teamId}/members/{userId}
     * @secure
     */
    addMemberToOrganizationTeamById: (
      organizationId: EntityId,
      teamId: EntityId,
      userId: string,
      data: {
        /**
         * "The role of a team member.
         * "owner": Can manage team members.
         * "member": Is a member of the team.
         */
        role?: TeamMemberRole;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/teams/${teamId}/members/${userId}`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}/members/{userId}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes member from the specified organization team.
     *
     * @tags team-members
     * @name DeleteMemberFromOrganizationTeamById
     * @summary Delete a team member
     * @request DELETE:/orgs/{organizationId}/teams/{teamId}/members/{userId}
     * @secure
     */
    deleteMemberFromOrganizationTeamById: (
      organizationId: EntityId,
      teamId: EntityId,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/teams/${teamId}/members/${userId}`,
        routeTemplate: "/orgs/{organizationId}/teams/{teamId}/members/{userId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  organizationInvites = {
    /**
     * No description
     *
     * @tags organization-invites
     * @name InviteUsersToOrganization
     * @summary Invite users in an organization
     * @request POST:/orgs/{organizationId}/invites
     * @secure
     */
    inviteUsersToOrganization: (
      organizationId: EntityId,
      data: InviteUsersToOrganization,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          users: string[];
          /** The number of users who were added to the organization */
          invited: number;
          failedSSOEmails?: string[];
        },
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/invites`,
        routeTemplate: "/orgs/{organizationId}/invites",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-invites
     * @name JoinOrganizationWithInvite
     * @summary Join an organization with an invite
     * @request POST:/orgs/{organizationId}/invites/{inviteId}
     * @secure
     */
    joinOrganizationWithInvite: (
      organizationId: EntityId,
      inviteId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/orgs/${organizationId}/invites/${inviteId}`,
        routeTemplate: "/orgs/{organizationId}/invites/{inviteId}",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-invites, internal
     * @name ListOrganizationContentInviteLinks
     * @summary List all content invites
     * @request GET:/orgs/{organizationId}/content-link-invites
     * @secure
     */
    listOrganizationContentInviteLinks: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** If specified, only return invite links that provide specific permissions on the given space. */
        space?: string;
        /** If specified, only return invite links that provide permissions on the given collection. */
        collection?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: (InviteLinkToCollection | InviteLinkToSpace)[];
        },
        any
      >({
        path: `/orgs/${organizationId}/content-link-invites`,
        routeTemplate: "/orgs/{organizationId}/content-link-invites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-invites
     * @name ListOrganizationInviteLinks
     * @summary List organization invites
     * @request GET:/orgs/{organizationId}/link-invites
     * @secure
     */
    listOrganizationInviteLinks: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: InviteLinkToOrganization[];
        },
        any
      >({
        path: `/orgs/${organizationId}/link-invites`,
        routeTemplate: "/orgs/{organizationId}/link-invites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-invites
     * @name CreateOrganizationInvite
     * @summary Create an organization invite
     * @request POST:/orgs/{organizationId}/link-invites
     * @secure
     */
    createOrganizationInvite: (
      organizationId: EntityId,
      data: CreateOrganizationInvite,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationInviteLink, any>({
        path: `/orgs/${organizationId}/link-invites`,
        routeTemplate: "/orgs/{organizationId}/link-invites",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-invites
     * @name GetOrganizationInviteLink
     * @summary Get an organization by its ID
     * @request GET:/orgs/{organizationId}/link-invites/{inviteId}
     * @secure
     */
    getOrganizationInviteLink: (
      organizationId: EntityId,
      inviteId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationInviteLink, any>({
        path: `/orgs/${organizationId}/link-invites/${inviteId}`,
        routeTemplate: "/orgs/{organizationId}/link-invites/{inviteId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-invites
     * @name UpdateOrganizationInviteById
     * @summary Update an organization invite
     * @request PATCH:/orgs/{organizationId}/link-invites/{inviteId}
     * @secure
     */
    updateOrganizationInviteById: (
      organizationId: EntityId,
      inviteId: EntityId,
      data:
        | {
            /** The role of a member in an organization, null for guests */
            role: MemberRoleOrGuest;
          }
        | {
            /** The role of a member in an organization, null for guests */
            level: MemberRoleOrGuest;
          },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationInviteLink, any>({
        path: `/orgs/${organizationId}/link-invites/${inviteId}`,
        routeTemplate: "/orgs/{organizationId}/link-invites/{inviteId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  billing = {
    /**
     * No description
     *
     * @tags billing, internal
     * @name UpgradeOrganizationPlan
     * @summary Upgrade an organization billing plan
     * @request POST:/orgs/{organizationId}/billing
     * @secure
     */
    upgradeOrganizationPlan: (
      organizationId: EntityId,
      data: UpgradeOrganizationBilling,
      query?: {
        /** The app screen URL to bring the user back to after a successful checkout. */
        successReturnURL?: string;
        /** The app screen URL to bring the user back to after a canceled checkout. */
        cancelReturnURL?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BillingUpgrade, any>({
        path: `/orgs/${organizationId}/billing`,
        routeTemplate: "/orgs/{organizationId}/billing",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing, internal
     * @name UpdateOrganizationBillingSettings
     * @summary Update organization billing settings
     * @request PATCH:/orgs/{organizationId}/billing/settings
     * @secure
     */
    updateOrganizationBillingSettings: (
      organizationId: EntityId,
      data: {
        /** Percentage threshold, or null to disable the alert. */
        aiCreditAlertThreshold?: AICreditThreshold;
        /** Whether AI features pause automatically once all AI credits are used, before usage is billed as overage. */
        aiCreditPauseEnabled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Organization, any>({
        path: `/orgs/${organizationId}/billing/settings`,
        routeTemplate: "/orgs/{organizationId}/billing/settings",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing, internal
     * @name GetOrganizationBillingPortal
     * @summary Get the billing portal
     * @request GET:/orgs/{organizationId}/billing/portal
     * @secure
     */
    getOrganizationBillingPortal: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<BillingPortal, any>({
        path: `/orgs/${organizationId}/billing/portal`,
        routeTemplate: "/orgs/{organizationId}/billing/portal",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates a billing invoice preview for organizations without an active subscription.
     *
     * @tags billing, internal
     * @name PreviewBillingInvoice
     * @summary Preview billing invoice
     * @request GET:/orgs/{organizationId}/billing/preview
     * @secure
     */
    previewBillingInvoice: (
      organizationId: EntityId,
      query: {
        /** The desired billing interval plan */
        interval: BillingInterval;
        /** The desired core plan */
        product: BillingProduct;
        /** The desired amount of members in the organization */
        members?: number;
        /** The desired amount of published premium sites */
        premiumSites?: number;
        /** The desired amount of published ultimate sites */
        ultimateSites?: number;
        /** Coupon or promotion code to apply */
        coupon?: BillingCoupon;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BillingInvoicePreview & {
          action: BillingSwitchAction | null;
        },
        any
      >({
        path: `/orgs/${organizationId}/billing/preview`,
        routeTemplate: "/orgs/{organizationId}/billing/preview",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns recorded AI usage for an organization. Calendar buckets use UTC; weeks start on Monday. Requires organization administrator permissions.
     *
     * @tags billing
     * @name GetOrganizationAiUsage
     * @summary Get AI credit usage by AI feature and time period
     * @request GET:/orgs/{organizationId}/billing/ai-usage
     * @secure
     */
    getOrganizationAiUsage: (
      organizationId: EntityId,
      query: {
        /**
         * Inclusive start timestamp. Cannot be older than two years from now.
         * @format date-time
         */
        from: string;
        /**
         * Exclusive end timestamp.
         * @format date-time
         */
        to: string;
        /** Calendar interval used to aggregate usage. */
        interval?: AIUsageInterval;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationAIUsage, any>({
        path: `/orgs/${organizationId}/billing/ai-usage`,
        routeTemplate: "/orgs/{organizationId}/billing/ai-usage",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing, internal
     * @name EnableOrganizationBillingMeterAddon
     * @summary Enable billing meter addon for an organization
     * @request PUT:/orgs/{organizationId}/billing/meters/{meterName}
     * @secure
     */
    enableOrganizationBillingMeterAddon: (
      organizationId: EntityId,
      meterName: BillingMeter,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/billing/meters/${meterName}`,
        routeTemplate: "/orgs/{organizationId}/billing/meters/{meterName}",
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing, internal
     * @name DisableOrganizationBillingMeterAddon
     * @summary Disable billing meter addon for an organization
     * @request DELETE:/orgs/{organizationId}/billing/meters/{meterName}
     * @secure
     */
    disableOrganizationBillingMeterAddon: (
      organizationId: EntityId,
      meterName: BillingMeter,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/billing/meters/${meterName}`,
        routeTemplate: "/orgs/{organizationId}/billing/meters/{meterName}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags billing, internal
     * @name GetOrganizationBillingMeterUsage
     * @summary Get billing meter usage for an organization
     * @request GET:/orgs/{organizationId}/billing/meters/{meterName}/usage
     * @secure
     */
    getOrganizationBillingMeterUsage: (
      organizationId: EntityId,
      meterName: BillingMeter,
      params: RequestParams = {},
    ) =>
      this.request<BillingMeterUsage, any>({
        path: `/orgs/${organizationId}/billing/meters/${meterName}/usage`,
        routeTemplate:
          "/orgs/{organizationId}/billing/meters/{meterName}/usage",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sso = {
    /**
     * @description Lists SAML providers configured for the specified organization.
     *
     * @tags sso
     * @name ListSamlProvidersInOrganizationById
     * @summary List all SAML providers
     * @request GET:/orgs/{organizationId}/saml
     * @secure
     */
    listSamlProvidersInOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationSAMLProvider[];
        },
        any
      >({
        path: `/orgs/${organizationId}/saml`,
        routeTemplate: "/orgs/{organizationId}/saml",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso
     * @name CreateOrganizationSamlProvider
     * @summary Create a new SAML provider
     * @request POST:/orgs/{organizationId}/saml
     * @secure
     */
    createOrganizationSamlProvider: (
      organizationId: EntityId,
      data: {
        label: SAMLProviderLabel;
        entityID?: SAMLProviderEntityID;
        certificate?: SAMLProviderCertificate;
        ssoURL?: URL;
        defaultTeam?: string;
        /** The role of a member in an organization, null for guests */
        defaultRole?: MemberRoleOrGuest;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationSAMLProvider, any>({
        path: `/orgs/${organizationId}/saml`,
        routeTemplate: "/orgs/{organizationId}/saml",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso
     * @name GetOrganizationSamlProviderById
     * @summary Get a SAML provider by its ID
     * @request GET:/orgs/{organizationId}/saml/{samlProviderId}
     * @secure
     */
    getOrganizationSamlProviderById: (
      organizationId: EntityId,
      samlProviderId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationSAMLProvider,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/saml/${samlProviderId}`,
        routeTemplate: "/orgs/{organizationId}/saml/{samlProviderId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso
     * @name UpdateOrganizationSamlProvider
     * @summary Update a SAML provider
     * @request PATCH:/orgs/{organizationId}/saml/{samlProviderId}
     * @secure
     */
    updateOrganizationSamlProvider: (
      organizationId: EntityId,
      samlProviderId: string,
      data: {
        label?: SAMLProviderLabel;
        entityID?: SAMLProviderEntityID;
        certificate?: SAMLProviderCertificate;
        ssoURL?: URL;
        defaultTeam?: string;
        /** The role of a member in an organization, null for guests */
        defaultRole?: MemberRoleOrGuest;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationSAMLProvider, any>({
        path: `/orgs/${organizationId}/saml/${samlProviderId}`,
        routeTemplate: "/orgs/{organizationId}/saml/{samlProviderId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso
     * @name DeleteOrganizationSamlProvider
     * @summary Delete a SAML provider
     * @request DELETE:/orgs/{organizationId}/saml/{samlProviderId}
     * @secure
     */
    deleteOrganizationSamlProvider: (
      organizationId: EntityId,
      samlProviderId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/saml/${samlProviderId}`,
        routeTemplate: "/orgs/{organizationId}/saml/{samlProviderId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso
     * @name ListSsoProviderLoginsInOrganization
     * @summary List all SSO provider login infos
     * @request GET:/orgs/{organizationId}/sso
     * @secure
     */
    listSsoProviderLoginsInOrganization: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: OrganizationSSOProviderLogin[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sso`,
        routeTemplate: "/orgs/{organizationId}/sso",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  scim = {
    /**
     * No description
     *
     * @tags scim
     * @name ListOrganizationScimConnections
     * @summary List SCIM connections
     * @request GET:/orgs/{organizationId}/scim/connections
     * @secure
     */
    listOrganizationScimConnections: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OrganizationSCIMConnection[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/scim/connections`,
        routeTemplate: "/orgs/{organizationId}/scim/connections",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a SCIM connection and its token. The token is only returned in this response.
     *
     * @tags scim
     * @name CreateOrganizationScimConnection
     * @summary Create a SCIM connection
     * @request POST:/orgs/{organizationId}/scim/connections
     * @secure
     */
    createOrganizationScimConnection: (
      organizationId: EntityId,
      data: {
        /** Name of the SCIM connection, shown to organization admins. */
        label: SCIMConnectionLabel;
        /** Identity provider that provisions members through the SCIM connection. */
        provider: SCIMConnectionProvider;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationSCIMConnectionWithToken,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 412;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/scim/connections`,
        routeTemplate: "/orgs/{organizationId}/scim/connections",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags scim
     * @name GetOrganizationScimConnection
     * @summary Get a SCIM connection by its ID
     * @request GET:/orgs/{organizationId}/scim/connections/{scimConnectionId}
     * @secure
     */
    getOrganizationScimConnection: (
      organizationId: EntityId,
      scimConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationSCIMConnection,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/scim/connections/${scimConnectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/scim/connections/{scimConnectionId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags scim
     * @name UpdateOrganizationScimConnection
     * @summary Update a SCIM connection
     * @request PATCH:/orgs/{organizationId}/scim/connections/{scimConnectionId}
     * @secure
     */
    updateOrganizationScimConnection: (
      organizationId: EntityId,
      scimConnectionId: string,
      data: {
        /** Name of the SCIM connection, shown to organization admins. */
        label: SCIMConnectionLabel;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationSCIMConnection,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/scim/connections/${scimConnectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/scim/connections/{scimConnectionId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a SCIM connection. Its token stops working immediately.
     *
     * @tags scim
     * @name DeleteOrganizationScimConnection
     * @summary Delete a SCIM connection
     * @request DELETE:/orgs/{organizationId}/scim/connections/{scimConnectionId}
     * @secure
     */
    deleteOrganizationScimConnection: (
      organizationId: EntityId,
      scimConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/scim/connections/${scimConnectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/scim/connections/{scimConnectionId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Replaces the token of a SCIM connection. The previous token stops working immediately, and the new token is only returned in this response.
     *
     * @tags scim
     * @name RotateOrganizationScimConnectionToken
     * @summary Rotate the token of a SCIM connection
     * @request POST:/orgs/{organizationId}/scim/connections/{scimConnectionId}/token
     * @secure
     */
    rotateOrganizationScimConnectionToken: (
      organizationId: EntityId,
      scimConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationSCIMConnectionWithToken,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/scim/connections/${scimConnectionId}/token`,
        routeTemplate:
          "/orgs/{organizationId}/scim/connections/{scimConnectionId}/token",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  organizationsUsage = {
    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetUsageForOrganizationById
     * @summary Get all usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage
     * @secure
     */
    getUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationUsage, any>({
        path: `/orgs/${organizationId}/usage`,
        routeTemplate: "/orgs/{organizationId}/usage",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetCollectionsUsageForOrganizationById
     * @summary Get collections usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage/collections
     * @secure
     */
    getCollectionsUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Collections usage metrics of an organization */
          collections: OrganizationUsageCollections;
        },
        any
      >({
        path: `/orgs/${organizationId}/usage/collections`,
        routeTemplate: "/orgs/{organizationId}/usage/collections",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetSpacesUsageForOrganizationById
     * @summary Get spaces usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage/spaces
     * @secure
     */
    getSpacesUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Spaces usage metrics of an organization */
          spaces: OrganizationUsageSpaces;
        },
        any
      >({
        path: `/orgs/${organizationId}/usage/spaces`,
        routeTemplate: "/orgs/{organizationId}/usage/spaces",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetSitesUsageForOrganizationById
     * @summary Get sites usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage/sites
     * @secure
     */
    getSitesUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Sites usage metrics of an organization */
          sites: OrganizationUsageSites;
        },
        any
      >({
        path: `/orgs/${organizationId}/usage/sites`,
        routeTemplate: "/orgs/{organizationId}/usage/sites",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetTeamsUsageForOrganizationById
     * @summary Get teams usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage/teams
     * @secure
     */
    getTeamsUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Team members usage metrics of an organization */
          teams: OrganizationUsageTeams;
        },
        any
      >({
        path: `/orgs/${organizationId}/usage/teams`,
        routeTemplate: "/orgs/{organizationId}/usage/teams",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetMembersUsageForOrganizationById
     * @summary Get members usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage/members
     * @secure
     */
    getMembersUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Members usage metrics of an organization */
          members: OrganizationUsageMembers;
        },
        any
      >({
        path: `/orgs/${organizationId}/usage/members`,
        routeTemplate: "/orgs/{organizationId}/usage/members",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations-usage, usage, internal
     * @name GetTeamMembersUsageForOrganizationById
     * @summary Get team members usage metrics for an organization
     * @request GET:/orgs/{organizationId}/usage/team-members
     * @secure
     */
    getTeamMembersUsageForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Team members usage metrics of an organization */
          teamMembers: OrganizationUsageTeamMembers;
        },
        any
      >({
        path: `/orgs/${organizationId}/usage/team-members`,
        routeTemplate: "/orgs/{organizationId}/usage/team-members",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  organizationAsk = {
    /**
     * @description Ask a question to an AI across spaces that is accessible by the currently authenticated target.
     *
     * @tags organization-ask
     * @name AskInOrganization
     * @summary Ask a question in an organization
     * @request POST:/orgs/{organizationId}/ask
     * @secure
     */
    askInOrganization: (
      organizationId: EntityId,
      data: SearchAIQuery,
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
        /** Return query details in the result */
        details?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Answer from AI for a question asked on a content. */
          answer?: SearchAIAnswer;
        },
        any
      >({
        path: `/orgs/${organizationId}/ask`,
        routeTemplate: "/orgs/{organizationId}/ask",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-ask
     * @name GetRecommendedQuestionsInOrganization
     * @summary List recommended questions to ask in an organization
     * @request GET:/orgs/{organizationId}/ask/questions
     * @secure
     */
    getRecommendedQuestionsInOrganization: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<SearchAIRecommendedQuestions, any>({
        path: `/orgs/${organizationId}/ask/questions`,
        routeTemplate: "/orgs/{organizationId}/ask/questions",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags organization-ask
     * @name StreamRecommendedQuestionsInOrganization
     * @summary List recommended questions to ask in an organization (streamed)
     * @request GET:/orgs/{organizationId}/ask/questions/stream
     * @secure
     */
    streamRecommendedQuestionsInOrganization: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.streamRequest<SearchAIRecommendedQuestionStream, any>({
        path: `/orgs/${organizationId}/ask/questions/stream`,
        routeTemplate: "/orgs/{organizationId}/ask/questions/stream",
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Ask a question to an AI across spaces that is accessible by the currently authenticated target and stream the answer as a Server-Sent Events URL.
     *
     * @tags organization-ask
     * @name StreamAskInOrganization
     * @summary Ask a question in an organization (streamed)
     * @request GET:/orgs/{organizationId}/ask/stream
     * @secure
     */
    streamAskInOrganization: (
      organizationId: EntityId,
      query: {
        query: string;
        /** Output format for the content. */
        format?: "document" | "markdown";
        /** Return query details in the result */
        details?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.streamRequest<SearchAIAnswerStream, any>({
        path: `/orgs/${organizationId}/ask/stream`,
        routeTemplate: "/orgs/{organizationId}/ask/stream",
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  openapi = {
    /**
     * No description
     *
     * @tags openapi
     * @name ListOpenApiSpecs
     * @summary List all OpenAPI spec
     * @request GET:/orgs/{organizationId}/openapi
     * @secure
     */
    listOpenApiSpecs: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OpenAPISpec[];
        },
        any
      >({
        path: `/orgs/${organizationId}/openapi`,
        routeTemplate: "/orgs/{organizationId}/openapi",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Adds an OpenAPI spec to the organization, from a URL or from its text. The spec is processed asynchronously and no page is created: to publish its API reference in a space, insert a page that renders it with an `insert_computed_page` change, through the `updateChangeRequestContent` operation. That reference fills in once processing completes and is regenerated each time the spec is updated.
     *
     * @tags openapi
     * @name CreateOpenApiSpec
     * @summary Create an OpenAPI spec
     * @request POST:/orgs/{organizationId}/openapi
     * @secure
     */
    createOpenApiSpec: (
      organizationId: EntityId,
      data: {
        /** Slug used as reference */
        slug: OpenAPISpecSlug;
        /** Create a specification from an URL */
        source: OpenAPISpecSource;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpec,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi`,
        routeTemplate: "/orgs/{organizationId}/openapi",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi
     * @name GetOpenApiSpecBySlug
     * @summary Get an OpenAPI spec by its slug
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}
     * @secure
     */
    getOpenApiSpecBySlug: (
      organizationId: EntityId,
      specSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpec,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}`,
        routeTemplate: "/orgs/{organizationId}/openapi/{specSlug}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates the organization's OpenAPI spec with this slug, or replaces its source with a new version. The spec is processed asynchronously, and pages that already render it are regenerated once it is. Creating a spec adds no page: to publish its API reference in a space, insert a page that renders it with an `insert_computed_page` change, through the `updateChangeRequestContent` operation.
     *
     * @tags openapi
     * @name CreateOrUpdateOpenApiSpecBySlug
     * @summary Create or update an OpenAPI spec
     * @request PUT:/orgs/{organizationId}/openapi/{specSlug}
     * @secure
     */
    createOrUpdateOpenApiSpecBySlug: (
      organizationId: EntityId,
      specSlug: string,
      data: {
        /** Create a specification from an URL */
        source: OpenAPISpecSource;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpec,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}`,
        routeTemplate: "/orgs/{organizationId}/openapi/{specSlug}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi
     * @name UpdateOpenApiSpecBySlug
     * @summary Update OpenAPI spec visibility
     * @request PATCH:/orgs/{organizationId}/openapi/{specSlug}
     * @secure
     */
    updateOpenApiSpecBySlug: (
      organizationId: EntityId,
      specSlug: string,
      data: {
        /**
         * The visibility setting of the OpenAPI spec.
         * * `private`: The spec is not publicly available.
         * * `public`: The spec is available to anyone with a public link.
         */
        visibility: OpenAPISpecVisibility;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpec,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}`,
        routeTemplate: "/orgs/{organizationId}/openapi/{specSlug}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi
     * @name DeleteOpenApiSpecBySlug
     * @summary Delete an OpenAPI spec
     * @request DELETE:/orgs/{organizationId}/openapi/{specSlug}
     * @secure
     */
    deleteOpenApiSpecBySlug: (
      organizationId: EntityId,
      specSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/openapi/${specSlug}`,
        routeTemplate: "/orgs/{organizationId}/openapi/{specSlug}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  openapiVersions = {
    /**
     * No description
     *
     * @tags openapi-versions
     * @name ListOpenApiSpecVersions
     * @summary List all OpenAPI spec versions
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions
     * @secure
     */
    listOpenApiSpecVersions: (
      organizationId: EntityId,
      specSlug: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: OpenAPISpecVersion[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}/versions`,
        routeTemplate: "/orgs/{organizationId}/openapi/{specSlug}/versions",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi-versions
     * @name GetLatestOpenApiSpecVersion
     * @summary Get the latest OpenAPI spec version
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/latest
     * @secure
     */
    getLatestOpenApiSpecVersion: (
      organizationId: EntityId,
      specSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpecVersion,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}/versions/latest`,
        routeTemplate:
          "/orgs/{organizationId}/openapi/{specSlug}/versions/latest",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi-versions
     * @name GetLatestOpenApiSpecVersionContent
     * @summary Get the latest OpenAPI spec version content
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content
     * @secure
     */
    getLatestOpenApiSpecVersionContent: (
      organizationId: EntityId,
      specSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpecContent,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}/versions/latest/content`,
        routeTemplate:
          "/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi-versions
     * @name GetLatestOpenApiSpecVersionContentRaw
     * @summary Get the raw content of the latest OpenAPI spec version
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content/raw
     * @secure
     */
    getLatestOpenApiSpecVersionContentRaw: (
      organizationId: EntityId,
      specSlug: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpecRawContent,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}/versions/latest/content/raw`,
        routeTemplate:
          "/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content/raw",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi-versions
     * @name GetOpenApiSpecVersionById
     * @summary Get an OpenAPI spec version by its ID
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}
     * @secure
     */
    getOpenApiSpecVersionById: (
      organizationId: EntityId,
      specSlug: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpecVersion,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}/versions/${versionId}`,
        routeTemplate:
          "/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags openapi-versions
     * @name GetOpenApiSpecVersionContentById
     * @summary Get an OpenAPI spec version content by its ID
     * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}/content
     * @secure
     */
    getOpenApiSpecVersionContentById: (
      organizationId: EntityId,
      specSlug: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OpenAPISpecContent,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/openapi/${specSlug}/versions/${versionId}/content`,
        routeTemplate:
          "/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}/content",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  translations = {
    /**
     * No description
     *
     * @tags translations
     * @name ListTranslations
     * @summary List all the translations
     * @request GET:/orgs/{organizationId}/translations
     * @secure
     */
    listTranslations: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Translation[];
        },
        any
      >({
        path: `/orgs/${organizationId}/translations`,
        routeTemplate: "/orgs/{organizationId}/translations",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags translations
     * @name CreateTranslation
     * @summary Create a translation
     * @request POST:/orgs/{organizationId}/translations
     * @secure
     */
    createTranslation: (
      organizationId: EntityId,
      data: {
        source: TranslationSource;
        language: TranslationLanguage;
        instructions?: JSONDocument;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Translation,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/translations`,
        routeTemplate: "/orgs/{organizationId}/translations",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags translations
     * @name GetTranslation
     * @summary Get a translation by its ID
     * @request GET:/orgs/{organizationId}/translations/{translationId}
     * @secure
     */
    getTranslation: (
      organizationId: EntityId,
      translationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Translation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/translations/${translationId}`,
        routeTemplate: "/orgs/{organizationId}/translations/{translationId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags translations
     * @name UpdateTranslation
     * @summary Update a translation
     * @request PUT:/orgs/{organizationId}/translations/{translationId}
     * @secure
     */
    updateTranslation: (
      organizationId: EntityId,
      translationId: string,
      data: {
        instructions: JSONDocument;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Translation,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/translations/${translationId}`,
        routeTemplate: "/orgs/{organizationId}/translations/{translationId}",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags translations
     * @name DeleteTranslation
     * @summary Delete a translation
     * @request DELETE:/orgs/{organizationId}/translations/{translationId}
     * @secure
     */
    deleteTranslation: (
      organizationId: EntityId,
      translationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/translations/${translationId}`,
        routeTemplate: "/orgs/{organizationId}/translations/{translationId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags translations
     * @name RunTranslation
     * @summary Run a translation again
     * @request POST:/orgs/{organizationId}/translations/{translationId}/run
     * @secure
     */
    runTranslation: (
      organizationId: EntityId,
      translationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/translations/${translationId}/run`,
        routeTemplate:
          "/orgs/{organizationId}/translations/{translationId}/run",
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  glossary = {
    /**
     * No description
     *
     * @tags glossary
     * @name ListGlossaryEntries
     * @summary List glossary entries
     * @request GET:/orgs/{organizationId}/translations-glossary
     * @secure
     */
    listGlossaryEntries: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Sort results by language key */
        orderBy?: TranslationLanguage;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: GlossaryEntry[];
        },
        any
      >({
        path: `/orgs/${organizationId}/translations-glossary`,
        routeTemplate: "/orgs/{organizationId}/translations-glossary",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags glossary
     * @name UpdateGlossaryEntries
     * @summary Update glossary entries
     * @request PUT:/orgs/{organizationId}/translations-glossary
     * @secure
     */
    updateGlossaryEntries: (
      organizationId: EntityId,
      data: {
        operations: GlossaryBatchOperation[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/translations-glossary`,
        routeTemplate: "/orgs/{organizationId}/translations-glossary",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags glossary
     * @name GetGlossaryEntry
     * @summary Get a glossary entry by its ID
     * @request GET:/orgs/{organizationId}/translations-glossary/{glossaryEntryId}
     * @secure
     */
    getGlossaryEntry: (
      organizationId: EntityId,
      glossaryEntryId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        GlossaryEntry,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/translations-glossary/${glossaryEntryId}`,
        routeTemplate:
          "/orgs/{organizationId}/translations-glossary/{glossaryEntryId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  storage = {
    /**
     * @description Generate a pre-signed URL that can be used to upload a file to storage
     *
     * @tags storage
     * @name GenerateStorageUploadUrl
     * @summary Create a signed URL to upload a file
     * @request POST:/orgs/{organizationId}/storage/upload
     * @secure
     */
    generateStorageUploadUrl: (
      organizationId: EntityId,
      data: {
        file: StorageFileMetadata;
        kind: StorageUploadKind;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        StorageUploadURL,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/storage/upload`,
        routeTemplate: "/orgs/{organizationId}/storage/upload",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customFonts = {
    /**
     * No description
     *
     * @tags custom-fonts
     * @name ListCustomFonts
     * @summary List all custom fonts
     * @request GET:/orgs/{organizationId}/fonts
     * @secure
     */
    listCustomFonts: (organizationId: EntityId, params: RequestParams = {}) =>
      this.request<
        List & {
          items: CustomizationFontDefinition[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/fonts`,
        routeTemplate: "/orgs/{organizationId}/fonts",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom-fonts
     * @name CreateCustomFont
     * @summary Create a custom font
     * @request PUT:/orgs/{organizationId}/fonts
     * @secure
     */
    createCustomFont: (
      organizationId: EntityId,
      data: {
        /** The human-readable font-family name used in CSS (e.g., "Open Sans", "Playfair Display"). */
        fontFamily: FontFamily;
        /**
         * Array of font faces specifying weights and their corresponding storage keys.
         * At least one font face with weight 400 (regular) must be provided.
         * @minItems 1
         */
        fontFaces: {
          /** Numeric representation of the font weight (400=regular, 500=medium, 700=bold, 900=black). */
          weight: FontWeight;
          /** The path of the file in the storage bucket */
          storageKey: StorageFileKey;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        CustomizationFontDefinition,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 412;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/fonts`,
        routeTemplate: "/orgs/{organizationId}/fonts",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom-fonts
     * @name GetCustomFont
     * @summary Get a custom font by its ID
     * @request GET:/orgs/{organizationId}/fonts/{fontId}
     * @secure
     */
    getCustomFont: (
      organizationId: EntityId,
      fontId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CustomizationFontDefinition,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/fonts/${fontId}`,
        routeTemplate: "/orgs/{organizationId}/fonts/{fontId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom-fonts
     * @name UpdateCustomFont
     * @summary Update a custom font
     * @request POST:/orgs/{organizationId}/fonts/{fontId}
     * @secure
     */
    updateCustomFont: (
      organizationId: EntityId,
      fontId: string,
      data: {
        /** The human-readable font-family name used in CSS (e.g., "Open Sans", "Playfair Display"). */
        fontFamily?: FontFamily;
        /** Array of font faces specifying weights and their corresponding storage keys. Passing null as the storage key will remove that weight. */
        fontFaces?: {
          /** Numeric representation of the font weight (400=regular, 500=medium, 700=bold, 900=black). */
          weight: FontWeight;
          storageKey: StorageFileKey | null;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        CustomizationFontDefinition,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 412;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/fonts/${fontId}`,
        routeTemplate: "/orgs/{organizationId}/fonts/{fontId}",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom-fonts
     * @name DeleteCustomFont
     * @summary Delete a custom font
     * @request DELETE:/orgs/{organizationId}/fonts/{fontId}
     * @secure
     */
    deleteCustomFont: (
      organizationId: EntityId,
      fontId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/fonts/${fontId}`,
        routeTemplate: "/orgs/{organizationId}/fonts/{fontId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  imports = {
    /**
     * @description Returns the import runs of the organization, most recent first. Runs left behind by an import that never reported back are returned as failed.
     *
     * @tags imports
     * @name ListImportRuns
     * @summary List the import runs of an organization
     * @request GET:/org/{organizationId}/imports
     * @secure
     */
    listImportRuns: (
      organizationId: EntityId,
      query?: {
        /** Only return the import runs targeting this space. */
        space?: string;
        /** Only return the import runs targeting this change request. */
        changeRequest?: string;
        /** Only return the import runs targeting a space of this site. */
        site?: string;
        /** Only return the import runs in this status. `active` covers both `pending` and `in-progress`. */
        status?:
          | "active"
          | "pending"
          | "in-progress"
          | "completed"
          | "failed"
          | "cancelled";
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ContentImportRun[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/org/${organizationId}/imports`,
        routeTemplate: "/org/{organizationId}/imports",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags imports
     * @name StartImportRun
     * @summary Import content into a space from a website
     * @request POST:/org/{organizationId}/imports
     * @secure
     */
    startImportRun: (
      organizationId: EntityId,
      data: {
        source: ContentImportSource;
        target: ContentImportTarget;
        /** ID of the site the import is for, to list it among that site's imports. Only needed when the target space does not belong to the site yet — a site being set up, whose space is attached once the import has started. Otherwise the site is resolved from the space. */
        site?: string;
        /**
         * Enhance the imported content with AI
         * @default true
         */
        enhance?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ContentImportRun,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/org/${organizationId}/imports`,
        routeTemplate: "/org/{organizationId}/imports",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the import run. A run left behind by an import that never reported back is returned as failed.
     *
     * @tags imports
     * @name GetImportRun
     * @summary Get an import run
     * @request GET:/org/{organizationId}/imports/{importRunId}
     * @secure
     */
    getImportRun: (
      organizationId: EntityId,
      importRunId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ContentImportRun,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/org/${organizationId}/imports/${importRunId}`,
        routeTemplate: "/org/{organizationId}/imports/{importRunId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags imports
     * @name CancelImportRun
     * @summary Cancel an import run
     * @request POST:/org/{organizationId}/imports/{importRunId}/cancel
     * @secure
     */
    cancelImportRun: (
      organizationId: EntityId,
      importRunId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ContentImportRun,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/org/${organizationId}/imports/${importRunId}/cancel`,
        routeTemplate: "/org/{organizationId}/imports/{importRunId}/cancel",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sites = {
    /**
     * @description Returns a paginated list of all documentation sites belonging to the organization. Use this to discover available sites before fetching their content, settings, or structure. Members with access only to individual spaces receive the sites that use those spaces as site items, with site administration fields omitted.
     *
     * @tags sites, critical
     * @name ListSites
     * @summary List all documentation sites in an organization
     * @request GET:/orgs/{organizationId}/sites
     * @secure
     */
    listSites: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Identifier of the space to filter the sites by */
        space?: string;
        /** Filter sites by their title */
        title?: string;
        /** Filter sites by their published status */
        published?: boolean;
        /** Filter by site type */
        type?: SiteType[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Site[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites`,
        routeTemplate: "/orgs/{organizationId}/sites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new documentation site within the organization. Optionally links one or more existing spaces as content sources at creation time. The site is created in an unpublished state; call the publish endpoint separately to make it publicly accessible.
     *
     * @tags sites
     * @name CreateSite
     * @summary Create a new documentation site in an organization
     * @request POST:/orgs/{organizationId}/sites
     * @secure
     */
    createSite: (
      organizationId: EntityId,
      data: {
        /**
         * The type of the site. Defaults to:
         *   - Sponsored for community organizations
         *   - Ultimate for all other organizations
         */
        type?: SiteType;
        /** Title of the site */
        title?: SiteTitle;
        /**
         * The visibility setting of the site determines the audience of the site.
         * * `public`: Anyone can access the site, and the site is indexed by search engines.
         * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
         * * `share-link`: Anyone with a secret token in the url can access the site.
         * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
         */
        visibility?: SiteVisibility;
        /** ID of spaces to be added to the site */
        spaces?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Site, any>({
        path: `/orgs/${organizationId}/sites`,
        routeTemplate: "/orgs/{organizationId}/sites",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sites, internal
     * @name PreviewSitePublishCheckout
     * @summary Preview checkout information upon publishing a site in the organization.
     * @request GET:/orgs/{organizationId}/sites/publishing/checkout
     * @secure
     */
    previewSitePublishCheckout: (
      organizationId: EntityId,
      query: {
        /** The plan of the site to preview the checkout information for. */
        plan: SiteType;
      },
      params: RequestParams = {},
    ) =>
      this.request<SitePublishOperationPreviewResponse, any>({
        path: `/orgs/${organizationId}/sites/publishing/checkout`,
        routeTemplate: "/orgs/{organizationId}/sites/publishing/checkout",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves full details for a single documentation site. Use this to inspect a specific site's metadata before reading or modifying its settings, structure, or content. Members with access only through a linked space can retrieve a limited site summary; site administration fields are omitted.
     *
     * @tags sites
     * @name GetSiteById
     * @summary Get a documentation site by its ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}
     * @secure
     */
    getSiteById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        Site,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a documentation site's configuration. Use this to rename a site, change its access level, or point it at a reverse-proxy path such as https://company.com/docs.
     *
     * @tags sites
     * @name UpdateSiteById
     * @summary Update the properties of a documentation site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}
     * @secure
     */
    updateSiteById: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Title of the site */
        title?: SiteTitle;
        /**
         * The visibility setting of the site determines the audience of the site.
         * * `public`: Anyone can access the site, and the site is indexed by search engines.
         * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
         * * `share-link`: Anyone with a secret token in the url can access the site.
         * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
         */
        visibility?: SiteVisibility;
        /** Basename for the site. For e.g. api */
        basename?: SiteBasename;
        adaptiveContent?: SiteAdaptiveContent;
        /** Default level for a piece of content */
        defaultLevel?: DefaultLevel;
        /** ID of the site-space to be used as the default at the root level. If site has sections, this will mark the default site space in the site's default section. */
        defaultSiteSpace?: string;
        /** ID of the site-section to be used as the default. */
        defaultSiteSection?: string;
        /**
         * Configure a proxy URL for a site. For example, you can use it to host the site on a subdirectory of your domain like `https://company.com/docs`.
         * Use `null` to remove the proxy.
         */
        proxy?: SiteProxyOrigin | null;
        /** Attach an existing style guide to the site by the ID of the style guide space, or `null` to detach the current one. The space must be a style guide owned by the same organization. */
        styleguide?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<Site, any>({
        path: `/orgs/${organizationId}/sites/${siteId}`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sites
     * @name DeleteSiteById
     * @summary Delete a site
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}
     * @secure
     */
    deleteSiteById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns the JSON schema that defines the visitor attributes expected by an adaptive content site. Adaptive content uses these attributes (e.g., user role, plan tier) to conditionally show or hide content sections. Use this to understand what visitor data must be provided when rendering adaptive content.
     *
     * @tags sites
     * @name GetSiteAdaptiveSchema
     * @summary Get the visitor attributes JSON schema for an adaptive content site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/adaptive-schema
     * @secure
     */
    getSiteAdaptiveSchema: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteAdaptiveSchema,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | Error
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/adaptive-schema`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Replaces the JSON schema that defines expected visitor attributes for adaptive content. The schema controls which attributes (e.g., role, subscription tier) can be used in conditional expressions to show or hide content for specific visitors. After updating, existing conditional expressions are evaluated against the new schema.
     *
     * @tags sites
     * @name UpdateSiteAdaptiveSchema
     * @summary Update the visitor attributes JSON schema for an adaptive content site
     * @request PUT:/orgs/{organizationId}/sites/{siteId}/adaptive-schema
     * @secure
     */
    updateSiteAdaptiveSchema: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** The JSON schema to set on the site. `regions` is only accepted for organizations with regions enabled. */
        jsonSchema: SiteAdaptiveJSONSchemaWithRegions;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteAdaptiveSchema,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | Error
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/adaptive-schema`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns pre-generated condition templates derived from the site's visitor attributes schema. These templates can be used as building blocks when writing adaptive content expressions to conditionally show or hide content for different visitor types. Use this to discover available conditions before authoring adaptive rules.
     *
     * @tags sites
     * @name ListSiteAdaptiveTemplateConditions
     * @summary List condition templates for adaptive content expressions in a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/adaptive-schema/template-conditions
     * @secure
     */
    listSiteAdaptiveTemplateConditions: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: SiteAdaptiveTemplateCondition[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/adaptive-schema/template-conditions`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/adaptive-schema/template-conditions",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the complete profile needed to render the published experience of a site. Use this when building a site renderer or preview rather than fetching each resource individually.
     *
     * @tags sites
     * @name GetPublishedContentSite
     * @summary Get the full published profile of a site including structure and customization
     * @request GET:/orgs/{organizationId}/sites/{siteId}/published
     * @secure
     */
    getPublishedContentSite: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** For sites published via share-links, the share key is useful to resolve published URLs. */
        shareKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PublishedContentSite,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/published`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/published",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Makes the site publicly accessible at its configured URL by publishing it. If the organization's plan requires an upgrade, the response includes a Stripe checkout session ID instead of the site object. Use unpublish to take the site offline again.
     *
     * @tags sites
     * @name PublishSite
     * @summary Publish a site to make it publicly accessible
     * @request POST:/orgs/{organizationId}/sites/{siteId}/publish
     * @secure
     */
    publishSite: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | (Site & {
            /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
            subscriptionNotice?: SubscriptionNotice;
          })
        | {
            type: "checkout";
            /** Stripe payment session ID */
            sessionId: string;
            /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
            subscriptionNotice?: SubscriptionNotice;
          },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/publish`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/publish",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the steps to set up a site, from a first edit to publishing, and whether each one is completed. Use it to know what is left to do on a site. Returns no steps once the site has been published.
     *
     * @tags sites
     * @name GetSiteSetup
     * @summary Get the setup steps of a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/setup
     * @secure
     */
    getSiteSetup: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSetup,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/setup`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/setup",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes the site from public access by unpublishing it. The site's configuration and content are preserved; use the publish endpoint to make it accessible again. Use this when you need to temporarily hide a site or take it down for maintenance.
     *
     * @tags sites
     * @name UnpublishSite
     * @summary Take a site offline by unpublishing it
     * @request POST:/orgs/{organizationId}/sites/{siteId}/unpublish
     * @secure
     */
    unpublishSite: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<Site, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/unpublish`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/unpublish",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reorders a site space, section, section group, or external link relative to any sibling at the same structure level. Sorting changes sibling order only; move an item between the root and a group through that item's update operation first.
     *
     * @tags sites
     * @name SortSiteStructure
     * @summary Move a site structure item to a new position
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/structure/sort
     * @secure
     */
    sortSiteStructure: <TRequestParams extends RequestParams = {}>(
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Pointer to the site space, section, section group, or external link being moved. */
        item: SiteStructureItemPointer;
        /** The position to move the item to. When not provided the item is moved to the end of the site structure. */
        position: SiteStructureItemMovePosition;
      },
      params?: TRequestParams,
    ) =>
      this.request<
        PreferredResponse<SiteStructureItem, TRequestParams>,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | Error
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/structure/sort`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/structure/sort",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sites, internal
     * @name UpdateSitePlan
     * @summary Update the site plan.
     * @request POST:/orgs/{organizationId}/sites/{siteId}/plan
     * @secure
     */
    updateSitePlan: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** The type of the site */
        plan: SiteType;
        /** Desired interval for new subscriptions. Defaults to the existing billing interval. */
        interval?: BillingInterval;
        /** The reason or feature that triggered the site upgrade */
        reason: SiteUpgradeReason;
      },
      query?: {
        /** The app screen URL to bring the user back to after a successful checkout. */
        successReturnURL?: string;
        /** The app screen URL to bring the user back to after a canceled checkout. */
        cancelReturnURL?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | {
            /** User must checkout to complete the update. */
            type: "checkout";
            /** Stripe payment session ID */
            sessionId: string;
          }
        | {
            /** The site plan was successfully updated. */
            type: "success";
            /**
             * * `upgraded`: Subscription was upgraded to include the site
             * * `downgraded`: Subscription was downgraded by removing the site
             * * `no-payment-changes`: No impact on subscription (e.g. trial, unpublished)
             */
            outcome?: "upgraded" | "downgraded" | "no-payment-changes";
          },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/plan`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/plan",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sites, internal, critical
     * @name PreviewSitePlanUpdate
     * @summary Preview an upgrade to a site plan, returning checkout information.
     * @request GET:/orgs/{organizationId}/sites/{siteId}/plan
     * @secure
     */
    previewSitePlanUpdate: (
      organizationId: EntityId,
      siteId: string,
      query: {
        /** The desired site plan */
        plan: SiteType;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BillingOperationPreviewResponse,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/plan`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/plan",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a request to ask the organization's admins to upgrade the site's plan.
     *
     * @tags sites, internal
     * @name RequestSiteUpgrade
     * @summary Request site upgrade
     * @request POST:/orgs/{organizationId}/sites/{siteId}/request_upgrade
     * @secure
     */
    requestSiteUpgrade: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** The feature the user is asking a site upgrade for */
        featureKey: SiteFeatureKey;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/request_upgrade`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/request_upgrade",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Performs a full-text search across all published spaces in the site and returns matching pages with relevant excerpts. Use the scope parameter to restrict the search to specific site spaces or sections. Prefer this over the space-level search when you need to search across a multi-section site in one call.
     *
     * @tags sites
     * @name SearchSiteContent
     * @summary Full-text search across all content in a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/search
     * @secure
     */
    searchSiteContent: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** @maxLength 512 */
        query: string;
      } & (
        | {
            /** Define the scope of the search. */
            scope: SiteSearchScope;
          }
        | {
            /**
             * Search only in the site spaces provided. Deprecated, use scope instead.
             * @deprecated
             */
            mode?: "specific";
            /** @minLength 1 */
            siteSpaceIds: string[];
          }
        | {
            /**
             * Search in the current site space and all section's defaults. Deprecated, use scope instead.
             * @deprecated
             */
            mode: "current";
            siteSpaceId: string;
          }
        | {
            /**
             * Search in all site-spaces. Deprecated, use scope instead.
             * @deprecated
             */
            mode: "all";
          }
      ),
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: (SearchSpaceResult | SearchRecordResult)[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/search`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/search",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Hints the search backend that latency-sensitive site search requests are likely to arrive soon. Call this when a visitor opens the site's search interface.
     *
     * @tags sites
     * @name PrewarmSiteSearch
     * @summary Prewarm a site's search cache
     * @request POST:/orgs/{organizationId}/sites/{siteId}/search/prewarm
     * @secure
     */
    prewarmSiteSearch: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/search/prewarm`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/search/prewarm",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Populates an empty site with GitBook's default documentation structure, content, and customization. Use this after creating a site without spaces to give it a ready-to-edit starting point.
     *
     * @tags sites
     * @name ApplyTemplateToSite
     * @summary Apply the default documentation template to a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/template
     * @secure
     */
    applyTemplateToSite: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/template`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/template",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Ensures the site has a dedicated style guide space and returns it. The style guide defines writing style and tone guidelines that the AI editor agent references when generating or refining content for the site. If a style guide already exists, this is idempotent and returns the existing space.
     *
     * @tags sites
     * @name CreateSiteStyleguideById
     * @summary Create or retrieve the style guide space for a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/styleguide
     * @secure
     */
    createSiteStyleguideById: (
      organizationId: EntityId,
      siteId: string,
      data?: {
        /** Built-in template id to seed the style guide content with. Omit (or send no body) to create a blank style guide. */
        template?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Space,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/styleguide`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/styleguide",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Starts a style guide check: GitBook Agent reviews the given spaces against the site's style guide and proposes fixes. A space with no check open gets a new draft change request marked as belonging to the returned run; one whose check is still open has it taken over instead, so it stays marked with the run that opened it. Fails if the site has no style guide.
     *
     * @tags sites
     * @name CreateSiteStyleguideRun
     * @summary Start a style guide check run for a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/styleguide/runs
     * @secure
     */
    createSiteStyleguideRun: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /**
         * IDs of the site's spaces to check. Each must be an editable content space of the site, and not the style guide itself.
         * @maxItems 3
         * @minItems 1
         */
        spaces: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** A style guide check run: one time a user asked GitBook Agent to check a set of the site's spaces against the site's style guide, opening a change request for each. */
          run: SiteStyleguideRun;
          /** The change request each space's check runs in: opened by this run, or already open and taken over. One per space that could be started. */
          changeRequests: ChangeRequest[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/styleguide/runs`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/styleguide/runs",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the site's style guide check runs, most recent first. Use the `styleguideRun` filter on the organization change requests endpoint to get the change requests a run opened.
     *
     * @tags sites
     * @name ListSiteStyleguideRuns
     * @summary List the style guide check runs of a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/styleguide/runs
     * @secure
     */
    listSiteStyleguideRuns: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteStyleguideRun[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/styleguide/runs`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/styleguide/runs",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  git = {
    /**
     * No description
     *
     * @tags git
     * @name ListSiteGitSyncInstallations
     * @summary List the Git Sync installations for a site and its spaces
     * @request GET:/orgs/{organizationId}/sites/{siteId}/spaces/git/installations
     * @secure
     */
    listSiteGitSyncInstallations: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: GitSyncInstallation[];
        },
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/spaces/git/installations`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/spaces/git/installations",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name InstallGitSyncProviderOnTarget
     * @summary Install a Git Sync provider on a target
     * @request POST:/git/installations
     * @secure
     */
    installGitSyncProviderOnTarget: (
      data: {
        /** The provider of the Git Sync installation. */
        provider: GitSyncInstallationProvider;
        /** Resource targeted by a Git Sync installation. */
        target: GitSyncInstallationTarget;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GitSyncInstallation,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/git/installations`,
        routeTemplate: "/git/installations",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name GetGitSyncInstallationById
     * @summary Get a Git Sync installation
     * @request GET:/git/installations/{installationId}
     * @secure
     */
    getGitSyncInstallationById: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        GitSyncInstallation,
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}`,
        routeTemplate: "/git/installations/{installationId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the installation configuration, then queues a sync operation using the new settings. A `git` priority queues an import from the selected repository and branch into GitBook; a `gitbook` priority queues an export from GitBook to the repository. Site imports require a `gitbook-docs.yaml` file at the configured project directory and return a conflict without saving or queuing the sync when the file is missing.
     *
     * @tags git
     * @name UpdateGitSyncInstallationById
     * @summary Update a Git Sync installation configuration
     * @request PATCH:/git/installations/{installationId}
     * @secure
     */
    updateGitSyncInstallationById: (
      installationId: string,
      data: GitSyncInstallationSetup & {
        /** Project directories keyed by child installation ID for a site installation. */
        childInstallationProjectDirectories?: Record<string, string>;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GitSyncInstallation,
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | (Error & {
            error: {
              type: "missing_site_git_sync_config";
              details: {
                /** Repository-relative path where `gitbook-docs.yaml` is required. */
                path: string;
                /** Repository branch where `gitbook-docs.yaml` is required. */
                branch: string;
                /** Prompt for a coding agent to create and commit the missing file. */
                prompt: string;
              };
            };
          })
      >({
        path: `/git/installations/${installationId}`,
        routeTemplate: "/git/installations/{installationId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name UninstallGitSyncInstallation
     * @summary Uninstall a Git Sync installation
     * @request DELETE:/git/installations/{installationId}
     * @secure
     */
    uninstallGitSyncInstallation: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/git/installations/${installationId}`,
        routeTemplate: "/git/installations/{installationId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name ListGitHubRepositoriesForGitSyncInstallation
     * @summary List GitHub repositories available for a Git Sync installation
     * @request GET:/git/installations/{installationId}/github/repos
     * @secure
     */
    listGitHubRepositoriesForGitSyncInstallation: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: GitSyncGitHubRepository[];
        },
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}/github/repos`,
        routeTemplate: "/git/installations/{installationId}/github/repos",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name ListGitHubRepoBranchesForGitSyncInstallation
     * @summary List GitHub repository branches available for a Git Sync installation
     * @request GET:/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/branches
     * @secure
     */
    listGitHubRepoBranchesForGitSyncInstallation: (
      installationId: string,
      accountName: string,
      repositoryName: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: GitSyncBranch[];
        },
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}/github/repos/${accountName}/${repositoryName}/branches`,
        routeTemplate:
          "/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/branches",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name GetGitHubRepoFileForGitSyncInstallation
     * @summary Get a file from a GitHub repository for a Git Sync installation
     * @request GET:/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/file
     * @secure
     */
    getGitHubRepoFileForGitSyncInstallation: (
      installationId: string,
      accountName: string,
      repositoryName: string,
      query: {
        path: string;
        ref: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GitSyncRepositoryFile,
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}/github/repos/${accountName}/${repositoryName}/file`,
        routeTemplate:
          "/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/file",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name ListGitLabProjectsForGitSyncInstallation
     * @summary List GitLab projects available for a Git Sync installation
     * @request GET:/git/installations/{installationId}/gitlab/projects
     * @secure
     */
    listGitLabProjectsForGitSyncInstallation: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: GitSyncGitLabProject[];
        },
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}/gitlab/projects`,
        routeTemplate: "/git/installations/{installationId}/gitlab/projects",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name ListGitLabProjectBranchesForGitSyncInstallation
     * @summary List GitLab project branches available for a Git Sync installation
     * @request GET:/git/installations/{installationId}/gitlab/projects/{projectId}/branches
     * @secure
     */
    listGitLabProjectBranchesForGitSyncInstallation: (
      installationId: string,
      projectId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: GitSyncBranch[];
        },
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}/gitlab/projects/${projectId}/branches`,
        routeTemplate:
          "/git/installations/{installationId}/gitlab/projects/{projectId}/branches",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags git
     * @name GetGitLabProjectFileForGitSyncInstallation
     * @summary Get a file from a GitLab project for a Git Sync installation
     * @request GET:/git/installations/{installationId}/gitlab/projects/{projectId}/file
     * @secure
     */
    getGitLabProjectFileForGitSyncInstallation: (
      installationId: string,
      projectId: number,
      query: {
        path: string;
        ref: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GitSyncRepositoryFile,
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/git/installations/${installationId}/gitlab/projects/${projectId}/file`,
        routeTemplate:
          "/git/installations/{installationId}/gitlab/projects/{projectId}/file",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteChangeRequests = {
    /**
     * @description Returns a paginated list of change requests reviewing the site. A site change request groups changes to the site structure and to any number of its spaces into one review. Use this to discover existing change requests before creating a new one.
     *
     * @tags site-change-requests
     * @name ListChangeRequestsForSite
     * @summary List all change requests for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/change-requests
     * @secure
     */
    listChangeRequestsForSite: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * If defined, only change requests matching this status will be returned.
         * @default "open"
         */
        status?: ChangeRequestStatus;
        /** If defined, only change requests created by this user will be returned. */
        createdBy?: string;
        /** If defined, only change requests moved out of draft by this user will be returned. */
        openedBy?: string;
        /** If defined, only change requests archived by this user will be returned. */
        archivedBy?: string;
        /** If defined, only change requests merged by this user will be returned. */
        mergedBy?: string;
        /** If defined, only change requests with contributions from this user will be returned. */
        contributor?: string;
        /**
         * Status of the members.
         * @default "active"
         */
        memberStatus?: SiteChangeRequestMemberStatus;
        /** The field to sort change requests by. Defaults to 'updatedAt'. */
        orderBy?: ChangeRequestOrderBy;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteChangeRequest[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/change-requests`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/change-requests",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a change request reviewing the site, as a draft working copy of the content of the spaces it changes. It starts with no members: a space becomes one on its first edit.
     *
     * @tags site-change-requests
     * @name CreateSiteChangeRequest
     * @summary Create a new change request in a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/change-requests
     * @secure
     */
    createSiteChangeRequest: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Subject of the change request */
        subject?: ChangeRequestSubject;
        description?: JSONDocument;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteChangeRequest, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/change-requests`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/change-requests",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a single site change request, including its status, subject, description, aggregate version and active members. Use this to check its current state before deciding to merge, update or request a review.
     *
     * @tags site-change-requests
     * @name GetSiteChangeRequestById
     * @summary Get a site change request by its ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}
     * @secure
     */
    getSiteChangeRequestById: (
      organizationId: EntityId,
      siteId: string,
      changeRequestId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteChangeRequest,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/change-requests/${changeRequestId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the metadata of a site change request. Use this to rename it, add context before requesting a review, or change its workflow status without merging. To change the resources it reviews, update its members instead.
     *
     * @tags site-change-requests
     * @name UpdateSiteChangeRequestById
     * @summary Update a site change request's subject, description, or status
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}
     * @secure
     */
    updateSiteChangeRequestById: (
      organizationId: EntityId,
      siteId: string,
      changeRequestId: EntityId,
      data: {
        /** Subject of the change request */
        subject?: ChangeRequestSubject;
        description?: JSONDocument;
        status?: "draft" | "open" | "archived";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteChangeRequest,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/change-requests/${changeRequestId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently deletes a change request and its members. Merged change requests cannot be deleted; archive a change request instead to keep its review history.
     *
     * @tags site-change-requests
     * @name DeleteSiteChangeRequestById
     * @summary Delete a site change request
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}
     * @secure
     */
    deleteSiteChangeRequestById: (
      organizationId: EntityId,
      siteId: string,
      changeRequestId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 409;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/change-requests/${changeRequestId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteShareLinks = {
    /**
     * @description Returns a paginated list of share links configured for the site. Share links grant access to a private site without requiring full authentication. Use this to audit existing share links, check their active status, or find a link ID before updating or revoking it.
     *
     * @tags site-share-links
     * @name ListSiteShareLinks
     * @summary List all private share links for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/share-links
     * @secure
     */
    listSiteShareLinks: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Search share links by name or key */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ShareLink[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/share-links`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/share-links",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new named share link that grants access to the private site without requiring full user authentication. Share links are useful for sharing pre-publication content with reviewers or stakeholders. Each link has a unique key and can be activated or deactivated independently.
     *
     * @tags site-share-links
     * @name CreateSiteShareLink
     * @summary Create a private share link for a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/share-links
     * @secure
     */
    createSiteShareLink: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Name of the share link */
        name: ShareLinkName;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShareLink, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/share-links`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/share-links",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a share link's properties. Use this to temporarily disable a share link without losing its configuration.
     *
     * @tags site-share-links
     * @name UpdateSiteShareLinkById
     * @summary Update a private share link for a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}
     * @secure
     */
    updateSiteShareLinkById: (
      organizationId: EntityId,
      siteId: string,
      shareLinkId: string,
      data: {
        active?: boolean;
        /** Name of the share link */
        name?: ShareLinkName;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShareLink, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/share-links/${shareLinkId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-share-links
     * @name DeleteSiteShareLinkById
     * @summary Deletes a share link
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}
     * @secure
     */
    deleteSiteShareLinkById: (
      organizationId: EntityId,
      siteId: string,
      shareLinkId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/share-links/${shareLinkId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteStructure = {
    /**
     * @description Returns the complete hierarchical structure of a site, including all sections, section groups, and site spaces in their current order. Use this to understand how a site's navigation is organized before making structural changes, or to render the full navigation tree of a site. Members with access only to individual spaces receive only the site items backed by those spaces and their parent sections.
     *
     * @tags site-structure
     * @name GetSiteStructure
     * @summary Get the full navigation structure of a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/structure
     * @secure
     */
    getSiteStructure: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** For sites published via share-links, the share key is useful to resolve published URLs. */
        shareKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteStructure,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/structure`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/structure",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sitePublishingAuth = {
    /**
     * @description Retrieves the authentication settings that protect a site's published content. Use this to review the current auth method before making changes or troubleshooting access issues.
     *
     * @tags site-publishing-auth
     * @name GetSitePublishingAuthById
     * @summary Get the published content authentication configuration for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/publishing/auth
     * @secure
     */
    getSitePublishingAuthById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SitePublishingAuth,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/publishing/auth`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/publishing/auth",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies the authentication method used to protect a site's published content. Use this to enable, disable, or change the auth method for a published site.
     *
     * @tags site-publishing-auth
     * @name UpdateSitePublishingAuthById
     * @summary Update the published content authentication configuration for a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/publishing/auth
     * @secure
     */
    updateSitePublishingAuthById: (
      organizationId: EntityId,
      siteId: string,
      data: SitePublishingAuthUpdate,
      params: RequestParams = {},
    ) =>
      this.request<
        SitePublishingAuth,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/publishing/auth`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/publishing/auth",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-generates the private key used for the site's publishing authentication (e.g., JWT signing key for SSO). Existing tokens signed with the old key will become invalid immediately. Use this to rotate credentials after a security incident or as part of a regular key rotation policy.
     *
     * @tags site-publishing-auth
     * @name RegenerateSitePublishingAuthById
     * @summary Regenerate the private key for a site's published content authentication
     * @request POST:/orgs/{organizationId}/sites/{siteId}/publishing/auth/regenerate
     * @secure
     */
    regenerateSitePublishingAuthById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SitePublishingAuth,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/publishing/auth/regenerate`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/publishing/auth/regenerate",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sitePreview = {
    /**
     * @description Generates a time-limited URL (valid for 1 hour) to preview how a site will look when published. Use this to verify changes before making the site publicly accessible.
     *
     * @tags site-preview
     * @name GetSitePublishingPreviewById
     * @summary Generate a temporary preview URL for a site's published content
     * @request GET:/orgs/{organizationId}/sites/{siteId}/publishing/preview
     * @secure
     */
    getSitePublishingPreviewById: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** ID of the site-space to preview. If not provided, the default site-space will be used. */
        siteSpace?: string;
        /** Rison encoded string of attributes/assertions about the visitor for which we want to preview the site. */
        claims?: string;
        /** ISO 3166-1 alpha-2 code of the country of the visitor for which we want to preview the site. It is matched against the `regions` of the site adaptive schema to resolve `visitor.region`. */
        country?: string;
        /** Whether the visitor for which we want to preview the site is signed in, as `visitor.isAuthenticated` reports it. Claims outside `unsigned` already imply a signed-in visitor; set this to preview one that is signed in while carrying no claim. */
        visitorAuthenticated?: boolean;
        /**
         * Whether to include draft content in the preview. Defaults to true
         * @default true
         */
        draft?: boolean;
        /** Target URL of the preview. If not provided, the default site preview URL will be used. */
        target?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: URL;
        },
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/publishing/preview`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/publishing/preview",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteCustomization = {
    /**
     * @description Retrieves the full customization configuration for a site. Use this before making updates to read the current state, or to audit branding settings.
     *
     * @tags site-customization
     * @name GetSiteCustomizationById
     * @summary Get the branding and visual customization settings for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/customization
     * @secure
     */
    getSiteCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /**
         * (Deprecated) Use the getRawCustomizationSettingsById internal endpoint.
         * @deprecated
         * @default false
         */
        unmasked?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteCustomizationSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/customization`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/customization",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Replaces the full customization configuration for a site. This is a full replacement — unset fields revert to defaults. Use the GET endpoint first to read the current settings before making targeted changes.
     *
     * @tags site-customization
     * @name UpdateSiteCustomizationById
     * @summary Update the branding and visual customization settings for a site
     * @request PUT:/orgs/{organizationId}/sites/{siteId}/customization
     * @secure
     */
    updateSiteCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      data: SiteCustomizationSettingsInput,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteCustomizationSettings & {
          /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
          subscriptionNotice?: SubscriptionNotice;
        },
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/customization`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/customization",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-customization, internal
     * @name GetSiteRawCustomizationById
     * @summary Get a site raw customization settings
     * @request GET:/orgs/{organizationId}/sites/{siteId}/customization/raw
     * @secure
     */
    getSiteRawCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteCustomizationSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/customization/raw`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/customization/raw",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the customization settings that override the site-level branding for a specific site space, such as a language variant or content version. Returns the effective settings with site-level defaults where no override is set. Use this before applying or removing overrides.
     *
     * @tags site-customization
     * @name GetSiteSpaceCustomizationById
     * @summary Get the customization overrides for a site space
     * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
     * @secure
     */
    getSiteSpaceCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      query?: {
        /**
         * (Deprecated) Use the getRawCustomizationSettingsById internal endpoint.
         * @deprecated
         * @default false
         */
        unmasked?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteCustomizationSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}/customization`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Applies customization overrides to a specific site space, such as a language variant or content version, that take precedence over the site-level settings. Only provided fields are overridden; set a field to null to clear its override and fall back to the site-level value.
     *
     * @tags site-customization
     * @name OverrideSiteSpaceCustomizationById
     * @summary Override branding and customization settings for a specific site space
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
     * @secure
     */
    overrideSiteSpaceCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      data: {
        /** Title to use for the published site variant. If not defined, the title will not be changed. If set to null, the title will be unset and will fallback to the content title. */
        title?: SiteTitle | null;
        /** Localized titles for the site variant, keyed by locale. If not defined, the localized title will not be changed. If set to null, all localized titles will be removed. */
        localizedTitle?: LocalizedString128 | null;
        styling?: {
          /** The site theme. Set to null to reset the override. */
          theme?: CustomizationTheme | null;
          /** The primary color used for links and UI text. Set to null to reset the override. */
          primaryColor?: CustomizationThemedColor | null;
          /** The secondary brand color used for secondary buttons and content colored with `$secondary`. Set to null to reset the override. */
          secondaryColor?: CustomizationThemedColor | null;
          /** Used for informational messages and neutral alerts. Set to null to reset the override. */
          infoColor?: CustomizationThemedColor | null;
          /** Used for showing positive actions or achievements. Set to null to reset the override. */
          successColor?: CustomizationThemedColor | null;
          /** Used for showing important information or non-critical warnings. Set to null to reset the override. */
          warningColor?: CustomizationThemedColor | null;
          /** Used for destructive actions or raising attention to critical information. Set to null to reset the override. */
          dangerColor?: CustomizationThemedColor | null;
          /** The tint will color the site’s UI beyond links and buttons, such as header, sidebar and background. By default, the tint colour is the same as your Primary colour, but you can set a custom one too. Set to false to remove the tint from this site space, or to null to reset the override. */
          tint?: CustomizationTint | false | null;
          /** The style of the corners to use. Set to null to reset the override. */
          corners?: CustomizationCorners | null;
          /** The depth of elements on the site. Set to null to reset the override. */
          depth?: CustomizationDepth | null;
          /** The style for links to use. Set to null to reset the override. */
          links?: CustomizationLinksStyle | null;
          /** The icons style to use for the content. Set to null to reset the override. */
          icons?: CustomizationIconsStyle | null;
          /** Various styles for the sidebar. Each can be Set to null to reset the override. */
          sidebar?: {
            background?: CustomizationSidebarBackgroundStyle | null;
            list?: CustomizationSidebarListStyle | null;
          };
          /** Styling for the search button at the top of the site. */
          search?: CustomizationSearchStyle | null;
          /** The style of background to use. Set to null to reset the override. */
          background?: CustomizationBackground | null;
          /** The code theme to use. Set to null to reset the override. */
          codeTheme?: {
            default?: CustomizationThemedCodeTheme | null;
            openapi?: CustomizationThemedCodeTheme | null;
          };
        };
        /** @deprecated */
        internationalization?: {
          /** The locale to use for the non-custom elements of the UI. Set to null to reset the override. */
          locale: CustomizationLocale | null;
        };
        /** The favicon to use. Set to null to reset the override. */
        favicon?: CustomizationFavicon | null;
        announcement?: CustomizationAnnouncement;
        header?: {
          /** The theme preset to use. Set to null to reset the override. */
          preset?: CustomizationHeaderPreset | null;
          /** The header logo to use. Set to null to reset the override. */
          logo?: CustomizationThemedURL | null;
          /** The destination to open when visitors click the site title/logo in the header. Set to null to reset the override. */
          primaryLink?: ContentRef | null;
          /** The background color used in the header. Set to null to reset the override. */
          backgroundColor?: CustomizationThemedColor | null;
          /** The color used by the links in the header. Set to null to reset the override. */
          linkColor?: CustomizationThemedColor | null;
          /** The links that are displayed in the header. Set to null to reset the override. */
          links?: CustomizationHeaderItem[] | null;
        };
        footer?: {
          /** The logo displayed in the footer. Set to null to reset the override. */
          logo?: CustomizationThemedURL | null;
          /** The links groups that are displayed in the footer. Set to null to reset the override. */
          groups?: CustomizationFooterGroup[] | null;
          /**
           * The copyright text that is displayed in the footer. Set to null to reset the override.
           * @maxLength 512
           */
          copyright?: string | null;
        };
        themes?: {
          /** The theme mode default value. Set to null to reset the override. */
          default?: CustomizationDefaultThemeMode | null;
          /** Should the reader be able to switch between dark and light mode. Set to null to reset the override. */
          toggeable?: boolean | null;
        };
        feedback?: {
          /** If true, feedback gathering is enabled. Set to null to reset the override. */
          enabled: boolean | null;
        };
        externalLinks?: {
          /** How external links should open. Set to null to reset the override. */
          target: SiteExternalLinksTarget | null;
        };
        pagination?: {
          /** Whether the pagination navigation should be displayed on pages. Set to null to reset the override. */
          enabled: boolean | null;
        };
        trademark?: {
          /** Whether the GitBook trademark ("Powered by GitBook") should be visible. Set to null to reset the override. */
          enabled: boolean | null;
        };
        privacyPolicy?: {
          /** The custom link to the privacy policy. Set to null to reset the override. */
          url?: URL | null;
        };
        socialPreview?: {
          /** The URL for the social preview image. Set to null to reset the override. */
          url?: URL | null;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteCustomizationSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}/customization`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-customization
     * @name DeleteSiteSpaceCustomizationById
     * @summary Delete a site space customization settings
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
     * @secure
     */
    deleteSiteSpaceCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}/customization`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-customization, internal
     * @name GetSiteSpaceRawCustomizationById
     * @summary Get a site space raw customization settings
     * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization/raw
     * @secure
     */
    getSiteSpaceRawCustomizationById: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSpaceCustomizationSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}/customization/raw`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization/raw",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteSpaces = {
    /**
     * @description Pass an existing space ID to link it, or pass `null` to create and link a new space. New spaces start with a blank page unless a template is provided or `empty` is `true`, which creates the space with no page at all (use it when you are about to add the pages yourself).
     *
     * @tags site-spaces
     * @name AddSpaceToSite
     * @summary Add a space to a site as a content source
     * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces
     * @secure
     */
    addSpaceToSite: <TRequestParams extends RequestParams = {}>(
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Pass the ID of an existing space or `null` to create a new space. */
        spaceId: string | null;
        /** Template for the new space when `spaceId` is `null`. Templates that provision organization-level resources, such as OpenAPI specifications, are not supported by this site-scoped operation. */
        template?: ApplySpaceTemplate;
        /** ID of the section to add the space to. If not provided, the space will be added to the default section or at the root level if the site has no sections. */
        sectionId?: string;
        /**
         * Whether the site space should be created as draft. Defaults to false. Editors can set this to true to create draft content on a non-empty site. Creating live content and adding the first content require Creator permission.
         * @default false
         */
        draft?: boolean;
        /** Custom home page within an existing space, rendered at the site space's path root instead of the space's default landing page. Providing it when `spaceId` is `null` returns a 400 error. */
        pageId?: string | null;
        /**
         * Create the new space without any content, not even a blank page. Useful when the content is about to be populated, for example by an import. Only valid when `spaceId` is `null` and no template is provided.
         * @default false
         */
        empty?: boolean;
        /** Site-specific title override for the variant. Also used as the space title when `spaceId` is `null` and no template is provided. */
        title?: SiteTitle;
      },
      params?: TRequestParams,
    ) =>
      this.request<PreferredResponse<SiteSpace, TRequestParams>, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/site-spaces",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of site spaces — the links between a site and its content source spaces. Each site space can be a language variant or content version within a section. Use the default filter to retrieve only the primary site space, or omit it to get all linked spaces including drafts. Members with access only to individual spaces receive only site-space links for those spaces.
     *
     * @tags site-spaces, critical
     * @name ListSiteSpaces
     * @summary List all spaces linked to a site as content sources
     * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces
     * @secure
     */
    listSiteSpaces: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** For sites published via share-links, the share key is useful to resolve published URLs. */
        shareKey?: string;
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** If true, only the default site space will be returned. If false, only the non-default site spaces are returned. If undefined, all site spaces are returned. */
        default?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteSpace[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/site-spaces",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the configuration of a site space. Use this to remap a site space to a different space, hide it from navigation, or promote it from draft to live.
     *
     * @tags site-spaces
     * @name UpdateSiteSpaceById
     * @summary Update a space linked to a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}
     * @secure
     */
    updateSiteSpaceById: <TRequestParams extends RequestParams = {}>(
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      data: {
        /** Path to the space on the site */
        path?: SiteSpacePath;
        /** Conditional expression used to evaluate whether the site space should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
        condition?: Expression | null;
        /** Custom home page within the space, rendered at the site space's path root instead of the space's default landing page. If not set, the page will remain unchanged unless spaceId is changed, in which case the custom home page will be removed. If set to null, the custom home page will be removed. */
        pageId?: string | null;
        /** The content that this site space points to. If not set, the space will remain unchanged. */
        spaceId?: string;
        /** Whether the site space is hidden. If true, the site space will not be shown in the site's navigation. If not set, the hidden state will remain unchanged. If set to false, the site space will be shown in site navigation. */
        hidden?: boolean;
        /** Whether the site space should be kept in draft mode. Setting it to true makes the site space draft. Setting it to false makes the site space live. */
        draft?: boolean;
      },
      params?: TRequestParams,
    ) =>
      this.request<PreferredResponse<SiteSpace, TRequestParams>, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-spaces
     * @name DeleteSiteSpaceById
     * @summary Delete a site space
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}
     * @secure
     */
    deleteSiteSpaceById: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Creates a full copy of the space linked by the specified site space. When the site space is the only variant in a section, the copy is placed in a new sibling section. Otherwise, it is added as a variant under the same parent. Prefer this operation over duplicateSpace whenever the request originates from a site or needs to preserve site placement.
     *
     * @tags site-spaces, spaces
     * @name DuplicateSiteSpace
     * @summary Duplicate a space in a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/duplicate
     * @secure
     */
    duplicateSiteSpace: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      data: {
        /**
         * Whether the duplicated site space and any new section should be created as drafts.
         * @default false
         */
        draft?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteSpace, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}/duplicate`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/duplicate",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-spaces
     * @name MoveSiteSpace
     * @summary Move a site space to a new position. (Deprecated) use sortSiteStructure instead.
     * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/move
     * @deprecated
     * @secure
     */
    moveSiteSpace: (
      organizationId: EntityId,
      siteId: string,
      siteSpaceId: string,
      data: {
        /** The position where to move the site space. When not provided the site space is moved at the end of the site. */
        position?: SiteSpaceMovePosition;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSpace,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/site-spaces/${siteSpaceId}/move`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/move",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteSectionGroups = {
    /**
     * @description Returns a paginated list of section groups for the site. Section groups are containers that organize multiple sections into a hierarchical navigation structure. Use this to inspect the current grouping before adding, updating, or reordering items in the site structure.
     *
     * @tags site-section-groups
     * @name ListSiteSectionGroups
     * @summary List all section groups in a site's navigation structure
     * @request GET:/orgs/{organizationId}/sites/{siteId}/section-groups
     * @secure
     */
    listSiteSectionGroups: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteSectionGroup[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/section-groups`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/section-groups",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new section group to organize multiple sections under a shared navigation label. Section groups can be nested by providing a parent group ID. Existing sections can be assigned to the group at creation time via their IDs. Create the group in draft mode to stage it before publishing.
     *
     * @tags site-section-groups
     * @name AddSectionGroupToSite
     * @summary Add a section group to a site's navigation structure
     * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups
     * @secure
     */
    addSectionGroupToSite: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Title of the site section group */
        title: SiteSectionGroupTitle;
        /** Conditional expression used to evaluate whether the site section group should be shown to the site's visitor (should evaluate to a boolean). */
        condition?: Expression;
        icon?: Icon | null;
        /** IDs of the sections to be added to the section group */
        sections?: string[];
        /** ID of the parent section group to nest this group under. If not provided, the section group will be added at the root of the site. */
        parent?: string;
        /** Whether the section group should be created in draft mode. */
        draft?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSectionGroup & {
          /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
          subscriptionNotice?: SubscriptionNotice;
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/section-groups`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/section-groups",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a section group's properties in the site's navigation structure.
     *
     * @tags site-section-groups
     * @name UpdateSiteSectionGroupById
     * @summary Update a section group in a site's navigation structure
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}
     * @secure
     */
    updateSiteSectionGroupById: <TRequestParams extends RequestParams = {}>(
      organizationId: EntityId,
      siteId: string,
      siteSectionGroupId: string,
      data: {
        /** Title of the site section group */
        title?: SiteSectionGroupTitle;
        /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
        localizedTitle?: LocalizedString128;
        /** Conditional expression used to evaluate whether the site section group should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
        condition?: Expression | null;
        icon?: Icon | null;
        /** Whether the site section group should be kept in draft mode. Setting it to true makes the site section group draft. Setting it to false makes the site section group live. */
        draft?: boolean;
        /** ID of the parent section group to move this section group into. Set to null to move the section group to the root of the site. */
        parentSectionGroupId?: string | null;
      },
      params?: TRequestParams,
    ) =>
      this.request<PreferredResponse<SiteSectionGroup, TRequestParams>, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/section-groups/${siteSectionGroupId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-section-groups
     * @name DeleteSiteSectionGroupById
     * @summary Delete a site section group
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}
     * @secure
     */
    deleteSiteSectionGroupById: (
      organizationId: EntityId,
      siteId: string,
      siteSectionGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/section-groups/${siteSectionGroupId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-section-groups
     * @name MoveSiteSectionGroup
     * @summary Move a site section group to a new position. (Deprecated) use sortSiteStructure instead.
     * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/move
     * @deprecated
     * @secure
     */
    moveSiteSectionGroup: (
      organizationId: EntityId,
      siteId: string,
      siteSectionGroupId: string,
      data: {
        /** The position where to move the site section group. When not provided the site section group is moved at the end of the site. */
        position?: SiteSectionGroupMovePosition;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSectionGroup,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/section-groups/${siteSectionGroupId}/move`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/move",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteSections = {
    /**
     * @description Creates a new top-level navigation section in the site. The section appears as a tab or sidebar entry in the site navigation. Pass an existing space ID to link it as the section's primary content source, or pass `null` to create and link a new space. New spaces start with a blank page unless a template is provided or `empty` is `true`, which creates the space with no page at all (use it when you are about to add the pages yourself).
     *
     * @tags site-sections
     * @name AddSectionToSite
     * @summary Add a new navigation section to a site backed by a space
     * @request POST:/orgs/{organizationId}/sites/{siteId}/sections
     * @secure
     */
    addSectionToSite: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Pass the ID of an existing space or pass `null` to create a new space. The space will be added to the section as a site space variant. */
        spaceId: string | null;
        /** Template for the new space when `spaceId` is `null`. Templates that provision organization-level resources, such as OpenAPI specifications, are not supported by this site-scoped operation. */
        template?: ApplySpaceTemplate;
        /**
         * Create the new space without any content, not even a blank page. Useful when the content is about to be populated, for example by an import. Only valid when `spaceId` is `null` and no template is provided.
         * @default false
         */
        empty?: boolean;
        /** Section title. Also used as the space title when `spaceId` is `null` and no template is provided. */
        title?: SiteSectionTitle | null;
        icon?: Icon | null;
        /**
         * Whether the section should be created in draft mode. Defaults to false. Editors can set this to true to create draft content after sections are enabled. Creating live content requires Creator permission; enabling sections requires Admin permission.
         * @default false
         */
        draft?: boolean;
        /** Custom home page within an existing space, rendered at the section's path root instead of the space's default landing page. Providing it when `spaceId` is `null` returns a 400 error. */
        pageId?: string;
        /** ID of the section group to create the section in */
        siteSectionGroupId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSection & {
          /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
          subscriptionNotice?: SubscriptionNotice;
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/sections`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/sections",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of sections in the site. Each section is a top-level navigation item backed by one or more site spaces. Use this to inspect the current navigation structure, find a section ID before updating it, or check whether sections are in draft or live state.
     *
     * @tags site-sections
     * @name ListSiteSections
     * @summary List all navigation sections in a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/sections
     * @secure
     */
    listSiteSections: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** For sites published via share-links, the share key is useful to resolve published URLs. */
        shareKey?: string;
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteSection[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/sections`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/sections",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a navigation section's configuration in the site structure.
     *
     * @tags site-sections
     * @name UpdateSiteSectionById
     * @summary Update a navigation section in a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}
     * @secure
     */
    updateSiteSectionById: <TRequestParams extends RequestParams = {}>(
      organizationId: EntityId,
      siteId: string,
      siteSectionId: string,
      data: {
        /** Title of the site section */
        title?: SiteSectionTitle;
        /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
        localizedTitle?: LocalizedString128;
        /** Path to the section on the site */
        path?: SiteSectionPath;
        /** ID of the site-space to be used as the default in this section. */
        defaultSiteSpace?: string;
        /** Whether to hide the site section from the site's navigation. Setting it updates all the site spaces of the section, and site spaces added to a hidden section are hidden too. The default site section cannot be hidden. */
        hidden?: boolean;
        /** Conditional expression used to evaluate whether the site section should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
        condition?: Expression | null;
        icon?: Icon | null;
        /** Whether the site section should be kept in draft mode. Setting it to true makes the site section draft. Setting it to false makes the site section live. */
        draft?: boolean;
        description?: SiteSectionDescription | null;
        /** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
        localizedDescription?: LocalizedString256;
        /** ID of the section group to move the section into. Set to null to move the section to the root of the site. */
        siteSectionGroupId?: string | null;
      },
      params?: TRequestParams,
    ) =>
      this.request<PreferredResponse<SiteSection, TRequestParams>, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/sections/${siteSectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-sections
     * @name DeleteSiteSectionById
     * @summary Delete a site section
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}
     * @secure
     */
    deleteSiteSectionById: (
      organizationId: EntityId,
      siteId: string,
      siteSectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/sections/${siteSectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-sections
     * @name MoveSiteSection
     * @summary Move a site section to a new position. (Deprecated) use sortSiteStructure instead.
     * @request POST:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}/move
     * @deprecated
     * @secure
     */
    moveSiteSection: (
      organizationId: EntityId,
      siteId: string,
      siteSectionId: string,
      data: {
        /** The position where to move the site section. When not provided the site section is moved at the end of the site. */
        position?: SiteSectionMovePosition;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteSection,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/sections/${siteSectionId}/move`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}/move",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteExternalLinks = {
    /**
     * @description Creates an external navigation link at the site root or in a section group. On a site with root variants and no sections, creating the first external link enables sections and moves those variants into a default section. Links cannot be placed inside a section. The destination must be an absolute HTTP or HTTPS URL. Draft links and links whose adaptive condition does not match are omitted from published structure responses. Use the generic structure sort operation after creation to change sibling order.
     *
     * @tags site-external-links
     * @name AddExternalLinkToSite
     * @summary Add an external link to a site's navigation
     * @request POST:/orgs/{organizationId}/sites/{siteId}/external-links
     * @secure
     */
    addExternalLinkToSite: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Title of the site section */
        title: SiteSectionTitle;
        /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
        localizedTitle?: LocalizedString128;
        description?: SiteSectionDescription | null;
        localizedDescription?: LocalizedString256 | null;
        icon?: Icon | null;
        /** Absolute HTTP or HTTPS destination URL */
        url: URL;
        /** ID of the section group to create the link in. Omit to place it at the site root. */
        parent?: string;
        /** Whether the external link should be created in draft mode */
        draft?: boolean;
        /** Adaptive condition controlling whether visitors see the link */
        condition?: Expression | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SiteExternalLink,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | Error
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/external-links`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/external-links",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an external navigation link. Set parent to a section group ID to move the link into that group, or null to move it to the site root; links cannot be placed inside a section. A changed destination must remain an absolute HTTP or HTTPS URL. Draft and adaptive-condition fields control visibility. Use the generic structure sort operation after changing the parent to adjust the link's sibling order.
     *
     * @tags site-external-links
     * @name UpdateSiteExternalLinkById
     * @summary Update an external link in a site's navigation
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}
     * @secure
     */
    updateSiteExternalLinkById: <TRequestParams extends RequestParams = {}>(
      organizationId: EntityId,
      siteId: string,
      siteExternalLinkId: string,
      data: {
        /** Title of the site section */
        title?: SiteSectionTitle;
        localizedTitle?: LocalizedString128 | null;
        description?: SiteSectionDescription | null;
        localizedDescription?: LocalizedString256 | null;
        icon?: Icon | null;
        /** Absolute HTTP or HTTPS destination URL */
        url?: URL;
        /** ID of the section group to move the link into. Set to null to move it to the site root. */
        parent?: string | null;
        /** Whether the external link should be kept in draft mode */
        draft?: boolean;
        /** Adaptive condition controlling whether visitors see the link */
        condition?: Expression | null;
      },
      params?: TRequestParams,
    ) =>
      this.request<
        PreferredResponse<SiteExternalLink, TRequestParams>,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | Error
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/external-links/${siteExternalLinkId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes an external link. This operation is intentionally unavailable to MCP clients.
     *
     * @tags site-external-links
     * @name DeleteSiteExternalLinkById
     * @summary Delete an external link from a site's navigation
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}
     * @secure
     */
    deleteSiteExternalLinkById: (
      organizationId: EntityId,
      siteId: string,
      siteExternalLinkId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | Error
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/external-links/${siteExternalLinkId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteInsights = {
    /**
     * @description Submit feedback from an AI agent about the content of the site, such as outdated, incorrect or missing content encountered while helping a user. Deprecated in favour of `submitAgentFeedbackToSite`, which collects feedback about every surface a site exposes to agents. Send the same payload there as a `site-content` subject.
     *
     * @tags site-insights
     * @name SubmitSiteAgentFeedback
     * @summary Submit agent feedback for a site. (Deprecated) use submitAgentFeedbackToSite instead.
     * @request POST:/orgs/{organizationId}/sites/{siteId}/agent-feedback
     * @deprecated
     * @secure
     */
    submitSiteAgentFeedback: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /**
         * The feedback about the content of the site.
         * @minLength 1
         * @maxLength 2048
         */
        feedback: string;
        /** The end goal the agent is trying to accomplish on behalf of the user, giving the context the agent was working towards when it encountered the issue. */
        goal?: AgentGoal;
        /** URL of the content the feedback is about. */
        url: URL;
        /** ID of the space the feedback is about. */
        spaceId: string;
        /** ID of the page the feedback is about. */
        pageId: string;
        /** Surface the feedback was submitted from. When omitted, the feedback is recorded with an unknown source. */
        source?: AgentFeedbackSource;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/agent-feedback`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/agent-feedback",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-insights
     * @name TrackEventsInSiteById
     * @summary Track site events
     * @request POST:/orgs/{organizationId}/sites/{siteId}/insights/events
     * @secure
     */
    trackEventsInSiteById: (
      organizationId: EntityId,
      siteId: string,
      data: {
        events: SiteInsightsEvent[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/insights/events`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/insights/events",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Runs an aggregation query over a published site's Insights events, grouped and filtered over a time range. Use it to answer analytics questions about how visitors engage with a site's documentation: page views, visitors, searches, referrers, and broken URLs (404s). A 404 is a `page_view` or `search_open_result` event whose `page` is `null`, in the `site` display context; filter `eventPageNotFoundType` not in `conditional` to leave out 404s that adaptive content explains. Group by `datetime` for a trend over time and by `urlPath` for the top broken URLs.
     *
     * @tags site-insights
     * @name AggregateSiteEvents
     * @summary Query a site's analytics events
     * @request POST:/orgs/{organizationId}/sites/{siteId}/insights/events/aggregate
     * @secure
     */
    aggregateSiteEvents: (
      organizationId: EntityId,
      siteId: string,
      data: SiteInsightsQueryEventsAggregation,
      params: RequestParams = {},
    ) =>
      this.request<SiteInsightsQueryEventsAggregationResult, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/insights/events/aggregate`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/insights/events/aggregate",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-insights
     * @name ListSiteVisitorSegments
     * @summary List a site visitor segments
     * @request GET:/orgs/{organizationId}/sites/{siteId}/insights/visitor-segments
     * @secure
     */
    listSiteVisitorSegments: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteInsightsVisitorSegment[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/insights/visitor-segments`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/insights/visitor-segments",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteAgentFeedback = {
    /**
     * @description Submit structured feedback from an AI agent about an MCP tool or operation, a CLI command, an API endpoint, a site page/mcp, or the product overall. The site collects and owns the feedback rather than being its subject.
     *
     * @tags site-agent-feedback
     * @name SubmitAgentFeedbackToSite
     * @summary Submit agent feedback
     * @request POST:/orgs/{organizationId}/sites/{siteId}/agents/feedback
     * @secure
     */
    submitAgentFeedbackToSite: (
      organizationId: EntityId,
      siteId: string,
      data: AgentFeedbackInput,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Unique identifier of the submission. */
          id: string;
          /** Message relayed back to the agent, acknowledging the feedback and telling it what happens next. */
          result: string;
        },
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 403;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/agents/feedback`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/agents/feedback",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteAsk = {
    /**
     * @description The response is streamed.
     *
     * @tags site-ask
     * @name StreamAskInSite
     * @summary Ask a question in a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/ask
     * @secure
     */
    streamAskInSite: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** @maxLength 512 */
        question: string;
        /** You may optionally provide additional information about the context of the question. This doesn't affect the scope of the search, but GitBook may use this information to provide a better answer. Generally speaking, you should provide as much context as possible. */
        context?: {
          siteSpaceId?: string;
          /** The end goal the agent is trying to accomplish on behalf of the user. Unlike the question, which is the immediate query, the goal describes the broader task or outcome the agent is working towards. GitBook uses this to steer the answer towards what is ultimately useful for that goal. */
          goal?: AgentGoal;
        };
        scope: SiteSearchScope;
        /** Identifiers for a GitBook site session, used for analytics and adaptive content. */
        session?: SiteInsightsSession;
      },
      query?: {
        /** Output format for the content. */
        format?: "document" | "markdown";
      },
      params: RequestParams = {},
    ) =>
      this.streamRequest<SearchAIAnswerStream, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/ask`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/ask",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description The response is streamed.
     *
     * @tags site-ask
     * @name StreamRecommendedQuestionsInSite
     * @summary List recommended questions to ask in a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/ask/questions
     * @secure
     */
    streamRecommendedQuestionsInSite: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** The ID of the site space to filter the recommended questions for. */
        siteSpaceId?: string;
        /**
         * The ID of the space to filter the recommended questions for.
         * @deprecated
         */
        spaceId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.streamRequest<SearchAIRecommendedQuestionStream, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/ask/questions`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/ask/questions",
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  siteContext = {
    /**
     * No description
     *
     * @tags site-context
     * @name ListSiteContextRecords
     * @summary List all context records
     * @request GET:/orgs/{organizationId}/sites/{siteId}/context-records
     * @secure
     */
    listSiteContextRecords: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Filter context records by type. */
        type?: ContextRecordType;
        /** Filter context records by connector type. */
        connector?: ContextConnector;
        /** Filter context records by connection id. */
        connection?: string;
        /** Filter context records by associated site topic ID. */
        topic?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ContextRecord[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/context-records`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/context-records",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name UpsertSiteContextRecords
     * @summary Create or update context records
     * @request PUT:/orgs/{organizationId}/sites/{siteId}/context-records
     * @secure
     */
    upsertSiteContextRecords: (
      organizationId: EntityId,
      siteId: string,
      data: ContextRecordInput[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-records`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/context-records",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name GetSiteContextRecordById
     * @summary Get a context record
     * @request GET:/orgs/{organizationId}/sites/{siteId}/context-records/{siteContextRecordId}
     * @secure
     */
    getSiteContextRecordById: (
      organizationId: EntityId,
      siteId: string,
      siteContextRecordId: string,
      params: RequestParams = {},
    ) =>
      this.request<ContextRecord, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-records/${siteContextRecordId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-records/{siteContextRecordId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name ListSiteScans
     * @summary List all site scans
     * @request GET:/orgs/{organizationId}/sites/{siteId}/scans
     * @secure
     */
    listSiteScans: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Filter scans by associated site topic ID. */
        topic?: string;
        /** Filter scans by status. */
        status?: SiteScanStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteScan[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/scans`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/scans",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name GetSiteScanById
     * @summary Get a site scan by ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}/scans/{siteScanId}
     * @secure
     */
    getSiteScanById: (
      organizationId: EntityId,
      siteId: string,
      siteScanId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteScan, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/scans/${siteScanId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/scans/{siteScanId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the quality issues GitBook's AI has identified on a site by comparing its content against real usage and external sources — content gaps, outdated or incorrect content, and broken or outbound links. Use this when asked to find, audit, or fix problems in a site's docs. Only findings with status "open" need work; "candidate" ones have not been confirmed yet. A "broken-link" finding is fixed by a redirect rather than a content edit: pass its `brokenLinkAction` to createSiteRedirect. Fix the rest by opening a change request with its `siteFindingId` set, so merging the change request resolves it.
     *
     * @tags site-context
     * @name ListSiteFindings
     * @summary List documentation issues GitBook has found on a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/findings
     * @secure
     */
    listSiteFindings: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Filter findings by associated site topic ID. */
        topic?: string;
        /** Filter findings that reference the given site question ID as evidence. */
        question?: string;
        /** Filter findings by status. */
        status?: SiteFindingStatus;
        /** Filter findings by type. When multiple types are given, findings matching any of them are returned. */
        type?: SiteFindingType[];
        /** Filter link findings whose URL contains this text: the broken path of a `broken-link` finding, or the checked URL of an `outbound-link-error` one. Findings of any other type never match, so this narrows the list to link findings on its own. */
        url?: string;
        /** Filter findings by estimated severity. */
        severity?: SiteFindingSeverity;
        /** Filter findings by what GitBook did on its own to resolve them: `drafted` fixes wait for approval, `applied` ones were made live, `undone` ones were reversed by a person. */
        autoResolution?: SiteFindingAutoResolution;
        /**
         * Only return findings GitBook drafted or applied a fix for at or after this date. Combine with `autoResolution` and `status` to count recent automatic fixes.
         * @format date-time
         */
        autoResolvedAfter?: string;
        /** Filter findings that have at least one associated change request. */
        hasChangeRequests?: boolean;
        /** Filter link findings by where they stand, for example `awaiting-approval` for broken links with a redirect GitBook drafted. */
        state?: SiteFindingState;
        /** Filter findings by the source of their evidence. Each entry is either `connection:<connectionId>` (findings with at least one piece of evidence coming from the given connection) or `questions` (findings with at least one piece of evidence coming from a site question). When multiple entries are given, findings matching any of them are returned. */
        source?: (SiteTriageFilterQuestions | SiteTriageFilterConnections)[];
        /**
         * Only return findings last updated at or after this date.
         * @format date-time
         */
        updatedAfter?: string;
        /**
         * Only return findings last updated before this date.
         * @format date-time
         */
        updatedBefore?: string;
        /** Sort findings by the given field. */
        orderBy?: SiteFindingOrderBy;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteFinding[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/findings`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/findings",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the full detail of one documentation issue found by GitBook's AI. Use this after `listSiteFindings` to inspect a specific issue before deciding to fix, dismiss, or investigate it further.
     *
     * @tags site-context
     * @name GetSiteFindingById
     * @summary Get details of a single documentation issue
     * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}
     * @secure
     */
    getSiteFindingById: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteFinding, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the change requests created to fix a documentation issue. Use this to check whether an issue already has a pending or merged fix before triggering a new one.
     *
     * @tags site-context
     * @name ListChangeRequestsForSiteFinding
     * @summary List content fixes already proposed for a documentation issue
     * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests
     * @secure
     */
    listChangeRequestsForSiteFinding: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ChangeRequest[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}/change-requests`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Starts GitBook's AI on fixing a documentation issue directly: it drafts the content change and opens it as a change request for review, rather than editing content in place. This is the primary way to act on "fix issues/gaps/broken links in my docs" requests once `listSiteFindings` has surfaced the relevant findings. Processing is asynchronous; poll `listChangeRequestsForSiteFinding` for the resulting change request, then review and merge it with `submitOrMergeChangeRequest`.
     *
     * @tags site-context
     * @name TriggerChangeRequestsForSiteFinding
     * @summary Fix a documentation issue by generating a change request
     * @request POST:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests
     * @secure
     */
    triggerChangeRequestsForSiteFinding: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}/change-requests`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Lists the site pages a documentation issue relates to. Use this to locate which page(s) to edit when fixing an issue manually instead of via `triggerChangeRequestsForSiteFinding`.
     *
     * @tags site-context
     * @name ListPagesForSiteFinding
     * @summary List the pages affected by a documentation issue
     * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/pages
     * @secure
     */
    listPagesForSiteFinding: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteFindingPage[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}/pages`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/pages",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the questions end users asked GitBook's Ask-AI assistant that were used as evidence for a documentation issue. Use this to see what users actually wanted to know before deciding how to fix the issue.
     *
     * @tags site-context
     * @name ListQuestionsForSiteFinding
     * @summary List the Ask-AI questions evidencing a documentation issue
     * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/questions
     * @secure
     */
    listQuestionsForSiteFinding: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteQuestion[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}/questions`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/questions",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the context records that GitBook's AI used as evidence for a documentation issue. Use this to see what real-world signal led to the finding before deciding how to fix it.
     *
     * @tags site-context
     * @name ListRecordsForSiteFinding
     * @summary List the source content evidencing a documentation issue
     * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/records
     * @secure
     */
    listRecordsForSiteFinding: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ContextRecord[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}/records`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/records",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Applies one of the `actions` a finding lists, with the site permission it gives: resolve, dismiss or reopen it, act on a broken link's redirect, or reject the change request GitBook drafted for an outbound link. Returns 409 when the finding doesn't allow the action now.
     *
     * @tags site-context
     * @name ApplySiteFindingAction
     * @summary Apply an action to a finding
     * @request POST:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/actions
     * @secure
     */
    applySiteFindingAction: (
      organizationId: EntityId,
      siteId: string,
      siteFindingId: string,
      data: {
        /**
         * An action that moves a finding to another state. A finding's `actions` lists the ones it allows.
         *   - `approve` makes the redirect GitBook drafted for a broken link live, which resolves the finding. A change request GitBook drafted for an outbound link is approved by merging it.
         *   - `reject` deletes the redirect GitBook drafted for a broken link; the finding stays open and GitBook won't draft a fix for it again. For an outbound link, it archives the change request GitBook drafted (`awaitingChangeRequest`) and unlinks every link it fixes. They are open again, marked `undone`, and GitBook won't draft a fix for them again.
         *   - `create-redirect` creates a redirect for a broken link's path with `createSiteRedirect`, prefilled with the suggestion; it resolves the finding.
         *   - `mark-resolved` resolves it. A broken link resolved this way has no redirect: visitors still get a 404.
         *   - `reopen` reopens a resolved finding. For a broken link, it deletes the live redirect at its path; for a fix GitBook applied, this undoes the fix and GitBook won't fix the link again.
         *   - `ignore` dismisses it.
         *   - `restore` reopens a dismissed finding.
         */
        action: SiteFindingAction;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteFinding, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/findings/${siteFindingId}/actions`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/actions",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns aggregate statistics about the documentation issues GitBook identified on a site. Accepts the same filters as `listSiteFindings`. Use this to answer "how healthy are my docs" before drilling into individual findings.
     *
     * @tags site-context
     * @name GetSiteFindingStats
     * @summary Get a summary of documentation issues found on a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/stats/findings
     * @secure
     */
    getSiteFindingStats: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Filter findings by associated site topic ID. */
        topic?: string;
        /** Filter findings by status. */
        status?: SiteFindingStatus;
        /** Filter findings by type. When multiple types are given, findings matching any of them are returned. */
        type?: SiteFindingType[];
        /** Filter findings by estimated severity. */
        severity?: SiteFindingSeverity;
        /** Filter findings by what GitBook did on its own to resolve them: `drafted` fixes wait for approval, `applied` ones were made live, `undone` ones were reversed by a person. */
        autoResolution?: SiteFindingAutoResolution;
        /**
         * Only return findings GitBook drafted or applied a fix for at or after this date. Combine with `autoResolution` and `status` to count recent automatic fixes.
         * @format date-time
         */
        autoResolvedAfter?: string;
        /** Filter findings that have at least one associated change request. */
        hasChangeRequests?: boolean;
        /** Filter findings by the source of their evidence. Each entry is either `connection:<connectionId>` (findings with at least one piece of evidence coming from the given connection) or `questions` (findings with at least one piece of evidence coming from a site question). When multiple entries are given, findings matching any of them are counted. */
        source?: (SiteTriageFilterQuestions | SiteTriageFilterConnections)[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteFindingStats, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/stats/findings`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/stats/findings",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name ListSiteContextConnections
     * @summary List all context connections
     * @request GET:/orgs/{organizationId}/sites/{siteId}/context-connections
     * @secure
     */
    listSiteContextConnections: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ContextConnection[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name CreateSiteContextConnection
     * @summary Create a context connection
     * @request POST:/orgs/{organizationId}/sites/{siteId}/context-connections
     * @secure
     */
    createSiteContextConnection: (
      organizationId: EntityId,
      siteId: string,
      data: ContextConnectorSetup & {
        usageSettings?: ContextUsageSettings;
        /** Optional filter used to restrict which items are ingested from the source. Its meaning depends on the connector: it can be a tag, label, or an expression. When empty or omitted, all resolved items are ingested. */
        filter?: ContextConnectionFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContextConnection, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name GetSiteContextConnectionById
     * @summary Get a context connection
     * @request GET:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}
     * @secure
     */
    getSiteContextConnectionById: (
      organizationId: EntityId,
      siteId: string,
      siteContextConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ContextConnection, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections/${siteContextConnectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name UpdateSiteContextConnectionById
     * @summary Update a context connection
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}
     * @secure
     */
    updateSiteContextConnectionById: (
      organizationId: EntityId,
      siteId: string,
      siteContextConnectionId: string,
      data:
        | ContextConnectorSetup
        | {
            connector: "builtin:jira";
            /** Optional label for the connection */
            label?: ContextConnectionLabel;
            setupSettings: {
              /** Base URL of the Jira Cloud site, e.g. https://your-team.atlassian.net. */
              baseUrl: BaseUrl;
              /** Email of the Atlassian account whose API token is used. */
              apiEmail: ApiEmail;
              /** Atlassian API token used for outbound writes. Redacted when read back. Omit it when updating a connection to keep the stored token; required when the site URL or account email changes. */
              apiToken?: ApiToken;
              /** Projects where GitBook handles issues. Empty means all accessible projects. */
              projectKeys?: ProjectKeys;
              /** Jira status to move the linked issue to when the change request reaches a given status, e.g. `{ "merged": "Done" }`. A status left out is not synced. */
              statusMapping?: StatusMapping;
            };
          }
        | {
            usageSettings?: ContextUsageSettings;
            /** Optional label for the connection */
            label?: ContextConnectionLabel;
            /** Optional filter used to restrict which items are ingested from the source. Its meaning depends on the connector: it can be a tag, label, or an expression. When empty or omitted, all resolved items are ingested. */
            filter?: ContextConnectionFilter;
          },
      params: RequestParams = {},
    ) =>
      this.request<ContextConnection, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections/${siteContextConnectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name DeleteSiteContextConnectionById
     * @summary Delete a context connection
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}
     * @secure
     */
    deleteSiteContextConnectionById: (
      organizationId: EntityId,
      siteId: string,
      siteContextConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections/${siteContextConnectionId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name SyncSiteContextConnection
     * @summary Trigger a sync for a context connection
     * @request POST:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/sync
     * @secure
     */
    syncSiteContextConnection: (
      organizationId: EntityId,
      siteId: string,
      siteContextConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections/${siteContextConnectionId}/sync`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/sync",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Verifies the stored credentials of a context connection against the external service, without changing anything. A failed verification is reported in the response body with `success` set to `false` rather than as an HTTP error. Connectors that have nothing to verify report `success: true`.
     *
     * @tags site-context
     * @name TestSiteContextConnection
     * @summary Test a context connection's stored credentials
     * @request POST:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/test
     * @secure
     */
    testSiteContextConnection: (
      organizationId: EntityId,
      siteId: string,
      siteContextConnectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ContextConnectionTestResult, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/context-connections/${siteContextConnectionId}/test`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/test",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name ListSiteTopics
     * @summary List all topics
     * @request GET:/orgs/{organizationId}/sites/{siteId}/topics
     * @secure
     */
    listSiteTopics: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Filter stats to answers created at or after this timestamp. */
        from?: Timestamp;
        /** Filter stats to answers created at or before this timestamp. */
        to?: Timestamp;
        /** Filter stats by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter stats by answer channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter stats by answer resolution. */
        answered?: SiteQuestionAnswerResolution[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: SiteTopic[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/topics`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/topics",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a single topic of a site by its ID, including its label, its parent topic when it is a subtopic, its summary and usage settings, and its page, record, finding and Ask AI question counts. Use this when you have a topic ID and need the topic's label or its stats.
     *
     * @tags site-context
     * @name GetSiteTopicById
     * @summary Get a topic
     * @request GET:/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}
     * @secure
     */
    getSiteTopicById: (
      organizationId: EntityId,
      siteId: string,
      siteTopicId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteTopic, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/topics/${siteTopicId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-context
     * @name UpdateSiteTopicById
     * @summary Update a topic
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}
     * @secure
     */
    updateSiteTopicById: (
      organizationId: EntityId,
      siteId: string,
      siteTopicId: string,
      data: {
        usageSettings: SiteTopicUsageSettings;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteTopic, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/topics/${siteTopicId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently deletes every finding associated with a site topic, regardless of status. This is a bulk, irreversible cleanup operation — use `applySiteFindingAction` to resolve or dismiss individual issues instead unless the intent is to wipe every issue under a topic, for example when the topic itself is being removed.
     *
     * @tags site-context
     * @name DeleteSiteTopicFindings
     * @summary Delete all documentation issues found under a topic
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}/findings
     * @secure
     */
    deleteSiteTopicFindings: (
      organizationId: EntityId,
      siteId: string,
      siteTopicId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/topics/${siteTopicId}/findings`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}/findings",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteQuestions = {
    /**
     * @description Returns a paginated list of the questions visitors asked a site's Ask AI assistant, each with usage stats. Use it to discover what users are looking for and where the documentation has gaps.
     *
     * @tags site-questions
     * @name ListSiteQuestions
     * @summary List the questions visitors asked a site's Ask AI assistant
     * @request GET:/orgs/{organizationId}/sites/{siteId}/questions
     * @secure
     */
    listSiteQuestions: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Filter stats to answers created at or after this timestamp. */
        from?: Timestamp;
        /** Filter stats to answers created at or before this timestamp. */
        to?: Timestamp;
        /** Filter questions by question type. */
        type?: SiteQuestionType;
        /** Filter questions by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter questions by answer channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter questions by answer resolution. */
        answered?: SiteQuestionAnswerResolution[];
        /** Filter questions by associated site topic IDs. */
        topic?: string[];
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
        /** Sort questions by latest ask activity, answered rate, or positive feedback rate. If omitted, ordering stays on canonical question creation date to preserve current behavior. */
        sort?:
          | "askedAt"
          | "stats.answered"
          | "stats.feedback"
          | "stats.answers";
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteQuestion[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/questions`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/questions",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves one question asked to a site's Ask AI assistant, including its canonical text and aggregate stats. Use it to inspect a specific question discovered via listSiteQuestions.
     *
     * @tags site-questions
     * @name GetSiteQuestionById
     * @summary Get a single Ask AI question by ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}
     * @secure
     */
    getSiteQuestionById: (
      organizationId: EntityId,
      siteId: string,
      siteQuestionId: string,
      query?: {
        /** Filter stats to answers created at or after this timestamp. */
        from?: Timestamp;
        /** Filter stats to answers created at or before this timestamp. */
        to?: Timestamp;
        /** Filter stats by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter stats by answer channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter stats by answer resolution. */
        answered?: SiteQuestionAnswerResolution[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteQuestion, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/questions/${siteQuestionId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the documentation pages the Ask AI assistant used to answer a given question. Use it to see which content grounded the AI's responses to that question.
     *
     * @tags site-questions
     * @name ListSiteQuestionSources
     * @summary List the documentation sources used to answer a question
     * @request GET:/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}/sources
     * @secure
     */
    listSiteQuestionSources: (
      organizationId: EntityId,
      siteId: string,
      siteQuestionId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Filter sources to answers created at or after this timestamp. */
        from?: Timestamp;
        /** Filter sources to answers created at or before this timestamp. */
        to?: Timestamp;
        /** Filter answer sources by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter answer sources by answer channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter answer sources by answer resolution. */
        answered?: SiteQuestionAnswerResolution[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteQuestionAnswerSource[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/questions/${siteQuestionId}/sources`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}/sources",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns aggregate statistics about the questions visitors asked a site's Ask AI assistant over a time range, optionally filtered by topic, relevance, or channel.  Use it for a high-level view of AI-assistant usage before drilling into individual questions.
     *
     * @tags site-questions
     * @name GetSiteQuestionStats
     * @summary Get aggregate Ask AI question statistics for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/question-stats
     * @secure
     */
    getSiteQuestionStats: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Filter stats to answers created at or after this timestamp. */
        from?: Timestamp;
        /** Filter stats to answers created at or before this timestamp. */
        to?: Timestamp;
        /** Filter stats by associated site topic IDs. */
        topic?: string[];
        /** Filter stats by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter stats by answer channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter stats by answer resolution. */
        answered?: SiteQuestionAnswerResolution[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteQuestionStats, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/question-stats`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/question-stats",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns how many answers the site's Ask AI assistant gave, and to how many visitors, in each UTC bucket of the interval between `from` and `to`, optionally filtered by topic, relevance, channel, visitor type or resolution. Buckets without answers are omitted.
     *
     * @tags site-questions
     * @name GetSiteQuestionTimeline
     * @summary Get Ask AI answers over time for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/question-timeline
     * @secure
     */
    getSiteQuestionTimeline: (
      organizationId: EntityId,
      siteId: string,
      query: {
        /** Count answers created at or after this timestamp. */
        from: Timestamp;
        /** Count answers created at or before this timestamp. */
        to: Timestamp;
        /** Size of each bucket. An hourly timeline covers at most 31 days. */
        interval: SiteQuestionTimelineInterval;
        /** Filter answers by associated site topic IDs. */
        topic?: string[];
        /** Filter answers by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter answers by channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter answers by resolution. */
        answered?: SiteQuestionAnswerResolution[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteQuestionTimeline, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/question-timeline`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/question-timeline",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of individual Ask AI answers generated for a site. Each is the assistant's response to a specific asked question, with the raw question text, channel, and feedback. Use it to review answer quality and what users asked across the site.
     *
     * @tags site-questions
     * @name ListSiteQuestionAnswers
     * @summary List the answers a site's Ask AI assistant generated
     * @request GET:/orgs/{organizationId}/sites/{siteId}/answers
     * @secure
     */
    listSiteQuestionAnswers: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Filter answers to a specific site question ID. */
        question?: string;
        /** Filter answers created at or after this timestamp. */
        from?: Timestamp;
        /** Filter answers created at or before this timestamp. */
        to?: Timestamp;
        /** Filter answers by ISO language code. */
        language?: string;
        /** Filter answers by answered resolution. */
        answered?: SiteQuestionAnswerResolution[];
        /** Filter answers by answered helpfulness. */
        helpfulness?: SiteQuestionAnswerHelpfulness;
        /** Filter answers by question relevance. */
        relevance?: SiteQuestionAnswerRelevance[];
        /** Filter answers by answer channel type. */
        channelType?: SiteChannelType[];
        /** Filter by whether a person or an AI agent asked the question. */
        visitorType?: SiteQuestionVisitorType[];
        /** Filter answers by question type. */
        "question.type"?: SiteQuestionType;
        /** Filter answers by associated site topic ID. */
        topic?: string;
        /** Filter answers by thread root answer ID. Includes the root answer itself. */
        thread?: string;
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteQuestionAnswer[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/answers`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/answers",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves one Ask AI answer, including the question that prompted it, the response, and its feedback. Use it to inspect a specific answer discovered via listSiteQuestionAnswers.
     *
     * @tags site-questions
     * @name GetSiteQuestionAnswerById
     * @summary Get a single Ask AI answer by ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}
     * @secure
     */
    getSiteQuestionAnswerById: (
      organizationId: EntityId,
      siteId: string,
      siteQuestionAnswerId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteQuestionAnswerWithResponse, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/answers/${siteQuestionAnswerId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the full conversation thread for a given Ask AI answer: the sequence of follow-up questions and responses in that exchange.
     *
     * @tags site-questions
     * @name GetSiteQuestionAnswerThreadById
     * @summary Get the conversation thread for an Ask AI answer
     * @request GET:/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/thread
     * @secure
     */
    getSiteQuestionAnswerThreadById: (
      organizationId: EntityId,
      siteId: string,
      siteQuestionAnswerId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteQuestionAnswerWithResponse[], any>({
        path: `/orgs/${organizationId}/sites/${siteId}/answers/${siteQuestionAnswerId}/thread`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/thread",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the documentation pages the Ask AI assistant cited to produce a given answer. Use it to see exactly which content grounded that specific answer.
     *
     * @tags site-questions
     * @name ListSiteQuestionAnswerSources
     * @summary List the documentation sources cited for an answer
     * @request GET:/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/sources
     * @secure
     */
    listSiteQuestionAnswerSources: (
      organizationId: EntityId,
      siteId: string,
      siteQuestionAnswerId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteQuestionAnswerSource[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/answers/${siteQuestionAnswerId}/sources`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/sources",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sitePermissions = {
    /**
     * No description
     *
     * @tags site-permissions
     * @name InviteToSite
     * @summary Invite a user or a team to a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/permissions
     * @secure
     */
    inviteToSite: (
      organizationId: EntityId,
      siteId: string,
      data: InviteSiteUsersAndTeams,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/permissions",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-permissions
     * @name ListTeamPermissionsInSite
     * @summary List an org team's permission in a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/teams
     * @secure
     */
    listTeamPermissionsInSite: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: TeamSitePermissionOverride[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/teams`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/teams",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-permissions
     * @name UpdateTeamPermissionInSite
     * @summary Update an org team's permission in a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}
     * @secure
     */
    updateTeamPermissionInSite: (
      organizationId: EntityId,
      siteId: string,
      teamId: EntityId,
      data: {
        /**
         * "The role of a member in an organization.
         * "admin": Can administrate the content: create, delete spaces, ...
         * "create": Can create content.
         * "review": Can review content.
         * "edit": Can edit the content (live or change requests).
         * "comment": Can access the content and its discussions.
         * "read": Can access the content, but cannot update it in any way.
         */
        role?: MemberRole;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/teams/${teamId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-permissions
     * @name RemoveTeamFromSite
     * @summary Remove an org team from a site
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}
     * @secure
     */
    removeTeamFromSite: (
      organizationId: EntityId,
      siteId: string,
      teamId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/teams/${teamId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteUsers = {
    /**
     * No description
     *
     * @tags site-users
     * @name ListPermissionsAggregateInSite
     * @summary List all sites users permissions
     * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/aggregate
     * @secure
     */
    listPermissionsAggregateInSite: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * An order for the items in the list
         * @default "desc"
         */
        order?: "asc" | "desc";
        /** The role to filter the list by */
        role?: MemberRole | "guest";
        /** A query to filter the list by display name and email */
        search?: string;
        /**
         * The property to sort the list by
         * @default "joinedAt"
         */
        sort?: "joinedAt" | "lastSeenAt" | "name";
        /** Team identifier. Filter the list to members of a specific team. */
        team?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          /**
           * Number of users with a role in the site, guests excluded. It ignores the filters and the pagination of the request.
           * @min 0
           */
          membersCount: number;
          items: UserSitePermission[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/aggregate`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/aggregate",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-users
     * @name ListUserPermissionsInSite
     * @summary List site user permissions
     * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/users
     * @secure
     */
    listUserPermissionsInSite: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: UserSitePermissionOverride[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/users`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/users",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-users
     * @name UpdateUserPermissionInSite
     * @summary Update site user permissions
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}
     * @secure
     */
    updateUserPermissionInSite: (
      organizationId: EntityId,
      siteId: string,
      userId: string,
      data: {
        /**
         * "The role of a member in an organization.
         * "admin": Can administrate the content: create, delete spaces, ...
         * "create": Can create content.
         * "review": Can review content.
         * "edit": Can edit the content (live or change requests).
         * "comment": Can access the content and its discussions.
         * "read": Can access the content, but cannot update it in any way.
         */
        role?: MemberRole;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/users/${userId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-users
     * @name RemoveUserFromSite
     * @summary Remove a site user
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}
     * @secure
     */
    removeUserFromSite: (
      organizationId: EntityId,
      siteId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/permissions/users/${userId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteAi = {
    /**
     * @description Generate an AI response in a conversation.
     *
     * @tags site-ai
     * @name StreamAiResponseInSite
     * @summary Generate an AI response in a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/ai/response
     * @secure
     */
    streamAiResponseInSite: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** The ID of the previous response to continue from */
        previousResponseId?: string;
        /** The messages to send to the AI agent. */
        input: AIMessageInput[];
        model?: AIModel;
        /** Custom tools to provide to the AI agent. */
        tools?: AIToolDefinition[];
        /** Result of a tool call. */
        toolCall?: AIToolCallResult;
        /** Identifiers for a GitBook site session, used for analytics and adaptive content. */
        session?: SiteInsightsSession;
        /** The channel from which the question was asked, if applicable. */
        channel?: {
          type: SiteCoreChannelType;
        };
      },
      params: RequestParams = {},
    ) =>
      this.streamRequest<AIStreamResponse, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/ai/response`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/ai/response",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  siteAgentSettings = {
    /**
     * @description Retrieves the configuration for the AI built into the GitBook editor that assists authors with drafting and refining content changes. Use this before updating agent settings to understand the current configuration.
     *
     * @tags site-agent-settings
     * @name GetSiteAgentSettingsById
     * @summary Get the AI agent configuration for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/agent-settings
     * @secure
     */
    getSiteAgentSettingsById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteAgentSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/agent-settings`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/agent-settings",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Replaces the configuration for the AI built into the GitBook editor that helps authors draft, review, and refine content changes. Use this to customize how the AI behaves when assisting authors working on content for this site. When `brokenLinks` is omitted, the current broken links settings are kept.
     *
     * @tags site-agent-settings
     * @name UpdateSiteAgentSettingsById
     * @summary Update the AI agent configuration for a site
     * @request PUT:/orgs/{organizationId}/sites/{siteId}/agent-settings
     * @secure
     */
    updateSiteAgentSettingsById: (
      organizationId: EntityId,
      siteId: string,
      data: SiteAgentSettingsInput,
      params: RequestParams = {},
    ) =>
      this.request<
        SiteAgentSettings,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/agent-settings`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/agent-settings",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  analytics = {
    /**
     * No description
     *
     * @tags analytics, sites, internal
     * @name GetAdsInsightsForSiteById
     * @summary Get analytics insights of ads on a site.
     * @request GET:/orgs/{organizationId}/sites/{siteId}/insights/ads
     * @secure
     */
    getAdsInsightsForSiteById: (
      organizationId: EntityId,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** A time serie of the ads stats over the provided period */
          values: {
            /**
             * The start date of this interval
             * @format date-time
             */
            date: string;
            stats: SiteAdsStats;
          }[];
          account: {
            /** Email address on the Ads platform. */
            email: string;
            /** URL to configure payout. */
            url: string;
          };
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/insights/ads`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/insights/ads",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteAds = {
    /**
     * @description Updates the advertising configuration for a site, including the review status and topic category used to select relevant ads. This controls GitBook's monetization feature for sites opted into the ads program.
     *
     * @tags site-ads
     * @name UpdateSiteAdsById
     * @summary Update the advertising settings for a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/ads
     * @secure
     */
    updateSiteAdsById: (
      organizationId: EntityId,
      siteId: string,
      data?: {
        status?: "in-review" | "disabled";
        /** Topic of the content */
        topic?: SiteAdsTopic;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/ads`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/ads",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-ads
     * @name AdsListSites
     * @summary List all the sites with ads configured
     * @request GET:/ads/sites
     * @secure
     */
    adsListSites: (
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /**
         * Filter sites by their ads review status
         * @default "in-review"
         */
        status?: "in-review" | "live" | "rejected";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: ({
            id: string;
            url: string;
            email: string;
            /** Topic of the content */
            topic: SiteAdsTopic;
          } & (
            | {
                status: "in-review";
              }
            | {
                status: "live";
                /** The ad network zone ID */
                zoneId: string;
              }
            | {
                status: "rejected";
                /** Reason for the rejection */
                reason?: string;
              }
          ))[];
        },
        any
      >({
        path: `/ads/sites`,
        routeTemplate: "/ads/sites",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-ads
     * @name AdsUpdateSite
     * @summary Update the Ads configuration for a site
     * @request PATCH:/ads/sites/{siteId}
     * @secure
     */
    adsUpdateSite: (
      siteId: string,
      data:
        | {
            status: "live";
            /** ID of the zone */
            zoneId: string;
            /** ID to fetch reporting data */
            reportingId: string;
          }
        | {
            status: "rejected";
            /**
             * Reason for the rejection
             * @maxLength 512
             */
            reason?: string;
          }
        | {
            status: "pending";
          },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/ads/sites/${siteId}`,
        routeTemplate: "/ads/sites/{siteId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  siteRedirects = {
    /**
     * @description Creates a new redirect rule mapping a source path to a destination URL or content reference. Creating a live redirect also resolves open broken-link findings for the same source path. Use the bulk upsert endpoint instead when creating many redirects at once.
     *
     * @tags site-redirects
     * @name CreateSiteRedirect
     * @summary Create a URL redirect rule for a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/redirects
     * @secure
     */
    createSiteRedirect: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** The broken-link finding that prompted this redirect. Must belong to this site. Used to attribute redirect creation, including drafts, to the finding. */
        siteFindingId?: string;
        /** The source path to redirect from. */
        source: SiteRedirectSourcePath;
        /**
         * Capture and append the wildcard-matched suffix to the destination URL.
         * @default false
         */
        captureWildcard?: boolean;
        /**
         * Whether the redirect is draft and not live.
         * @default false
         */
        draft?: boolean;
        /**
         * Whether the redirect is permanent for public live traffic.
         * @default false
         */
        permanent?: boolean;
        destination: SiteRedirectInputDestination;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteRedirect, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/redirects`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/redirects",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Processes up to 500 redirect operations in a single request. Each redirect in the array is processed independently and the response includes per-item status. Prefer this over individual create/update calls when managing large sets of redirects.
     *
     * @tags site-redirects
     * @name BulkUpsertSiteRedirects
     * @summary Create, update, delete, or publish site redirect rules in bulk
     * @request PUT:/orgs/{organizationId}/sites/{siteId}/redirects
     * @secure
     */
    bulkUpsertSiteRedirects: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /**
         * @maxItems 500
         * @minItems 1
         */
        redirects: (
          | {
              /** The source path to redirect from. */
              source: SiteRedirectSourcePath;
              /** Publish a draft redirect to live and remove the draft redirect. */
              intent: "publish";
            }
          | {
              /** The source path to redirect from. */
              source: SiteRedirectSourcePath;
              /**
               * Redirect operation intent.
               * - live: upsert/delete a live redirect (draft=false)
               * - draft: upsert/delete a draft redirect (draft=true)
               * @default "live"
               */
              intent?: "live" | "draft";
              /**
               * Capture and append the wildcard-matched suffix to the destination URL.
               * @default false
               */
              captureWildcard?: boolean;
              /** Whether the redirect is permanent for public live traffic. */
              permanent?: boolean;
              /** If set to null, the redirect matching the source+intent target will be deleted. */
              destination: SiteRedirectInputDestination | null;
            }
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          results: (
            | {
                /** The redirect was created. */
                status: "created";
                /** The source path to redirect from. */
                source: SiteRedirectSourcePath;
                /** Whether the redirect is draft and not live. */
                draft: boolean;
                /** The ID of the created redirect. */
                id: string;
              }
            | {
                /** The redirect was updated. */
                status: "updated";
                /** The source path to redirect from. */
                source: SiteRedirectSourcePath;
                /** Whether the redirect is draft and not live. */
                draft: boolean;
                /** The ID of the updated redirect. */
                id: string;
              }
            | {
                /** The redirect was deleted. */
                status: "deleted";
                /** The source path to redirect from. */
                source: SiteRedirectSourcePath;
                /** Whether the deleted redirect was draft. */
                draft: boolean;
              }
            | {
                /** The draft redirect was published to live and removed from draft. */
                status: "published";
                /** The source path to redirect from. */
                source: SiteRedirectSourcePath;
                /** Always false for published redirects. */
                draft: boolean;
                /** The ID of the resulting live redirect. */
                id: string;
              }
            | {
                /** There was an error processing the redirect. */
                status: "error";
                /** The source path to redirect from. */
                source: SiteRedirectSourcePath;
                /** Whether the redirect is draft and not live. */
                draft: boolean;
                /** The error message. */
                error: string;
              }
          )[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/redirects`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/redirects",
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of redirect rules for the site. Supports filtering by draft status and searching by path. Use this to audit redirects, find a specific rule before updating it, or check whether draft redirects are pending publication.
     *
     * @tags site-redirects
     * @name ListSiteRedirects
     * @summary List all URL redirect rules configured for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/redirects
     * @secure
     */
    listSiteRedirects: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
        /** Search for a redirect by path */
        search?: string;
        /**
         * Filter redirects by draft mode.
         * @default false
         */
        draft?: boolean;
        /** Sort redirects by the given field. */
        orderBy?: SiteRedirectOrderBy;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteRedirect[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/redirects`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/redirects",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an existing redirect rule for a site. Only provided fields are updated.
     *
     * @tags site-redirects
     * @name UpdateSiteRedirectById
     * @summary Update a URL redirect rule for a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}
     * @secure
     */
    updateSiteRedirectById: (
      organizationId: EntityId,
      siteId: string,
      siteRedirectId: string,
      data: {
        /** The source path to redirect from. */
        source?: SiteRedirectSourcePath;
        /** Capture and append the wildcard-matched suffix to the destination URL. */
        captureWildcard?: boolean;
        /** When true, it can be used to promote a draft redirect to live. */
        draft?: boolean;
        /** Whether the redirect is permanent for public live traffic. */
        permanent?: boolean;
        destination?: SiteRedirectDestination;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteRedirect, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/redirects/${siteRedirectId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-redirects
     * @name DeleteSiteRedirectById
     * @summary Delete a site redirect
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}
     * @secure
     */
    deleteSiteRedirectById: (
      organizationId: EntityId,
      siteId: string,
      siteRedirectId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/redirects/${siteRedirectId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Looks up a redirect rule by its source URL path and returns both the redirect configuration and the resolved destination URL. Use this to check whether a specific path has a redirect configured, or to resolve where a path currently points before updating or removing the redirect.
     *
     * @tags site-redirects
     * @name GetSiteRedirectBySource
     * @summary Resolve a site redirect rule by its source path
     * @request GET:/orgs/{organizationId}/sites/{siteId}/redirect
     * @secure
     */
    getSiteRedirectBySource: (
      organizationId: EntityId,
      siteId: string,
      query: {
        /** For sites published via share-links, the share key is useful to resolve published URLs. */
        shareKey?: string;
        /** The source path of the redirect. */
        source: SiteRedirectSourcePath;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          redirect: SiteRedirect;
          /** URL of the destination of the redirect. */
          target: string;
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/redirect`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/redirect",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteMcpServers = {
    /**
     * @description Returns a paginated list of Model Context Protocol (MCP) server configurations attached to the site. MCP servers expose tools and resources that the AI Assistant can call when helping site visitors find information. Use this to audit or manage the AI tool integrations available on a site.
     *
     * @tags site-mcp-servers
     * @name ListSiteMcpServers
     * @summary List all MCP servers configured for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/mcp-servers
     * @secure
     */
    listSiteMcpServers: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteMcpServer[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/mcp-servers`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/mcp-servers",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Registers a new Model Context Protocol (MCP) server with the site, providing its URL, transport type, request headers, and an optional conditional expression to control visibility per visitor. Once added, the MCP server's tools become available to the AI Assistant when helping visitors of this site.
     *
     * @tags site-mcp-servers
     * @name CreateSiteMcpServer
     * @summary Add a new MCP server configuration to a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/mcp-servers
     * @secure
     */
    createSiteMcpServer: (
      organizationId: EntityId,
      siteId: string,
      data: {
        /** Name of the MCP server */
        name: SiteMcpServerName;
        url: URL;
        /** Transport protocol used to connect to the MCP server */
        transport?: SiteMcpServerTransport;
        /** HTTP headers sent with requests to this server */
        headers: SiteMcpServerHeaders;
        /** Conditional expression used to evaluate whether the MCP server should be available to the site's visitor (should evaluate to a boolean). If set to null, the condition will be removed. */
        condition?: Expression | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteMcpServer, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/mcp-servers`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/mcp-servers",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Attempts to connect to a Model Context Protocol (MCP) server using the provided URL, transport, and headers, then lists the tools it exposes. Use this to validate an MCP server's configuration before saving it to a site. The configuration is not persisted. A connection failure is reported in the response body with `success` set to `false` rather than as an HTTP error.
     *
     * @tags site-mcp-servers, internal
     * @name TestSiteMcpServer
     * @summary Test a connection to an MCP server configuration
     * @request POST:/orgs/{organizationId}/sites/{siteId}/mcp-servers/test
     * @secure
     */
    testSiteMcpServer: (
      organizationId: EntityId,
      siteId: string,
      data: {
        url: URL;
        /** Transport protocol used to connect to the MCP server */
        transport?: SiteMcpServerTransport;
        /** HTTP headers sent with requests to this server */
        headers?: SiteMcpServerHeaders;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          object: "site-mcp-server-test-result";
          /** Whether GitBook could connect to the MCP server. */
          success: boolean;
          /** Tools exposed by the MCP server, when the connection succeeded. */
          tools?: {
            name: string;
            description?: string;
          }[];
          /** A human-readable reason for the failure, when the connection failed. */
          error?: string;
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/mcp-servers/test`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/test",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the configuration of a specific MCP server registered with the site. Use this to inspect an MCP server's details before updating or removing it.
     *
     * @tags site-mcp-servers
     * @name GetSiteMcpServerById
     * @summary Get an MCP server configuration for a site by its ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
     * @secure
     */
    getSiteMcpServerById: (
      organizationId: EntityId,
      siteId: string,
      siteMcpServerId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteMcpServer, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/mcp-servers/${siteMcpServerId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies an existing MCP server's configuration. Only provided fields are updated; omitting a field leaves it unchanged. Set condition to null to remove it and make the MCP server available to all visitors.
     *
     * @tags site-mcp-servers
     * @name UpdateSiteMcpServerById
     * @summary Update an MCP server configuration for a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
     * @secure
     */
    updateSiteMcpServerById: (
      organizationId: EntityId,
      siteId: string,
      siteMcpServerId: string,
      data: {
        /** Name of the MCP server */
        name?: SiteMcpServerName;
        /**
         * @format uri
         * @maxLength 2048
         */
        url?: string;
        /** Transport protocol used to connect to the MCP server */
        transport?: SiteMcpServerTransport;
        /** HTTP headers sent with requests to this server */
        headers?: SiteMcpServerHeaders;
        /** Conditional expression used to evaluate whether the MCP server should be available to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
        condition?: Expression | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteMcpServer, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/mcp-servers/${siteMcpServerId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags site-mcp-servers
     * @name DeleteSiteMcpServerById
     * @summary Delete a site MCP server
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
     * @secure
     */
    deleteSiteMcpServerById: (
      organizationId: EntityId,
      siteId: string,
      siteMcpServerId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/mcp-servers/${siteMcpServerId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  siteChannels = {
    /**
     * @description Returns a paginated list of channels configured for the site. Channels are integrations that allow GitBook Agent to operate within external tools your team already uses, bringing documentation assistance directly into existing workflows. Each channel has a role that determines whether the Agent answers questions from the site's documentation or actively collaborates by opening and managing content changes. Use this to inspect or manage the Agent channel integrations for a site.
     *
     * @tags site-channels
     * @name ListSiteChannels
     * @summary List all GitBook Agent channels for a site
     * @request GET:/orgs/{organizationId}/sites/{siteId}/channels
     * @secure
     */
    listSiteChannels: (
      organizationId: EntityId,
      siteId: string,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: SiteChannel[];
        },
        any
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/channels`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/channels",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Configures a new channel integration that allows GitBook Agent to operate within an external tool connected to this site. The channel role determines whether the Agent acts as a support assistant — answering questions sourced from the site's documentation — or as a collaborator that can open change requests and sync documentation updates directly from the connected platform.
     *
     * @tags site-channels
     * @name CreateSiteChannel
     * @summary Create a new GitBook Agent channel for a site
     * @request POST:/orgs/{organizationId}/sites/{siteId}/channels
     * @secure
     */
    createSiteChannel: (
      organizationId: EntityId,
      siteId: string,
      data: SiteChannelSetup & {
        role?: SiteChannelRole;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteChannel, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/channels`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/channels",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Lists accessible Linear teams, GitHub repositories, Slack channels or Jira projects. Requires site admin permission. Linear, GitHub and Slack require an already-connected channel belonging to this site and matching the provider. Jira uses either the credentials supplied, verified without saving a connection, or those stored on an existing Jira context connection of this site. Slack includes public channels and accessible private channels, excluding archived channels. To fetch another page, pass the opaque token from `next.page` as the `page` query parameter with the same request body. An absent `next` means there are no more pages; an empty `items` array alone does not indicate the end of the list.
     *
     * @tags site-channels
     * @name ListSiteChannelScopes
     * @summary List available site channel scopes
     * @request POST:/orgs/{organizationId}/sites/{siteId}/channels/scopes
     * @secure
     */
    listSiteChannelScopes: (
      organizationId: EntityId,
      siteId: string,
      data:
        | {
            provider: "linear";
            /** ID of an already-connected channel belonging to this site and matching the provider. */
            siteChannelId: string;
          }
        | {
            provider: "github";
            /** ID of an already-connected channel belonging to this site and matching the provider. */
            siteChannelId: string;
          }
        | {
            provider: "slack";
            /** ID of an already-connected channel belonging to this site and matching the provider. */
            siteChannelId: string;
          }
        | {
            provider: "jira";
            /** ID of a Jira context connection belonging to this site, whose stored credentials are used. */
            siteContextConnectionId: string;
          }
        | {
            provider: "jira";
            credentials: {
              /**
               * Base URL of the Jira Cloud site, e.g. https://your-team.atlassian.net.
               * @format uri
               * @minLength 1
               * @maxLength 2048
               */
              baseUrl: string;
              /**
               * Email of the Atlassian account whose API token is used.
               * @format email
               * @minLength 1
               * @maxLength 254
               */
              apiEmail: string;
              /**
               * Atlassian API token used to verify the account and list accessible projects. Not saved.
               * @minLength 1
               * @maxLength 1024
               */
              apiToken: string;
            };
          },
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          object: "site-channel-scopes";
          /** Linear workspace name, GitHub account name, Slack workspace name (or ID if unavailable), or Jira Cloud hostname. */
          connection: string;
          items: {
            /** Value accepted by the provider scope settings, such as a team key, repository full name, channel name, Jira project key. */
            key: string;
            name: string;
          }[];
        },
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 401;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 403;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/orgs/${organizationId}/sites/${siteId}/channels/scopes`,
        routeTemplate: "/orgs/{organizationId}/sites/{siteId}/channels/scopes",
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the configuration of a specific GitBook Agent channel integration, including its connected platform type and role. Use this to inspect or verify the channel's setup before updating it.
     *
     * @tags site-channels
     * @name GetSiteChannelById
     * @summary Get a GitBook Agent channel for a site by its ID
     * @request GET:/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}
     * @secure
     */
    getSiteChannelById: (
      organizationId: EntityId,
      siteId: string,
      siteChannelId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteChannel, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/channels/${siteChannelId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies the configuration of a specific GitBook Agent channel integration, including its role. Use this to change whether the Agent answers documentation questions or actively collaborates on content changes through the connected platform.
     *
     * @tags site-channels
     * @name UpdateSiteChannelById
     * @summary Update a GitBook Agent channel for a site
     * @request PATCH:/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}
     * @secure
     */
    updateSiteChannelById: (
      organizationId: EntityId,
      siteId: string,
      siteChannelId: string,
      data:
        | SiteChannelSetup
        | {
            role?: SiteChannelRole;
          },
      params: RequestParams = {},
    ) =>
      this.request<SiteChannel, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/channels/${siteChannelId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes the channel configuration from the site, so GitBook Agent stops answering and collaborating through the connected platform. The app itself is not uninstalled and its access is not revoked on the platform, so remove it there as well to fully disconnect.
     *
     * @tags site-channels
     * @name DeleteSiteChannelById
     * @summary Delete a GitBook Agent channel from a site
     * @request DELETE:/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}
     * @secure
     */
    deleteSiteChannelById: (
      organizationId: EntityId,
      siteId: string,
      siteChannelId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orgs/${organizationId}/sites/${siteId}/channels/${siteChannelId}`,
        routeTemplate:
          "/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  subdomains = {
    /**
     * No description
     *
     * @tags subdomains
     * @name GetSubdomain
     * @summary Get a subdomain
     * @request GET:/subdomains/{subdomain}
     * @secure
     */
    getSubdomain: (subdomain: string, params: RequestParams = {}) =>
      this.request<Subdomain, any>({
        path: `/subdomains/${subdomain}`,
        routeTemplate: "/subdomains/{subdomain}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customHostnames = {
    /**
     * No description
     *
     * @tags custom-hostnames
     * @name GetCustomHostname
     * @summary Get a custom hostname
     * @request GET:/custom-hostnames/{hostname}
     * @secure
     */
    getCustomHostname: (hostname: string, params: RequestParams = {}) =>
      this.request<CustomHostname, any>({
        path: `/custom-hostnames/${hostname}`,
        routeTemplate: "/custom-hostnames/{hostname}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Any previously set custom hostname will continue pointing to the target but marked as available for use with another target.
     *
     * @tags custom-hostnames, internal
     * @name SetupCustomHostname
     * @summary Setup a custom hostname
     * @request POST:/custom-hostnames/{hostname}
     * @secure
     */
    setupCustomHostname: (
      hostname: string,
      data: {
        target: OrganizationPointer | SitePointer;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        CustomHostname,
        {
          error: {
            /** @format int32 */
            code: 409;
            message: string;
          };
        }
      >({
        path: `/custom-hostnames/${hostname}`,
        routeTemplate: "/custom-hostnames/{hostname}",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Revalidate DNS records and status.
     *
     * @tags custom-hostnames
     * @name DnsRevalidateCustomHostname
     * @summary Revalidate a custom hostname DNS
     * @request PATCH:/custom-hostnames/{hostname}
     * @secure
     */
    dnsRevalidateCustomHostname: (
      hostname: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 409;
            message: string;
          };
        }
      >({
        path: `/custom-hostnames/${hostname}`,
        routeTemplate: "/custom-hostnames/{hostname}",
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * @description The custom hostname will continue to point to the content or organization unless it is used for another one.
     *
     * @tags custom-hostnames
     * @name RemoveCustomHostname
     * @summary Remove a custom hostname
     * @request DELETE:/custom-hostnames/{hostname}
     * @secure
     */
    removeCustomHostname: (hostname: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/custom-hostnames/${hostname}`,
        routeTemplate: "/custom-hostnames/{hostname}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Test if a custom hostname can be used for a site or organization.
     *
     * @tags custom-hostnames, internal
     * @name TestCustomHostname
     * @summary Test a custom hostname
     * @request POST:/custom-hostnames/{hostname}/test
     * @secure
     */
    testCustomHostname: (
      hostname: string,
      data: {
        target: OrganizationPointer | SitePointer;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/custom-hostnames/${hostname}/test`,
        routeTemplate: "/custom-hostnames/{hostname}/test",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  internal = {
    /**
     * No description
     *
     * @tags internal
     * @name SignInWithEmailLink
     * @summary Send a sign-in link to the specified email address
     * @request POST:/internal/signin/email-link
     * @secure
     */
    signInWithEmailLink: (
      data: {
        /** Email to send the link to. */
        email: string;
        /** URL to redirect to with the OOB code (with protocol, ex: "http://localhost:5000"). */
        url?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/internal/signin/email-link`,
        routeTemplate: "/internal/signin/email-link",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags internal
     * @name SignInMethodsForEmail
     * @summary Get supported sign in methods for an email address
     * @request GET:/internal/signin/{email}/methods
     * @secure
     */
    signInMethodsForEmail: (email: string, params: RequestParams = {}) =>
      this.request<
        {
          methods: ("emailLink" | "password" | "google.com" | "github.com")[];
          /** The ID of the organization the user has an SSO link to. */
          ssoOrganization?: string;
        },
        any
      >({
        path: `/internal/signin/${email}/methods`,
        routeTemplate: "/internal/signin/{email}/methods",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags internal
     * @name SearchUnsplashImages
     * @summary Search images in unsplash.
     * @request GET:/internal/unsplash/images
     * @secure
     */
    searchUnsplashImages: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: UnsplashImage[];
        },
        any
      >({
        path: `/internal/unsplash/images`,
        routeTemplate: "/internal/unsplash/images",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Indicate the use of an unsplash image. It's a requirement as part of their API Guidelines.
     *
     * @tags internal
     * @name TrackDownloadUnplashImage
     * @summary Track the download of an image from Unsplash
     * @request POST:/internal/unsplash/track_download
     * @secure
     */
    trackDownloadUnplashImage: (
      data: {
        downloadLocation: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/internal/unsplash/track_download`,
        routeTemplate: "/internal/unsplash/track_download",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags internal
     * @name SignServiceUrl
     * @summary Sign a browser service URL for the authenticated user.
     * @request POST:/internal/urls/sign
     * @secure
     */
    signServiceUrl: (
      data: {
        /** Absolute HTTPS service URL to sign. */
        url: URL;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        SignedURL,
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/internal/urls/sign`,
        routeTemplate: "/internal/urls/sign",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hive = {
    /**
     * No description
     *
     * @tags hive, critical, internal
     * @name GenerateHiveAccessToken
     * @summary Returns a token to authenticate with Hive.
     * @request POST:/internal/hive/token
     * @secure
     */
    generateHiveAccessToken: (
      data?: {
        contentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<HiveAccessToken, any>({
        path: `/internal/hive/token`,
        routeTemplate: "/internal/hive/token",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  backoffice = {
    /**
     * @description Backoffice endpoint to update the organization-level static-IP proxy setting used by Git Sync or the integration proxy setting.
     *
     * @tags backoffice
     * @name UpdateOrganizationIntegrationInstallationProxy
     * @summary Update the Git Sync proxy status (github or gitlab) for an organization
     * @request PATCH:/backoffice/organizations/{organizationId}/integrations/{integrationName}/network
     * @secure
     */
    updateOrganizationIntegrationInstallationProxy: (
      organizationId: EntityId,
      integrationName: string,
      data: {
        /** Whether the installation should be proxied */
        proxy: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/organizations/${organizationId}/integrations/${integrationName}/network`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/integrations/{integrationName}/network",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Start one hour of bounded CPU or allocation captures with GC and stall timelines on the CI-managed profiling revision. CPU is the default; allocation sampling runs separately and includes collected objects. No deployment or environment configuration is required. Returns a conflict if a session is already active.
     *
     * @tags backoffice
     * @name CreateCpuProfilingSession
     * @summary Start an API profiling session
     * @request POST:/backoffice/debug/cpu-profile-sessions
     * @secure
     */
    createCpuProfilingSession: (
      data?: {
        /** @default "cpu" */
        mode?: "cpu" | "allocations";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        APIProfilingSession,
        {
          error: {
            /** @format int32 */
            code: 409;
            message: string;
          };
        }
      >({
        path: `/backoffice/debug/cpu-profile-sessions`,
        routeTemplate: "/backoffice/debug/cpu-profile-sessions",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetCpuProfilingSession
     * @summary Get an API CPU profiling session
     * @request GET:/backoffice/debug/cpu-profile-sessions/{sessionId}
     * @secure
     */
    getCpuProfilingSession: (sessionId: string, params: RequestParams = {}) =>
      this.request<APIProfilingSession, any>({
        path: `/backoffice/debug/cpu-profile-sessions/${sessionId}`,
        routeTemplate: "/backoffice/debug/cpu-profile-sessions/{sessionId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Profiling instances observe an explicit stop at the next session poll, nominally every ten seconds. Expiry is also enforced locally.
     *
     * @tags backoffice
     * @name StopCpuProfilingSession
     * @summary Stop an API CPU profiling session
     * @request DELETE:/backoffice/debug/cpu-profile-sessions/{sessionId}
     * @secure
     */
    stopCpuProfilingSession: (sessionId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/debug/cpu-profile-sessions/${sessionId}`,
        routeTemplate: "/backoffice/debug/cpu-profile-sessions/{sessionId}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ListCpuProfiles
     * @summary List an API session's CPU profiles
     * @request GET:/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles
     * @secure
     */
    listCpuProfiles: (
      sessionId: string,
      query?: {
        /**
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          profiles: APICPUProfile[];
          count: number;
        },
        any
      >({
        path: `/backoffice/debug/cpu-profile-sessions/${sessionId}/profiles`,
        routeTemplate:
          "/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return CPU or allocation stacks, GC and stall timelines with process identity. Use format=devtools to download a .cpuprofile or .heapprofile directly. Profile objects remain private and require staff authorization.
     *
     * @tags backoffice
     * @name GetCpuProfile
     * @summary Download an API profile
     * @request GET:/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles/{profileId}
     * @secure
     */
    getCpuProfile: (
      sessionId: string,
      profileId: string,
      query?: {
        /**
         * Return the full diagnostic record or its raw DevTools-compatible profile.
         * @default "diagnostic"
         */
        format?: "diagnostic" | "devtools";
      },
      params: RequestParams = {},
    ) =>
      this.request<IntegrationInstallationConfiguration, any>({
        path: `/backoffice/debug/cpu-profile-sessions/${sessionId}/profiles/${profileId}`,
        routeTemplate:
          "/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles/{profileId}",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name PurgeCloudflareCdnCache
     * @summary Purge Cloudflare's CDN cache by tags or hosts
     * @request POST:/backoffice/cdn-cache/purge
     * @secure
     */
    purgeCloudflareCdnCache: (
      data: PurgeCDNCacheContext,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/backoffice/cdn-cache/purge`,
        routeTemplate: "/backoffice/cdn-cache/purge",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetCustomDomainInfo
     * @summary Get Custom Domain info
     * @request GET:/backoffice/custom-domains/{hostname}
     * @secure
     */
    getCustomDomainInfo: (hostname: string, params: RequestParams = {}) =>
      this.request<
        CustomDomainInfo,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/custom-domains/${hostname}`,
        routeTemplate: "/backoffice/custom-domains/{hostname}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name HardDeleteCustomDomain
     * @summary Completely remove a Custom Domain from our DB and from Cloudflare
     * @request DELETE:/backoffice/custom-domains/{hostname}
     * @secure
     */
    hardDeleteCustomDomain: (hostname: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/custom-domains/${hostname}`,
        routeTemplate: "/backoffice/custom-domains/{hostname}",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name CreateCloudflareHostname
     * @summary Create Cloudflare hostname entry for the custom domain.
     * @request PUT:/backoffice/custom-domains/{hostname}/cloudflare
     * @secure
     */
    createCloudflareHostname: (hostname: string, params: RequestParams = {}) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/custom-domains/${hostname}/cloudflare`,
        routeTemplate: "/backoffice/custom-domains/{hostname}/cloudflare",
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name RestartCloudflareHostnameValidation
     * @summary Restart Cloudflare hostname TLS validation for the custom domain.
     * @request PATCH:/backoffice/custom-domains/{hostname}/cloudflare
     * @secure
     */
    restartCloudflareHostnameValidation: (
      hostname: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/custom-domains/${hostname}/cloudflare`,
        routeTemplate: "/backoffice/custom-domains/{hostname}/cloudflare",
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name BlockPublicContentUrls
     * @summary Block public content by a list of public URLs
     * @request POST:/backoffice/blocks/public-urls
     * @secure
     */
    blockPublicContentUrls: (
      data:
        | string[]
        | {
            /** A short description giving context on the reason for the block. */
            reason: BlockReason;
            /** @minItems 1 */
            urls: string[];
          },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          blocked: string[];
          failed: {
            url?: string;
            reason?: string;
          }[];
        },
        any
      >({
        path: `/backoffice/blocks/public-urls`,
        routeTemplate: "/backoffice/blocks/public-urls",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetUserBackOfficeInfo
     * @summary Get the GitBook User info shown in the BackOffice
     * @request GET:/backoffice/users/{userId}
     * @secure
     */
    getUserBackOfficeInfo: (userId: string, params: RequestParams = {}) =>
      this.request<
        UserBackOfficeInfo,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/users/${userId}`,
        routeTemplate: "/backoffice/users/{userId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ResetMfa
     * @summary Reset a user's MFA
     * @request DELETE:/backoffice/users/{userId}/mfa
     * @secure
     */
    resetMfa: (userId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/users/${userId}/mfa`,
        routeTemplate: "/backoffice/users/{userId}/mfa",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name BlockUser
     * @summary Block or Unblock a User
     * @request PATCH:/backoffice/users/{userId}/block
     * @secure
     */
    blockUser: (
      userId: string,
      data: BlockContext,
      params: RequestParams = {},
    ) =>
      this.request<
        UserBackOfficeInfo,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/users/${userId}/block`,
        routeTemplate: "/backoffice/users/{userId}/block",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ImpersonateUser
     * @summary Impersonate a User
     * @request POST:/backoffice/users/{userId}/impersonate
     * @secure
     */
    impersonateUser: (userId: string, params: RequestParams = {}) =>
      this.request<
        UserImpersonation,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/users/${userId}/impersonate`,
        routeTemplate: "/backoffice/users/{userId}/impersonate",
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UserPermissions
     * @summary Returns user permissions
     * @request GET:/backoffice/users/{userId}/permissions
     * @secure
     */
    userPermissions: (userId: string, params: RequestParams = {}) =>
      this.request<
        Index,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/users/${userId}/permissions`,
        routeTemplate: "/backoffice/users/{userId}/permissions",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice, organizations
     * @name GetHideTrademarkForOrganizationById
     * @summary Get the hide trademark flag for an organization
     * @request GET:/backoffice/organizations/{organizationId}/trademark
     * @secure
     */
    getHideTrademarkForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          hideTrademark: boolean;
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/organizations/${organizationId}/trademark`,
        routeTemplate: "/backoffice/organizations/{organizationId}/trademark",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice, organizations
     * @name ToggleHideTrademarkForOrganizationById
     * @summary Hide trademark or show it for an organization
     * @request PATCH:/backoffice/organizations/{organizationId}/trademark
     * @secure
     */
    toggleHideTrademarkForOrganizationById: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          hideTrademark: boolean;
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/organizations/${organizationId}/trademark`,
        routeTemplate: "/backoffice/organizations/{organizationId}/trademark",
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name BlockOrganization
     * @summary Block or Unblock an Organization
     * @request PATCH:/backoffice/organizations/{organizationId}/block
     * @secure
     */
    blockOrganization: (
      organizationId: EntityId,
      data: BlockContext,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Whether the organization is blocked */
          blocked: boolean;
        },
        any
      >({
        path: `/backoffice/organizations/${organizationId}/block`,
        routeTemplate: "/backoffice/organizations/{organizationId}/block",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name SwitchOrganizationType
     * @summary Switch an Organization from Paid to Community or vice-versa
     * @request PATCH:/backoffice/organizations/{organizationId}/switch
     * @secure
     */
    switchOrganizationType: (
      organizationId: EntityId,
      data:
        | {
            type: "community";
            communityType: OrganizationCommunityType;
          }
        | {
            type: "business";
          },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          type: OrganizationType;
          communityType?: OrganizationCommunityType;
        },
        any
      >({
        path: `/backoffice/organizations/${organizationId}/switch`,
        routeTemplate: "/backoffice/organizations/{organizationId}/switch",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Start a trial for an organization for a given number of days. Backoffice-only.
     *
     * @tags backoffice, organizations
     * @name StartTrial
     * @summary Start a trial for an organization
     * @request POST:/backoffice/organizations/{organizationId}/trial
     * @secure
     */
    startTrial: (
      organizationId: EntityId,
      data: {
        /**
         * Number of days for the trial period
         * @min 1
         */
        days: number;
        /** Force starting a trial even if an active subscription exists */
        force?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/backoffice/organizations/${organizationId}/trial`,
        routeTemplate: "/backoffice/organizations/{organizationId}/trial",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get Stripe customer metadata billing overrides for an organization. Backoffice-only.
     *
     * @tags backoffice, organizations
     * @name GetOrganizationBillingOverrides
     * @summary Get billing overrides for an organization
     * @request GET:/backoffice/organizations/{organizationId}/billing-overrides
     * @secure
     */
    getOrganizationBillingOverrides: (
      organizationId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationBillingOverrides, any>({
        path: `/backoffice/organizations/${organizationId}/billing-overrides`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/billing-overrides",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Set or unset Stripe customer metadata billing overrides for an organization. Backoffice-only.
     *
     * @tags backoffice, organizations
     * @name UpdateOrganizationBillingOverrides
     * @summary Update billing overrides for an organization
     * @request PATCH:/backoffice/organizations/{organizationId}/billing-overrides
     * @secure
     */
    updateOrganizationBillingOverrides: (
      organizationId: EntityId,
      data: {
        /** Set to true for an indefinite override, to a timestamp for a dated override, or to null to unset. */
        frozenInterval?: OrganizationBillingDateOverride | null;
        /** Set to true for an indefinite override, to a timestamp for a dated override, or to null to unset. */
        enableSAML?: OrganizationBillingDateOverride | null;
        /** Set an Enterprise organization's contractual AI credit allowance, or null to unset. */
        aiCreditAllowance?: OrganizationBillingNumericOverride | null;
        /** Set the percentage of paid AI credits carried into the next billing period, or null to use the 50% default for paid organizations. Set to 0 to disable rollover. */
        aiCreditRollover?: PercentageThreshold;
        /** Set the percentage of total AI credits remaining at which to send a low-balance alert, or null to disable the alert. */
        aiCreditAlertThreshold?: AICreditThreshold;
        /** Whether AI features pause automatically once all AI credits are used, before usage is billed as overage. */
        aiCreditPauseEnabled?: boolean;
        /** Set to false to force AI off as the organization's contract requires, or to null to unset. */
        hasAI?: false | null;
        /** Set to an integer numeric override, or to null to unset. */
        minUsers?: OrganizationBillingNumericOverride | null;
        /** Set to an integer numeric override, or to null to unset. */
        maxUsers?: OrganizationBillingNumericOverride | null;
        /** Set to an integer numeric override, or to null to unset. */
        minPremiumSites?: OrganizationBillingNumericOverride | null;
        /** Set to an integer numeric override, or to null to unset. */
        maxPremiumSites?: OrganizationBillingNumericOverride | null;
        /** Set to an integer numeric override, or to null to unset. */
        minUltimateSites?: OrganizationBillingNumericOverride | null;
        /** Set to an integer numeric override, or to null to unset. */
        maxUltimateSites?: OrganizationBillingNumericOverride | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/backoffice/organizations/${organizationId}/billing-overrides`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/billing-overrides",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Backoffice-only migration of existing organization SSO users from old emails to new emails.
     *
     * @tags backoffice, organizations
     * @name MigrateSsoEmails
     * @summary Migrate organization SSO emails
     * @request POST:/backoffice/organizations/{organizationId}/sso-email-migration
     * @secure
     */
    migrateSsoEmails: (
      organizationId: EntityId,
      data: {
        /** @minItems 1 */
        migrations: {
          /** @format email */
          fromEmail: string;
          /** @format email */
          toEmail: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 409;
              message: string;
            };
          }
      >({
        path: `/backoffice/organizations/${organizationId}/sso-email-migration`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/sso-email-migration",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Backoffice-only preflight for an organization SSO email migration.
     *
     * @tags backoffice, organizations
     * @name PreviewSsoEmailMigration
     * @summary Preview organization SSO email migration
     * @request POST:/backoffice/organizations/{organizationId}/sso-email-migration/preview
     * @secure
     */
    previewSsoEmailMigration: (
      organizationId: EntityId,
      data: {
        /** @minItems 1 */
        migrations: {
          /** @format email */
          fromEmail: string;
          /** @format email */
          toEmail: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          organization: string;
          entries: {
            /** @format email */
            fromEmail: string;
            /** @format email */
            toEmail: string;
            status: "ready" | "blocked";
            issues: (
              | "same_email"
              | "source_email_not_found"
              | "source_email_used_by_multiple_mappings"
              | "source_user_not_org_sso"
              | "source_user_not_org_member"
              | "target_email_already_used"
              | "target_email_used_by_non_org_sso_user"
              | "target_email_used_by_multiple_mappings"
            )[];
            sourceUser: User | null;
            sourceMember: OrganizationMember | null;
            sourceAuthSSO?: string;
            sourceProfileSSO?: string;
            sourceOrganizationSSO: boolean;
            targetUser: User | null;
            targetMember: OrganizationMember | null;
            targetAuthSSO?: string;
            targetProfileSSO?: string;
            targetOrganizationSSO: boolean;
          }[];
          /** Target-email users that block migration and are not tied to the organization through SSO. */
          duplicateUsers: User[];
          summary: {
            total: number;
            ready: number;
            blocked: number;
            duplicates: number;
            canMigrate: boolean;
          };
        },
        | {
            error: {
              /** @format int32 */
              code: 400;
              message: string;
            };
          }
        | {
            error: {
              /** @format int32 */
              code: 404;
              message: string;
            };
          }
      >({
        path: `/backoffice/organizations/${organizationId}/sso-email-migration/preview`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/sso-email-migration/preview",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ListCustomHostnamesForOrganizationById
     * @summary List active and deprecated Custom Domains for an organization
     * @request GET:/backoffice/organizations/{organizationId}/custom-hostnames
     * @secure
     */
    listCustomHostnamesForOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: CustomHostname[];
        },
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/organizations/${organizationId}/custom-hostnames`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/custom-hostnames",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ListSubdomainsForOrganizationById
     * @summary List active and deprecated subdomains for an organization
     * @request GET:/backoffice/organizations/{organizationId}/subdomains
     * @secure
     */
    listSubdomainsForOrganizationById: (
      organizationId: EntityId,
      query?: {
        /** Identifier of the page results to fetch. */
        page?: string;
        /**
         * The number of results per page
         * @min 0
         * @max 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        List & {
          items: Subdomain[];
        },
        any
      >({
        path: `/backoffice/organizations/${organizationId}/subdomains`,
        routeTemplate: "/backoffice/organizations/{organizationId}/subdomains",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name PurgeOpenApiSpecs
     * @summary Purge the cache for all OpenAPI specs associated to an organization
     * @request DELETE:/backoffice/organizations/{organizationId}/openapi/cache
     * @secure
     */
    purgeOpenApiSpecs: (organizationId: EntityId, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/organizations/${organizationId}/openapi/cache`,
        routeTemplate:
          "/backoffice/organizations/{organizationId}/openapi/cache",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UnblockSpace
     * @summary Unblock a Space
     * @request PATCH:/backoffice/spaces/{spaceId}/block
     * @secure
     */
    unblockSpace: (
      spaceId: EntityId,
      data: BlockContext,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Whether the space is blocked */
          blocked: boolean;
        },
        any
      >({
        path: `/backoffice/spaces/${spaceId}/block`,
        routeTemplate: "/backoffice/spaces/{spaceId}/block",
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name PurgeSpaceCache
     * @summary Purge the cache for a single space
     * @request DELETE:/backoffice/spaces/{spaceId}/cache
     * @secure
     */
    purgeSpaceCache: (spaceId: EntityId, params: RequestParams = {}) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/spaces/${spaceId}/cache`,
        routeTemplate: "/backoffice/spaces/{spaceId}/cache",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ReindexSpaceContentSearch
     * @summary Run a health check on the indexation of a space in the search engine. Run an indexation if needed.
     * @request POST:/backoffice/spaces/{spaceId}/content/index/search
     * @secure
     */
    reindexSpaceContentSearch: (
      spaceId: EntityId,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/spaces/${spaceId}/content/index/search`,
        routeTemplate: "/backoffice/spaces/{spaceId}/content/index/search",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ReindexSpaceContentAi
     * @summary Run an indexation of the content into the vector DB.
     * @request POST:/backoffice/spaces/{spaceId}/content/index/vectors
     * @secure
     */
    reindexSpaceContentAi: (spaceId: EntityId, params: RequestParams = {}) =>
      this.request<
        void,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/spaces/${spaceId}/content/index/vectors`,
        routeTemplate: "/backoffice/spaces/{spaceId}/content/index/vectors",
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetSiteBackOfficeInfo
     * @summary Get a site by its ID with no organization ID
     * @request GET:/backoffice/sites/{siteId}
     * @secure
     */
    getSiteBackOfficeInfo: (siteId: string, params: RequestParams = {}) =>
      this.request<
        BackOfficeSite,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/backoffice/sites/${siteId}`,
        routeTemplate: "/backoffice/sites/{siteId}",
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name PurgeSiteCache
     * @summary Purge a site's cache
     * @request DELETE:/backoffice/sites/{siteId}/cache
     * @secure
     */
    purgeSiteCache: (siteId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/sites/${siteId}/cache`,
        routeTemplate: "/backoffice/sites/{siteId}/cache",
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint is available for sites with Visitor Authentication (VA) enabled, and for adaptive content sites. Adaptive content sites can optionally provide visitor claims to be embedded in the generated token.
     *
     * @tags backoffice
     * @name GetSiteVisitorAuthToken
     * @summary Get a site visitor auth token
     * @request POST:/backoffice/sites/{siteId}/auth/token
     * @secure
     */
    getSiteVisitorAuthToken: (
      siteId: string,
      data?: {
        visitorSignedClaims?: PlainObject;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          token: string;
        },
        {
          error: {
            /** @format int32 */
            code: 400;
            message: string;
          };
        }
      >({
        path: `/backoffice/sites/${siteId}/auth/token`,
        routeTemplate: "/backoffice/sites/{siteId}/auth/token",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  urls = {
    /**
     * No description
     *
     * @tags urls
     * @name GetContentByUrl
     * @summary Resolve a URL to a content (space, collection, page)
     * @request GET:/urls/content
     * @secure
     */
    getContentByUrl: (
      query: {
        /** URL to resolve */
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | {
            collection: Collection;
          }
        | {
            space: Space;
            changeRequest?: ChangeRequest;
            page?: RevisionPageDocument | RevisionPageGroup;
          },
        any
      >({
        path: `/urls/content`,
        routeTemplate: "/urls/content",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags urls
     * @name GetEmbedByUrl
     * @summary Resolve a URL to an embed
     * @request GET:/urls/embed
     * @secure
     */
    getEmbedByUrl: (
      query: {
        /** URL to resolve */
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Embed, any>({
        path: `/urls/embed`,
        routeTemplate: "/urls/embed",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags urls
     * @name GetPublishedContentByUrl
     * @summary Resolve a URL of a published content.
     * @request GET:/urls/published
     * @deprecated
     * @secure
     */
    getPublishedContentByUrl: (
      query: {
        /** URL to resolve */
        url: URL;
        /** JWT token generated for a authenticated access session */
        visitorAuthToken?: string;
        /**
         * When true redirects the user to the authentication/fallback URL if the access token is invalid
         * @default false
         */
        redirectOnError?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PublishedSiteContentLookup,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/urls/published`,
        routeTemplate: "/urls/published",
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags urls
     * @name ResolvePublishedContentByUrl
     * @summary Resolve a URL of a published content.
     * @request POST:/urls/published
     * @secure
     */
    resolvePublishedContentByUrl: (
      data: {
        /** URL to resolve */
        url: URL;
        /**
         * When true redirects the user to the authentication/fallback URL if the access token is invalid
         * @default false
         */
        redirectOnError?: boolean;
        /** An object that describes the payload of site visitor info. It can include a jwt token with signed claims and/or a record of its unsigned claims. */
        visitor?: SiteVisitorPayload;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PublishedSiteContentLookup,
        {
          error: {
            /** @format int32 */
            code: 404;
            message: string;
          };
        }
      >({
        path: `/urls/published`,
        routeTemplate: "/urls/published",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rpc = {
    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentRouting
     * @summary How a hostname maps to sites, for the edge.
     * @request POST:/rpc/published-content/routing
     * @secure
     */
    getPublishedContentRouting: (
      data: PublishedContentRoutingInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentRouting, any>({
        path: `/rpc/published-content/routing`,
        routeTemplate: "/rpc/published-content/routing",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentSiteBundle
     * @summary The site bundle used to resolve published content, for the edge.
     * @request POST:/rpc/published-content/site-bundle
     * @secure
     */
    getPublishedContentSiteBundle: (
      data: PublishedContentSiteBundleInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentSiteBundle, any>({
        path: `/rpc/published-content/site-bundle`,
        routeTemplate: "/rpc/published-content/site-bundle",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentPublishedSite
     * @summary The published content of a site with what filtering it for a visitor needs, for the edge.
     * @request POST:/rpc/published-content/published-site
     * @secure
     */
    getPublishedContentPublishedSite: (
      data: PublishedContentPublishedSiteInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentSiteEntry, any>({
        path: `/rpc/published-content/published-site`,
        routeTemplate: "/rpc/published-content/published-site",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentCaller
     * @summary The caller of GitBook Open identified by its API token, for the edge.
     * @request POST:/rpc/published-content/caller
     * @secure
     */
    getPublishedContentCaller: (
      data: PublishedContentCallerInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentCallerContext, any>({
        path: `/rpc/published-content/caller`,
        routeTemplate: "/rpc/published-content/caller",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentRevisionMetaLinks
     * @summary The meta links of every page in a revision, for the edge.
     * @request POST:/rpc/published-content/revision-meta-links
     * @secure
     */
    getPublishedContentRevisionMetaLinks: (
      data: PublishedContentRevisionMetaLinksInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentRevisionMetaLinks, any>({
        path: `/rpc/published-content/revision-meta-links`,
        routeTemplate: "/rpc/published-content/revision-meta-links",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentDraftSiteBundle
     * @summary The site bundle of a site in draft mode, used to resolve previews, for the edge.
     * @request POST:/rpc/published-content/draft-site-bundle
     * @secure
     */
    getPublishedContentDraftSiteBundle: (
      data: PublishedContentSiteBundleInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentSiteBundle, any>({
        path: `/rpc/published-content/draft-site-bundle`,
        routeTemplate: "/rpc/published-content/draft-site-bundle",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rpc, internal
     * @name GetPublishedContentCustomHomepage
     * @summary The custom homepage path of a space revision as a content token sees it, for the edge.
     * @request POST:/rpc/published-content/custom-homepage
     * @secure
     */
    getPublishedContentCustomHomepage: (
      data: PublishedContentCustomHomepageInput,
      params: RequestParams = {},
    ) =>
      this.request<PublishedContentCustomHomepage, any>({
        path: `/rpc/published-content/custom-homepage`,
        routeTemplate: "/rpc/published-content/custom-homepage",
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
